export const stldigitalRegionData = [
  {
    "countryCode": "Country",
    "region": "Region code",
    "description": "Region name"
  },
  {
    "countryCode": "AD",
    "region": "02",
    "description": "Canillo"
  },
  {
    "countryCode": "AD",
    "region": "03",
    "description": "Encamp"
  },
  {
    "countryCode": "AD",
    "region": "04",
    "description": "La Massana"
  },
  {
    "countryCode": "AD",
    "region": "05",
    "description": "Ordino"
  },
  {
    "countryCode": "AD",
    "region": "06",
    "description": "Sant Juli\u00e0 de L\u00f2ria"
  },
  {
    "countryCode": "AD",
    "region": "07",
    "description": "Andorra la Vella"
  },
  {
    "countryCode": "AD",
    "region": "08",
    "description": "Escaldes-Engordany"
  },
  {
    "countryCode": "AE",
    "region": "AJ",
    "description": "Ajman"
  },
  {
    "countryCode": "AE",
    "region": "AZ",
    "description": "Abu Dhabi"
  },
  {
    "countryCode": "AE",
    "region": "DU",
    "description": "Dubai"
  },
  {
    "countryCode": "AE",
    "region": "FU",
    "description": "Fujairah"
  },
  {
    "countryCode": "AE",
    "region": "RK",
    "description": "Ras al-Khaimah"
  },
  {
    "countryCode": "AE",
    "region": "SH",
    "description": "Sharjah"
  },
  {
    "countryCode": "AE",
    "region": "UQ",
    "description": "Umm al-Quwain"
  },
  {
    "countryCode": "AF",
    "region": "BAL",
    "description": "Balkh"
  },
  {
    "countryCode": "AF",
    "region": "BAM",
    "description": "Bamyan"
  },
  {
    "countryCode": "AF",
    "region": "BDG",
    "description": "Badghis"
  },
  {
    "countryCode": "AF",
    "region": "BDS",
    "description": "Badakhshan"
  },
  {
    "countryCode": "AF",
    "region": "BGL",
    "description": "Baglan"
  },
  {
    "countryCode": "AF",
    "region": "DAY",
    "description": "Daykundi"
  },
  {
    "countryCode": "AF",
    "region": "FRA",
    "description": "Farah"
  },
  {
    "countryCode": "AF",
    "region": "FYB",
    "description": "Faryab"
  },
  {
    "countryCode": "AF",
    "region": "GHA",
    "description": "Ghazni"
  },
  {
    "countryCode": "AF",
    "region": "GHO",
    "description": "Ghor"
  },
  {
    "countryCode": "AF",
    "region": "HEL",
    "description": "Helmand"
  },
  {
    "countryCode": "AF",
    "region": "HER",
    "description": "Herat"
  },
  {
    "countryCode": "AF",
    "region": "JOW",
    "description": "Jowzjan"
  },
  {
    "countryCode": "AF",
    "region": "KAB",
    "description": "Kabul"
  },
  {
    "countryCode": "AF",
    "region": "KAN",
    "description": "Kandahar"
  },
  {
    "countryCode": "AF",
    "region": "KAP",
    "description": "Kapisa"
  },
  {
    "countryCode": "AF",
    "region": "KDZ",
    "description": "Kunduz"
  },
  {
    "countryCode": "AF",
    "region": "KHO",
    "description": "Khost"
  },
  {
    "countryCode": "AF",
    "region": "KNR",
    "description": "Kunar"
  },
  {
    "countryCode": "AF",
    "region": "LAG",
    "description": "Laghman"
  },
  {
    "countryCode": "AF",
    "region": "LOG",
    "description": "Logar"
  },
  {
    "countryCode": "AF",
    "region": "NAN",
    "description": "Nangarhar"
  },
  {
    "countryCode": "AF",
    "region": "NIM",
    "description": "Nimruz"
  },
  {
    "countryCode": "AF",
    "region": "NUR",
    "description": "Nuristan"
  },
  {
    "countryCode": "AF",
    "region": "PAN",
    "description": "Panjshir"
  },
  {
    "countryCode": "AF",
    "region": "PAR",
    "description": "Parwan"
  },
  {
    "countryCode": "AF",
    "region": "PIA",
    "description": "Paktia"
  },
  {
    "countryCode": "AF",
    "region": "PKA",
    "description": "Paktika"
  },
  {
    "countryCode": "AF",
    "region": "SAM",
    "description": "Samangan"
  },
  {
    "countryCode": "AF",
    "region": "SAR",
    "description": "Sar-e Pul"
  },
  {
    "countryCode": "AF",
    "region": "TAK",
    "description": "Takhar"
  },
  {
    "countryCode": "AF",
    "region": "URU",
    "description": "Uruzgan"
  },
  {
    "countryCode": "AF",
    "region": "WAR",
    "description": "Wardak"
  },
  {
    "countryCode": "AF",
    "region": "ZAB",
    "description": "Zabul"
  },
  {
    "countryCode": "AL",
    "region": "01",
    "description": "Berat"
  },
  {
    "countryCode": "AL",
    "region": "02",
    "description": "Durr\u00ebs"
  },
  {
    "countryCode": "AL",
    "region": "03",
    "description": "Elbasan"
  },
  {
    "countryCode": "AL",
    "region": "04",
    "description": "Fier"
  },
  {
    "countryCode": "AL",
    "region": "05",
    "description": "Gjirokast\u00ebr"
  },
  {
    "countryCode": "AL",
    "region": "06",
    "description": "Kor\u00e7\u00eb"
  },
  {
    "countryCode": "AL",
    "region": "07",
    "description": "Kuk\u00ebs"
  },
  {
    "countryCode": "AL",
    "region": "08",
    "description": "Lezh\u00eb"
  },
  {
    "countryCode": "AL",
    "region": "09",
    "description": "Dib\u00ebr"
  },
  {
    "countryCode": "AL",
    "region": "10",
    "description": "Shkod\u00ebr"
  },
  {
    "countryCode": "AL",
    "region": "11",
    "description": "Tiran\u00eb"
  },
  {
    "countryCode": "AL",
    "region": "12",
    "description": "Vlor\u00eb"
  },
  {
    "countryCode": "AM",
    "region": "AG",
    "description": "Aragatsotn"
  },
  {
    "countryCode": "AM",
    "region": "AR",
    "description": "Ararat"
  },
  {
    "countryCode": "AM",
    "region": "AV",
    "description": "Armavir"
  },
  {
    "countryCode": "AM",
    "region": "ER",
    "description": "Yerevan"
  },
  {
    "countryCode": "AM",
    "region": "GR",
    "description": "Gegharkunik"
  },
  {
    "countryCode": "AM",
    "region": "KT",
    "description": "Kotayk"
  },
  {
    "countryCode": "AM",
    "region": "LO",
    "description": "Lori"
  },
  {
    "countryCode": "AM",
    "region": "SH",
    "description": "Shirak"
  },
  {
    "countryCode": "AM",
    "region": "SU",
    "description": "Syunik"
  },
  {
    "countryCode": "AM",
    "region": "TV",
    "description": "Tavush"
  },
  {
    "countryCode": "AM",
    "region": "VD",
    "description": "Vayots Dzor"
  },
  {
    "countryCode": "AO",
    "region": "BGO",
    "description": "Bengo"
  },
  {
    "countryCode": "AO",
    "region": "BGU",
    "description": "Benguela"
  },
  {
    "countryCode": "AO",
    "region": "BIE",
    "description": "Bi\u00e9"
  },
  {
    "countryCode": "AO",
    "region": "CAB",
    "description": "Cabinda"
  },
  {
    "countryCode": "AO",
    "region": "CCU",
    "description": "Cuando Cubango"
  },
  {
    "countryCode": "AO",
    "region": "CNN",
    "description": "Cunene"
  },
  {
    "countryCode": "AO",
    "region": "CNO",
    "description": "Cuanza-Norte"
  },
  {
    "countryCode": "AO",
    "region": "CUS",
    "description": "Cuanza-Sul"
  },
  {
    "countryCode": "AO",
    "region": "HUA",
    "description": "Huambo"
  },
  {
    "countryCode": "AO",
    "region": "HUI",
    "description": "Hu\u00edla"
  },
  {
    "countryCode": "AO",
    "region": "LNO",
    "description": "Lunda-Norte"
  },
  {
    "countryCode": "AO",
    "region": "LSU",
    "description": "Lunda-Sul"
  },
  {
    "countryCode": "AO",
    "region": "LUA",
    "description": "Luanda"
  },
  {
    "countryCode": "AO",
    "region": "MAL",
    "description": "Malange"
  },
  {
    "countryCode": "AO",
    "region": "MOX",
    "description": "Moxico"
  },
  {
    "countryCode": "AO",
    "region": "NAM",
    "description": "Namibe"
  },
  {
    "countryCode": "AO",
    "region": "UIG",
    "description": "U\u00edge"
  },
  {
    "countryCode": "AO",
    "region": "ZAI",
    "description": "Zaire"
  },
  {
    "countryCode": "AR",
    "region": "00",
    "description": "Capital Federal"
  },
  {
    "countryCode": "AR",
    "region": "01",
    "description": "Buenos Aires"
  },
  {
    "countryCode": "AR",
    "region": "02",
    "description": "Catamarca"
  },
  {
    "countryCode": "AR",
    "region": "03",
    "description": "Cordoba"
  },
  {
    "countryCode": "AR",
    "region": "04",
    "description": "Corrientes"
  },
  {
    "countryCode": "AR",
    "region": "05",
    "description": "Entre Rios"
  },
  {
    "countryCode": "AR",
    "region": "06",
    "description": "Jujuy"
  },
  {
    "countryCode": "AR",
    "region": "07",
    "description": "Mendoza"
  },
  {
    "countryCode": "AR",
    "region": "08",
    "description": "La Rioja"
  },
  {
    "countryCode": "AR",
    "region": "09",
    "description": "Salta"
  },
  {
    "countryCode": "AR",
    "region": "10",
    "description": "San Juan"
  },
  {
    "countryCode": "AR",
    "region": "11",
    "description": "San Luis"
  },
  {
    "countryCode": "AR",
    "region": "12",
    "description": "Santa Fe"
  },
  {
    "countryCode": "AR",
    "region": "13",
    "description": "Santiago del Estero"
  },
  {
    "countryCode": "AR",
    "region": "14",
    "description": "Tucuman"
  },
  {
    "countryCode": "AR",
    "region": "16",
    "description": "Chaco"
  },
  {
    "countryCode": "AR",
    "region": "17",
    "description": "Chubut"
  },
  {
    "countryCode": "AR",
    "region": "18",
    "description": "Formosa"
  },
  {
    "countryCode": "AR",
    "region": "19",
    "description": "Misiones"
  },
  {
    "countryCode": "AR",
    "region": "20",
    "description": "Neuquen"
  },
  {
    "countryCode": "AR",
    "region": "21",
    "description": "La Pampa"
  },
  {
    "countryCode": "AR",
    "region": "22",
    "description": "Rio Negro"
  },
  {
    "countryCode": "AR",
    "region": "23",
    "description": "Santa Cruz"
  },
  {
    "countryCode": "AR",
    "region": "24",
    "description": "Tierra del Fuego"
  },
  {
    "countryCode": "AT",
    "region": "1",
    "description": "Burgenland"
  },
  {
    "countryCode": "AT",
    "region": "2",
    "description": "Carinthia"
  },
  {
    "countryCode": "AT",
    "region": "3",
    "description": "Lower Austria"
  },
  {
    "countryCode": "AT",
    "region": "4",
    "description": "Upper Austria"
  },
  {
    "countryCode": "AT",
    "region": "5",
    "description": "Salzburg"
  },
  {
    "countryCode": "AT",
    "region": "6",
    "description": "Styria"
  },
  {
    "countryCode": "AT",
    "region": "7",
    "description": "Tyrol"
  },
  {
    "countryCode": "AT",
    "region": "8",
    "description": "Vorarlberg"
  },
  {
    "countryCode": "AT",
    "region": "9",
    "description": "Vienna"
  },
  {
    "countryCode": "AU",
    "region": "ACT",
    "description": "Aust Capital Terr"
  },
  {
    "countryCode": "AU",
    "region": "NSW",
    "description": "New South Wales"
  },
  {
    "countryCode": "AU",
    "region": "NT",
    "description": "Northern Territory"
  },
  {
    "countryCode": "AU",
    "region": "QLD",
    "description": "Queensland"
  },
  {
    "countryCode": "AU",
    "region": "SA",
    "description": "South Australia"
  },
  {
    "countryCode": "AU",
    "region": "TAS",
    "description": "Tasmania"
  },
  {
    "countryCode": "AU",
    "region": "VIC",
    "description": "Victoria"
  },
  {
    "countryCode": "AU",
    "region": "WA",
    "description": "Western Australia"
  },
  {
    "countryCode": "AZ",
    "region": "ABS",
    "description": "Ab\u015feron"
  },
  {
    "countryCode": "AZ",
    "region": "AGA",
    "description": "A\u011fstafa"
  },
  {
    "countryCode": "AZ",
    "region": "AGC",
    "description": "A\u011fcab\u0259di"
  },
  {
    "countryCode": "AZ",
    "region": "AGM",
    "description": "A\u011fdam"
  },
  {
    "countryCode": "AZ",
    "region": "AGS",
    "description": "A\u011fda\u015f"
  },
  {
    "countryCode": "AZ",
    "region": "AGU",
    "description": "A\u011fsu"
  },
  {
    "countryCode": "AZ",
    "region": "AST",
    "description": "Astara"
  },
  {
    "countryCode": "AZ",
    "region": "BA",
    "description": "Bak\u0131"
  },
  {
    "countryCode": "AZ",
    "region": "BAB",
    "description": "Bab\u0259k"
  },
  {
    "countryCode": "AZ",
    "region": "BAL",
    "description": "Balak\u0259n"
  },
  {
    "countryCode": "AZ",
    "region": "BAR",
    "description": "B\u0259rd\u0259"
  },
  {
    "countryCode": "AZ",
    "region": "BEY",
    "description": "Beyl\u0259qan"
  },
  {
    "countryCode": "AZ",
    "region": "BIL",
    "description": "Bil\u0259suvar"
  },
  {
    "countryCode": "AZ",
    "region": "CAB",
    "description": "C\u0259bray\u0131l"
  },
  {
    "countryCode": "AZ",
    "region": "CAL",
    "description": "C\u0259lilabad"
  },
  {
    "countryCode": "AZ",
    "region": "CUL",
    "description": "Culfa"
  },
  {
    "countryCode": "AZ",
    "region": "DAS",
    "description": "Da\u015fk\u0259s\u0259n"
  },
  {
    "countryCode": "AZ",
    "region": "FUZ",
    "description": "F\u00fczuli"
  },
  {
    "countryCode": "AZ",
    "region": "GA",
    "description": "G\u0259nc\u0259"
  },
  {
    "countryCode": "AZ",
    "region": "GAD",
    "description": "G\u0259d\u0259b\u0259y"
  },
  {
    "countryCode": "AZ",
    "region": "GOR",
    "description": "Goranboy"
  },
  {
    "countryCode": "AZ",
    "region": "GOY",
    "description": "G\u00f6y\u00e7ay"
  },
  {
    "countryCode": "AZ",
    "region": "GYG",
    "description": "G\u00f6yg\u00f6l"
  },
  {
    "countryCode": "AZ",
    "region": "HAC",
    "description": "Hac\u0131qabul"
  },
  {
    "countryCode": "AZ",
    "region": "IMI",
    "description": "\u0130mi\u015fli"
  },
  {
    "countryCode": "AZ",
    "region": "ISM",
    "description": "\u0130smay\u0131ll\u0131"
  },
  {
    "countryCode": "AZ",
    "region": "KAL",
    "description": "K\u0259lb\u0259c\u0259r"
  },
  {
    "countryCode": "AZ",
    "region": "KAN",
    "description": "K\u0259ng\u0259rli"
  },
  {
    "countryCode": "AZ",
    "region": "KUR",
    "description": "K\u00fcrd\u0259mir"
  },
  {
    "countryCode": "AZ",
    "region": "LA",
    "description": "L\u0259nk\u0259ran (city)"
  },
  {
    "countryCode": "AZ",
    "region": "LAC",
    "description": "La\u00e7\u0131n"
  },
  {
    "countryCode": "AZ",
    "region": "LAN",
    "description": "L\u0259nk\u0259ran (region)"
  },
  {
    "countryCode": "AZ",
    "region": "LER",
    "description": "Lerik"
  },
  {
    "countryCode": "AZ",
    "region": "MAS",
    "description": "Masall\u0131"
  },
  {
    "countryCode": "AZ",
    "region": "MI",
    "description": "Ming\u0259\u00e7evir"
  },
  {
    "countryCode": "AZ",
    "region": "NA",
    "description": "Naftalan"
  },
  {
    "countryCode": "AZ",
    "region": "NEF",
    "description": "Neft\u00e7ala"
  },
  {
    "countryCode": "AZ",
    "region": "NV",
    "description": "Nax\u00e7\u0131van"
  },
  {
    "countryCode": "AZ",
    "region": "OGU",
    "description": "O\u011fuz"
  },
  {
    "countryCode": "AZ",
    "region": "ORD",
    "description": "Ordubad"
  },
  {
    "countryCode": "AZ",
    "region": "QAB",
    "description": "Q\u0259b\u0259l\u0259"
  },
  {
    "countryCode": "AZ",
    "region": "QAX",
    "description": "Qax"
  },
  {
    "countryCode": "AZ",
    "region": "QAZ",
    "description": "Qazax"
  },
  {
    "countryCode": "AZ",
    "region": "QBA",
    "description": "Quba"
  },
  {
    "countryCode": "AZ",
    "region": "QBI",
    "description": "Qubadl\u0131"
  },
  {
    "countryCode": "AZ",
    "region": "QOB",
    "description": "Qobustan"
  },
  {
    "countryCode": "AZ",
    "region": "QUS",
    "description": "Qusar"
  },
  {
    "countryCode": "AZ",
    "region": "SA",
    "description": "\u015e\u0259ki (city)"
  },
  {
    "countryCode": "AZ",
    "region": "SAB",
    "description": "Sabirabad"
  },
  {
    "countryCode": "AZ",
    "region": "SAD",
    "description": "S\u0259d\u0259r\u0259k"
  },
  {
    "countryCode": "AZ",
    "region": "SAH",
    "description": "\u015eahbuz"
  },
  {
    "countryCode": "AZ",
    "region": "SAK",
    "description": "\u015e\u0259ki (region)"
  },
  {
    "countryCode": "AZ",
    "region": "SAL",
    "description": "Salyan"
  },
  {
    "countryCode": "AZ",
    "region": "SAR",
    "description": "\u015e\u0259rur"
  },
  {
    "countryCode": "AZ",
    "region": "SAT",
    "description": "Saatl\u0131"
  },
  {
    "countryCode": "AZ",
    "region": "SBN",
    "description": "\u015eabran"
  },
  {
    "countryCode": "AZ",
    "region": "SIY",
    "description": "Siy\u0259z\u0259n"
  },
  {
    "countryCode": "AZ",
    "region": "SKR",
    "description": "\u015e\u0259mkir"
  },
  {
    "countryCode": "AZ",
    "region": "SM",
    "description": "Sumqay\u0131t"
  },
  {
    "countryCode": "AZ",
    "region": "SMI",
    "description": "\u015eamax\u0131"
  },
  {
    "countryCode": "AZ",
    "region": "SMX",
    "description": "Samux"
  },
  {
    "countryCode": "AZ",
    "region": "SR",
    "description": "\u015eirvan"
  },
  {
    "countryCode": "AZ",
    "region": "SUS",
    "description": "\u015eu\u015fa"
  },
  {
    "countryCode": "AZ",
    "region": "TAR",
    "description": "T\u0259rt\u0259r"
  },
  {
    "countryCode": "AZ",
    "region": "TOV",
    "description": "Tovuz"
  },
  {
    "countryCode": "AZ",
    "region": "UCA",
    "description": "Ucar"
  },
  {
    "countryCode": "AZ",
    "region": "XA",
    "description": "Xank\u0259ndi"
  },
  {
    "countryCode": "AZ",
    "region": "XAC",
    "description": "Xa\u00e7maz"
  },
  {
    "countryCode": "AZ",
    "region": "XCI",
    "description": "Xocal\u0131"
  },
  {
    "countryCode": "AZ",
    "region": "XIZ",
    "description": "X\u0131z\u0131"
  },
  {
    "countryCode": "AZ",
    "region": "XVD",
    "description": "Xocav\u0259nd"
  },
  {
    "countryCode": "AZ",
    "region": "YAR",
    "description": "Yard\u0131ml\u0131"
  },
  {
    "countryCode": "AZ",
    "region": "YE",
    "description": "Yevlax (city)"
  },
  {
    "countryCode": "AZ",
    "region": "YEV",
    "description": "Yevlax (region)"
  },
  {
    "countryCode": "AZ",
    "region": "ZAN",
    "description": "Z\u0259ngilan"
  },
  {
    "countryCode": "AZ",
    "region": "ZAQ",
    "description": "Zaqatala"
  },
  {
    "countryCode": "AZ",
    "region": "ZAR",
    "description": "Z\u0259rdab"
  },
  {
    "countryCode": "BA",
    "region": "BIH",
    "description": "Fed. Bosnia &Herzeg."
  },
  {
    "countryCode": "BA",
    "region": "BRC",
    "description": "Br\u010dko district"
  },
  {
    "countryCode": "BA",
    "region": "SRP",
    "description": "Republika Srpska"
  },
  {
    "countryCode": "BD",
    "region": "01",
    "description": "Bandarban"
  },
  {
    "countryCode": "BD",
    "region": "02",
    "description": "Barguna"
  },
  {
    "countryCode": "BD",
    "region": "03",
    "description": "Bogura"
  },
  {
    "countryCode": "BD",
    "region": "04",
    "description": "Brahmanbaria"
  },
  {
    "countryCode": "BD",
    "region": "05",
    "description": "Bagerhat"
  },
  {
    "countryCode": "BD",
    "region": "06",
    "description": "Barishal"
  },
  {
    "countryCode": "BD",
    "region": "07",
    "description": "Bhola"
  },
  {
    "countryCode": "BD",
    "region": "08",
    "description": "Cumilla"
  },
  {
    "countryCode": "BD",
    "region": "09",
    "description": "Chandpur"
  },
  {
    "countryCode": "BD",
    "region": "10",
    "description": "Chattogram"
  },
  {
    "countryCode": "BD",
    "region": "11",
    "description": "Cox's Bazar"
  },
  {
    "countryCode": "BD",
    "region": "12",
    "description": "Chuadanga"
  },
  {
    "countryCode": "BD",
    "region": "13",
    "description": "Dhaka"
  },
  {
    "countryCode": "BD",
    "region": "14",
    "description": "Dinajpur"
  },
  {
    "countryCode": "BD",
    "region": "15",
    "description": "Faridpur"
  },
  {
    "countryCode": "BD",
    "region": "16",
    "description": "Feni"
  },
  {
    "countryCode": "BD",
    "region": "17",
    "description": "Gopalganj"
  },
  {
    "countryCode": "BD",
    "region": "18",
    "description": "Gazipur"
  },
  {
    "countryCode": "BD",
    "region": "19",
    "description": "Gaibandha"
  },
  {
    "countryCode": "BD",
    "region": "20",
    "description": "Habiganj"
  },
  {
    "countryCode": "BD",
    "region": "21",
    "description": "Jamalpur"
  },
  {
    "countryCode": "BD",
    "region": "22",
    "description": "Jashore"
  },
  {
    "countryCode": "BD",
    "region": "23",
    "description": "Jhenaidah"
  },
  {
    "countryCode": "BD",
    "region": "24",
    "description": "Joypurhat"
  },
  {
    "countryCode": "BD",
    "region": "25",
    "description": "Jhalakathi"
  },
  {
    "countryCode": "BD",
    "region": "26",
    "description": "Kishoreganj"
  },
  {
    "countryCode": "BD",
    "region": "27",
    "description": "Khulna"
  },
  {
    "countryCode": "BD",
    "region": "28",
    "description": "Kurigram"
  },
  {
    "countryCode": "BD",
    "region": "29",
    "description": "Khagrachhari"
  },
  {
    "countryCode": "BD",
    "region": "30",
    "description": "Kushtia"
  },
  {
    "countryCode": "BD",
    "region": "31",
    "description": "Lakshmipur"
  },
  {
    "countryCode": "BD",
    "region": "32",
    "description": "Lalmonirhat"
  },
  {
    "countryCode": "BD",
    "region": "33",
    "description": "Manikganj"
  },
  {
    "countryCode": "BD",
    "region": "34",
    "description": "Mymensingh"
  },
  {
    "countryCode": "BD",
    "region": "35",
    "description": "Munshiganj"
  },
  {
    "countryCode": "BD",
    "region": "36",
    "description": "Madaripur"
  },
  {
    "countryCode": "BD",
    "region": "37",
    "description": "Magura"
  },
  {
    "countryCode": "BD",
    "region": "38",
    "description": "Moulvibazar"
  },
  {
    "countryCode": "BD",
    "region": "39",
    "description": "Meherpur"
  },
  {
    "countryCode": "BD",
    "region": "40",
    "description": "Narayanganj"
  },
  {
    "countryCode": "BD",
    "region": "41",
    "description": "Netrakona"
  },
  {
    "countryCode": "BD",
    "region": "42",
    "description": "Narsingdi"
  },
  {
    "countryCode": "BD",
    "region": "43",
    "description": "Narail"
  },
  {
    "countryCode": "BD",
    "region": "44",
    "description": "Natore"
  },
  {
    "countryCode": "BD",
    "region": "45",
    "description": "Chapai Nawabganj"
  },
  {
    "countryCode": "BD",
    "region": "46",
    "description": "Nilphamari"
  },
  {
    "countryCode": "BD",
    "region": "47",
    "description": "Noakhali"
  },
  {
    "countryCode": "BD",
    "region": "48",
    "description": "Naogaon"
  },
  {
    "countryCode": "BD",
    "region": "49",
    "description": "Pabna"
  },
  {
    "countryCode": "BD",
    "region": "50",
    "description": "Pirojpur"
  },
  {
    "countryCode": "BD",
    "region": "51",
    "description": "Patuakhali"
  },
  {
    "countryCode": "BD",
    "region": "52",
    "description": "Panchagarh"
  },
  {
    "countryCode": "BD",
    "region": "53",
    "description": "Rajbari"
  },
  {
    "countryCode": "BD",
    "region": "54",
    "description": "Rajshahi"
  },
  {
    "countryCode": "BD",
    "region": "55",
    "description": "Rangpur"
  },
  {
    "countryCode": "BD",
    "region": "56",
    "description": "Rangamati"
  },
  {
    "countryCode": "BD",
    "region": "57",
    "description": "Sherpur"
  },
  {
    "countryCode": "BD",
    "region": "58",
    "description": "Satkhira"
  },
  {
    "countryCode": "BD",
    "region": "59",
    "description": "Sirajganj"
  },
  {
    "countryCode": "BD",
    "region": "60",
    "description": "Sylhet"
  },
  {
    "countryCode": "BD",
    "region": "61",
    "description": "Sunamganj"
  },
  {
    "countryCode": "BD",
    "region": "62",
    "description": "Shariatpur"
  },
  {
    "countryCode": "BD",
    "region": "63",
    "description": "Tangail"
  },
  {
    "countryCode": "BD",
    "region": "64",
    "description": "Thakurgaon"
  },
  {
    "countryCode": "BE",
    "region": "BRU",
    "description": "Brussels-Capital Reg"
  },
  {
    "countryCode": "BE",
    "region": "VAN",
    "description": "Antwerp"
  },
  {
    "countryCode": "BE",
    "region": "VBR",
    "description": "Flemish Brabant"
  },
  {
    "countryCode": "BE",
    "region": "VLI",
    "description": "Limburg"
  },
  {
    "countryCode": "BE",
    "region": "VOV",
    "description": "East Flanders"
  },
  {
    "countryCode": "BE",
    "region": "VWV",
    "description": "West Flanders"
  },
  {
    "countryCode": "BE",
    "region": "WBR",
    "description": "Walloon Brabant"
  },
  {
    "countryCode": "BE",
    "region": "WHT",
    "description": "Hainaut"
  },
  {
    "countryCode": "BE",
    "region": "WLG",
    "description": "Liege"
  },
  {
    "countryCode": "BE",
    "region": "WLX",
    "description": "Luxembourg"
  },
  {
    "countryCode": "BE",
    "region": "WNA",
    "description": "Namur"
  },
  {
    "countryCode": "BF",
    "region": "BAL",
    "description": "Bal\u00e9"
  },
  {
    "countryCode": "BF",
    "region": "BAM",
    "description": "Bam"
  },
  {
    "countryCode": "BF",
    "region": "BAN",
    "description": "Banwa"
  },
  {
    "countryCode": "BF",
    "region": "BAZ",
    "description": "Baz\u00e8ga"
  },
  {
    "countryCode": "BF",
    "region": "BGR",
    "description": "Bougouriba"
  },
  {
    "countryCode": "BF",
    "region": "BLG",
    "description": "Boulgou"
  },
  {
    "countryCode": "BF",
    "region": "BLK",
    "description": "Boulkiemd\u00e9"
  },
  {
    "countryCode": "BF",
    "region": "COM",
    "description": "Como\u00e9"
  },
  {
    "countryCode": "BF",
    "region": "GAN",
    "description": "Ganzourgou"
  },
  {
    "countryCode": "BF",
    "region": "GNA",
    "description": "Gnagna"
  },
  {
    "countryCode": "BF",
    "region": "GOU",
    "description": "Gourma"
  },
  {
    "countryCode": "BF",
    "region": "HOU",
    "description": "Houet"
  },
  {
    "countryCode": "BF",
    "region": "IOB",
    "description": "Ioba"
  },
  {
    "countryCode": "BF",
    "region": "KAD",
    "description": "Kadiogo"
  },
  {
    "countryCode": "BF",
    "region": "KEN",
    "description": "K\u00e9n\u00e9dougou"
  },
  {
    "countryCode": "BF",
    "region": "KMD",
    "description": "Komondjari"
  },
  {
    "countryCode": "BF",
    "region": "KMP",
    "description": "Kompienga"
  },
  {
    "countryCode": "BF",
    "region": "KOP",
    "description": "Koulp\u00e9logo"
  },
  {
    "countryCode": "BF",
    "region": "KOS",
    "description": "Kossi"
  },
  {
    "countryCode": "BF",
    "region": "KOT",
    "description": "Kouritenga"
  },
  {
    "countryCode": "BF",
    "region": "KOW",
    "description": "Kourw\u00e9ogo"
  },
  {
    "countryCode": "BF",
    "region": "LER",
    "description": "L\u00e9raba"
  },
  {
    "countryCode": "BF",
    "region": "LOR",
    "description": "Loroum"
  },
  {
    "countryCode": "BF",
    "region": "MOU",
    "description": "Mouhoun"
  },
  {
    "countryCode": "BF",
    "region": "NAM",
    "description": "Namentenga"
  },
  {
    "countryCode": "BF",
    "region": "NAO",
    "description": "Nahouri"
  },
  {
    "countryCode": "BF",
    "region": "NAY",
    "description": "Nayala"
  },
  {
    "countryCode": "BF",
    "region": "NOU",
    "description": "Noumbiel"
  },
  {
    "countryCode": "BF",
    "region": "OUB",
    "description": "Oubritenga"
  },
  {
    "countryCode": "BF",
    "region": "OUD",
    "description": "Oudalan"
  },
  {
    "countryCode": "BF",
    "region": "PAS",
    "description": "Passor\u00e9"
  },
  {
    "countryCode": "BF",
    "region": "PON",
    "description": "Poni"
  },
  {
    "countryCode": "BF",
    "region": "SEN",
    "description": "S\u00e9no"
  },
  {
    "countryCode": "BF",
    "region": "SIS",
    "description": "Sissili"
  },
  {
    "countryCode": "BF",
    "region": "SMT",
    "description": "Sanmatenga"
  },
  {
    "countryCode": "BF",
    "region": "SNG",
    "description": "Sangui\u00e9"
  },
  {
    "countryCode": "BF",
    "region": "SOM",
    "description": "Soum"
  },
  {
    "countryCode": "BF",
    "region": "SOR",
    "description": "Sourou"
  },
  {
    "countryCode": "BF",
    "region": "TAP",
    "description": "Tapoa"
  },
  {
    "countryCode": "BF",
    "region": "TUI",
    "description": "Tuy"
  },
  {
    "countryCode": "BF",
    "region": "YAG",
    "description": "Yagha"
  },
  {
    "countryCode": "BF",
    "region": "YAT",
    "description": "Yatenga"
  },
  {
    "countryCode": "BF",
    "region": "ZIR",
    "description": "Ziro"
  },
  {
    "countryCode": "BF",
    "region": "ZON",
    "description": "Zondoma"
  },
  {
    "countryCode": "BF",
    "region": "ZOU",
    "description": "Zoundw\u00e9ogo"
  },
  {
    "countryCode": "BG",
    "region": "01",
    "description": "Blagoevgrad"
  },
  {
    "countryCode": "BG",
    "region": "02",
    "description": "Burgas"
  },
  {
    "countryCode": "BG",
    "region": "03",
    "description": "Varna"
  },
  {
    "countryCode": "BG",
    "region": "04",
    "description": "Veliko Tarnovo"
  },
  {
    "countryCode": "BG",
    "region": "05",
    "description": "Vidin"
  },
  {
    "countryCode": "BG",
    "region": "06",
    "description": "Vratsa"
  },
  {
    "countryCode": "BG",
    "region": "07",
    "description": "Gabrovo"
  },
  {
    "countryCode": "BG",
    "region": "08",
    "description": "Dobrich"
  },
  {
    "countryCode": "BG",
    "region": "09",
    "description": "Kardzhali"
  },
  {
    "countryCode": "BG",
    "region": "10",
    "description": "Kyustendil"
  },
  {
    "countryCode": "BG",
    "region": "11",
    "description": "Lovech"
  },
  {
    "countryCode": "BG",
    "region": "12",
    "description": "Montana"
  },
  {
    "countryCode": "BG",
    "region": "13",
    "description": "Pazardzhik"
  },
  {
    "countryCode": "BG",
    "region": "14",
    "description": "Pernik"
  },
  {
    "countryCode": "BG",
    "region": "15",
    "description": "Pleven"
  },
  {
    "countryCode": "BG",
    "region": "16",
    "description": "Plovdiv"
  },
  {
    "countryCode": "BG",
    "region": "17",
    "description": "Razgrad"
  },
  {
    "countryCode": "BG",
    "region": "18",
    "description": "Ruse"
  },
  {
    "countryCode": "BG",
    "region": "19",
    "description": "Silistra"
  },
  {
    "countryCode": "BG",
    "region": "20",
    "description": "Sliven"
  },
  {
    "countryCode": "BG",
    "region": "21",
    "description": "Smolyan"
  },
  {
    "countryCode": "BG",
    "region": "22",
    "description": "Sofia-Grad"
  },
  {
    "countryCode": "BG",
    "region": "23",
    "description": "Sofia"
  },
  {
    "countryCode": "BG",
    "region": "24",
    "description": "Stara Zagora"
  },
  {
    "countryCode": "BG",
    "region": "25",
    "description": "Targovishte"
  },
  {
    "countryCode": "BG",
    "region": "26",
    "description": "Haskovo"
  },
  {
    "countryCode": "BG",
    "region": "27",
    "description": "Shumen"
  },
  {
    "countryCode": "BG",
    "region": "28",
    "description": "Yambol"
  },
  {
    "countryCode": "BH",
    "region": "13",
    "description": "Capital Governorate"
  },
  {
    "countryCode": "BH",
    "region": "14",
    "description": "Southern Governorate"
  },
  {
    "countryCode": "BH",
    "region": "15",
    "description": "Muharraq Governorate"
  },
  {
    "countryCode": "BH",
    "region": "17",
    "description": "Northern Governorate"
  },
  {
    "countryCode": "BI",
    "region": "BB",
    "description": "Bubanza"
  },
  {
    "countryCode": "BI",
    "region": "BL",
    "description": "Bujumbura Rural"
  },
  {
    "countryCode": "BI",
    "region": "BM",
    "description": "Bujumbura Mairie"
  },
  {
    "countryCode": "BI",
    "region": "BR",
    "description": "Bururi"
  },
  {
    "countryCode": "BI",
    "region": "CA",
    "description": "Cankuzo"
  },
  {
    "countryCode": "BI",
    "region": "CI",
    "description": "Cibitoke"
  },
  {
    "countryCode": "BI",
    "region": "GI",
    "description": "Gitega"
  },
  {
    "countryCode": "BI",
    "region": "KI",
    "description": "Kirundo"
  },
  {
    "countryCode": "BI",
    "region": "KR",
    "description": "Karuzi"
  },
  {
    "countryCode": "BI",
    "region": "KY",
    "description": "Kayanza"
  },
  {
    "countryCode": "BI",
    "region": "MA",
    "description": "Makamba"
  },
  {
    "countryCode": "BI",
    "region": "MU",
    "description": "Muramvya"
  },
  {
    "countryCode": "BI",
    "region": "MW",
    "description": "Mwaro"
  },
  {
    "countryCode": "BI",
    "region": "MY",
    "description": "Muyinga"
  },
  {
    "countryCode": "BI",
    "region": "NG",
    "description": "Ngozi"
  },
  {
    "countryCode": "BI",
    "region": "RM",
    "description": "Rumonge"
  },
  {
    "countryCode": "BI",
    "region": "RT",
    "description": "Rutana"
  },
  {
    "countryCode": "BI",
    "region": "RY",
    "description": "Ruyigi"
  },
  {
    "countryCode": "BJ",
    "region": "AK",
    "description": "Atacora"
  },
  {
    "countryCode": "BJ",
    "region": "AL",
    "description": "Alibori"
  },
  {
    "countryCode": "BJ",
    "region": "AQ",
    "description": "Atlantique"
  },
  {
    "countryCode": "BJ",
    "region": "BO",
    "description": "Borgou"
  },
  {
    "countryCode": "BJ",
    "region": "CO",
    "description": "Collines"
  },
  {
    "countryCode": "BJ",
    "region": "DO",
    "description": "Donga"
  },
  {
    "countryCode": "BJ",
    "region": "KO",
    "description": "Couffo"
  },
  {
    "countryCode": "BJ",
    "region": "LI",
    "description": "Littoral"
  },
  {
    "countryCode": "BJ",
    "region": "MO",
    "description": "Mono"
  },
  {
    "countryCode": "BJ",
    "region": "OU",
    "description": "Ou\u00e9m\u00e9"
  },
  {
    "countryCode": "BJ",
    "region": "PL",
    "description": "Plateau"
  },
  {
    "countryCode": "BJ",
    "region": "ZO",
    "description": "Zou"
  },
  {
    "countryCode": "BN",
    "region": "BE",
    "description": "Belait"
  },
  {
    "countryCode": "BN",
    "region": "BM",
    "description": "Brunei-Muara"
  },
  {
    "countryCode": "BN",
    "region": "TE",
    "description": "Temburong"
  },
  {
    "countryCode": "BN",
    "region": "TU",
    "description": "Tutong"
  },
  {
    "countryCode": "BO",
    "region": "B",
    "description": "Beni"
  },
  {
    "countryCode": "BO",
    "region": "C",
    "description": "Cochabamba"
  },
  {
    "countryCode": "BO",
    "region": "H",
    "description": "Chuquisaca"
  },
  {
    "countryCode": "BO",
    "region": "L",
    "description": "La Paz"
  },
  {
    "countryCode": "BO",
    "region": "N",
    "description": "Pando"
  },
  {
    "countryCode": "BO",
    "region": "O",
    "description": "Oruro"
  },
  {
    "countryCode": "BO",
    "region": "P",
    "description": "Potos\u00ed"
  },
  {
    "countryCode": "BO",
    "region": "S",
    "description": "Santa Cruz"
  },
  {
    "countryCode": "BO",
    "region": "T",
    "description": "Tarija"
  },
  {
    "countryCode": "BQ",
    "region": "BO",
    "description": "Bonaire"
  },
  {
    "countryCode": "BQ",
    "region": "SA",
    "description": "Saba"
  },
  {
    "countryCode": "BQ",
    "region": "SE",
    "description": "Sint Eustatius"
  },
  {
    "countryCode": "BR",
    "region": "AC",
    "description": "Acre"
  },
  {
    "countryCode": "BR",
    "region": "AL",
    "description": "Alagoas"
  },
  {
    "countryCode": "BR",
    "region": "AM",
    "description": "Amazon"
  },
  {
    "countryCode": "BR",
    "region": "AP",
    "description": "Amapa"
  },
  {
    "countryCode": "BR",
    "region": "BA",
    "description": "Bahia"
  },
  {
    "countryCode": "BR",
    "region": "CE",
    "description": "Ceara"
  },
  {
    "countryCode": "BR",
    "region": "DF",
    "description": "Brasilia"
  },
  {
    "countryCode": "BR",
    "region": "ES",
    "description": "Espirito Santo"
  },
  {
    "countryCode": "BR",
    "region": "GO",
    "description": "Goias"
  },
  {
    "countryCode": "BR",
    "region": "MA",
    "description": "Maranhao"
  },
  {
    "countryCode": "BR",
    "region": "MG",
    "description": "Minas Gerais"
  },
  {
    "countryCode": "BR",
    "region": "MS",
    "description": "Mato Grosso do Sul"
  },
  {
    "countryCode": "BR",
    "region": "MT",
    "description": "Mato Grosso"
  },
  {
    "countryCode": "BR",
    "region": "PA",
    "description": "Para"
  },
  {
    "countryCode": "BR",
    "region": "PB",
    "description": "Paraiba"
  },
  {
    "countryCode": "BR",
    "region": "PE",
    "description": "Pernambuco"
  },
  {
    "countryCode": "BR",
    "region": "PI",
    "description": "Piaui"
  },
  {
    "countryCode": "BR",
    "region": "PR",
    "description": "Parana"
  },
  {
    "countryCode": "BR",
    "region": "RJ",
    "description": "Rio de Janeiro"
  },
  {
    "countryCode": "BR",
    "region": "RN",
    "description": "Rio Grande do Norte"
  },
  {
    "countryCode": "BR",
    "region": "RO",
    "description": "Rondonia"
  },
  {
    "countryCode": "BR",
    "region": "RR",
    "description": "Roraima"
  },
  {
    "countryCode": "BR",
    "region": "RS",
    "description": "Rio Grande do Sul"
  },
  {
    "countryCode": "BR",
    "region": "SC",
    "description": "Santa Catarina"
  },
  {
    "countryCode": "BR",
    "region": "SE",
    "description": "Sergipe"
  },
  {
    "countryCode": "BR",
    "region": "SP",
    "description": "Sao Paulo"
  },
  {
    "countryCode": "BR",
    "region": "TO",
    "description": "Tocantins"
  },
  {
    "countryCode": "BS",
    "region": "AK",
    "description": "Acklins"
  },
  {
    "countryCode": "BS",
    "region": "BI",
    "description": "Bimini"
  },
  {
    "countryCode": "BS",
    "region": "BP",
    "description": "Black Point"
  },
  {
    "countryCode": "BS",
    "region": "BY",
    "description": "Berry Islands"
  },
  {
    "countryCode": "BS",
    "region": "CE",
    "description": "Central Eleuthera"
  },
  {
    "countryCode": "BS",
    "region": "CI",
    "description": "Cat Island"
  },
  {
    "countryCode": "BS",
    "region": "CK",
    "description": "Crooked Isl.& L. Cay"
  },
  {
    "countryCode": "BS",
    "region": "CO",
    "description": "Central Abaco"
  },
  {
    "countryCode": "BS",
    "region": "CS",
    "description": "Central Andros"
  },
  {
    "countryCode": "BS",
    "region": "EG",
    "description": "East Grand Bahama"
  },
  {
    "countryCode": "BS",
    "region": "EX",
    "description": "Exuma"
  },
  {
    "countryCode": "BS",
    "region": "FP",
    "description": "Freeport"
  },
  {
    "countryCode": "BS",
    "region": "GC",
    "description": "Grand Cay"
  },
  {
    "countryCode": "BS",
    "region": "HI",
    "description": "Harbour Island"
  },
  {
    "countryCode": "BS",
    "region": "HT",
    "description": "Hope Town"
  },
  {
    "countryCode": "BS",
    "region": "IN",
    "description": "Inagua"
  },
  {
    "countryCode": "BS",
    "region": "LI",
    "description": "Long Island"
  },
  {
    "countryCode": "BS",
    "region": "MC",
    "description": "Mangrove Cay"
  },
  {
    "countryCode": "BS",
    "region": "MG",
    "description": "Mayaguana"
  },
  {
    "countryCode": "BS",
    "region": "MI",
    "description": "Moore's Island"
  },
  {
    "countryCode": "BS",
    "region": "NE",
    "description": "North Eleuthera"
  },
  {
    "countryCode": "BS",
    "region": "NO",
    "description": "North Abaco"
  },
  {
    "countryCode": "BS",
    "region": "NP",
    "description": "New Providence"
  },
  {
    "countryCode": "BS",
    "region": "NS",
    "description": "North Andros"
  },
  {
    "countryCode": "BS",
    "region": "RC",
    "description": "Rum Cay"
  },
  {
    "countryCode": "BS",
    "region": "RI",
    "description": "Ragged Island"
  },
  {
    "countryCode": "BS",
    "region": "SA",
    "description": "South Andros"
  },
  {
    "countryCode": "BS",
    "region": "SE",
    "description": "South Eleuthera"
  },
  {
    "countryCode": "BS",
    "region": "SO",
    "description": "South Abaco"
  },
  {
    "countryCode": "BS",
    "region": "SS",
    "description": "San Salvador"
  },
  {
    "countryCode": "BS",
    "region": "SW",
    "description": "Spanish Wells"
  },
  {
    "countryCode": "BS",
    "region": "WG",
    "description": "West Grand Bahama"
  },
  {
    "countryCode": "BT",
    "region": "11",
    "description": "Paro"
  },
  {
    "countryCode": "BT",
    "region": "12",
    "description": "Chhukha"
  },
  {
    "countryCode": "BT",
    "region": "13",
    "description": "Haa"
  },
  {
    "countryCode": "BT",
    "region": "14",
    "description": "Samtse"
  },
  {
    "countryCode": "BT",
    "region": "15",
    "description": "Thimphu"
  },
  {
    "countryCode": "BT",
    "region": "21",
    "description": "Tsirang"
  },
  {
    "countryCode": "BT",
    "region": "22",
    "description": "Dagana"
  },
  {
    "countryCode": "BT",
    "region": "23",
    "description": "Punakha"
  },
  {
    "countryCode": "BT",
    "region": "24",
    "description": "Wangdue Phodrang"
  },
  {
    "countryCode": "BT",
    "region": "31",
    "description": "Sarpang"
  },
  {
    "countryCode": "BT",
    "region": "32",
    "description": "Trongsa"
  },
  {
    "countryCode": "BT",
    "region": "33",
    "description": "Bumthang"
  },
  {
    "countryCode": "BT",
    "region": "34",
    "description": "Zhemgang"
  },
  {
    "countryCode": "BT",
    "region": "41",
    "description": "Trashigang"
  },
  {
    "countryCode": "BT",
    "region": "42",
    "description": "Monggar"
  },
  {
    "countryCode": "BT",
    "region": "43",
    "description": "Pema Gatshel"
  },
  {
    "countryCode": "BT",
    "region": "44",
    "description": "Lhuentse"
  },
  {
    "countryCode": "BT",
    "region": "45",
    "description": "Samdrup Jongkhar"
  },
  {
    "countryCode": "BT",
    "region": "GA",
    "description": "Gasa"
  },
  {
    "countryCode": "BT",
    "region": "TY",
    "description": "Trashi Yangtse"
  },
  {
    "countryCode": "BW",
    "region": "CE",
    "description": "Central"
  },
  {
    "countryCode": "BW",
    "region": "CH",
    "description": "Chobe"
  },
  {
    "countryCode": "BW",
    "region": "FR",
    "description": "Francistown"
  },
  {
    "countryCode": "BW",
    "region": "GA",
    "description": "Gaborone"
  },
  {
    "countryCode": "BW",
    "region": "GH",
    "description": "Ghanzi"
  },
  {
    "countryCode": "BW",
    "region": "JW",
    "description": "Jwaneng"
  },
  {
    "countryCode": "BW",
    "region": "KG",
    "description": "Kgalagadi"
  },
  {
    "countryCode": "BW",
    "region": "KL",
    "description": "Kgatleng"
  },
  {
    "countryCode": "BW",
    "region": "KW",
    "description": "Kweneng"
  },
  {
    "countryCode": "BW",
    "region": "LO",
    "description": "Lobatse"
  },
  {
    "countryCode": "BW",
    "region": "NE",
    "description": "North East"
  },
  {
    "countryCode": "BW",
    "region": "NW",
    "description": "North West"
  },
  {
    "countryCode": "BW",
    "region": "SE",
    "description": "South East"
  },
  {
    "countryCode": "BW",
    "region": "SO",
    "description": "Southern"
  },
  {
    "countryCode": "BW",
    "region": "SP",
    "description": "Selibe Phikwe"
  },
  {
    "countryCode": "BW",
    "region": "ST",
    "description": "Sowa Town"
  },
  {
    "countryCode": "BY",
    "region": "BR",
    "description": "Brest Region"
  },
  {
    "countryCode": "BY",
    "region": "HM",
    "description": "City of Minsk"
  },
  {
    "countryCode": "BY",
    "region": "HO",
    "description": "Gomel Region"
  },
  {
    "countryCode": "BY",
    "region": "HR",
    "description": "Grodno Region"
  },
  {
    "countryCode": "BY",
    "region": "MA",
    "description": "Mogilev Region"
  },
  {
    "countryCode": "BY",
    "region": "MI",
    "description": "Minsk Region"
  },
  {
    "countryCode": "BY",
    "region": "VI",
    "description": "Vitebsk Region"
  },
  {
    "countryCode": "BZ",
    "region": "BZ",
    "description": "Belize"
  },
  {
    "countryCode": "BZ",
    "region": "CY",
    "description": "Cayo"
  },
  {
    "countryCode": "BZ",
    "region": "CZL",
    "description": "Corozal"
  },
  {
    "countryCode": "BZ",
    "region": "OW",
    "description": "Orange Walk"
  },
  {
    "countryCode": "BZ",
    "region": "SC",
    "description": "Stann Creek"
  },
  {
    "countryCode": "BZ",
    "region": "TOL",
    "description": "Toledo"
  },
  {
    "countryCode": "CA",
    "region": "AB",
    "description": "Alberta"
  },
  {
    "countryCode": "CA",
    "region": "BC",
    "description": "British Columbia"
  },
  {
    "countryCode": "CA",
    "region": "MB",
    "description": "Manitoba"
  },
  {
    "countryCode": "CA",
    "region": "NB",
    "description": "New Brunswick"
  },
  {
    "countryCode": "CA",
    "region": "NL",
    "description": "Newfoundland & Labr."
  },
  {
    "countryCode": "CA",
    "region": "NS",
    "description": "Nova Scotia"
  },
  {
    "countryCode": "CA",
    "region": "NT",
    "description": "Northwest Terr."
  },
  {
    "countryCode": "CA",
    "region": "NU",
    "description": "Nunavut"
  },
  {
    "countryCode": "CA",
    "region": "ON",
    "description": "Ontario"
  },
  {
    "countryCode": "CA",
    "region": "PE",
    "description": "Prince Edward Island"
  },
  {
    "countryCode": "CA",
    "region": "QC",
    "description": "Quebec"
  },
  {
    "countryCode": "CA",
    "region": "SK",
    "description": "Saskatchewan"
  },
  {
    "countryCode": "CA",
    "region": "YT",
    "description": "Yukon Territory"
  },
  {
    "countryCode": "CD",
    "region": "BC",
    "description": "Kongo Central"
  },
  {
    "countryCode": "CD",
    "region": "BU",
    "description": "Bas-U\u00e9l\u00e9"
  },
  {
    "countryCode": "CD",
    "region": "EQ",
    "description": "\u00c9quateur"
  },
  {
    "countryCode": "CD",
    "region": "HK",
    "description": "Haut-Katanga"
  },
  {
    "countryCode": "CD",
    "region": "HL",
    "description": "Haut-Lomami"
  },
  {
    "countryCode": "CD",
    "region": "HU",
    "description": "Haut-U\u00e9l\u00e9"
  },
  {
    "countryCode": "CD",
    "region": "IT",
    "description": "Ituri"
  },
  {
    "countryCode": "CD",
    "region": "KC",
    "description": "Kasa\u00ef Central"
  },
  {
    "countryCode": "CD",
    "region": "KE",
    "description": "Kasai-Oriental"
  },
  {
    "countryCode": "CD",
    "region": "KG",
    "description": "Kwango"
  },
  {
    "countryCode": "CD",
    "region": "KL",
    "description": "Kwilu"
  },
  {
    "countryCode": "CD",
    "region": "KN",
    "description": "Kinshasa"
  },
  {
    "countryCode": "CD",
    "region": "KS",
    "description": "Kasa\u00ef"
  },
  {
    "countryCode": "CD",
    "region": "LO",
    "description": "Lomami"
  },
  {
    "countryCode": "CD",
    "region": "LU",
    "description": "Lualaba"
  },
  {
    "countryCode": "CD",
    "region": "MA",
    "description": "Maniema"
  },
  {
    "countryCode": "CD",
    "region": "MN",
    "description": "Mai-Ndombe"
  },
  {
    "countryCode": "CD",
    "region": "MO",
    "description": "Mongala"
  },
  {
    "countryCode": "CD",
    "region": "NK",
    "description": "Nord-Kivu"
  },
  {
    "countryCode": "CD",
    "region": "NU",
    "description": "Nord-Ubangi"
  },
  {
    "countryCode": "CD",
    "region": "SA",
    "description": "Sankuru"
  },
  {
    "countryCode": "CD",
    "region": "SK",
    "description": "Sud-Kivu"
  },
  {
    "countryCode": "CD",
    "region": "SU",
    "description": "Sud-Ubangi"
  },
  {
    "countryCode": "CD",
    "region": "TA",
    "description": "Tanganyika"
  },
  {
    "countryCode": "CD",
    "region": "TO",
    "description": "Tshopo"
  },
  {
    "countryCode": "CD",
    "region": "TU",
    "description": "Tshuapa"
  },
  {
    "countryCode": "CF",
    "region": "AC",
    "description": "Ouham"
  },
  {
    "countryCode": "CF",
    "region": "BB",
    "description": "Bamingui-Bangoran"
  },
  {
    "countryCode": "CF",
    "region": "BGF",
    "description": "Bangui"
  },
  {
    "countryCode": "CF",
    "region": "BK",
    "description": "Basse-Kotto"
  },
  {
    "countryCode": "CF",
    "region": "HK",
    "description": "Haute-Kotto"
  },
  {
    "countryCode": "CF",
    "region": "HM",
    "description": "Haut-Mbomou"
  },
  {
    "countryCode": "CF",
    "region": "HS",
    "description": "Mamb\u00e9r\u00e9-Kad\u00e9\u00ef"
  },
  {
    "countryCode": "CF",
    "region": "KB",
    "description": "Gribingui"
  },
  {
    "countryCode": "CF",
    "region": "KG",
    "description": "K\u00e9mo-Gribingui"
  },
  {
    "countryCode": "CF",
    "region": "LB",
    "description": "Lobaye"
  },
  {
    "countryCode": "CF",
    "region": "MB",
    "description": "Mbomou"
  },
  {
    "countryCode": "CF",
    "region": "MP",
    "description": "Ombella-Mpoko"
  },
  {
    "countryCode": "CF",
    "region": "NM",
    "description": "Nana-Mamb\u00e9r\u00e9"
  },
  {
    "countryCode": "CF",
    "region": "OP",
    "description": "Ouham-Pend\u00e9"
  },
  {
    "countryCode": "CF",
    "region": "SE",
    "description": "Sangha"
  },
  {
    "countryCode": "CF",
    "region": "UK",
    "description": "Ouaka"
  },
  {
    "countryCode": "CF",
    "region": "VK",
    "description": "Vakaga"
  },
  {
    "countryCode": "CG",
    "region": "11",
    "description": "Bouenza"
  },
  {
    "countryCode": "CG",
    "region": "12",
    "description": "Pool"
  },
  {
    "countryCode": "CG",
    "region": "13",
    "description": "Sangha"
  },
  {
    "countryCode": "CG",
    "region": "14",
    "description": "Plateaux"
  },
  {
    "countryCode": "CG",
    "region": "15",
    "description": "Cuvette-Ouest"
  },
  {
    "countryCode": "CG",
    "region": "16",
    "description": "Pointe-Noire"
  },
  {
    "countryCode": "CG",
    "region": "2",
    "description": "L\u00e9koumou"
  },
  {
    "countryCode": "CG",
    "region": "5",
    "description": "Kouilou"
  },
  {
    "countryCode": "CG",
    "region": "7",
    "description": "Likouala"
  },
  {
    "countryCode": "CG",
    "region": "8",
    "description": "Cuvette"
  },
  {
    "countryCode": "CG",
    "region": "9",
    "description": "Niari"
  },
  {
    "countryCode": "CG",
    "region": "BZV",
    "description": "Brazzaville"
  },
  {
    "countryCode": "CH",
    "region": "AG",
    "description": "Aargau"
  },
  {
    "countryCode": "CH",
    "region": "AI",
    "description": "Inner-Rhoden"
  },
  {
    "countryCode": "CH",
    "region": "AR",
    "description": "Ausser-Rhoden"
  },
  {
    "countryCode": "CH",
    "region": "BE",
    "description": "Bern"
  },
  {
    "countryCode": "CH",
    "region": "BL",
    "description": "Basel Land"
  },
  {
    "countryCode": "CH",
    "region": "BS",
    "description": "Basel Stadt"
  },
  {
    "countryCode": "CH",
    "region": "FR",
    "description": "Fribourg"
  },
  {
    "countryCode": "CH",
    "region": "GE",
    "description": "Geneva"
  },
  {
    "countryCode": "CH",
    "region": "GL",
    "description": "Glarus"
  },
  {
    "countryCode": "CH",
    "region": "GR",
    "description": "Graubuenden"
  },
  {
    "countryCode": "CH",
    "region": "JU",
    "description": "Jura"
  },
  {
    "countryCode": "CH",
    "region": "LU",
    "description": "Lucerne"
  },
  {
    "countryCode": "CH",
    "region": "NE",
    "description": "Neuchatel"
  },
  {
    "countryCode": "CH",
    "region": "NW",
    "description": "Nidwalden"
  },
  {
    "countryCode": "CH",
    "region": "OW",
    "description": "Obwalden"
  },
  {
    "countryCode": "CH",
    "region": "SG",
    "description": "St. Gallen"
  },
  {
    "countryCode": "CH",
    "region": "SH",
    "description": "Schaffhausen"
  },
  {
    "countryCode": "CH",
    "region": "SO",
    "description": "Solothurn"
  },
  {
    "countryCode": "CH",
    "region": "SZ",
    "description": "Schwyz"
  },
  {
    "countryCode": "CH",
    "region": "TG",
    "description": "Thurgau"
  },
  {
    "countryCode": "CH",
    "region": "TI",
    "description": "Ticino"
  },
  {
    "countryCode": "CH",
    "region": "UR",
    "description": "Uri"
  },
  {
    "countryCode": "CH",
    "region": "VD",
    "description": "Vaud"
  },
  {
    "countryCode": "CH",
    "region": "VS",
    "description": "Valais"
  },
  {
    "countryCode": "CH",
    "region": "ZG",
    "description": "Zug"
  },
  {
    "countryCode": "CH",
    "region": "ZH",
    "description": "Zurich"
  },
  {
    "countryCode": "CI",
    "region": "AB",
    "description": "Abidjan"
  },
  {
    "countryCode": "CI",
    "region": "BS",
    "description": "Bas-Sassandra"
  },
  {
    "countryCode": "CI",
    "region": "CM",
    "description": "Como\u00e9"
  },
  {
    "countryCode": "CI",
    "region": "DN",
    "description": "Dengu\u00e9l\u00e9"
  },
  {
    "countryCode": "CI",
    "region": "GD",
    "description": "G\u00f4h-Djiboua"
  },
  {
    "countryCode": "CI",
    "region": "LC",
    "description": "Lacs"
  },
  {
    "countryCode": "CI",
    "region": "LG",
    "description": "Lagunes"
  },
  {
    "countryCode": "CI",
    "region": "MG",
    "description": "Montagnes"
  },
  {
    "countryCode": "CI",
    "region": "SM",
    "description": "Sassandra-Marahou\u00e9"
  },
  {
    "countryCode": "CI",
    "region": "SV",
    "description": "Savanes"
  },
  {
    "countryCode": "CI",
    "region": "VB",
    "description": "Vall\u00e9e du Bandama"
  },
  {
    "countryCode": "CI",
    "region": "WR",
    "description": "Woroba"
  },
  {
    "countryCode": "CI",
    "region": "YM",
    "description": "Yamoussoukro"
  },
  {
    "countryCode": "CI",
    "region": "ZZ",
    "description": "Zanzan"
  },
  {
    "countryCode": "CL",
    "region": "AI",
    "description": "Region de Aysen"
  },
  {
    "countryCode": "CL",
    "region": "AN",
    "description": "Antofagasta"
  },
  {
    "countryCode": "CL",
    "region": "AP",
    "description": "Arica y Parinacota"
  },
  {
    "countryCode": "CL",
    "region": "AR",
    "description": "Araucania"
  },
  {
    "countryCode": "CL",
    "region": "AT",
    "description": "Atacama"
  },
  {
    "countryCode": "CL",
    "region": "BI",
    "description": "Bio-Bio"
  },
  {
    "countryCode": "CL",
    "region": "CO",
    "description": "Coquimbo"
  },
  {
    "countryCode": "CL",
    "region": "LI",
    "description": "O'Higgins Region"
  },
  {
    "countryCode": "CL",
    "region": "LL",
    "description": "Los Lagos"
  },
  {
    "countryCode": "CL",
    "region": "LR",
    "description": "Los Rios"
  },
  {
    "countryCode": "CL",
    "region": "MA",
    "description": "Magallanes"
  },
  {
    "countryCode": "CL",
    "region": "ML",
    "description": "Maule"
  },
  {
    "countryCode": "CL",
    "region": "NB",
    "description": "\u00d1uble"
  },
  {
    "countryCode": "CL",
    "region": "RM",
    "description": "Regi\u00f3n Metropolitana"
  },
  {
    "countryCode": "CL",
    "region": "TA",
    "description": "Tarapaca"
  },
  {
    "countryCode": "CL",
    "region": "VS",
    "description": "Valparaiso"
  },
  {
    "countryCode": "CM",
    "region": "AD",
    "description": "Adamaoua"
  },
  {
    "countryCode": "CM",
    "region": "CE",
    "description": "Centre"
  },
  {
    "countryCode": "CM",
    "region": "EN",
    "description": "Far North"
  },
  {
    "countryCode": "CM",
    "region": "ES",
    "description": "East"
  },
  {
    "countryCode": "CM",
    "region": "LT",
    "description": "Littoral"
  },
  {
    "countryCode": "CM",
    "region": "NO",
    "description": "North"
  },
  {
    "countryCode": "CM",
    "region": "NW",
    "description": "North-West"
  },
  {
    "countryCode": "CM",
    "region": "OU",
    "description": "West"
  },
  {
    "countryCode": "CM",
    "region": "SU",
    "description": "South"
  },
  {
    "countryCode": "CM",
    "region": "SW",
    "description": "South-West"
  },
  {
    "countryCode": "CN",
    "region": "AH",
    "description": "Anhui"
  },
  {
    "countryCode": "CN",
    "region": "BJ",
    "description": "Beijing"
  },
  {
    "countryCode": "CN",
    "region": "CQ",
    "description": "Chongqing"
  },
  {
    "countryCode": "CN",
    "region": "FJ",
    "description": "Fujian"
  },
  {
    "countryCode": "CN",
    "region": "GD",
    "description": "Guangdong"
  },
  {
    "countryCode": "CN",
    "region": "GS",
    "description": "Gansu"
  },
  {
    "countryCode": "CN",
    "region": "GX",
    "description": "Guangxi"
  },
  {
    "countryCode": "CN",
    "region": "GZ",
    "description": "Guizhou"
  },
  {
    "countryCode": "CN",
    "region": "HA",
    "description": "Henan"
  },
  {
    "countryCode": "CN",
    "region": "HB",
    "description": "Hubei"
  },
  {
    "countryCode": "CN",
    "region": "HE",
    "description": "Hebei"
  },
  {
    "countryCode": "CN",
    "region": "HI",
    "description": "Hainan"
  },
  {
    "countryCode": "CN",
    "region": "HK",
    "description": "Hong Kong"
  },
  {
    "countryCode": "CN",
    "region": "HL",
    "description": "Heilongjiang"
  },
  {
    "countryCode": "CN",
    "region": "HN",
    "description": "Hunan"
  },
  {
    "countryCode": "CN",
    "region": "JL",
    "description": "Jilin"
  },
  {
    "countryCode": "CN",
    "region": "JS",
    "description": "Jiangsu"
  },
  {
    "countryCode": "CN",
    "region": "JX",
    "description": "Jiangxi"
  },
  {
    "countryCode": "CN",
    "region": "LN",
    "description": "Liaoning"
  },
  {
    "countryCode": "CN",
    "region": "MO",
    "description": "Macao"
  },
  {
    "countryCode": "CN",
    "region": "NM",
    "description": "Nei Mongol"
  },
  {
    "countryCode": "CN",
    "region": "NX",
    "description": "Ningxia Huizu Zizhiq"
  },
  {
    "countryCode": "CN",
    "region": "QH",
    "description": "Qinghai"
  },
  {
    "countryCode": "CN",
    "region": "SC",
    "description": "Sichuan"
  },
  {
    "countryCode": "CN",
    "region": "SD",
    "description": "Shandong"
  },
  {
    "countryCode": "CN",
    "region": "SH",
    "description": "Shanghai"
  },
  {
    "countryCode": "CN",
    "region": "SN",
    "description": "Shaanxi"
  },
  {
    "countryCode": "CN",
    "region": "SX",
    "description": "Shanxi"
  },
  {
    "countryCode": "CN",
    "region": "TJ",
    "description": "Tianjin"
  },
  {
    "countryCode": "CN",
    "region": "XJ",
    "description": "Xinjiang"
  },
  {
    "countryCode": "CN",
    "region": "XZ",
    "description": "Xizang"
  },
  {
    "countryCode": "CN",
    "region": "YN",
    "description": "Yunnan"
  },
  {
    "countryCode": "CN",
    "region": "ZJ",
    "description": "Zhejiang"
  },
  {
    "countryCode": "CO",
    "region": "05",
    "description": "Antioquia"
  },
  {
    "countryCode": "CO",
    "region": "08",
    "description": "Atlantico"
  },
  {
    "countryCode": "CO",
    "region": "11",
    "description": "Bogota"
  },
  {
    "countryCode": "CO",
    "region": "13",
    "description": "Bolivar"
  },
  {
    "countryCode": "CO",
    "region": "15",
    "description": "Boyaca"
  },
  {
    "countryCode": "CO",
    "region": "17",
    "description": "Caldas"
  },
  {
    "countryCode": "CO",
    "region": "18",
    "description": "Caqueta"
  },
  {
    "countryCode": "CO",
    "region": "19",
    "description": "Cauca"
  },
  {
    "countryCode": "CO",
    "region": "20",
    "description": "Cesar"
  },
  {
    "countryCode": "CO",
    "region": "23",
    "description": "Cordoba"
  },
  {
    "countryCode": "CO",
    "region": "25",
    "description": "Cundinamarca"
  },
  {
    "countryCode": "CO",
    "region": "27",
    "description": "Choco"
  },
  {
    "countryCode": "CO",
    "region": "41",
    "description": "Huila"
  },
  {
    "countryCode": "CO",
    "region": "44",
    "description": "La Guajira"
  },
  {
    "countryCode": "CO",
    "region": "47",
    "description": "Magdalena"
  },
  {
    "countryCode": "CO",
    "region": "50",
    "description": "Meta"
  },
  {
    "countryCode": "CO",
    "region": "52",
    "description": "Narino"
  },
  {
    "countryCode": "CO",
    "region": "54",
    "description": "Norte de Santander"
  },
  {
    "countryCode": "CO",
    "region": "63",
    "description": "Quindio"
  },
  {
    "countryCode": "CO",
    "region": "66",
    "description": "Risaralda"
  },
  {
    "countryCode": "CO",
    "region": "68",
    "description": "Santander"
  },
  {
    "countryCode": "CO",
    "region": "70",
    "description": "Sucre"
  },
  {
    "countryCode": "CO",
    "region": "73",
    "description": "Tolima"
  },
  {
    "countryCode": "CO",
    "region": "76",
    "description": "Valle del Cauca"
  },
  {
    "countryCode": "CO",
    "region": "81",
    "description": "Arauca"
  },
  {
    "countryCode": "CO",
    "region": "85",
    "description": "Casanare"
  },
  {
    "countryCode": "CO",
    "region": "86",
    "description": "Putumayo"
  },
  {
    "countryCode": "CO",
    "region": "88",
    "description": "San Andres"
  },
  {
    "countryCode": "CO",
    "region": "91",
    "description": "Amazonas"
  },
  {
    "countryCode": "CO",
    "region": "94",
    "description": "Guania"
  },
  {
    "countryCode": "CO",
    "region": "95",
    "description": "Guaviare"
  },
  {
    "countryCode": "CO",
    "region": "97",
    "description": "Vaupes"
  },
  {
    "countryCode": "CO",
    "region": "99",
    "description": "Vichada"
  },
  {
    "countryCode": "CR",
    "region": "A",
    "description": "Alajuela"
  },
  {
    "countryCode": "CR",
    "region": "C",
    "description": "Cartago"
  },
  {
    "countryCode": "CR",
    "region": "G",
    "description": "Guanacaste"
  },
  {
    "countryCode": "CR",
    "region": "H",
    "description": "Heredia"
  },
  {
    "countryCode": "CR",
    "region": "L",
    "description": "Lim\u00f3n"
  },
  {
    "countryCode": "CR",
    "region": "P",
    "description": "Puntarenas"
  },
  {
    "countryCode": "CR",
    "region": "SJ",
    "description": "San Jos\u00e9"
  },
  {
    "countryCode": "CU",
    "region": "01",
    "description": "Pinar del R\u00edo"
  },
  {
    "countryCode": "CU",
    "region": "03",
    "description": "La Habana"
  },
  {
    "countryCode": "CU",
    "region": "04",
    "description": "Matanzas"
  },
  {
    "countryCode": "CU",
    "region": "05",
    "description": "Villa Clara"
  },
  {
    "countryCode": "CU",
    "region": "06",
    "description": "Cienfuegos"
  },
  {
    "countryCode": "CU",
    "region": "07",
    "description": "Sancti Sp\u00edritus"
  },
  {
    "countryCode": "CU",
    "region": "08",
    "description": "Ciego de \u00c1vila"
  },
  {
    "countryCode": "CU",
    "region": "09",
    "description": "Camag\u00fcey"
  },
  {
    "countryCode": "CU",
    "region": "10",
    "description": "Las Tunas"
  },
  {
    "countryCode": "CU",
    "region": "11",
    "description": "Holgu\u00edn"
  },
  {
    "countryCode": "CU",
    "region": "12",
    "description": "Granma"
  },
  {
    "countryCode": "CU",
    "region": "13",
    "description": "Santiago de Cuba"
  },
  {
    "countryCode": "CU",
    "region": "14",
    "description": "Guant\u00e1namo"
  },
  {
    "countryCode": "CU",
    "region": "15",
    "description": "Artemisa"
  },
  {
    "countryCode": "CU",
    "region": "16",
    "description": "Mayabeque"
  },
  {
    "countryCode": "CU",
    "region": "99",
    "description": "Isla de la Juventud"
  },
  {
    "countryCode": "CV",
    "region": "BR",
    "description": "Brava"
  },
  {
    "countryCode": "CV",
    "region": "BV",
    "description": "Boa Vista"
  },
  {
    "countryCode": "CV",
    "region": "CA",
    "description": "Santa Catarina"
  },
  {
    "countryCode": "CV",
    "region": "CF",
    "description": "St Catarina do Fogo"
  },
  {
    "countryCode": "CV",
    "region": "CR",
    "description": "Santa Cruz"
  },
  {
    "countryCode": "CV",
    "region": "MA",
    "description": "Maio"
  },
  {
    "countryCode": "CV",
    "region": "MO",
    "description": "Mosteiros"
  },
  {
    "countryCode": "CV",
    "region": "PA",
    "description": "Paul"
  },
  {
    "countryCode": "CV",
    "region": "PN",
    "description": "Porto Novo"
  },
  {
    "countryCode": "CV",
    "region": "PR",
    "description": "Praia"
  },
  {
    "countryCode": "CV",
    "region": "RB",
    "description": "Ribeira Brava"
  },
  {
    "countryCode": "CV",
    "region": "RG",
    "description": "Ribeira Grande"
  },
  {
    "countryCode": "CV",
    "region": "RS",
    "description": "Ribeira Gr. Santiago"
  },
  {
    "countryCode": "CV",
    "region": "SD",
    "description": "S\u00e3o Domingos"
  },
  {
    "countryCode": "CV",
    "region": "SF",
    "description": "S\u00e3o Filipe"
  },
  {
    "countryCode": "CV",
    "region": "SL",
    "description": "Sal"
  },
  {
    "countryCode": "CV",
    "region": "SM",
    "description": "S\u00e3o Miguel"
  },
  {
    "countryCode": "CV",
    "region": "SO",
    "description": "S\u00e3o Louren\u00e7o \u00d3rg\u00e3os"
  },
  {
    "countryCode": "CV",
    "region": "SS",
    "description": "S\u00e3o Salvador Mundo"
  },
  {
    "countryCode": "CV",
    "region": "SV",
    "description": "S\u00e3o Vicente"
  },
  {
    "countryCode": "CV",
    "region": "TA",
    "description": "Tarrafal"
  },
  {
    "countryCode": "CV",
    "region": "TS",
    "description": "Tarrafal S\u00e3o Nicolau"
  },
  {
    "countryCode": "CY",
    "region": "01",
    "description": "Nicosia"
  },
  {
    "countryCode": "CY",
    "region": "02",
    "description": "Limassol"
  },
  {
    "countryCode": "CY",
    "region": "03",
    "description": "Larnaca"
  },
  {
    "countryCode": "CY",
    "region": "04",
    "description": "Famagusta"
  },
  {
    "countryCode": "CY",
    "region": "05",
    "description": "Paphos"
  },
  {
    "countryCode": "CY",
    "region": "06",
    "description": "Kyrenia"
  },
  {
    "countryCode": "CZ",
    "region": "10",
    "description": "Praha"
  },
  {
    "countryCode": "CZ",
    "region": "20",
    "description": "Stredocesky"
  },
  {
    "countryCode": "CZ",
    "region": "31",
    "description": "Jihocesky"
  },
  {
    "countryCode": "CZ",
    "region": "32",
    "description": "Plzensky"
  },
  {
    "countryCode": "CZ",
    "region": "41",
    "description": "Karlovarsky"
  },
  {
    "countryCode": "CZ",
    "region": "42",
    "description": "Ustecky"
  },
  {
    "countryCode": "CZ",
    "region": "51",
    "description": "Liberecky"
  },
  {
    "countryCode": "CZ",
    "region": "52",
    "description": "Kralovehradecky"
  },
  {
    "countryCode": "CZ",
    "region": "53",
    "description": "Pardubicky"
  },
  {
    "countryCode": "CZ",
    "region": "63",
    "description": "Vysocina"
  },
  {
    "countryCode": "CZ",
    "region": "64",
    "description": "Jihomoravsky"
  },
  {
    "countryCode": "CZ",
    "region": "71",
    "description": "Olomoucky"
  },
  {
    "countryCode": "CZ",
    "region": "72",
    "description": "Zlinsky"
  },
  {
    "countryCode": "CZ",
    "region": "80",
    "description": "Moravskoslezsky"
  },
  {
    "countryCode": "DE",
    "region": "BB",
    "description": "Brandenburg"
  },
  {
    "countryCode": "DE",
    "region": "BE",
    "description": "Berlin"
  },
  {
    "countryCode": "DE",
    "region": "BW",
    "description": "Baden-Wuerttemberg"
  },
  {
    "countryCode": "DE",
    "region": "BY",
    "description": "Bavaria"
  },
  {
    "countryCode": "DE",
    "region": "HB",
    "description": "Bremen"
  },
  {
    "countryCode": "DE",
    "region": "HE",
    "description": "Hessen"
  },
  {
    "countryCode": "DE",
    "region": "HH",
    "description": "Hamburg"
  },
  {
    "countryCode": "DE",
    "region": "MV",
    "description": "Mecklenburg-Vorpomm."
  },
  {
    "countryCode": "DE",
    "region": "NI",
    "description": "Lower Saxony"
  },
  {
    "countryCode": "DE",
    "region": "NW",
    "description": "Nrth Rhine Westfalia"
  },
  {
    "countryCode": "DE",
    "region": "RP",
    "description": "Rhineland Palatinate"
  },
  {
    "countryCode": "DE",
    "region": "SH",
    "description": "Schleswig-Holstein"
  },
  {
    "countryCode": "DE",
    "region": "SL",
    "description": "Saarland"
  },
  {
    "countryCode": "DE",
    "region": "SN",
    "description": "Saxony"
  },
  {
    "countryCode": "DE",
    "region": "ST",
    "description": "Saxony-Anhalt"
  },
  {
    "countryCode": "DE",
    "region": "TH",
    "description": "Thuringia"
  },
  {
    "countryCode": "DJ",
    "region": "AR",
    "description": "Arta"
  },
  {
    "countryCode": "DJ",
    "region": "AS",
    "description": "Ali Sabieh"
  },
  {
    "countryCode": "DJ",
    "region": "DI",
    "description": "Dikhil"
  },
  {
    "countryCode": "DJ",
    "region": "DJ",
    "description": "Djibouti"
  },
  {
    "countryCode": "DJ",
    "region": "OB",
    "description": "Obock"
  },
  {
    "countryCode": "DJ",
    "region": "TA",
    "description": "Tadjourah"
  },
  {
    "countryCode": "DK",
    "region": "81",
    "description": "North Denmark"
  },
  {
    "countryCode": "DK",
    "region": "82",
    "description": "Central Denmark"
  },
  {
    "countryCode": "DK",
    "region": "83",
    "description": "South Denmark"
  },
  {
    "countryCode": "DK",
    "region": "84",
    "description": "Danish Capital Reg."
  },
  {
    "countryCode": "DK",
    "region": "85",
    "description": "Zealand"
  },
  {
    "countryCode": "DM",
    "region": "02",
    "description": "Saint Andrew"
  },
  {
    "countryCode": "DM",
    "region": "03",
    "description": "Saint David"
  },
  {
    "countryCode": "DM",
    "region": "04",
    "description": "Saint George"
  },
  {
    "countryCode": "DM",
    "region": "05",
    "description": "Saint John"
  },
  {
    "countryCode": "DM",
    "region": "06",
    "description": "Saint Joseph"
  },
  {
    "countryCode": "DM",
    "region": "07",
    "description": "Saint Luke"
  },
  {
    "countryCode": "DM",
    "region": "08",
    "description": "Saint Mark"
  },
  {
    "countryCode": "DM",
    "region": "09",
    "description": "Saint Patrick"
  },
  {
    "countryCode": "DM",
    "region": "10",
    "description": "Saint Paul"
  },
  {
    "countryCode": "DM",
    "region": "11",
    "description": "Saint Peter"
  },
  {
    "countryCode": "DO",
    "region": "01",
    "description": "Distrito Nacional"
  },
  {
    "countryCode": "DO",
    "region": "02",
    "description": "Azua"
  },
  {
    "countryCode": "DO",
    "region": "03",
    "description": "Baoruco"
  },
  {
    "countryCode": "DO",
    "region": "04",
    "description": "Barahona"
  },
  {
    "countryCode": "DO",
    "region": "05",
    "description": "Dajab\u00f3n"
  },
  {
    "countryCode": "DO",
    "region": "06",
    "description": "Duarte"
  },
  {
    "countryCode": "DO",
    "region": "07",
    "description": "El\u00edas Pi\u00f1a"
  },
  {
    "countryCode": "DO",
    "region": "08",
    "description": "El Seibo"
  },
  {
    "countryCode": "DO",
    "region": "09",
    "description": "Espaillat"
  },
  {
    "countryCode": "DO",
    "region": "10",
    "description": "Independencia"
  },
  {
    "countryCode": "DO",
    "region": "11",
    "description": "La Altagracia"
  },
  {
    "countryCode": "DO",
    "region": "12",
    "description": "La Romana"
  },
  {
    "countryCode": "DO",
    "region": "13",
    "description": "La Vega"
  },
  {
    "countryCode": "DO",
    "region": "14",
    "description": "Mar\u00eda Trinidad S\u00e1nch"
  },
  {
    "countryCode": "DO",
    "region": "15",
    "description": "Monte Cristi"
  },
  {
    "countryCode": "DO",
    "region": "16",
    "description": "Pedernales"
  },
  {
    "countryCode": "DO",
    "region": "17",
    "description": "Peravia"
  },
  {
    "countryCode": "DO",
    "region": "18",
    "description": "Puerto Plata"
  },
  {
    "countryCode": "DO",
    "region": "19",
    "description": "Hermanas Mirabal"
  },
  {
    "countryCode": "DO",
    "region": "20",
    "description": "Saman\u00e1"
  },
  {
    "countryCode": "DO",
    "region": "21",
    "description": "San Crist\u00f3bal"
  },
  {
    "countryCode": "DO",
    "region": "22",
    "description": "San Juan"
  },
  {
    "countryCode": "DO",
    "region": "23",
    "description": "San Pedro de Macor\u00eds"
  },
  {
    "countryCode": "DO",
    "region": "24",
    "description": "S\u00e1nchez Ram\u00edrez"
  },
  {
    "countryCode": "DO",
    "region": "25",
    "description": "Santiago"
  },
  {
    "countryCode": "DO",
    "region": "26",
    "description": "Santiago Rodr\u00edguez"
  },
  {
    "countryCode": "DO",
    "region": "27",
    "description": "Valverde"
  },
  {
    "countryCode": "DO",
    "region": "28",
    "description": "Monse\u00f1or Nouel"
  },
  {
    "countryCode": "DO",
    "region": "29",
    "description": "Monte Plata"
  },
  {
    "countryCode": "DO",
    "region": "30",
    "description": "Hato Mayor"
  },
  {
    "countryCode": "DO",
    "region": "31",
    "description": "San Jos\u00e9 de Ocoa"
  },
  {
    "countryCode": "DO",
    "region": "32",
    "description": "Santo Domingo"
  },
  {
    "countryCode": "DZ",
    "region": "01",
    "description": "Adrar"
  },
  {
    "countryCode": "DZ",
    "region": "02",
    "description": "Chlef"
  },
  {
    "countryCode": "DZ",
    "region": "03",
    "description": "Laghouat"
  },
  {
    "countryCode": "DZ",
    "region": "04",
    "description": "Oum el Bouaghi"
  },
  {
    "countryCode": "DZ",
    "region": "05",
    "description": "Batna"
  },
  {
    "countryCode": "DZ",
    "region": "06",
    "description": "Bejaia"
  },
  {
    "countryCode": "DZ",
    "region": "07",
    "description": "Biskra"
  },
  {
    "countryCode": "DZ",
    "region": "08",
    "description": "Bechar"
  },
  {
    "countryCode": "DZ",
    "region": "09",
    "description": "Blida"
  },
  {
    "countryCode": "DZ",
    "region": "10",
    "description": "Bouira"
  },
  {
    "countryCode": "DZ",
    "region": "11",
    "description": "Tamanrasset"
  },
  {
    "countryCode": "DZ",
    "region": "12",
    "description": "Tebessa"
  },
  {
    "countryCode": "DZ",
    "region": "13",
    "description": "Tlemcen"
  },
  {
    "countryCode": "DZ",
    "region": "14",
    "description": "Tiaret"
  },
  {
    "countryCode": "DZ",
    "region": "15",
    "description": "Tizi Ouzou"
  },
  {
    "countryCode": "DZ",
    "region": "16",
    "description": "Algier"
  },
  {
    "countryCode": "DZ",
    "region": "17",
    "description": "Djelfa"
  },
  {
    "countryCode": "DZ",
    "region": "18",
    "description": "Jijel"
  },
  {
    "countryCode": "DZ",
    "region": "19",
    "description": "Setif"
  },
  {
    "countryCode": "DZ",
    "region": "20",
    "description": "Saida"
  },
  {
    "countryCode": "DZ",
    "region": "21",
    "description": "Skikda"
  },
  {
    "countryCode": "DZ",
    "region": "22",
    "description": "Sidi Bel Abb\u00e8s"
  },
  {
    "countryCode": "DZ",
    "region": "23",
    "description": "Annaba"
  },
  {
    "countryCode": "DZ",
    "region": "24",
    "description": "Guelma"
  },
  {
    "countryCode": "DZ",
    "region": "25",
    "description": "Constantine"
  },
  {
    "countryCode": "DZ",
    "region": "26",
    "description": "Medea"
  },
  {
    "countryCode": "DZ",
    "region": "27",
    "description": "Mostaganem"
  },
  {
    "countryCode": "DZ",
    "region": "28",
    "description": "M'Sila"
  },
  {
    "countryCode": "DZ",
    "region": "29",
    "description": "Muaskar"
  },
  {
    "countryCode": "DZ",
    "region": "30",
    "description": "Ouargla"
  },
  {
    "countryCode": "DZ",
    "region": "31",
    "description": "Oran"
  },
  {
    "countryCode": "DZ",
    "region": "32",
    "description": "El Bayadh"
  },
  {
    "countryCode": "DZ",
    "region": "33",
    "description": "Illizi"
  },
  {
    "countryCode": "DZ",
    "region": "34",
    "description": "Bordj Bou Arreridj"
  },
  {
    "countryCode": "DZ",
    "region": "35",
    "description": "Boumerdes"
  },
  {
    "countryCode": "DZ",
    "region": "36",
    "description": "El Tarf"
  },
  {
    "countryCode": "DZ",
    "region": "37",
    "description": "Tindouf"
  },
  {
    "countryCode": "DZ",
    "region": "38",
    "description": "Tissemsilt"
  },
  {
    "countryCode": "DZ",
    "region": "39",
    "description": "El Oued"
  },
  {
    "countryCode": "DZ",
    "region": "40",
    "description": "Khenchela"
  },
  {
    "countryCode": "DZ",
    "region": "41",
    "description": "Souk Ahras"
  },
  {
    "countryCode": "DZ",
    "region": "42",
    "description": "Tipaza"
  },
  {
    "countryCode": "DZ",
    "region": "43",
    "description": "Mila"
  },
  {
    "countryCode": "DZ",
    "region": "44",
    "description": "Ain Defla"
  },
  {
    "countryCode": "DZ",
    "region": "45",
    "description": "Naama"
  },
  {
    "countryCode": "DZ",
    "region": "46",
    "description": "Ain Temouchent"
  },
  {
    "countryCode": "DZ",
    "region": "47",
    "description": "Ghardaia"
  },
  {
    "countryCode": "DZ",
    "region": "48",
    "description": "Relizane"
  },
  {
    "countryCode": "DZ",
    "region": "49",
    "description": "Timimoun"
  },
  {
    "countryCode": "DZ",
    "region": "50",
    "description": "Bordj Badji Mokhtar"
  },
  {
    "countryCode": "DZ",
    "region": "51",
    "description": "Ouled Djellal"
  },
  {
    "countryCode": "DZ",
    "region": "52",
    "description": "B\u00e9ni Abb\u00e8s"
  },
  {
    "countryCode": "DZ",
    "region": "53",
    "description": "In Salah"
  },
  {
    "countryCode": "DZ",
    "region": "54",
    "description": "In Guezzam"
  },
  {
    "countryCode": "DZ",
    "region": "55",
    "description": "Touggourt"
  },
  {
    "countryCode": "DZ",
    "region": "56",
    "description": "Djanet"
  },
  {
    "countryCode": "DZ",
    "region": "57",
    "description": "El Meghaier"
  },
  {
    "countryCode": "DZ",
    "region": "58",
    "description": "El Meniaa"
  },
  {
    "countryCode": "EC",
    "region": "A",
    "description": "Azuay"
  },
  {
    "countryCode": "EC",
    "region": "B",
    "description": "Bol\u00edvar"
  },
  {
    "countryCode": "EC",
    "region": "C",
    "description": "Carchi"
  },
  {
    "countryCode": "EC",
    "region": "D",
    "description": "Orellana"
  },
  {
    "countryCode": "EC",
    "region": "E",
    "description": "Esmeraldas"
  },
  {
    "countryCode": "EC",
    "region": "F",
    "description": "Ca\u00f1ar"
  },
  {
    "countryCode": "EC",
    "region": "G",
    "description": "Guayas"
  },
  {
    "countryCode": "EC",
    "region": "H",
    "description": "Chimborazo"
  },
  {
    "countryCode": "EC",
    "region": "I",
    "description": "Imbabura"
  },
  {
    "countryCode": "EC",
    "region": "L",
    "description": "Loja"
  },
  {
    "countryCode": "EC",
    "region": "M",
    "description": "Manab\u00ed"
  },
  {
    "countryCode": "EC",
    "region": "N",
    "description": "Napo"
  },
  {
    "countryCode": "EC",
    "region": "O",
    "description": "El Oro"
  },
  {
    "countryCode": "EC",
    "region": "P",
    "description": "Pinchicha"
  },
  {
    "countryCode": "EC",
    "region": "R",
    "description": "Los R\u00edos"
  },
  {
    "countryCode": "EC",
    "region": "S",
    "description": "Morona Santiago"
  },
  {
    "countryCode": "EC",
    "region": "SD",
    "description": "St Domingo Ts\u00e1chilas"
  },
  {
    "countryCode": "EC",
    "region": "SE",
    "description": "Santa Elena"
  },
  {
    "countryCode": "EC",
    "region": "T",
    "description": "Tungurahua"
  },
  {
    "countryCode": "EC",
    "region": "U",
    "description": "Sucumb\u00edos"
  },
  {
    "countryCode": "EC",
    "region": "W",
    "description": "Gal\u00e1pagos"
  },
  {
    "countryCode": "EC",
    "region": "X",
    "description": "Cotopaxi"
  },
  {
    "countryCode": "EC",
    "region": "Y",
    "description": "Pastaza"
  },
  {
    "countryCode": "EC",
    "region": "Z",
    "description": "Zamora Chinchipe"
  },
  {
    "countryCode": "EE",
    "region": "37",
    "description": "Harju"
  },
  {
    "countryCode": "EE",
    "region": "39",
    "description": "Hiiu"
  },
  {
    "countryCode": "EE",
    "region": "44",
    "description": "Obsolete"
  },
  {
    "countryCode": "EE",
    "region": "45",
    "description": "Ida-Viru"
  },
  {
    "countryCode": "EE",
    "region": "49",
    "description": "Obsolete"
  },
  {
    "countryCode": "EE",
    "region": "50",
    "description": "J\u00f5geva"
  },
  {
    "countryCode": "EE",
    "region": "51",
    "description": "Obsolete"
  },
  {
    "countryCode": "EE",
    "region": "52",
    "description": "J\u00e4rva"
  },
  {
    "countryCode": "EE",
    "region": "56",
    "description": "L\u00e4\u00e4ne"
  },
  {
    "countryCode": "EE",
    "region": "57",
    "description": "Obsolete"
  },
  {
    "countryCode": "EE",
    "region": "59",
    "description": "Obsolete"
  },
  {
    "countryCode": "EE",
    "region": "60",
    "description": "L\u00e4\u00e4ne-Viru"
  },
  {
    "countryCode": "EE",
    "region": "64",
    "description": "P\u00f5lva"
  },
  {
    "countryCode": "EE",
    "region": "65",
    "description": "Obsolete"
  },
  {
    "countryCode": "EE",
    "region": "67",
    "description": "Obsolete"
  },
  {
    "countryCode": "EE",
    "region": "68",
    "description": "P\u00e4rnu"
  },
  {
    "countryCode": "EE",
    "region": "70",
    "description": "Obsolete"
  },
  {
    "countryCode": "EE",
    "region": "71",
    "description": "Rapla"
  },
  {
    "countryCode": "EE",
    "region": "74",
    "description": "Saare"
  },
  {
    "countryCode": "EE",
    "region": "78",
    "description": "Obsolete"
  },
  {
    "countryCode": "EE",
    "region": "79",
    "description": "Tartu"
  },
  {
    "countryCode": "EE",
    "region": "81",
    "description": "Valga"
  },
  {
    "countryCode": "EE",
    "region": "82",
    "description": "Obsolete"
  },
  {
    "countryCode": "EE",
    "region": "84",
    "description": "Viljandi"
  },
  {
    "countryCode": "EE",
    "region": "86",
    "description": "Obsolete"
  },
  {
    "countryCode": "EE",
    "region": "87",
    "description": "V\u00f5ru"
  },
  {
    "countryCode": "EG",
    "region": "ALX",
    "description": "Alexandria"
  },
  {
    "countryCode": "EG",
    "region": "ASN",
    "description": "Aswan"
  },
  {
    "countryCode": "EG",
    "region": "AST",
    "description": "Asyut"
  },
  {
    "countryCode": "EG",
    "region": "BA",
    "description": "Red Sea"
  },
  {
    "countryCode": "EG",
    "region": "BH",
    "description": "Beheira"
  },
  {
    "countryCode": "EG",
    "region": "BNS",
    "description": "Beni Suef"
  },
  {
    "countryCode": "EG",
    "region": "C",
    "description": "Cairo"
  },
  {
    "countryCode": "EG",
    "region": "DK",
    "description": "Dakahlia"
  },
  {
    "countryCode": "EG",
    "region": "DT",
    "description": "Damietta"
  },
  {
    "countryCode": "EG",
    "region": "FYM",
    "description": "Faiyum"
  },
  {
    "countryCode": "EG",
    "region": "GH",
    "description": "Gharbia"
  },
  {
    "countryCode": "EG",
    "region": "GZ",
    "description": "Giza"
  },
  {
    "countryCode": "EG",
    "region": "IS",
    "description": "Ismailia"
  },
  {
    "countryCode": "EG",
    "region": "JS",
    "description": "South Sinai"
  },
  {
    "countryCode": "EG",
    "region": "KB",
    "description": "Qalyubia"
  },
  {
    "countryCode": "EG",
    "region": "KFS",
    "description": "Kafr el-Sheikh"
  },
  {
    "countryCode": "EG",
    "region": "KN",
    "description": "Qena"
  },
  {
    "countryCode": "EG",
    "region": "LX",
    "description": "Luxor"
  },
  {
    "countryCode": "EG",
    "region": "MN",
    "description": "Minya"
  },
  {
    "countryCode": "EG",
    "region": "MNF",
    "description": "Monufia"
  },
  {
    "countryCode": "EG",
    "region": "MT",
    "description": "Matrouh"
  },
  {
    "countryCode": "EG",
    "region": "PTS",
    "description": "Port Said"
  },
  {
    "countryCode": "EG",
    "region": "SHG",
    "description": "Sohag"
  },
  {
    "countryCode": "EG",
    "region": "SHR",
    "description": "Al Sharqia"
  },
  {
    "countryCode": "EG",
    "region": "SIN",
    "description": "North Sinai"
  },
  {
    "countryCode": "EG",
    "region": "SUZ",
    "description": "Suez"
  },
  {
    "countryCode": "EG",
    "region": "WAD",
    "description": "New Valley"
  },
  {
    "countryCode": "ER",
    "region": "AN",
    "description": "Anseba"
  },
  {
    "countryCode": "ER",
    "region": "DK",
    "description": "Southern Red Sea"
  },
  {
    "countryCode": "ER",
    "region": "DU",
    "description": "Debub"
  },
  {
    "countryCode": "ER",
    "region": "GB",
    "description": "Gash-Barka"
  },
  {
    "countryCode": "ER",
    "region": "MA",
    "description": "Maekel"
  },
  {
    "countryCode": "ER",
    "region": "SK",
    "description": "Northern Red Sea"
  },
  {
    "countryCode": "ES",
    "region": "01",
    "description": "Alava"
  },
  {
    "countryCode": "ES",
    "region": "02",
    "description": "Albacete"
  },
  {
    "countryCode": "ES",
    "region": "03",
    "description": "Alicante"
  },
  {
    "countryCode": "ES",
    "region": "04",
    "description": "Almeria"
  },
  {
    "countryCode": "ES",
    "region": "05",
    "description": "Avila"
  },
  {
    "countryCode": "ES",
    "region": "06",
    "description": "Badajoz"
  },
  {
    "countryCode": "ES",
    "region": "07",
    "description": "Baleares"
  },
  {
    "countryCode": "ES",
    "region": "08",
    "description": "Barcelona"
  },
  {
    "countryCode": "ES",
    "region": "09",
    "description": "Burgos"
  },
  {
    "countryCode": "ES",
    "region": "10",
    "description": "Caceres"
  },
  {
    "countryCode": "ES",
    "region": "11",
    "description": "Cadiz"
  },
  {
    "countryCode": "ES",
    "region": "12",
    "description": "Castellon"
  },
  {
    "countryCode": "ES",
    "region": "13",
    "description": "Ciudad Real"
  },
  {
    "countryCode": "ES",
    "region": "14",
    "description": "Cordoba"
  },
  {
    "countryCode": "ES",
    "region": "15",
    "description": "La Coruna"
  },
  {
    "countryCode": "ES",
    "region": "16",
    "description": "Cuenca"
  },
  {
    "countryCode": "ES",
    "region": "17",
    "description": "Gerona"
  },
  {
    "countryCode": "ES",
    "region": "18",
    "description": "Granada"
  },
  {
    "countryCode": "ES",
    "region": "19",
    "description": "Guadalajara"
  },
  {
    "countryCode": "ES",
    "region": "20",
    "description": "Guipuzcoa"
  },
  {
    "countryCode": "ES",
    "region": "21",
    "description": "Huelva"
  },
  {
    "countryCode": "ES",
    "region": "22",
    "description": "Huesca"
  },
  {
    "countryCode": "ES",
    "region": "23",
    "description": "Jaen"
  },
  {
    "countryCode": "ES",
    "region": "24",
    "description": "Leon"
  },
  {
    "countryCode": "ES",
    "region": "25",
    "description": "Lerida"
  },
  {
    "countryCode": "ES",
    "region": "26",
    "description": "La Rioja"
  },
  {
    "countryCode": "ES",
    "region": "27",
    "description": "Lugo"
  },
  {
    "countryCode": "ES",
    "region": "28",
    "description": "Madrid"
  },
  {
    "countryCode": "ES",
    "region": "29",
    "description": "Malaga"
  },
  {
    "countryCode": "ES",
    "region": "30",
    "description": "Murcia"
  },
  {
    "countryCode": "ES",
    "region": "31",
    "description": "Navarra"
  },
  {
    "countryCode": "ES",
    "region": "32",
    "description": "Orense"
  },
  {
    "countryCode": "ES",
    "region": "33",
    "description": "Asturias"
  },
  {
    "countryCode": "ES",
    "region": "34",
    "description": "Palencia"
  },
  {
    "countryCode": "ES",
    "region": "35",
    "description": "Las Palmas"
  },
  {
    "countryCode": "ES",
    "region": "36",
    "description": "Pontevedra"
  },
  {
    "countryCode": "ES",
    "region": "37",
    "description": "Salamanca"
  },
  {
    "countryCode": "ES",
    "region": "38",
    "description": "Sta. Cruz Tenerife"
  },
  {
    "countryCode": "ES",
    "region": "39",
    "description": "Cantabria"
  },
  {
    "countryCode": "ES",
    "region": "40",
    "description": "Segovia"
  },
  {
    "countryCode": "ES",
    "region": "41",
    "description": "Sevilla"
  },
  {
    "countryCode": "ES",
    "region": "42",
    "description": "Soria"
  },
  {
    "countryCode": "ES",
    "region": "43",
    "description": "Tarragona"
  },
  {
    "countryCode": "ES",
    "region": "44",
    "description": "Teruel"
  },
  {
    "countryCode": "ES",
    "region": "45",
    "description": "Toledo"
  },
  {
    "countryCode": "ES",
    "region": "46",
    "description": "Valencia"
  },
  {
    "countryCode": "ES",
    "region": "47",
    "description": "Valladolid"
  },
  {
    "countryCode": "ES",
    "region": "48",
    "description": "Vizcaya"
  },
  {
    "countryCode": "ES",
    "region": "49",
    "description": "Zamora"
  },
  {
    "countryCode": "ES",
    "region": "50",
    "description": "Zaragoza"
  },
  {
    "countryCode": "ES",
    "region": "51",
    "description": "Ceuta"
  },
  {
    "countryCode": "ES",
    "region": "52",
    "description": "Melilla"
  },
  {
    "countryCode": "ET",
    "region": "AA",
    "description": "Addis Ababa"
  },
  {
    "countryCode": "ET",
    "region": "AF",
    "description": "Afar"
  },
  {
    "countryCode": "ET",
    "region": "AM",
    "description": "Amara"
  },
  {
    "countryCode": "ET",
    "region": "BE",
    "description": "Benshangul-Gumaz"
  },
  {
    "countryCode": "ET",
    "region": "DD",
    "description": "Dire Dawa"
  },
  {
    "countryCode": "ET",
    "region": "GA",
    "description": "Gambela Peoples"
  },
  {
    "countryCode": "ET",
    "region": "HA",
    "description": "Harari People"
  },
  {
    "countryCode": "ET",
    "region": "OR",
    "description": "Oromia"
  },
  {
    "countryCode": "ET",
    "region": "SI",
    "description": "Sidama"
  },
  {
    "countryCode": "ET",
    "region": "SN",
    "description": "Southern Peoples"
  },
  {
    "countryCode": "ET",
    "region": "SO",
    "description": "Somali"
  },
  {
    "countryCode": "ET",
    "region": "SW",
    "description": "Southwest Ethiopia"
  },
  {
    "countryCode": "ET",
    "region": "TI",
    "description": "Tigrai"
  },
  {
    "countryCode": "FI",
    "region": "01",
    "description": "Aland"
  },
  {
    "countryCode": "FI",
    "region": "02",
    "description": "South Karelia"
  },
  {
    "countryCode": "FI",
    "region": "03",
    "description": "Southern Ostrobothni"
  },
  {
    "countryCode": "FI",
    "region": "04",
    "description": "Southern Savonia"
  },
  {
    "countryCode": "FI",
    "region": "05",
    "description": "Kainuu"
  },
  {
    "countryCode": "FI",
    "region": "06",
    "description": "Tavastia Proper"
  },
  {
    "countryCode": "FI",
    "region": "07",
    "description": "Central Ostrobothnia"
  },
  {
    "countryCode": "FI",
    "region": "08",
    "description": "Central Finland"
  },
  {
    "countryCode": "FI",
    "region": "09",
    "description": "Kymenlaakso"
  },
  {
    "countryCode": "FI",
    "region": "10",
    "description": "Lapland"
  },
  {
    "countryCode": "FI",
    "region": "11",
    "description": "Pirkanmaa"
  },
  {
    "countryCode": "FI",
    "region": "12",
    "description": "Ostrobothnia"
  },
  {
    "countryCode": "FI",
    "region": "13",
    "description": "North Karelia"
  },
  {
    "countryCode": "FI",
    "region": "14",
    "description": "North. Ostrobothnia"
  },
  {
    "countryCode": "FI",
    "region": "15",
    "description": "Northern Savonia"
  },
  {
    "countryCode": "FI",
    "region": "16",
    "description": "P\u00e4ij\u00e4nne Tavastia"
  },
  {
    "countryCode": "FI",
    "region": "17",
    "description": "Satakunta"
  },
  {
    "countryCode": "FI",
    "region": "18",
    "description": "Uusimaa"
  },
  {
    "countryCode": "FI",
    "region": "19",
    "description": "Finland Proper"
  },
  {
    "countryCode": "FJ",
    "region": "C",
    "description": "Central"
  },
  {
    "countryCode": "FJ",
    "region": "E",
    "description": "Eastern"
  },
  {
    "countryCode": "FJ",
    "region": "N",
    "description": "Northern"
  },
  {
    "countryCode": "FJ",
    "region": "R",
    "description": "Rotuma"
  },
  {
    "countryCode": "FJ",
    "region": "W",
    "description": "Western"
  },
  {
    "countryCode": "FM",
    "region": "KSA",
    "description": "Kosrae"
  },
  {
    "countryCode": "FM",
    "region": "PNI",
    "description": "Pohnpei"
  },
  {
    "countryCode": "FM",
    "region": "TRK",
    "description": "Chuuk"
  },
  {
    "countryCode": "FM",
    "region": "YAP",
    "description": "Yap"
  },
  {
    "countryCode": "FR",
    "region": "01",
    "description": "Ain"
  },
  {
    "countryCode": "FR",
    "region": "02",
    "description": "Aisne"
  },
  {
    "countryCode": "FR",
    "region": "03",
    "description": "Allier"
  },
  {
    "countryCode": "FR",
    "region": "04",
    "description": "Alpes (Hte-Provence)"
  },
  {
    "countryCode": "FR",
    "region": "05",
    "description": "Alpes (Hautes)"
  },
  {
    "countryCode": "FR",
    "region": "06",
    "description": "Alpes-Maritimes"
  },
  {
    "countryCode": "FR",
    "region": "07",
    "description": "Ardeche"
  },
  {
    "countryCode": "FR",
    "region": "08",
    "description": "Ardennes"
  },
  {
    "countryCode": "FR",
    "region": "09",
    "description": "Ariege"
  },
  {
    "countryCode": "FR",
    "region": "10",
    "description": "Aube"
  },
  {
    "countryCode": "FR",
    "region": "11",
    "description": "Aude"
  },
  {
    "countryCode": "FR",
    "region": "12",
    "description": "Aveyron"
  },
  {
    "countryCode": "FR",
    "region": "13",
    "description": "Bouches-du-Rhone"
  },
  {
    "countryCode": "FR",
    "region": "14",
    "description": "Calvados"
  },
  {
    "countryCode": "FR",
    "region": "15",
    "description": "Cantal"
  },
  {
    "countryCode": "FR",
    "region": "16",
    "description": "Charente"
  },
  {
    "countryCode": "FR",
    "region": "17",
    "description": "Charente-Maritime"
  },
  {
    "countryCode": "FR",
    "region": "18",
    "description": "Cher"
  },
  {
    "countryCode": "FR",
    "region": "19",
    "description": "Correze"
  },
  {
    "countryCode": "FR",
    "region": "21",
    "description": "Cote-d'Or"
  },
  {
    "countryCode": "FR",
    "region": "22",
    "description": "Cotes-d'Armor"
  },
  {
    "countryCode": "FR",
    "region": "23",
    "description": "Creuse"
  },
  {
    "countryCode": "FR",
    "region": "24",
    "description": "Dordogne"
  },
  {
    "countryCode": "FR",
    "region": "25",
    "description": "Doubs"
  },
  {
    "countryCode": "FR",
    "region": "26",
    "description": "Drome"
  },
  {
    "countryCode": "FR",
    "region": "27",
    "description": "Eure"
  },
  {
    "countryCode": "FR",
    "region": "28",
    "description": "Eure-et-Loir"
  },
  {
    "countryCode": "FR",
    "region": "29",
    "description": "Finistere"
  },
  {
    "countryCode": "FR",
    "region": "2A",
    "description": "Corse-du-Sud"
  },
  {
    "countryCode": "FR",
    "region": "2B",
    "description": "Corse-du-Nord"
  },
  {
    "countryCode": "FR",
    "region": "30",
    "description": "Gard"
  },
  {
    "countryCode": "FR",
    "region": "31",
    "description": "Garonne (Haute)"
  },
  {
    "countryCode": "FR",
    "region": "32",
    "description": "Gers"
  },
  {
    "countryCode": "FR",
    "region": "33",
    "description": "Gironde"
  },
  {
    "countryCode": "FR",
    "region": "34",
    "description": "Herault"
  },
  {
    "countryCode": "FR",
    "region": "35",
    "description": "Ille-et-Vilaine"
  },
  {
    "countryCode": "FR",
    "region": "36",
    "description": "Indre"
  },
  {
    "countryCode": "FR",
    "region": "37",
    "description": "Indre-et-Loire"
  },
  {
    "countryCode": "FR",
    "region": "38",
    "description": "Isere"
  },
  {
    "countryCode": "FR",
    "region": "39",
    "description": "Jura"
  },
  {
    "countryCode": "FR",
    "region": "40",
    "description": "Landes"
  },
  {
    "countryCode": "FR",
    "region": "41",
    "description": "Loir-et-Cher"
  },
  {
    "countryCode": "FR",
    "region": "42",
    "description": "Loire"
  },
  {
    "countryCode": "FR",
    "region": "43",
    "description": "Loire (Haute)"
  },
  {
    "countryCode": "FR",
    "region": "44",
    "description": "Loire-Atlantique"
  },
  {
    "countryCode": "FR",
    "region": "45",
    "description": "Loiret"
  },
  {
    "countryCode": "FR",
    "region": "46",
    "description": "Lot"
  },
  {
    "countryCode": "FR",
    "region": "47",
    "description": "Lot-et-Garonne"
  },
  {
    "countryCode": "FR",
    "region": "48",
    "description": "Lozere"
  },
  {
    "countryCode": "FR",
    "region": "49",
    "description": "Maine-et-Loire"
  },
  {
    "countryCode": "FR",
    "region": "50",
    "description": "Manche"
  },
  {
    "countryCode": "FR",
    "region": "51",
    "description": "Marne"
  },
  {
    "countryCode": "FR",
    "region": "52",
    "description": "Marne (Haute)"
  },
  {
    "countryCode": "FR",
    "region": "53",
    "description": "Mayenne"
  },
  {
    "countryCode": "FR",
    "region": "54",
    "description": "Meurthe-et-Moselle"
  },
  {
    "countryCode": "FR",
    "region": "55",
    "description": "Meuse"
  },
  {
    "countryCode": "FR",
    "region": "56",
    "description": "Morbihan"
  },
  {
    "countryCode": "FR",
    "region": "57",
    "description": "Moselle"
  },
  {
    "countryCode": "FR",
    "region": "58",
    "description": "Nievre"
  },
  {
    "countryCode": "FR",
    "region": "59",
    "description": "Nord"
  },
  {
    "countryCode": "FR",
    "region": "60",
    "description": "Oise"
  },
  {
    "countryCode": "FR",
    "region": "61",
    "description": "Orne"
  },
  {
    "countryCode": "FR",
    "region": "62",
    "description": "Pas-de-Calais"
  },
  {
    "countryCode": "FR",
    "region": "63",
    "description": "Puy-de-Dome"
  },
  {
    "countryCode": "FR",
    "region": "64",
    "description": "Pyrenees-Atlantiques"
  },
  {
    "countryCode": "FR",
    "region": "65",
    "description": "Pyrenees (Hautes)"
  },
  {
    "countryCode": "FR",
    "region": "66",
    "description": "Pyrenees-Orientales"
  },
  {
    "countryCode": "FR",
    "region": "67",
    "description": "Bas-Rhin"
  },
  {
    "countryCode": "FR",
    "region": "68",
    "description": "Haut-Rhin"
  },
  {
    "countryCode": "FR",
    "region": "69",
    "description": "Rhone"
  },
  {
    "countryCode": "FR",
    "region": "69M",
    "description": "Lyon"
  },
  {
    "countryCode": "FR",
    "region": "70",
    "description": "Saone (Haute)"
  },
  {
    "countryCode": "FR",
    "region": "71",
    "description": "Saone-et-Loire"
  },
  {
    "countryCode": "FR",
    "region": "72",
    "description": "Sarthe"
  },
  {
    "countryCode": "FR",
    "region": "73",
    "description": "Savoie"
  },
  {
    "countryCode": "FR",
    "region": "74",
    "description": "Savoie (Haute)"
  },
  {
    "countryCode": "FR",
    "region": "75",
    "description": "Obsolete"
  },
  {
    "countryCode": "FR",
    "region": "75C",
    "description": "Paris"
  },
  {
    "countryCode": "FR",
    "region": "76",
    "description": "Seine-Maritime"
  },
  {
    "countryCode": "FR",
    "region": "77",
    "description": "Seine-et-Marne"
  },
  {
    "countryCode": "FR",
    "region": "78",
    "description": "Yvelines"
  },
  {
    "countryCode": "FR",
    "region": "79",
    "description": "Sevres (Deux)"
  },
  {
    "countryCode": "FR",
    "region": "80",
    "description": "Somme"
  },
  {
    "countryCode": "FR",
    "region": "81",
    "description": "Tarn"
  },
  {
    "countryCode": "FR",
    "region": "82",
    "description": "Tarn-et-Garonne"
  },
  {
    "countryCode": "FR",
    "region": "83",
    "description": "Var"
  },
  {
    "countryCode": "FR",
    "region": "84",
    "description": "Vaucluse"
  },
  {
    "countryCode": "FR",
    "region": "85",
    "description": "Vendee"
  },
  {
    "countryCode": "FR",
    "region": "86",
    "description": "Vienne"
  },
  {
    "countryCode": "FR",
    "region": "87",
    "description": "Vienne (Haute)"
  },
  {
    "countryCode": "FR",
    "region": "88",
    "description": "Vosges"
  },
  {
    "countryCode": "FR",
    "region": "89",
    "description": "Yonne"
  },
  {
    "countryCode": "FR",
    "region": "90",
    "description": "Territ.-de-Belfort"
  },
  {
    "countryCode": "FR",
    "region": "91",
    "description": "Essonne"
  },
  {
    "countryCode": "FR",
    "region": "92",
    "description": "Hauts-de-Seine"
  },
  {
    "countryCode": "FR",
    "region": "93",
    "description": "Seine-Saint-Denis"
  },
  {
    "countryCode": "FR",
    "region": "94",
    "description": "Val-de-Marne"
  },
  {
    "countryCode": "FR",
    "region": "95",
    "description": "Val-d'Oise"
  },
  {
    "countryCode": "FR",
    "region": "971",
    "description": "Guadeloupe"
  },
  {
    "countryCode": "FR",
    "region": "972",
    "description": "Martinique"
  },
  {
    "countryCode": "FR",
    "region": "973",
    "description": "Guyane"
  },
  {
    "countryCode": "FR",
    "region": "974",
    "description": "Reunion"
  },
  {
    "countryCode": "FR",
    "region": "975",
    "description": "Saint-Pierre-et-Miq."
  },
  {
    "countryCode": "FR",
    "region": "976",
    "description": "Mayotte"
  },
  {
    "countryCode": "FR",
    "region": "977",
    "description": "Saint Barthelemy"
  },
  {
    "countryCode": "FR",
    "region": "978",
    "description": "Saint Martin"
  },
  {
    "countryCode": "FR",
    "region": "984",
    "description": "French South. Terr."
  },
  {
    "countryCode": "FR",
    "region": "986",
    "description": "Wallis-et-Futuna"
  },
  {
    "countryCode": "FR",
    "region": "987",
    "description": "French Polynesia"
  },
  {
    "countryCode": "FR",
    "region": "988",
    "description": "New Caledonia"
  },
  {
    "countryCode": "GA",
    "region": "1",
    "description": "Estuaire"
  },
  {
    "countryCode": "GA",
    "region": "2",
    "description": "Haut-Ogoou\u00e9"
  },
  {
    "countryCode": "GA",
    "region": "3",
    "description": "Moyen-Ogoou\u00e9"
  },
  {
    "countryCode": "GA",
    "region": "4",
    "description": "Ngouni\u00e9"
  },
  {
    "countryCode": "GA",
    "region": "5",
    "description": "Nyanga"
  },
  {
    "countryCode": "GA",
    "region": "6",
    "description": "Ogoou\u00e9-Ivindo"
  },
  {
    "countryCode": "GA",
    "region": "7",
    "description": "Ogoou\u00e9-Lolo"
  },
  {
    "countryCode": "GA",
    "region": "8",
    "description": "Ogoou\u00e9-Maritime"
  },
  {
    "countryCode": "GA",
    "region": "9",
    "description": "Woleu-Ntem"
  },
  {
    "countryCode": "GB",
    "region": "ABC",
    "description": "Armagh, Banb.&Craig."
  },
  {
    "countryCode": "GB",
    "region": "ABD",
    "description": "Aberdeenshire"
  },
  {
    "countryCode": "GB",
    "region": "ABE",
    "description": "Aberdeen City"
  },
  {
    "countryCode": "GB",
    "region": "AGB",
    "description": "Argyll and Bute"
  },
  {
    "countryCode": "GB",
    "region": "AGY",
    "description": "Isle of Anglesey"
  },
  {
    "countryCode": "GB",
    "region": "AND",
    "description": "Ards & North Down"
  },
  {
    "countryCode": "GB",
    "region": "ANN",
    "description": "Antrim & Newtona."
  },
  {
    "countryCode": "GB",
    "region": "ANS",
    "description": "Angus"
  },
  {
    "countryCode": "GB",
    "region": "BAS",
    "description": "Bath and North East"
  },
  {
    "countryCode": "GB",
    "region": "BBD",
    "description": "Blackburn with Darwe"
  },
  {
    "countryCode": "GB",
    "region": "BCP",
    "description": "BournemChristchPoole"
  },
  {
    "countryCode": "GB",
    "region": "BDF",
    "description": "Bedford"
  },
  {
    "countryCode": "GB",
    "region": "BDG",
    "description": "Barking and Dagenham"
  },
  {
    "countryCode": "GB",
    "region": "BEN",
    "description": "Brent"
  },
  {
    "countryCode": "GB",
    "region": "BEX",
    "description": "Bexley"
  },
  {
    "countryCode": "GB",
    "region": "BFS",
    "description": "Belfast City"
  },
  {
    "countryCode": "GB",
    "region": "BGE",
    "description": "Bridgend"
  },
  {
    "countryCode": "GB",
    "region": "BGW",
    "description": "Blaenau Gwent"
  },
  {
    "countryCode": "GB",
    "region": "BIR",
    "description": "Birmingham"
  },
  {
    "countryCode": "GB",
    "region": "BKM",
    "description": "Buckinghamshire"
  },
  {
    "countryCode": "GB",
    "region": "BMH",
    "description": "Obsolete"
  },
  {
    "countryCode": "GB",
    "region": "BNE",
    "description": "Barnet"
  },
  {
    "countryCode": "GB",
    "region": "BNH",
    "description": "Brighton and Hove"
  },
  {
    "countryCode": "GB",
    "region": "BNS",
    "description": "Barnsley"
  },
  {
    "countryCode": "GB",
    "region": "BOL",
    "description": "Bolton"
  },
  {
    "countryCode": "GB",
    "region": "BPL",
    "description": "Blackpool"
  },
  {
    "countryCode": "GB",
    "region": "BRC",
    "description": "Bracknell Forest"
  },
  {
    "countryCode": "GB",
    "region": "BRD",
    "description": "Bradford"
  },
  {
    "countryCode": "GB",
    "region": "BRY",
    "description": "Bromley"
  },
  {
    "countryCode": "GB",
    "region": "BST",
    "description": "Bristol, City of"
  },
  {
    "countryCode": "GB",
    "region": "BUR",
    "description": "Bury"
  },
  {
    "countryCode": "GB",
    "region": "CAM",
    "description": "Cambridgeshire"
  },
  {
    "countryCode": "GB",
    "region": "CAY",
    "description": "Caerphilly"
  },
  {
    "countryCode": "GB",
    "region": "CBF",
    "description": "Central Bedfordshire"
  },
  {
    "countryCode": "GB",
    "region": "CCG",
    "description": "Causeway C. & Glens"
  },
  {
    "countryCode": "GB",
    "region": "CGN",
    "description": "Ceredigion"
  },
  {
    "countryCode": "GB",
    "region": "CHE",
    "description": "Cheshire East"
  },
  {
    "countryCode": "GB",
    "region": "CHW",
    "description": "W Cheshire & Chester"
  },
  {
    "countryCode": "GB",
    "region": "CLD",
    "description": "Calderdale"
  },
  {
    "countryCode": "GB",
    "region": "CLK",
    "description": "Clackmannanshire"
  },
  {
    "countryCode": "GB",
    "region": "CMA",
    "description": "Cumbria"
  },
  {
    "countryCode": "GB",
    "region": "CMD",
    "description": "Camden"
  },
  {
    "countryCode": "GB",
    "region": "CMN",
    "description": "Carmarthenshire"
  },
  {
    "countryCode": "GB",
    "region": "CON",
    "description": "Cornwall"
  },
  {
    "countryCode": "GB",
    "region": "COV",
    "description": "Coventry"
  },
  {
    "countryCode": "GB",
    "region": "CRF",
    "description": "Cardiff"
  },
  {
    "countryCode": "GB",
    "region": "CRY",
    "description": "Croydon"
  },
  {
    "countryCode": "GB",
    "region": "CWY",
    "description": "Conwy"
  },
  {
    "countryCode": "GB",
    "region": "DAL",
    "description": "Darlington"
  },
  {
    "countryCode": "GB",
    "region": "DBY",
    "description": "Derbyshire"
  },
  {
    "countryCode": "GB",
    "region": "DEN",
    "description": "Denbighshire"
  },
  {
    "countryCode": "GB",
    "region": "DER",
    "description": "Derby"
  },
  {
    "countryCode": "GB",
    "region": "DEV",
    "description": "Devon"
  },
  {
    "countryCode": "GB",
    "region": "DGY",
    "description": "Dumfries & Galloway"
  },
  {
    "countryCode": "GB",
    "region": "DNC",
    "description": "Doncaster"
  },
  {
    "countryCode": "GB",
    "region": "DND",
    "description": "Dundee City"
  },
  {
    "countryCode": "GB",
    "region": "DOR",
    "description": "Dorset"
  },
  {
    "countryCode": "GB",
    "region": "DRS",
    "description": "Derry and Strabane"
  },
  {
    "countryCode": "GB",
    "region": "DUD",
    "description": "Dudley"
  },
  {
    "countryCode": "GB",
    "region": "DUR",
    "description": "Durham, County"
  },
  {
    "countryCode": "GB",
    "region": "EAL",
    "description": "Ealing"
  },
  {
    "countryCode": "GB",
    "region": "EAY",
    "description": "East Ayrshire"
  },
  {
    "countryCode": "GB",
    "region": "EDH",
    "description": "Edinburgh"
  },
  {
    "countryCode": "GB",
    "region": "EDU",
    "description": "East Dunbartonshire"
  },
  {
    "countryCode": "GB",
    "region": "ELN",
    "description": "East Lothian"
  },
  {
    "countryCode": "GB",
    "region": "ELS",
    "description": "Eilean Siar"
  },
  {
    "countryCode": "GB",
    "region": "ENF",
    "description": "Enfield"
  },
  {
    "countryCode": "GB",
    "region": "ERW",
    "description": "East Renfrewshire"
  },
  {
    "countryCode": "GB",
    "region": "ERY",
    "description": "East Riding of York"
  },
  {
    "countryCode": "GB",
    "region": "ESS",
    "description": "Essex"
  },
  {
    "countryCode": "GB",
    "region": "ESX",
    "description": "East Sussex"
  },
  {
    "countryCode": "GB",
    "region": "FAL",
    "description": "Falkirk"
  },
  {
    "countryCode": "GB",
    "region": "FIF",
    "description": "Fife"
  },
  {
    "countryCode": "GB",
    "region": "FLN",
    "description": "Flintshire"
  },
  {
    "countryCode": "GB",
    "region": "FMO",
    "description": "Fermanagh & Omagh"
  },
  {
    "countryCode": "GB",
    "region": "GAT",
    "description": "Gateshead"
  },
  {
    "countryCode": "GB",
    "region": "GLG",
    "description": "Glasgow City"
  },
  {
    "countryCode": "GB",
    "region": "GLS",
    "description": "Gloucestershire"
  },
  {
    "countryCode": "GB",
    "region": "GRE",
    "description": "Greenwich"
  },
  {
    "countryCode": "GB",
    "region": "GWN",
    "description": "Gwynedd"
  },
  {
    "countryCode": "GB",
    "region": "HAL",
    "description": "Halton"
  },
  {
    "countryCode": "GB",
    "region": "HAM",
    "description": "Hampshire"
  },
  {
    "countryCode": "GB",
    "region": "HAV",
    "description": "Havering"
  },
  {
    "countryCode": "GB",
    "region": "HCK",
    "description": "Hackney"
  },
  {
    "countryCode": "GB",
    "region": "HEF",
    "description": "Herefordshire"
  },
  {
    "countryCode": "GB",
    "region": "HIL",
    "description": "Hillingdon"
  },
  {
    "countryCode": "GB",
    "region": "HLD",
    "description": "Highland"
  },
  {
    "countryCode": "GB",
    "region": "HMF",
    "description": "Hammersm & Fulham"
  },
  {
    "countryCode": "GB",
    "region": "HNS",
    "description": "Hounslow"
  },
  {
    "countryCode": "GB",
    "region": "HPL",
    "description": "Hartlepool"
  },
  {
    "countryCode": "GB",
    "region": "HRT",
    "description": "Hertfordshire"
  },
  {
    "countryCode": "GB",
    "region": "HRW",
    "description": "Harrow"
  },
  {
    "countryCode": "GB",
    "region": "HRY",
    "description": "Haringey"
  },
  {
    "countryCode": "GB",
    "region": "IOS",
    "description": "Isles of Scilly"
  },
  {
    "countryCode": "GB",
    "region": "IOW",
    "description": "Isle of Wight"
  },
  {
    "countryCode": "GB",
    "region": "ISL",
    "description": "Islington"
  },
  {
    "countryCode": "GB",
    "region": "IVC",
    "description": "Inverclyde"
  },
  {
    "countryCode": "GB",
    "region": "KEC",
    "description": "Kensington &Chelsea"
  },
  {
    "countryCode": "GB",
    "region": "KEN",
    "description": "Kent"
  },
  {
    "countryCode": "GB",
    "region": "KHL",
    "description": "Kingston upon Hull"
  },
  {
    "countryCode": "GB",
    "region": "KIR",
    "description": "Kirklees"
  },
  {
    "countryCode": "GB",
    "region": "KTT",
    "description": "Kingston upon Thames"
  },
  {
    "countryCode": "GB",
    "region": "KWL",
    "description": "Knowsley"
  },
  {
    "countryCode": "GB",
    "region": "LAN",
    "description": "Lancashire"
  },
  {
    "countryCode": "GB",
    "region": "LBC",
    "description": "Lisburn&Castlereagh"
  },
  {
    "countryCode": "GB",
    "region": "LBH",
    "description": "Lambeth"
  },
  {
    "countryCode": "GB",
    "region": "LCE",
    "description": "Leicester"
  },
  {
    "countryCode": "GB",
    "region": "LDS",
    "description": "Leeds"
  },
  {
    "countryCode": "GB",
    "region": "LEC",
    "description": "Leicestershire"
  },
  {
    "countryCode": "GB",
    "region": "LEW",
    "description": "Lewisham"
  },
  {
    "countryCode": "GB",
    "region": "LIN",
    "description": "Lincolnshire"
  },
  {
    "countryCode": "GB",
    "region": "LIV",
    "description": "Liverpool"
  },
  {
    "countryCode": "GB",
    "region": "LND",
    "description": "London"
  },
  {
    "countryCode": "GB",
    "region": "LUT",
    "description": "Luton"
  },
  {
    "countryCode": "GB",
    "region": "MAN",
    "description": "Manchester"
  },
  {
    "countryCode": "GB",
    "region": "MDB",
    "description": "Middlesbrough"
  },
  {
    "countryCode": "GB",
    "region": "MDW",
    "description": "Medway"
  },
  {
    "countryCode": "GB",
    "region": "MEA",
    "description": "Mid & East Antrim"
  },
  {
    "countryCode": "GB",
    "region": "MIK",
    "description": "Milton Keynes"
  },
  {
    "countryCode": "GB",
    "region": "MLN",
    "description": "Midlothian"
  },
  {
    "countryCode": "GB",
    "region": "MON",
    "description": "Monmouthshire"
  },
  {
    "countryCode": "GB",
    "region": "MRT",
    "description": "Merton"
  },
  {
    "countryCode": "GB",
    "region": "MRY",
    "description": "Moray"
  },
  {
    "countryCode": "GB",
    "region": "MTY",
    "description": "Merthyr Tydfil"
  },
  {
    "countryCode": "GB",
    "region": "MUL",
    "description": "Mid-Ulster"
  },
  {
    "countryCode": "GB",
    "region": "NAY",
    "description": "North Ayrshire"
  },
  {
    "countryCode": "GB",
    "region": "NBL",
    "description": "Northumberland"
  },
  {
    "countryCode": "GB",
    "region": "NEL",
    "description": "NE Lincolnshire"
  },
  {
    "countryCode": "GB",
    "region": "NET",
    "description": "Newcastle upon Tyne"
  },
  {
    "countryCode": "GB",
    "region": "NFK",
    "description": "Norfolk"
  },
  {
    "countryCode": "GB",
    "region": "NGM",
    "description": "Nottingham"
  },
  {
    "countryCode": "GB",
    "region": "NLK",
    "description": "North Lanarkshire"
  },
  {
    "countryCode": "GB",
    "region": "NLN",
    "description": "North Lincolnshire"
  },
  {
    "countryCode": "GB",
    "region": "NMD",
    "description": "Newry, Mourne & D."
  },
  {
    "countryCode": "GB",
    "region": "NNH",
    "description": "North Northamptonsh."
  },
  {
    "countryCode": "GB",
    "region": "NSM",
    "description": "North Somerset"
  },
  {
    "countryCode": "GB",
    "region": "NTH",
    "description": "Obsolete"
  },
  {
    "countryCode": "GB",
    "region": "NTL",
    "description": "Neath Port Talbot [C"
  },
  {
    "countryCode": "GB",
    "region": "NTT",
    "description": "Nottinghamshire"
  },
  {
    "countryCode": "GB",
    "region": "NTY",
    "description": "North Tyneside"
  },
  {
    "countryCode": "GB",
    "region": "NWM",
    "description": "Newham"
  },
  {
    "countryCode": "GB",
    "region": "NWP",
    "description": "Newport"
  },
  {
    "countryCode": "GB",
    "region": "NYK",
    "description": "North Yorkshire"
  },
  {
    "countryCode": "GB",
    "region": "OLD",
    "description": "Oldham"
  },
  {
    "countryCode": "GB",
    "region": "ORK",
    "description": "Orkney Islands"
  },
  {
    "countryCode": "GB",
    "region": "OXF",
    "description": "Oxfordshire"
  },
  {
    "countryCode": "GB",
    "region": "PEM",
    "description": "Pembrokeshire"
  },
  {
    "countryCode": "GB",
    "region": "PKN",
    "description": "Perth and Kinross"
  },
  {
    "countryCode": "GB",
    "region": "PLY",
    "description": "Plymouth"
  },
  {
    "countryCode": "GB",
    "region": "POL",
    "description": "Obsolete"
  },
  {
    "countryCode": "GB",
    "region": "POR",
    "description": "Portsmouth"
  },
  {
    "countryCode": "GB",
    "region": "POW",
    "description": "Powys"
  },
  {
    "countryCode": "GB",
    "region": "PTE",
    "description": "Peterborough"
  },
  {
    "countryCode": "GB",
    "region": "RCC",
    "description": "Redcar and Cleveland"
  },
  {
    "countryCode": "GB",
    "region": "RCH",
    "description": "Rochdale"
  },
  {
    "countryCode": "GB",
    "region": "RCT",
    "description": "Rhondda Cynon Taff"
  },
  {
    "countryCode": "GB",
    "region": "RDB",
    "description": "Redbridge"
  },
  {
    "countryCode": "GB",
    "region": "RDG",
    "description": "Reading"
  },
  {
    "countryCode": "GB",
    "region": "RFW",
    "description": "Renfrewshire"
  },
  {
    "countryCode": "GB",
    "region": "RIC",
    "description": "Richmond upon Thames"
  },
  {
    "countryCode": "GB",
    "region": "ROT",
    "description": "Rotherham"
  },
  {
    "countryCode": "GB",
    "region": "RUT",
    "description": "Rutland"
  },
  {
    "countryCode": "GB",
    "region": "SAW",
    "description": "Sandwell"
  },
  {
    "countryCode": "GB",
    "region": "SAY",
    "description": "South Ayrshire"
  },
  {
    "countryCode": "GB",
    "region": "SCB",
    "description": "Scottish Borders"
  },
  {
    "countryCode": "GB",
    "region": "SFK",
    "description": "Suffolk"
  },
  {
    "countryCode": "GB",
    "region": "SFT",
    "description": "Sefton"
  },
  {
    "countryCode": "GB",
    "region": "SGC",
    "description": "S Gloucestershire"
  },
  {
    "countryCode": "GB",
    "region": "SHF",
    "description": "Sheffield"
  },
  {
    "countryCode": "GB",
    "region": "SHN",
    "description": "Saint Helens"
  },
  {
    "countryCode": "GB",
    "region": "SHR",
    "description": "Shropshire"
  },
  {
    "countryCode": "GB",
    "region": "SKP",
    "description": "Stockport"
  },
  {
    "countryCode": "GB",
    "region": "SLF",
    "description": "Salford"
  },
  {
    "countryCode": "GB",
    "region": "SLG",
    "description": "Slough"
  },
  {
    "countryCode": "GB",
    "region": "SLK",
    "description": "South Lanarkshire"
  },
  {
    "countryCode": "GB",
    "region": "SND",
    "description": "Sunderland"
  },
  {
    "countryCode": "GB",
    "region": "SOL",
    "description": "Solihull"
  },
  {
    "countryCode": "GB",
    "region": "SOM",
    "description": "Somerset"
  },
  {
    "countryCode": "GB",
    "region": "SOS",
    "description": "Southend-on-Sea"
  },
  {
    "countryCode": "GB",
    "region": "SRY",
    "description": "Surrey"
  },
  {
    "countryCode": "GB",
    "region": "STE",
    "description": "Stoke-on-Trent"
  },
  {
    "countryCode": "GB",
    "region": "STG",
    "description": "Stirling"
  },
  {
    "countryCode": "GB",
    "region": "STH",
    "description": "Southampton"
  },
  {
    "countryCode": "GB",
    "region": "STN",
    "description": "Sutton"
  },
  {
    "countryCode": "GB",
    "region": "STS",
    "description": "Staffordshire"
  },
  {
    "countryCode": "GB",
    "region": "STT",
    "description": "Stockton-on-Tees"
  },
  {
    "countryCode": "GB",
    "region": "STY",
    "description": "South Tyneside"
  },
  {
    "countryCode": "GB",
    "region": "SWA",
    "description": "Swansea"
  },
  {
    "countryCode": "GB",
    "region": "SWD",
    "description": "Swindon"
  },
  {
    "countryCode": "GB",
    "region": "SWK",
    "description": "Southwark"
  },
  {
    "countryCode": "GB",
    "region": "TAM",
    "description": "Tameside"
  },
  {
    "countryCode": "GB",
    "region": "TFW",
    "description": "Telford and Wrekin"
  },
  {
    "countryCode": "GB",
    "region": "THR",
    "description": "Thurrock"
  },
  {
    "countryCode": "GB",
    "region": "TOB",
    "description": "Torbay"
  },
  {
    "countryCode": "GB",
    "region": "TOF",
    "description": "Torfaen"
  },
  {
    "countryCode": "GB",
    "region": "TRF",
    "description": "Trafford"
  },
  {
    "countryCode": "GB",
    "region": "TWH",
    "description": "Tower Hamlets"
  },
  {
    "countryCode": "GB",
    "region": "VGL",
    "description": "Vale of Glamorgan"
  },
  {
    "countryCode": "GB",
    "region": "WAR",
    "description": "Warwickshire"
  },
  {
    "countryCode": "GB",
    "region": "WBK",
    "description": "West Berkshire"
  },
  {
    "countryCode": "GB",
    "region": "WDU",
    "description": "West Dunbartonshire"
  },
  {
    "countryCode": "GB",
    "region": "WFT",
    "description": "Waltham Forest"
  },
  {
    "countryCode": "GB",
    "region": "WGN",
    "description": "Wigan"
  },
  {
    "countryCode": "GB",
    "region": "WIL",
    "description": "Wiltshire"
  },
  {
    "countryCode": "GB",
    "region": "WKF",
    "description": "Wakefield"
  },
  {
    "countryCode": "GB",
    "region": "WLL",
    "description": "Walsall"
  },
  {
    "countryCode": "GB",
    "region": "WLN",
    "description": "West Lothian"
  },
  {
    "countryCode": "GB",
    "region": "WLV",
    "description": "Wolverhampton"
  },
  {
    "countryCode": "GB",
    "region": "WND",
    "description": "Wandsworth"
  },
  {
    "countryCode": "GB",
    "region": "WNH",
    "description": "West Northamptonsh."
  },
  {
    "countryCode": "GB",
    "region": "WNM",
    "description": "Windsor &Maidenhead"
  },
  {
    "countryCode": "GB",
    "region": "WOK",
    "description": "Wokingham"
  },
  {
    "countryCode": "GB",
    "region": "WOR",
    "description": "Worcestershire"
  },
  {
    "countryCode": "GB",
    "region": "WRL",
    "description": "Wirral"
  },
  {
    "countryCode": "GB",
    "region": "WRT",
    "description": "Warrington"
  },
  {
    "countryCode": "GB",
    "region": "WRX",
    "description": "Wrexham"
  },
  {
    "countryCode": "GB",
    "region": "WSM",
    "description": "Westminster"
  },
  {
    "countryCode": "GB",
    "region": "WSX",
    "description": "West Sussex"
  },
  {
    "countryCode": "GB",
    "region": "YOR",
    "description": "York"
  },
  {
    "countryCode": "GB",
    "region": "ZET",
    "description": "Shetland Islands"
  },
  {
    "countryCode": "GD",
    "region": "01",
    "description": "Saint Andrew"
  },
  {
    "countryCode": "GD",
    "region": "02",
    "description": "Saint David"
  },
  {
    "countryCode": "GD",
    "region": "03",
    "description": "Saint George"
  },
  {
    "countryCode": "GD",
    "region": "04",
    "description": "Saint John"
  },
  {
    "countryCode": "GD",
    "region": "05",
    "description": "Saint Mark"
  },
  {
    "countryCode": "GD",
    "region": "06",
    "description": "Saint Patrick"
  },
  {
    "countryCode": "GD",
    "region": "10",
    "description": "Carriacou"
  },
  {
    "countryCode": "GE",
    "region": "AB",
    "description": "Abkhazia"
  },
  {
    "countryCode": "GE",
    "region": "AJ",
    "description": "Ajaria"
  },
  {
    "countryCode": "GE",
    "region": "GU",
    "description": "Guria"
  },
  {
    "countryCode": "GE",
    "region": "IM",
    "description": "Imereti"
  },
  {
    "countryCode": "GE",
    "region": "KA",
    "description": "Kakheti"
  },
  {
    "countryCode": "GE",
    "region": "KK",
    "description": "Kvemo Kartli"
  },
  {
    "countryCode": "GE",
    "region": "MM",
    "description": "Mtskheta-Mtianeti"
  },
  {
    "countryCode": "GE",
    "region": "RL",
    "description": "Racha-Lechkh./ Kvemo"
  },
  {
    "countryCode": "GE",
    "region": "SJ",
    "description": "Samtskhe-Javakheti"
  },
  {
    "countryCode": "GE",
    "region": "SK",
    "description": "Shida Kartli"
  },
  {
    "countryCode": "GE",
    "region": "SZ",
    "description": "Samegrelo-Zemo Svan"
  },
  {
    "countryCode": "GE",
    "region": "TB",
    "description": "Tbilisi"
  },
  {
    "countryCode": "GH",
    "region": "AA",
    "description": "Greater Accra"
  },
  {
    "countryCode": "GH",
    "region": "AF",
    "description": "Ahafo"
  },
  {
    "countryCode": "GH",
    "region": "AH",
    "description": "Ashanti"
  },
  {
    "countryCode": "GH",
    "region": "BE",
    "description": "Bono East"
  },
  {
    "countryCode": "GH",
    "region": "BO",
    "description": "Bono"
  },
  {
    "countryCode": "GH",
    "region": "CP",
    "description": "Central"
  },
  {
    "countryCode": "GH",
    "region": "EP",
    "description": "Eastern"
  },
  {
    "countryCode": "GH",
    "region": "NE",
    "description": "North East"
  },
  {
    "countryCode": "GH",
    "region": "NP",
    "description": "Northern"
  },
  {
    "countryCode": "GH",
    "region": "OT",
    "description": "Oti"
  },
  {
    "countryCode": "GH",
    "region": "SV",
    "description": "Savannah"
  },
  {
    "countryCode": "GH",
    "region": "TV",
    "description": "Volta"
  },
  {
    "countryCode": "GH",
    "region": "UE",
    "description": "Upper East"
  },
  {
    "countryCode": "GH",
    "region": "UW",
    "description": "Upper West"
  },
  {
    "countryCode": "GH",
    "region": "WN",
    "description": "Western North"
  },
  {
    "countryCode": "GH",
    "region": "WP",
    "description": "Western"
  },
  {
    "countryCode": "GM",
    "region": "B",
    "description": "Banjul"
  },
  {
    "countryCode": "GM",
    "region": "L",
    "description": "Lower River"
  },
  {
    "countryCode": "GM",
    "region": "M",
    "description": "Central River"
  },
  {
    "countryCode": "GM",
    "region": "N",
    "description": "North Bank"
  },
  {
    "countryCode": "GM",
    "region": "U",
    "description": "Upper River"
  },
  {
    "countryCode": "GM",
    "region": "W",
    "description": "Western"
  },
  {
    "countryCode": "GN",
    "region": "B",
    "description": "Bok\u00e9"
  },
  {
    "countryCode": "GN",
    "region": "C",
    "description": "Conakry"
  },
  {
    "countryCode": "GN",
    "region": "D",
    "description": "Kindia"
  },
  {
    "countryCode": "GN",
    "region": "F",
    "description": "Faranah"
  },
  {
    "countryCode": "GN",
    "region": "K",
    "description": "Kankan"
  },
  {
    "countryCode": "GN",
    "region": "L",
    "description": "Lab\u00e9"
  },
  {
    "countryCode": "GN",
    "region": "M",
    "description": "Mamou"
  },
  {
    "countryCode": "GN",
    "region": "N",
    "description": "Nz\u00e9r\u00e9kor\u00e9"
  },
  {
    "countryCode": "GQ",
    "region": "AN",
    "description": "Annob\u00f3n"
  },
  {
    "countryCode": "GQ",
    "region": "BN",
    "description": "Bioko Norte"
  },
  {
    "countryCode": "GQ",
    "region": "BS",
    "description": "Bioko Sur"
  },
  {
    "countryCode": "GQ",
    "region": "CS",
    "description": "Centro Sur"
  },
  {
    "countryCode": "GQ",
    "region": "DJ",
    "description": "Djibloho"
  },
  {
    "countryCode": "GQ",
    "region": "KN",
    "description": "Ki\u00e9-Ntem"
  },
  {
    "countryCode": "GQ",
    "region": "LI",
    "description": "Litoral"
  },
  {
    "countryCode": "GQ",
    "region": "WN",
    "description": "Wele-Nzas"
  },
  {
    "countryCode": "GR",
    "region": "69",
    "description": "Agio Oros"
  },
  {
    "countryCode": "GR",
    "region": "A",
    "description": "Anatolik\u00ed Makedon\u00eda"
  },
  {
    "countryCode": "GR",
    "region": "B",
    "description": "Kentrik\u00ed Makedon\u00eda"
  },
  {
    "countryCode": "GR",
    "region": "C",
    "description": "Dytik\u00ed Makedon\u00eda"
  },
  {
    "countryCode": "GR",
    "region": "D",
    "description": "\u00cdpeiros"
  },
  {
    "countryCode": "GR",
    "region": "E",
    "description": "Thessal\u00eda"
  },
  {
    "countryCode": "GR",
    "region": "F",
    "description": "Ion\u00eda N\u00edsia"
  },
  {
    "countryCode": "GR",
    "region": "G",
    "description": "Dytik\u00ed Ell\u00e1da"
  },
  {
    "countryCode": "GR",
    "region": "H",
    "description": "Stere\u00e1 Ell\u00e1da"
  },
  {
    "countryCode": "GR",
    "region": "I",
    "description": "Attik\u00ed"
  },
  {
    "countryCode": "GR",
    "region": "J",
    "description": "Pelop\u00f3nnisos"
  },
  {
    "countryCode": "GR",
    "region": "K",
    "description": "V\u00f3reio Aiga\u00edo"
  },
  {
    "countryCode": "GR",
    "region": "L",
    "description": "N\u00f3tio Aiga\u00edo"
  },
  {
    "countryCode": "GR",
    "region": "M",
    "description": "Kr\u00edti"
  },
  {
    "countryCode": "GT",
    "region": "01",
    "description": "Guatemala"
  },
  {
    "countryCode": "GT",
    "region": "02",
    "description": "El Progreso"
  },
  {
    "countryCode": "GT",
    "region": "03",
    "description": "Sacatep\u00e9quez"
  },
  {
    "countryCode": "GT",
    "region": "04",
    "description": "Chimaltenango"
  },
  {
    "countryCode": "GT",
    "region": "05",
    "description": "Escuintla"
  },
  {
    "countryCode": "GT",
    "region": "06",
    "description": "Santa Rosa"
  },
  {
    "countryCode": "GT",
    "region": "07",
    "description": "Solol\u00e1"
  },
  {
    "countryCode": "GT",
    "region": "08",
    "description": "Totonicap\u00e1n"
  },
  {
    "countryCode": "GT",
    "region": "09",
    "description": "Quetzaltenango"
  },
  {
    "countryCode": "GT",
    "region": "10",
    "description": "Suchitep\u00e9quez"
  },
  {
    "countryCode": "GT",
    "region": "11",
    "description": "Retalhuleu"
  },
  {
    "countryCode": "GT",
    "region": "12",
    "description": "San Marcos"
  },
  {
    "countryCode": "GT",
    "region": "13",
    "description": "Huehuetenango"
  },
  {
    "countryCode": "GT",
    "region": "14",
    "description": "Quich\u00e9"
  },
  {
    "countryCode": "GT",
    "region": "15",
    "description": "Baja Verapaz"
  },
  {
    "countryCode": "GT",
    "region": "16",
    "description": "Alta Verapaz"
  },
  {
    "countryCode": "GT",
    "region": "17",
    "description": "Pet\u00e9n"
  },
  {
    "countryCode": "GT",
    "region": "18",
    "description": "Izabal"
  },
  {
    "countryCode": "GT",
    "region": "19",
    "description": "Zacapa"
  },
  {
    "countryCode": "GT",
    "region": "20",
    "description": "Chiquimula"
  },
  {
    "countryCode": "GT",
    "region": "21",
    "description": "Jalapa"
  },
  {
    "countryCode": "GT",
    "region": "22",
    "description": "Jutiapa"
  },
  {
    "countryCode": "GT",
    "region": "AV",
    "description": "Obsolete"
  },
  {
    "countryCode": "GT",
    "region": "BV",
    "description": "Obsolete"
  },
  {
    "countryCode": "GT",
    "region": "CM",
    "description": "Obsolete"
  },
  {
    "countryCode": "GT",
    "region": "CQ",
    "description": "Obsolete"
  },
  {
    "countryCode": "GT",
    "region": "ES",
    "description": "Obsolete"
  },
  {
    "countryCode": "GT",
    "region": "GU",
    "description": "Obsolete"
  },
  {
    "countryCode": "GT",
    "region": "HU",
    "description": "Obsolete"
  },
  {
    "countryCode": "GT",
    "region": "IZ",
    "description": "Obsolete"
  },
  {
    "countryCode": "GT",
    "region": "JA",
    "description": "Obsolete"
  },
  {
    "countryCode": "GT",
    "region": "JU",
    "description": "Obsolete"
  },
  {
    "countryCode": "GT",
    "region": "PE",
    "description": "Obsolete"
  },
  {
    "countryCode": "GT",
    "region": "PR",
    "description": "Obsolete"
  },
  {
    "countryCode": "GT",
    "region": "QC",
    "description": "Obsolete"
  },
  {
    "countryCode": "GT",
    "region": "QZ",
    "description": "Obsolete"
  },
  {
    "countryCode": "GT",
    "region": "RE",
    "description": "Obsolete"
  },
  {
    "countryCode": "GT",
    "region": "SA",
    "description": "Obsolete"
  },
  {
    "countryCode": "GT",
    "region": "SM",
    "description": "Obsolete"
  },
  {
    "countryCode": "GT",
    "region": "SO",
    "description": "Obsolete"
  },
  {
    "countryCode": "GT",
    "region": "SR",
    "description": "Obsolete"
  },
  {
    "countryCode": "GT",
    "region": "SU",
    "description": "Obsolete"
  },
  {
    "countryCode": "GT",
    "region": "TO",
    "description": "Obsolete"
  },
  {
    "countryCode": "GT",
    "region": "ZA",
    "description": "Obsolete"
  },
  {
    "countryCode": "GW",
    "region": "BA",
    "description": "Bafat\u00e1"
  },
  {
    "countryCode": "GW",
    "region": "BL",
    "description": "Bolama / Bijag\u00f3s"
  },
  {
    "countryCode": "GW",
    "region": "BM",
    "description": "Biombo"
  },
  {
    "countryCode": "GW",
    "region": "BS",
    "description": "Bissau"
  },
  {
    "countryCode": "GW",
    "region": "CA",
    "description": "Cacheu"
  },
  {
    "countryCode": "GW",
    "region": "GA",
    "description": "Gab\u00fa"
  },
  {
    "countryCode": "GW",
    "region": "OI",
    "description": "Oio"
  },
  {
    "countryCode": "GW",
    "region": "QU",
    "description": "Quinara"
  },
  {
    "countryCode": "GW",
    "region": "TO",
    "description": "Tombali"
  },
  {
    "countryCode": "GY",
    "region": "BA",
    "description": "Barima-Waini"
  },
  {
    "countryCode": "GY",
    "region": "CU",
    "description": "Cuyuni-Mazaruni"
  },
  {
    "countryCode": "GY",
    "region": "DE",
    "description": "Demerara-Mahaica"
  },
  {
    "countryCode": "GY",
    "region": "EB",
    "description": "East Berbice-Corent."
  },
  {
    "countryCode": "GY",
    "region": "ES",
    "description": "Essequibo Islands"
  },
  {
    "countryCode": "GY",
    "region": "MA",
    "description": "Mahaica-Berbice"
  },
  {
    "countryCode": "GY",
    "region": "PM",
    "description": "Pomeroon-Supenaam"
  },
  {
    "countryCode": "GY",
    "region": "PT",
    "description": "Potaro-Siparuni"
  },
  {
    "countryCode": "GY",
    "region": "UD",
    "description": "Up. Demerara-Berbice"
  },
  {
    "countryCode": "GY",
    "region": "UT",
    "description": "UpperTak.-Upper Ess."
  },
  {
    "countryCode": "HK",
    "region": "HK",
    "description": "Hong Kong - China"
  },
  {
    "countryCode": "HN",
    "region": "AT",
    "description": "Atl\u00e1ntida"
  },
  {
    "countryCode": "HN",
    "region": "CH",
    "description": "Choluteca"
  },
  {
    "countryCode": "HN",
    "region": "CL",
    "description": "Col\u00f3n"
  },
  {
    "countryCode": "HN",
    "region": "CM",
    "description": "Comayagua"
  },
  {
    "countryCode": "HN",
    "region": "CP",
    "description": "Cop\u00e1n"
  },
  {
    "countryCode": "HN",
    "region": "CR",
    "description": "Cort\u00e9s"
  },
  {
    "countryCode": "HN",
    "region": "EP",
    "description": "El Para\u00edso"
  },
  {
    "countryCode": "HN",
    "region": "FM",
    "description": "Francisco Moraz\u00e1n"
  },
  {
    "countryCode": "HN",
    "region": "GD",
    "description": "Gracias a Dios"
  },
  {
    "countryCode": "HN",
    "region": "IB",
    "description": "Islas de la Bah\u00eda"
  },
  {
    "countryCode": "HN",
    "region": "IN",
    "description": "Intibuc\u00e1"
  },
  {
    "countryCode": "HN",
    "region": "LE",
    "description": "Lempira"
  },
  {
    "countryCode": "HN",
    "region": "LP",
    "description": "La Paz"
  },
  {
    "countryCode": "HN",
    "region": "OC",
    "description": "Ocotepeque"
  },
  {
    "countryCode": "HN",
    "region": "OL",
    "description": "Olancho"
  },
  {
    "countryCode": "HN",
    "region": "SB",
    "description": "Santa B\u00e1rbara"
  },
  {
    "countryCode": "HN",
    "region": "VA",
    "description": "Valle"
  },
  {
    "countryCode": "HN",
    "region": "YO",
    "description": "Yoro"
  },
  {
    "countryCode": "HR",
    "region": "01",
    "description": "Zagrebacka"
  },
  {
    "countryCode": "HR",
    "region": "02",
    "description": "Krapinsko-zagorska"
  },
  {
    "countryCode": "HR",
    "region": "03",
    "description": "Sisacko-moslavacka"
  },
  {
    "countryCode": "HR",
    "region": "04",
    "description": "Karlovacka"
  },
  {
    "countryCode": "HR",
    "region": "05",
    "description": "Varazdinska"
  },
  {
    "countryCode": "HR",
    "region": "06",
    "description": "Koprivnicko-krizevac"
  },
  {
    "countryCode": "HR",
    "region": "07",
    "description": "Bjelovarsko-bilogors"
  },
  {
    "countryCode": "HR",
    "region": "08",
    "description": "Primorsko-goranska"
  },
  {
    "countryCode": "HR",
    "region": "09",
    "description": "Licko-senjska"
  },
  {
    "countryCode": "HR",
    "region": "10",
    "description": "Viroviticko-podravac"
  },
  {
    "countryCode": "HR",
    "region": "11",
    "description": "Pozesko-slavonska"
  },
  {
    "countryCode": "HR",
    "region": "12",
    "description": "Brodsko-posavska"
  },
  {
    "countryCode": "HR",
    "region": "13",
    "description": "Zadarska"
  },
  {
    "countryCode": "HR",
    "region": "14",
    "description": "Osjecko-baranjska"
  },
  {
    "countryCode": "HR",
    "region": "15",
    "description": "Sibensko-kninska"
  },
  {
    "countryCode": "HR",
    "region": "16",
    "description": "Vukovarsko-srijemska"
  },
  {
    "countryCode": "HR",
    "region": "17",
    "description": "Splitsko-dalmatinska"
  },
  {
    "countryCode": "HR",
    "region": "18",
    "description": "Istarska"
  },
  {
    "countryCode": "HR",
    "region": "19",
    "description": "Dubrovacko-neretvans"
  },
  {
    "countryCode": "HR",
    "region": "20",
    "description": "Medjimurska"
  },
  {
    "countryCode": "HR",
    "region": "21",
    "description": "Zagreb"
  },
  {
    "countryCode": "HT",
    "region": "AR",
    "description": "Artibonite"
  },
  {
    "countryCode": "HT",
    "region": "CE",
    "description": "Centre"
  },
  {
    "countryCode": "HT",
    "region": "GA",
    "description": "Grande'Anse"
  },
  {
    "countryCode": "HT",
    "region": "ND",
    "description": "Nord"
  },
  {
    "countryCode": "HT",
    "region": "NE",
    "description": "Nord-Est"
  },
  {
    "countryCode": "HT",
    "region": "NI",
    "description": "Nippes"
  },
  {
    "countryCode": "HT",
    "region": "NO",
    "description": "Nord-Ouest"
  },
  {
    "countryCode": "HT",
    "region": "OU",
    "description": "Ouest"
  },
  {
    "countryCode": "HT",
    "region": "SD",
    "description": "Sud"
  },
  {
    "countryCode": "HT",
    "region": "SE",
    "description": "Sud-Est"
  },
  {
    "countryCode": "HU",
    "region": "BA",
    "description": "Baranya"
  },
  {
    "countryCode": "HU",
    "region": "BC",
    "description": "Bekescsaba"
  },
  {
    "countryCode": "HU",
    "region": "BE",
    "description": "Bekes"
  },
  {
    "countryCode": "HU",
    "region": "BK",
    "description": "Bacs-Kiskun"
  },
  {
    "countryCode": "HU",
    "region": "BU",
    "description": "Budapest"
  },
  {
    "countryCode": "HU",
    "region": "BZ",
    "description": "Borsod-Abauj-Zemplen"
  },
  {
    "countryCode": "HU",
    "region": "CS",
    "description": "Csongr\u00e1d-Csan\u00e1d"
  },
  {
    "countryCode": "HU",
    "region": "DE",
    "description": "Debrecen"
  },
  {
    "countryCode": "HU",
    "region": "DU",
    "description": "Dunaujvaros"
  },
  {
    "countryCode": "HU",
    "region": "EG",
    "description": "Eger"
  },
  {
    "countryCode": "HU",
    "region": "ER",
    "description": "Erd"
  },
  {
    "countryCode": "HU",
    "region": "FE",
    "description": "Fejer"
  },
  {
    "countryCode": "HU",
    "region": "GS",
    "description": "Gyor-Moson-Sopron"
  },
  {
    "countryCode": "HU",
    "region": "GY",
    "description": "Gyor"
  },
  {
    "countryCode": "HU",
    "region": "HB",
    "description": "Hajdu-Bihar"
  },
  {
    "countryCode": "HU",
    "region": "HE",
    "description": "Heves"
  },
  {
    "countryCode": "HU",
    "region": "HV",
    "description": "Hodmezovasarhely"
  },
  {
    "countryCode": "HU",
    "region": "JN",
    "description": "Jasz-Nagykun-Szolnok"
  },
  {
    "countryCode": "HU",
    "region": "KE",
    "description": "Komarom-Esztergom"
  },
  {
    "countryCode": "HU",
    "region": "KM",
    "description": "Kecskemet"
  },
  {
    "countryCode": "HU",
    "region": "KV",
    "description": "Kaposvar"
  },
  {
    "countryCode": "HU",
    "region": "MI",
    "description": "Miskolc"
  },
  {
    "countryCode": "HU",
    "region": "NK",
    "description": "Nagykanizsa"
  },
  {
    "countryCode": "HU",
    "region": "NO",
    "description": "Nograd"
  },
  {
    "countryCode": "HU",
    "region": "NY",
    "description": "Nyiregyhaza"
  },
  {
    "countryCode": "HU",
    "region": "PE",
    "description": "Pest"
  },
  {
    "countryCode": "HU",
    "region": "PS",
    "description": "Pecs"
  },
  {
    "countryCode": "HU",
    "region": "SD",
    "description": "Szeged"
  },
  {
    "countryCode": "HU",
    "region": "SF",
    "description": "Szekesfehervar"
  },
  {
    "countryCode": "HU",
    "region": "SH",
    "description": "Szombathely"
  },
  {
    "countryCode": "HU",
    "region": "SK",
    "description": "Szolnok"
  },
  {
    "countryCode": "HU",
    "region": "SN",
    "description": "Sopron"
  },
  {
    "countryCode": "HU",
    "region": "SO",
    "description": "Somogy"
  },
  {
    "countryCode": "HU",
    "region": "SS",
    "description": "Szekszard"
  },
  {
    "countryCode": "HU",
    "region": "ST",
    "description": "Salgotarjan"
  },
  {
    "countryCode": "HU",
    "region": "SZ",
    "description": "Szabolcs-Szat.-Bereg"
  },
  {
    "countryCode": "HU",
    "region": "TB",
    "description": "Tatabanya"
  },
  {
    "countryCode": "HU",
    "region": "TO",
    "description": "Tolna"
  },
  {
    "countryCode": "HU",
    "region": "VA",
    "description": "Vas"
  },
  {
    "countryCode": "HU",
    "region": "VE",
    "description": "Veszprem County"
  },
  {
    "countryCode": "HU",
    "region": "VM",
    "description": "Veszprem City"
  },
  {
    "countryCode": "HU",
    "region": "ZA",
    "description": "Zala"
  },
  {
    "countryCode": "HU",
    "region": "ZE",
    "description": "Zalaegerszeg"
  },
  {
    "countryCode": "ID",
    "region": "AC",
    "description": "Aceh"
  },
  {
    "countryCode": "ID",
    "region": "BA",
    "description": "Bali"
  },
  {
    "countryCode": "ID",
    "region": "BB",
    "description": "Bangka\u2013Belitung Isl."
  },
  {
    "countryCode": "ID",
    "region": "BE",
    "description": "Bengkulu"
  },
  {
    "countryCode": "ID",
    "region": "BT",
    "description": "Banten"
  },
  {
    "countryCode": "ID",
    "region": "GO",
    "description": "Gorontalo"
  },
  {
    "countryCode": "ID",
    "region": "JA",
    "description": "Jambi"
  },
  {
    "countryCode": "ID",
    "region": "JB",
    "description": "West Java"
  },
  {
    "countryCode": "ID",
    "region": "JI",
    "description": "East Java"
  },
  {
    "countryCode": "ID",
    "region": "JK",
    "description": "Jakarta"
  },
  {
    "countryCode": "ID",
    "region": "JT",
    "description": "Central Java"
  },
  {
    "countryCode": "ID",
    "region": "KB",
    "description": "West Kalimantan"
  },
  {
    "countryCode": "ID",
    "region": "KI",
    "description": "East Kalimantan"
  },
  {
    "countryCode": "ID",
    "region": "KR",
    "description": "Riau Islands"
  },
  {
    "countryCode": "ID",
    "region": "KS",
    "description": "South Kalimantan"
  },
  {
    "countryCode": "ID",
    "region": "KT",
    "description": "Central Kalimantan"
  },
  {
    "countryCode": "ID",
    "region": "KU",
    "description": "North Kalimantan"
  },
  {
    "countryCode": "ID",
    "region": "LA",
    "description": "Lampung"
  },
  {
    "countryCode": "ID",
    "region": "MA",
    "description": "Maluku"
  },
  {
    "countryCode": "ID",
    "region": "MU",
    "description": "North Maluku"
  },
  {
    "countryCode": "ID",
    "region": "NB",
    "description": "West Nusa Tenggara"
  },
  {
    "countryCode": "ID",
    "region": "NT",
    "description": "East Nusa Tenggara"
  },
  {
    "countryCode": "ID",
    "region": "PA",
    "description": "Papua"
  },
  {
    "countryCode": "ID",
    "region": "PB",
    "description": "West Papua"
  },
  {
    "countryCode": "ID",
    "region": "PD",
    "description": "Papua Barat Daya"
  },
  {
    "countryCode": "ID",
    "region": "PE",
    "description": "Papua Pengunungan"
  },
  {
    "countryCode": "ID",
    "region": "PS",
    "description": "South Papua"
  },
  {
    "countryCode": "ID",
    "region": "PT",
    "description": "Central Papua"
  },
  {
    "countryCode": "ID",
    "region": "RI",
    "description": "Riau"
  },
  {
    "countryCode": "ID",
    "region": "SA",
    "description": "North Sulawesi"
  },
  {
    "countryCode": "ID",
    "region": "SB",
    "description": "West Sumatra"
  },
  {
    "countryCode": "ID",
    "region": "SG",
    "description": "Southeast Sulawesi"
  },
  {
    "countryCode": "ID",
    "region": "SN",
    "description": "South Sulawesi"
  },
  {
    "countryCode": "ID",
    "region": "SR",
    "description": "West Sulawesi"
  },
  {
    "countryCode": "ID",
    "region": "SS",
    "description": "South Sumatra"
  },
  {
    "countryCode": "ID",
    "region": "ST",
    "description": "Central Sulawesi"
  },
  {
    "countryCode": "ID",
    "region": "SU",
    "description": "North Sumatra"
  },
  {
    "countryCode": "ID",
    "region": "YO",
    "description": "Yogyakarta"
  },
  {
    "countryCode": "IE",
    "region": "CE",
    "description": "Clare"
  },
  {
    "countryCode": "IE",
    "region": "CN",
    "description": "Cavan"
  },
  {
    "countryCode": "IE",
    "region": "CO",
    "description": "Cork"
  },
  {
    "countryCode": "IE",
    "region": "CW",
    "description": "Carlow"
  },
  {
    "countryCode": "IE",
    "region": "D",
    "description": "Dublin"
  },
  {
    "countryCode": "IE",
    "region": "DL",
    "description": "Donegal"
  },
  {
    "countryCode": "IE",
    "region": "G",
    "description": "Galway"
  },
  {
    "countryCode": "IE",
    "region": "KE",
    "description": "Kildare"
  },
  {
    "countryCode": "IE",
    "region": "KK",
    "description": "Kilkenny"
  },
  {
    "countryCode": "IE",
    "region": "KY",
    "description": "Kerry"
  },
  {
    "countryCode": "IE",
    "region": "LD",
    "description": "Longford"
  },
  {
    "countryCode": "IE",
    "region": "LH",
    "description": "Louth"
  },
  {
    "countryCode": "IE",
    "region": "LK",
    "description": "Limerick"
  },
  {
    "countryCode": "IE",
    "region": "LM",
    "description": "Leitrim"
  },
  {
    "countryCode": "IE",
    "region": "LS",
    "description": "Laois"
  },
  {
    "countryCode": "IE",
    "region": "MH",
    "description": "Meath"
  },
  {
    "countryCode": "IE",
    "region": "MN",
    "description": "Monaghan"
  },
  {
    "countryCode": "IE",
    "region": "MO",
    "description": "Mayo"
  },
  {
    "countryCode": "IE",
    "region": "OY",
    "description": "Offaly"
  },
  {
    "countryCode": "IE",
    "region": "RN",
    "description": "Roscommon"
  },
  {
    "countryCode": "IE",
    "region": "SO",
    "description": "Sligo"
  },
  {
    "countryCode": "IE",
    "region": "TA",
    "description": "Tipperary"
  },
  {
    "countryCode": "IE",
    "region": "WD",
    "description": "Waterford"
  },
  {
    "countryCode": "IE",
    "region": "WH",
    "description": "Westmeath"
  },
  {
    "countryCode": "IE",
    "region": "WW",
    "description": "Wicklow"
  },
  {
    "countryCode": "IE",
    "region": "WX",
    "description": "Wexford"
  },
  {
    "countryCode": "IL",
    "region": "D",
    "description": "Southern District"
  },
  {
    "countryCode": "IL",
    "region": "HA",
    "description": "Haifa"
  },
  {
    "countryCode": "IL",
    "region": "JM",
    "description": "Jerusalem"
  },
  {
    "countryCode": "IL",
    "region": "M",
    "description": "Central District"
  },
  {
    "countryCode": "IL",
    "region": "TA",
    "description": "Tel Aviv"
  },
  {
    "countryCode": "IL",
    "region": "Z",
    "description": "Northern District"
  },
  {
    "countryCode": "IN",
    "region": "AN",
    "description": "Andaman and Nico.Is."
  },
  {
    "countryCode": "IN",
    "region": "AP",
    "description": "Andra Pradesh"
  },
  {
    "countryCode": "IN",
    "region": "AR",
    "description": "Arunachal Pradesh"
  },
  {
    "countryCode": "IN",
    "region": "AS",
    "description": "Assam"
  },
  {
    "countryCode": "IN",
    "region": "BR",
    "description": "Bihar"
  },
  {
    "countryCode": "IN",
    "region": "CG",
    "description": "Chhatt\u012bsgarh"
  },
  {
    "countryCode": "IN",
    "region": "CH",
    "description": "Chandigarh"
  },
  {
    "countryCode": "IN",
    "region": "CT",
    "description": "Obsolete"
  },
  {
    "countryCode": "IN",
    "region": "DD",
    "description": "Obsolete"
  },
  {
    "countryCode": "IN",
    "region": "DH",
    "description": "DadraNagHavDamanDiu"
  },
  {
    "countryCode": "IN",
    "region": "DL",
    "description": "Delhi"
  },
  {
    "countryCode": "IN",
    "region": "DN",
    "description": "Obsolete"
  },
  {
    "countryCode": "IN",
    "region": "GA",
    "description": "Goa"
  },
  {
    "countryCode": "IN",
    "region": "GJ",
    "description": "Gujarat"
  },
  {
    "countryCode": "IN",
    "region": "HP",
    "description": "Himachal Pradesh"
  },
  {
    "countryCode": "IN",
    "region": "HR",
    "description": "Haryana"
  },
  {
    "countryCode": "IN",
    "region": "JH",
    "description": "Jharkhand"
  },
  {
    "countryCode": "IN",
    "region": "JK",
    "description": "Jammu and Kashmir"
  },
  {
    "countryCode": "IN",
    "region": "KA",
    "description": "Karnataka"
  },
  {
    "countryCode": "IN",
    "region": "KL",
    "description": "Kerala"
  },
  {
    "countryCode": "IN",
    "region": "LA",
    "description": "Ladakh"
  },
  {
    "countryCode": "IN",
    "region": "LD",
    "description": "Lakshadweep"
  },
  {
    "countryCode": "IN",
    "region": "MH",
    "description": "Maharashtra"
  },
  {
    "countryCode": "IN",
    "region": "ML",
    "description": "Megalaya"
  },
  {
    "countryCode": "IN",
    "region": "MN",
    "description": "Manipur"
  },
  {
    "countryCode": "IN",
    "region": "MP",
    "description": "Madhya Pradesh"
  },
  {
    "countryCode": "IN",
    "region": "MZ",
    "description": "Mizoram"
  },
  {
    "countryCode": "IN",
    "region": "NL",
    "description": "Nagaland"
  },
  {
    "countryCode": "IN",
    "region": "OD",
    "description": "Odisha"
  },
  {
    "countryCode": "IN",
    "region": "OR",
    "description": "Obsolete"
  },
  {
    "countryCode": "IN",
    "region": "PB",
    "description": "Punjab"
  },
  {
    "countryCode": "IN",
    "region": "PY",
    "description": "Pondicherry"
  },
  {
    "countryCode": "IN",
    "region": "RJ",
    "description": "Rajasthan"
  },
  {
    "countryCode": "IN",
    "region": "SK",
    "description": "Sikkim"
  },
  {
    "countryCode": "IN",
    "region": "TG",
    "description": "Obsolete"
  },
  {
    "countryCode": "IN",
    "region": "TN",
    "description": "Tamil Nadu"
  },
  {
    "countryCode": "IN",
    "region": "TR",
    "description": "Tripura"
  },
  {
    "countryCode": "IN",
    "region": "TS",
    "description": "Telangana"
  },
  {
    "countryCode": "IN",
    "region": "UK",
    "description": "Uttarakhand"
  },
  {
    "countryCode": "IN",
    "region": "UP",
    "description": "Uttar Pradesh"
  },
  {
    "countryCode": "IN",
    "region": "UT",
    "description": "Obsolete"
  },
  {
    "countryCode": "IN",
    "region": "WB",
    "description": "West Bengal"
  },
  {
    "countryCode": "IQ",
    "region": "AN",
    "description": "Al-Anbar"
  },
  {
    "countryCode": "IQ",
    "region": "AR",
    "description": "Arbil"
  },
  {
    "countryCode": "IQ",
    "region": "BA",
    "description": "Basra"
  },
  {
    "countryCode": "IQ",
    "region": "BB",
    "description": "Babil"
  },
  {
    "countryCode": "IQ",
    "region": "BG",
    "description": "Baghdad"
  },
  {
    "countryCode": "IQ",
    "region": "DA",
    "description": "Dahuk"
  },
  {
    "countryCode": "IQ",
    "region": "DI",
    "description": "Diyala"
  },
  {
    "countryCode": "IQ",
    "region": "DQ",
    "description": "Dhi Qar"
  },
  {
    "countryCode": "IQ",
    "region": "KA",
    "description": "Karbala"
  },
  {
    "countryCode": "IQ",
    "region": "KI",
    "description": "Kirkuk"
  },
  {
    "countryCode": "IQ",
    "region": "MA",
    "description": "Maisan"
  },
  {
    "countryCode": "IQ",
    "region": "MU",
    "description": "Al-Muthanna"
  },
  {
    "countryCode": "IQ",
    "region": "NA",
    "description": "An Najaf"
  },
  {
    "countryCode": "IQ",
    "region": "NI",
    "description": "Ninawa"
  },
  {
    "countryCode": "IQ",
    "region": "QA",
    "description": "Al-Qadisiyya"
  },
  {
    "countryCode": "IQ",
    "region": "SD",
    "description": "Salah ad-Din"
  },
  {
    "countryCode": "IQ",
    "region": "SU",
    "description": "As-Sulaimaniyya"
  },
  {
    "countryCode": "IQ",
    "region": "WA",
    "description": "Al-Wasit"
  },
  {
    "countryCode": "IR",
    "region": "01",
    "description": "East Azerbaijan"
  },
  {
    "countryCode": "IR",
    "region": "02",
    "description": "West Azerbaijan"
  },
  {
    "countryCode": "IR",
    "region": "03",
    "description": "Ardabil"
  },
  {
    "countryCode": "IR",
    "region": "04",
    "description": "Isfahan"
  },
  {
    "countryCode": "IR",
    "region": "05",
    "description": "Ilam"
  },
  {
    "countryCode": "IR",
    "region": "06",
    "description": "Bushehr"
  },
  {
    "countryCode": "IR",
    "region": "07",
    "description": "Tehran"
  },
  {
    "countryCode": "IR",
    "region": "08",
    "description": "Chaharmahal/Bakhtiar"
  },
  {
    "countryCode": "IR",
    "region": "10",
    "description": "Khuzestan"
  },
  {
    "countryCode": "IR",
    "region": "11",
    "description": "Zanjan"
  },
  {
    "countryCode": "IR",
    "region": "12",
    "description": "Semnan"
  },
  {
    "countryCode": "IR",
    "region": "13",
    "description": "Sistan/Baluchestan"
  },
  {
    "countryCode": "IR",
    "region": "14",
    "description": "Fars"
  },
  {
    "countryCode": "IR",
    "region": "15",
    "description": "Kerman"
  },
  {
    "countryCode": "IR",
    "region": "16",
    "description": "Kurdistan"
  },
  {
    "countryCode": "IR",
    "region": "17",
    "description": "Kermanshah"
  },
  {
    "countryCode": "IR",
    "region": "18",
    "description": "KohgiluyehBoyerAhm."
  },
  {
    "countryCode": "IR",
    "region": "19",
    "description": "Gilan"
  },
  {
    "countryCode": "IR",
    "region": "20",
    "description": "Lorestan"
  },
  {
    "countryCode": "IR",
    "region": "21",
    "description": "Mazandaran"
  },
  {
    "countryCode": "IR",
    "region": "22",
    "description": "Markazi"
  },
  {
    "countryCode": "IR",
    "region": "23",
    "description": "Hormozgan"
  },
  {
    "countryCode": "IR",
    "region": "24",
    "description": "Hamadan"
  },
  {
    "countryCode": "IR",
    "region": "25",
    "description": "Yazd"
  },
  {
    "countryCode": "IR",
    "region": "26",
    "description": "Qom"
  },
  {
    "countryCode": "IR",
    "region": "27",
    "description": "Golest\u0101n"
  },
  {
    "countryCode": "IR",
    "region": "28",
    "description": "Qazvin"
  },
  {
    "countryCode": "IR",
    "region": "29",
    "description": "South Khorasan"
  },
  {
    "countryCode": "IR",
    "region": "30",
    "description": "Razavi Khorasan"
  },
  {
    "countryCode": "IR",
    "region": "31",
    "description": "North Khorasan"
  },
  {
    "countryCode": "IR",
    "region": "32",
    "description": "Alborz"
  },
  {
    "countryCode": "IS",
    "region": "1",
    "description": "Capital Region"
  },
  {
    "countryCode": "IS",
    "region": "2",
    "description": "Southern Peninsula"
  },
  {
    "countryCode": "IS",
    "region": "3",
    "description": "Western (Vesturland)"
  },
  {
    "countryCode": "IS",
    "region": "4",
    "description": "Westfjords"
  },
  {
    "countryCode": "IS",
    "region": "5",
    "description": "Northwestern Region"
  },
  {
    "countryCode": "IS",
    "region": "6",
    "description": "Northeastern Region"
  },
  {
    "countryCode": "IS",
    "region": "7",
    "description": "Eastern (Austurland)"
  },
  {
    "countryCode": "IS",
    "region": "8",
    "description": "Southern (Su\u00f0urland)"
  },
  {
    "countryCode": "IT",
    "region": "AG",
    "description": "Agrigento"
  },
  {
    "countryCode": "IT",
    "region": "AL",
    "description": "Alessandria"
  },
  {
    "countryCode": "IT",
    "region": "AN",
    "description": "Ancona"
  },
  {
    "countryCode": "IT",
    "region": "AP",
    "description": "Ascoli Piceno"
  },
  {
    "countryCode": "IT",
    "region": "AQ",
    "description": "L'Aquila"
  },
  {
    "countryCode": "IT",
    "region": "AR",
    "description": "Arezzo"
  },
  {
    "countryCode": "IT",
    "region": "AT",
    "description": "Asti"
  },
  {
    "countryCode": "IT",
    "region": "AV",
    "description": "Avellino"
  },
  {
    "countryCode": "IT",
    "region": "BA",
    "description": "Bari"
  },
  {
    "countryCode": "IT",
    "region": "BG",
    "description": "Bergamo"
  },
  {
    "countryCode": "IT",
    "region": "BI",
    "description": "Biella"
  },
  {
    "countryCode": "IT",
    "region": "BL",
    "description": "Belluno"
  },
  {
    "countryCode": "IT",
    "region": "BN",
    "description": "Benevento"
  },
  {
    "countryCode": "IT",
    "region": "BO",
    "description": "Bologna"
  },
  {
    "countryCode": "IT",
    "region": "BR",
    "description": "Brindisi"
  },
  {
    "countryCode": "IT",
    "region": "BS",
    "description": "Brescia"
  },
  {
    "countryCode": "IT",
    "region": "BT",
    "description": "Barletta-Andria-Tr."
  },
  {
    "countryCode": "IT",
    "region": "BZ",
    "description": "Bolzano"
  },
  {
    "countryCode": "IT",
    "region": "CA",
    "description": "Cagliari"
  },
  {
    "countryCode": "IT",
    "region": "CB",
    "description": "Campobasso"
  },
  {
    "countryCode": "IT",
    "region": "CE",
    "description": "Caserta"
  },
  {
    "countryCode": "IT",
    "region": "CH",
    "description": "Chieti"
  },
  {
    "countryCode": "IT",
    "region": "CL",
    "description": "Caltanisetta"
  },
  {
    "countryCode": "IT",
    "region": "CN",
    "description": "Cuneo"
  },
  {
    "countryCode": "IT",
    "region": "CO",
    "description": "Como"
  },
  {
    "countryCode": "IT",
    "region": "CR",
    "description": "Cremona"
  },
  {
    "countryCode": "IT",
    "region": "CS",
    "description": "Cosenza"
  },
  {
    "countryCode": "IT",
    "region": "CT",
    "description": "Catania"
  },
  {
    "countryCode": "IT",
    "region": "CZ",
    "description": "Catanzaro"
  },
  {
    "countryCode": "IT",
    "region": "EN",
    "description": "Enna"
  },
  {
    "countryCode": "IT",
    "region": "FC",
    "description": "Forli/Cesana"
  },
  {
    "countryCode": "IT",
    "region": "FE",
    "description": "Ferrara"
  },
  {
    "countryCode": "IT",
    "region": "FG",
    "description": "Foggia"
  },
  {
    "countryCode": "IT",
    "region": "FI",
    "description": "Florence"
  },
  {
    "countryCode": "IT",
    "region": "FM",
    "description": "Fermo"
  },
  {
    "countryCode": "IT",
    "region": "FR",
    "description": "Frosinone"
  },
  {
    "countryCode": "IT",
    "region": "GE",
    "description": "Genova"
  },
  {
    "countryCode": "IT",
    "region": "GO",
    "description": "Gorizia"
  },
  {
    "countryCode": "IT",
    "region": "GR",
    "description": "Grosseto"
  },
  {
    "countryCode": "IT",
    "region": "IM",
    "description": "Imperia"
  },
  {
    "countryCode": "IT",
    "region": "IS",
    "description": "Isernia"
  },
  {
    "countryCode": "IT",
    "region": "KR",
    "description": "Crotone"
  },
  {
    "countryCode": "IT",
    "region": "LC",
    "description": "Lecco"
  },
  {
    "countryCode": "IT",
    "region": "LE",
    "description": "Lecce"
  },
  {
    "countryCode": "IT",
    "region": "LI",
    "description": "Livorno"
  },
  {
    "countryCode": "IT",
    "region": "LO",
    "description": "Lodi"
  },
  {
    "countryCode": "IT",
    "region": "LT",
    "description": "Latina"
  },
  {
    "countryCode": "IT",
    "region": "LU",
    "description": "Lucca"
  },
  {
    "countryCode": "IT",
    "region": "MB",
    "description": "Monza e Brianza"
  },
  {
    "countryCode": "IT",
    "region": "MC",
    "description": "Macerata"
  },
  {
    "countryCode": "IT",
    "region": "ME",
    "description": "Messina"
  },
  {
    "countryCode": "IT",
    "region": "MI",
    "description": "Milan"
  },
  {
    "countryCode": "IT",
    "region": "MN",
    "description": "Mantova"
  },
  {
    "countryCode": "IT",
    "region": "MO",
    "description": "Modena"
  },
  {
    "countryCode": "IT",
    "region": "MS",
    "description": "Massa Carrara"
  },
  {
    "countryCode": "IT",
    "region": "MT",
    "description": "Matera"
  },
  {
    "countryCode": "IT",
    "region": "NA",
    "description": "Naples"
  },
  {
    "countryCode": "IT",
    "region": "NO",
    "description": "Novara"
  },
  {
    "countryCode": "IT",
    "region": "NU",
    "description": "Nuoro"
  },
  {
    "countryCode": "IT",
    "region": "OR",
    "description": "Oristano"
  },
  {
    "countryCode": "IT",
    "region": "PA",
    "description": "Palermo"
  },
  {
    "countryCode": "IT",
    "region": "PC",
    "description": "Piacenza"
  },
  {
    "countryCode": "IT",
    "region": "PD",
    "description": "Padova"
  },
  {
    "countryCode": "IT",
    "region": "PE",
    "description": "Pescara"
  },
  {
    "countryCode": "IT",
    "region": "PG",
    "description": "Perugia"
  },
  {
    "countryCode": "IT",
    "region": "PI",
    "description": "Pisa"
  },
  {
    "countryCode": "IT",
    "region": "PN",
    "description": "Pordenone"
  },
  {
    "countryCode": "IT",
    "region": "PO",
    "description": "Prato"
  },
  {
    "countryCode": "IT",
    "region": "PR",
    "description": "Parma"
  },
  {
    "countryCode": "IT",
    "region": "PT",
    "description": "Pistoia"
  },
  {
    "countryCode": "IT",
    "region": "PU",
    "description": "Pesaro-Urbino"
  },
  {
    "countryCode": "IT",
    "region": "PV",
    "description": "Pavia"
  },
  {
    "countryCode": "IT",
    "region": "PZ",
    "description": "Potenza"
  },
  {
    "countryCode": "IT",
    "region": "RA",
    "description": "Ravenna"
  },
  {
    "countryCode": "IT",
    "region": "RC",
    "description": "Reggio Calabria"
  },
  {
    "countryCode": "IT",
    "region": "RE",
    "description": "Reggio Emilia"
  },
  {
    "countryCode": "IT",
    "region": "RG",
    "description": "Ragusa"
  },
  {
    "countryCode": "IT",
    "region": "RI",
    "description": "Rieti"
  },
  {
    "countryCode": "IT",
    "region": "RM",
    "description": "Rome"
  },
  {
    "countryCode": "IT",
    "region": "RN",
    "description": "Rimini"
  },
  {
    "countryCode": "IT",
    "region": "RO",
    "description": "Rovigo"
  },
  {
    "countryCode": "IT",
    "region": "SA",
    "description": "Salerno"
  },
  {
    "countryCode": "IT",
    "region": "SD",
    "description": "Obsolete"
  },
  {
    "countryCode": "IT",
    "region": "SI",
    "description": "Siena"
  },
  {
    "countryCode": "IT",
    "region": "SO",
    "description": "Sondrio"
  },
  {
    "countryCode": "IT",
    "region": "SP",
    "description": "La Spezia"
  },
  {
    "countryCode": "IT",
    "region": "SR",
    "description": "Siracusa"
  },
  {
    "countryCode": "IT",
    "region": "SS",
    "description": "Sassari"
  },
  {
    "countryCode": "IT",
    "region": "SU",
    "description": "South Sardinia"
  },
  {
    "countryCode": "IT",
    "region": "SV",
    "description": "Savona"
  },
  {
    "countryCode": "IT",
    "region": "TA",
    "description": "Taranto"
  },
  {
    "countryCode": "IT",
    "region": "TE",
    "description": "Teramo"
  },
  {
    "countryCode": "IT",
    "region": "TN",
    "description": "Trento"
  },
  {
    "countryCode": "IT",
    "region": "TO",
    "description": "Turin"
  },
  {
    "countryCode": "IT",
    "region": "TP",
    "description": "Trapani"
  },
  {
    "countryCode": "IT",
    "region": "TR",
    "description": "Terni"
  },
  {
    "countryCode": "IT",
    "region": "TS",
    "description": "Trieste"
  },
  {
    "countryCode": "IT",
    "region": "TV",
    "description": "Treviso"
  },
  {
    "countryCode": "IT",
    "region": "UD",
    "description": "Udine"
  },
  {
    "countryCode": "IT",
    "region": "VA",
    "description": "Varese"
  },
  {
    "countryCode": "IT",
    "region": "VB",
    "description": "Verbania"
  },
  {
    "countryCode": "IT",
    "region": "VC",
    "description": "Vercelli"
  },
  {
    "countryCode": "IT",
    "region": "VE",
    "description": "Venice"
  },
  {
    "countryCode": "IT",
    "region": "VI",
    "description": "Vicenza"
  },
  {
    "countryCode": "IT",
    "region": "VR",
    "description": "Verona"
  },
  {
    "countryCode": "IT",
    "region": "VT",
    "description": "Viterbo"
  },
  {
    "countryCode": "IT",
    "region": "VV",
    "description": "Vibo Valentia"
  },
  {
    "countryCode": "JM",
    "region": "01",
    "description": "Kingston"
  },
  {
    "countryCode": "JM",
    "region": "02",
    "description": "Saint Andrew"
  },
  {
    "countryCode": "JM",
    "region": "03",
    "description": "Saint Thomas"
  },
  {
    "countryCode": "JM",
    "region": "04",
    "description": "Portland"
  },
  {
    "countryCode": "JM",
    "region": "05",
    "description": "Saint Mary"
  },
  {
    "countryCode": "JM",
    "region": "06",
    "description": "Saint Ann"
  },
  {
    "countryCode": "JM",
    "region": "07",
    "description": "Trelawny"
  },
  {
    "countryCode": "JM",
    "region": "08",
    "description": "Saint James"
  },
  {
    "countryCode": "JM",
    "region": "09",
    "description": "Hanover"
  },
  {
    "countryCode": "JM",
    "region": "10",
    "description": "Westmoreland"
  },
  {
    "countryCode": "JM",
    "region": "11",
    "description": "Saint Elizabeth"
  },
  {
    "countryCode": "JM",
    "region": "12",
    "description": "Manchester"
  },
  {
    "countryCode": "JM",
    "region": "13",
    "description": "Clarendon"
  },
  {
    "countryCode": "JM",
    "region": "14",
    "description": "Saint Catherine"
  },
  {
    "countryCode": "JO",
    "region": "AJ",
    "description": "Ajloun"
  },
  {
    "countryCode": "JO",
    "region": "AM",
    "description": "Amman"
  },
  {
    "countryCode": "JO",
    "region": "AQ",
    "description": "Aqaba"
  },
  {
    "countryCode": "JO",
    "region": "AT",
    "description": "Tafila"
  },
  {
    "countryCode": "JO",
    "region": "AZ",
    "description": "Zarqa"
  },
  {
    "countryCode": "JO",
    "region": "BA",
    "description": "Balqa"
  },
  {
    "countryCode": "JO",
    "region": "IR",
    "description": "Irbid"
  },
  {
    "countryCode": "JO",
    "region": "JA",
    "description": "Jarash"
  },
  {
    "countryCode": "JO",
    "region": "KA",
    "description": "Karak"
  },
  {
    "countryCode": "JO",
    "region": "MA",
    "description": "Mafraq"
  },
  {
    "countryCode": "JO",
    "region": "MD",
    "description": "Madaba"
  },
  {
    "countryCode": "JO",
    "region": "MN",
    "description": "Ma'an"
  },
  {
    "countryCode": "JP",
    "region": "01",
    "description": "Hokkaido"
  },
  {
    "countryCode": "JP",
    "region": "02",
    "description": "Aomori"
  },
  {
    "countryCode": "JP",
    "region": "03",
    "description": "Iwate"
  },
  {
    "countryCode": "JP",
    "region": "04",
    "description": "Miyagi"
  },
  {
    "countryCode": "JP",
    "region": "05",
    "description": "Akita"
  },
  {
    "countryCode": "JP",
    "region": "06",
    "description": "Yamagata"
  },
  {
    "countryCode": "JP",
    "region": "07",
    "description": "Fukushima"
  },
  {
    "countryCode": "JP",
    "region": "08",
    "description": "Ibaraki"
  },
  {
    "countryCode": "JP",
    "region": "09",
    "description": "Tochigi"
  },
  {
    "countryCode": "JP",
    "region": "10",
    "description": "Gunma"
  },
  {
    "countryCode": "JP",
    "region": "11",
    "description": "Saitama"
  },
  {
    "countryCode": "JP",
    "region": "12",
    "description": "Chiba"
  },
  {
    "countryCode": "JP",
    "region": "13",
    "description": "Tokyo"
  },
  {
    "countryCode": "JP",
    "region": "14",
    "description": "Kanagawa"
  },
  {
    "countryCode": "JP",
    "region": "15",
    "description": "Niigata"
  },
  {
    "countryCode": "JP",
    "region": "16",
    "description": "Toyama"
  },
  {
    "countryCode": "JP",
    "region": "17",
    "description": "Ishikawa"
  },
  {
    "countryCode": "JP",
    "region": "18",
    "description": "Fukui"
  },
  {
    "countryCode": "JP",
    "region": "19",
    "description": "Yamanashi"
  },
  {
    "countryCode": "JP",
    "region": "20",
    "description": "Nagano"
  },
  {
    "countryCode": "JP",
    "region": "21",
    "description": "Gifu"
  },
  {
    "countryCode": "JP",
    "region": "22",
    "description": "Shizuoka"
  },
  {
    "countryCode": "JP",
    "region": "23",
    "description": "Aichi"
  },
  {
    "countryCode": "JP",
    "region": "24",
    "description": "Mie"
  },
  {
    "countryCode": "JP",
    "region": "25",
    "description": "Shiga"
  },
  {
    "countryCode": "JP",
    "region": "26",
    "description": "Kyoto"
  },
  {
    "countryCode": "JP",
    "region": "27",
    "description": "Osaka"
  },
  {
    "countryCode": "JP",
    "region": "28",
    "description": "Hyogo"
  },
  {
    "countryCode": "JP",
    "region": "29",
    "description": "Nara"
  },
  {
    "countryCode": "JP",
    "region": "30",
    "description": "Wakayama"
  },
  {
    "countryCode": "JP",
    "region": "31",
    "description": "Tottori"
  },
  {
    "countryCode": "JP",
    "region": "32",
    "description": "Shimane"
  },
  {
    "countryCode": "JP",
    "region": "33",
    "description": "Okayama"
  },
  {
    "countryCode": "JP",
    "region": "34",
    "description": "Hiroshima"
  },
  {
    "countryCode": "JP",
    "region": "35",
    "description": "Yamaguchi"
  },
  {
    "countryCode": "JP",
    "region": "36",
    "description": "Tokushima"
  },
  {
    "countryCode": "JP",
    "region": "37",
    "description": "Kagawa"
  },
  {
    "countryCode": "JP",
    "region": "38",
    "description": "Ehime"
  },
  {
    "countryCode": "JP",
    "region": "39",
    "description": "Kochi"
  },
  {
    "countryCode": "JP",
    "region": "40",
    "description": "Fukuoka"
  },
  {
    "countryCode": "JP",
    "region": "41",
    "description": "Saga"
  },
  {
    "countryCode": "JP",
    "region": "42",
    "description": "Nagasaki"
  },
  {
    "countryCode": "JP",
    "region": "43",
    "description": "Kumamoto"
  },
  {
    "countryCode": "JP",
    "region": "44",
    "description": "Oita"
  },
  {
    "countryCode": "JP",
    "region": "45",
    "description": "Miyazaki"
  },
  {
    "countryCode": "JP",
    "region": "46",
    "description": "Kagoshima"
  },
  {
    "countryCode": "JP",
    "region": "47",
    "description": "Okinawa"
  },
  {
    "countryCode": "KE",
    "region": "01",
    "description": "Baringo"
  },
  {
    "countryCode": "KE",
    "region": "02",
    "description": "Bomet"
  },
  {
    "countryCode": "KE",
    "region": "03",
    "description": "Bungoma"
  },
  {
    "countryCode": "KE",
    "region": "04",
    "description": "Busia"
  },
  {
    "countryCode": "KE",
    "region": "05",
    "description": "Elgeyo/Marakwet"
  },
  {
    "countryCode": "KE",
    "region": "06",
    "description": "Embu"
  },
  {
    "countryCode": "KE",
    "region": "07",
    "description": "Garissa"
  },
  {
    "countryCode": "KE",
    "region": "08",
    "description": "Homa Bay"
  },
  {
    "countryCode": "KE",
    "region": "09",
    "description": "Isiolo"
  },
  {
    "countryCode": "KE",
    "region": "10",
    "description": "Kajiado"
  },
  {
    "countryCode": "KE",
    "region": "11",
    "description": "Kakamega"
  },
  {
    "countryCode": "KE",
    "region": "12",
    "description": "Kericho"
  },
  {
    "countryCode": "KE",
    "region": "13",
    "description": "Kiambu"
  },
  {
    "countryCode": "KE",
    "region": "14",
    "description": "Kilifi"
  },
  {
    "countryCode": "KE",
    "region": "15",
    "description": "Kirinyaga"
  },
  {
    "countryCode": "KE",
    "region": "16",
    "description": "Kisii"
  },
  {
    "countryCode": "KE",
    "region": "17",
    "description": "Kisumu"
  },
  {
    "countryCode": "KE",
    "region": "18",
    "description": "Kitui"
  },
  {
    "countryCode": "KE",
    "region": "19",
    "description": "Kwale"
  },
  {
    "countryCode": "KE",
    "region": "20",
    "description": "Laikipia"
  },
  {
    "countryCode": "KE",
    "region": "21",
    "description": "Lamu"
  },
  {
    "countryCode": "KE",
    "region": "22",
    "description": "Machakos"
  },
  {
    "countryCode": "KE",
    "region": "23",
    "description": "Makueni"
  },
  {
    "countryCode": "KE",
    "region": "24",
    "description": "Mandera"
  },
  {
    "countryCode": "KE",
    "region": "25",
    "description": "Marsabit"
  },
  {
    "countryCode": "KE",
    "region": "26",
    "description": "Meru"
  },
  {
    "countryCode": "KE",
    "region": "27",
    "description": "Migori"
  },
  {
    "countryCode": "KE",
    "region": "28",
    "description": "Mombasa"
  },
  {
    "countryCode": "KE",
    "region": "29",
    "description": "Murang'a"
  },
  {
    "countryCode": "KE",
    "region": "30",
    "description": "Nairobi City"
  },
  {
    "countryCode": "KE",
    "region": "31",
    "description": "Nakuru"
  },
  {
    "countryCode": "KE",
    "region": "32",
    "description": "Nandi"
  },
  {
    "countryCode": "KE",
    "region": "33",
    "description": "Narok"
  },
  {
    "countryCode": "KE",
    "region": "34",
    "description": "Nyamira"
  },
  {
    "countryCode": "KE",
    "region": "35",
    "description": "Nyandarua"
  },
  {
    "countryCode": "KE",
    "region": "36",
    "description": "Nyeri"
  },
  {
    "countryCode": "KE",
    "region": "37",
    "description": "Samburu"
  },
  {
    "countryCode": "KE",
    "region": "38",
    "description": "Siaya"
  },
  {
    "countryCode": "KE",
    "region": "39",
    "description": "Taita/Taveta"
  },
  {
    "countryCode": "KE",
    "region": "40",
    "description": "Tana River"
  },
  {
    "countryCode": "KE",
    "region": "41",
    "description": "Tharaka-Nithi"
  },
  {
    "countryCode": "KE",
    "region": "42",
    "description": "Trans Nzoia"
  },
  {
    "countryCode": "KE",
    "region": "43",
    "description": "Turkana"
  },
  {
    "countryCode": "KE",
    "region": "44",
    "description": "Uasin Gishu"
  },
  {
    "countryCode": "KE",
    "region": "45",
    "description": "Vihiga"
  },
  {
    "countryCode": "KE",
    "region": "46",
    "description": "Wajir"
  },
  {
    "countryCode": "KE",
    "region": "47",
    "description": "West Pokot"
  },
  {
    "countryCode": "KG",
    "region": "B",
    "description": "Batken"
  },
  {
    "countryCode": "KG",
    "region": "C",
    "description": "Chuy"
  },
  {
    "countryCode": "KG",
    "region": "GB",
    "description": "Bishkek"
  },
  {
    "countryCode": "KG",
    "region": "GO",
    "description": "Osh City"
  },
  {
    "countryCode": "KG",
    "region": "J",
    "description": "Jalal-Abad"
  },
  {
    "countryCode": "KG",
    "region": "N",
    "description": "Naryn"
  },
  {
    "countryCode": "KG",
    "region": "O",
    "description": "Osh region"
  },
  {
    "countryCode": "KG",
    "region": "T",
    "description": "Talas"
  },
  {
    "countryCode": "KG",
    "region": "Y",
    "description": "Ysyk-Kul"
  },
  {
    "countryCode": "KH",
    "region": "1",
    "description": "Banteay Mean Cho\u0103y"
  },
  {
    "countryCode": "KH",
    "region": "10",
    "description": "Kracheh"
  },
  {
    "countryCode": "KH",
    "region": "11",
    "description": "Mondol Kiri"
  },
  {
    "countryCode": "KH",
    "region": "12",
    "description": "Phnom Penh"
  },
  {
    "countryCode": "KH",
    "region": "13",
    "description": "Preah Vihear"
  },
  {
    "countryCode": "KH",
    "region": "14",
    "description": "Prey Veaeng"
  },
  {
    "countryCode": "KH",
    "region": "15",
    "description": "Pousaat"
  },
  {
    "countryCode": "KH",
    "region": "16",
    "description": "Rotanak Kiri"
  },
  {
    "countryCode": "KH",
    "region": "17",
    "description": "Siem Reab"
  },
  {
    "countryCode": "KH",
    "region": "18",
    "description": "Preah Sihanouk"
  },
  {
    "countryCode": "KH",
    "region": "19",
    "description": "Stueng Traeng"
  },
  {
    "countryCode": "KH",
    "region": "2",
    "description": "Baat Dambang"
  },
  {
    "countryCode": "KH",
    "region": "20",
    "description": "Svaay Rieng"
  },
  {
    "countryCode": "KH",
    "region": "21",
    "description": "Taakaev"
  },
  {
    "countryCode": "KH",
    "region": "22",
    "description": "Otdar Mean Chey"
  },
  {
    "countryCode": "KH",
    "region": "23",
    "description": "Kaeb"
  },
  {
    "countryCode": "KH",
    "region": "24",
    "description": "Pailin"
  },
  {
    "countryCode": "KH",
    "region": "25",
    "description": "Tbong Khmum"
  },
  {
    "countryCode": "KH",
    "region": "3",
    "description": "Kampong Chaam"
  },
  {
    "countryCode": "KH",
    "region": "4",
    "description": "Kampong Chhnang"
  },
  {
    "countryCode": "KH",
    "region": "5",
    "description": "Kampong Spueu"
  },
  {
    "countryCode": "KH",
    "region": "6",
    "description": "Kampong Thum"
  },
  {
    "countryCode": "KH",
    "region": "7",
    "description": "Kampot"
  },
  {
    "countryCode": "KH",
    "region": "8",
    "description": "Kandaal"
  },
  {
    "countryCode": "KH",
    "region": "9",
    "description": "Kaoh Kong"
  },
  {
    "countryCode": "KI",
    "region": "G",
    "description": "Gilbert Islands"
  },
  {
    "countryCode": "KI",
    "region": "L",
    "description": "Line Islands"
  },
  {
    "countryCode": "KI",
    "region": "P",
    "description": "Phoenix Islands"
  },
  {
    "countryCode": "KM",
    "region": "A",
    "description": "Anjouan"
  },
  {
    "countryCode": "KM",
    "region": "G",
    "description": "Grande Comore"
  },
  {
    "countryCode": "KM",
    "region": "M",
    "description": "Moh\u00e9li"
  },
  {
    "countryCode": "KN",
    "region": "01",
    "description": "ChristChurchNicholaT"
  },
  {
    "countryCode": "KN",
    "region": "02",
    "description": "St Anne Sandy Point"
  },
  {
    "countryCode": "KN",
    "region": "03",
    "description": "St George Basseterre"
  },
  {
    "countryCode": "KN",
    "region": "04",
    "description": "St George Gingerland"
  },
  {
    "countryCode": "KN",
    "region": "05",
    "description": "St James Windward"
  },
  {
    "countryCode": "KN",
    "region": "06",
    "description": "St John Capisterre"
  },
  {
    "countryCode": "KN",
    "region": "07",
    "description": "St John Figtree"
  },
  {
    "countryCode": "KN",
    "region": "08",
    "description": "St Mary Cayon"
  },
  {
    "countryCode": "KN",
    "region": "09",
    "description": "St Paul Capisterre"
  },
  {
    "countryCode": "KN",
    "region": "10",
    "description": "St Paul Charlestown"
  },
  {
    "countryCode": "KN",
    "region": "11",
    "description": "St Peter Basseterre"
  },
  {
    "countryCode": "KN",
    "region": "12",
    "description": "St Thomas Lowland"
  },
  {
    "countryCode": "KN",
    "region": "13",
    "description": "St Thomas Mid.Island"
  },
  {
    "countryCode": "KN",
    "region": "15",
    "description": "Trinity Palmetto Pt."
  },
  {
    "countryCode": "KP",
    "region": "01",
    "description": "Pyongyang"
  },
  {
    "countryCode": "KP",
    "region": "02",
    "description": "South Pyongan"
  },
  {
    "countryCode": "KP",
    "region": "03",
    "description": "North Pyongan"
  },
  {
    "countryCode": "KP",
    "region": "04",
    "description": "Chagang"
  },
  {
    "countryCode": "KP",
    "region": "05",
    "description": "South Hwanghae"
  },
  {
    "countryCode": "KP",
    "region": "06",
    "description": "North Hwanghae"
  },
  {
    "countryCode": "KP",
    "region": "07",
    "description": "Kangwon"
  },
  {
    "countryCode": "KP",
    "region": "08",
    "description": "South Hamgyong"
  },
  {
    "countryCode": "KP",
    "region": "09",
    "description": "North Hamgyong"
  },
  {
    "countryCode": "KP",
    "region": "10",
    "description": "Ryanggang"
  },
  {
    "countryCode": "KP",
    "region": "13",
    "description": "Rason"
  },
  {
    "countryCode": "KP",
    "region": "14",
    "description": "Nampho"
  },
  {
    "countryCode": "KP",
    "region": "15",
    "description": "Kaeseong"
  },
  {
    "countryCode": "KR",
    "region": "11",
    "description": "Seoul"
  },
  {
    "countryCode": "KR",
    "region": "26",
    "description": "Busan"
  },
  {
    "countryCode": "KR",
    "region": "27",
    "description": "Daegu"
  },
  {
    "countryCode": "KR",
    "region": "28",
    "description": "Incheon"
  },
  {
    "countryCode": "KR",
    "region": "29",
    "description": "Gwangju"
  },
  {
    "countryCode": "KR",
    "region": "30",
    "description": "Daejeon"
  },
  {
    "countryCode": "KR",
    "region": "31",
    "description": "Ulsan"
  },
  {
    "countryCode": "KR",
    "region": "41",
    "description": "Gyeonggi"
  },
  {
    "countryCode": "KR",
    "region": "42",
    "description": "Gangwon"
  },
  {
    "countryCode": "KR",
    "region": "43",
    "description": "North Chungcheong"
  },
  {
    "countryCode": "KR",
    "region": "44",
    "description": "South Chungcheong"
  },
  {
    "countryCode": "KR",
    "region": "45",
    "description": "North Jeolla"
  },
  {
    "countryCode": "KR",
    "region": "46",
    "description": "South Jeolla"
  },
  {
    "countryCode": "KR",
    "region": "47",
    "description": "North Gyeongsang"
  },
  {
    "countryCode": "KR",
    "region": "48",
    "description": "South Gyeongsang"
  },
  {
    "countryCode": "KR",
    "region": "49",
    "description": "Jeju"
  },
  {
    "countryCode": "KR",
    "region": "50",
    "description": "Sejong"
  },
  {
    "countryCode": "KW",
    "region": "AH",
    "description": "Al Ahmadi"
  },
  {
    "countryCode": "KW",
    "region": "FA",
    "description": "Al Farwaniyah"
  },
  {
    "countryCode": "KW",
    "region": "HA",
    "description": "Hawalli"
  },
  {
    "countryCode": "KW",
    "region": "JA",
    "description": "Al Jahra"
  },
  {
    "countryCode": "KW",
    "region": "KU",
    "description": "Al Kuwayt(Al Asimah)"
  },
  {
    "countryCode": "KW",
    "region": "MU",
    "description": "Mubarak al Kabir"
  },
  {
    "countryCode": "KZ",
    "region": "10",
    "description": "Abajskaja region"
  },
  {
    "countryCode": "KZ",
    "region": "11",
    "description": "Akmola region"
  },
  {
    "countryCode": "KZ",
    "region": "15",
    "description": "Aktobe region"
  },
  {
    "countryCode": "KZ",
    "region": "19",
    "description": "Almaty Region"
  },
  {
    "countryCode": "KZ",
    "region": "23",
    "description": "Atyrau region"
  },
  {
    "countryCode": "KZ",
    "region": "27",
    "description": "West-Kazakhstan reg."
  },
  {
    "countryCode": "KZ",
    "region": "31",
    "description": "Zhambyl region"
  },
  {
    "countryCode": "KZ",
    "region": "33",
    "description": "Zhetysuskaya region"
  },
  {
    "countryCode": "KZ",
    "region": "35",
    "description": "Karagandy region"
  },
  {
    "countryCode": "KZ",
    "region": "39",
    "description": "Kostanay region"
  },
  {
    "countryCode": "KZ",
    "region": "43",
    "description": "Kyzylorda region"
  },
  {
    "countryCode": "KZ",
    "region": "47",
    "description": "Manghystau region"
  },
  {
    "countryCode": "KZ",
    "region": "55",
    "description": "Pavlodar region"
  },
  {
    "countryCode": "KZ",
    "region": "59",
    "description": "North-Kazakhstan reg"
  },
  {
    "countryCode": "KZ",
    "region": "61",
    "description": "Turkistan Region"
  },
  {
    "countryCode": "KZ",
    "region": "62",
    "description": "Ulytauskaya region"
  },
  {
    "countryCode": "KZ",
    "region": "63",
    "description": "East-Kazakhstan reg."
  },
  {
    "countryCode": "KZ",
    "region": "71",
    "description": "Astana"
  },
  {
    "countryCode": "KZ",
    "region": "75",
    "description": "Almaty"
  },
  {
    "countryCode": "KZ",
    "region": "79",
    "description": "Shymkent"
  },
  {
    "countryCode": "KZ",
    "region": "AKM",
    "description": "Obsolete"
  },
  {
    "countryCode": "KZ",
    "region": "AKT",
    "description": "Obsolete"
  },
  {
    "countryCode": "KZ",
    "region": "ALA",
    "description": "Obsolete"
  },
  {
    "countryCode": "KZ",
    "region": "ALM",
    "description": "Obsolete"
  },
  {
    "countryCode": "KZ",
    "region": "AST",
    "description": "Obsolete"
  },
  {
    "countryCode": "KZ",
    "region": "ATY",
    "description": "Obsolete"
  },
  {
    "countryCode": "KZ",
    "region": "BAY",
    "description": "Obsolete"
  },
  {
    "countryCode": "KZ",
    "region": "KAR",
    "description": "Obsolete"
  },
  {
    "countryCode": "KZ",
    "region": "KUS",
    "description": "Obsolete"
  },
  {
    "countryCode": "KZ",
    "region": "KZY",
    "description": "Obsolete"
  },
  {
    "countryCode": "KZ",
    "region": "MAN",
    "description": "Obsolete"
  },
  {
    "countryCode": "KZ",
    "region": "PAV",
    "description": "Obsolete"
  },
  {
    "countryCode": "KZ",
    "region": "SEV",
    "description": "Obsolete"
  },
  {
    "countryCode": "KZ",
    "region": "SHY",
    "description": "Obsolete"
  },
  {
    "countryCode": "KZ",
    "region": "VOS",
    "description": "Obsolete"
  },
  {
    "countryCode": "KZ",
    "region": "YUZ",
    "description": "Obsolete"
  },
  {
    "countryCode": "KZ",
    "region": "ZAP",
    "description": "Obsolete"
  },
  {
    "countryCode": "KZ",
    "region": "ZHA",
    "description": "Obsolete"
  },
  {
    "countryCode": "LA",
    "region": "AT",
    "description": "Attapu"
  },
  {
    "countryCode": "LA",
    "region": "BK",
    "description": "Bok\u00e8o"
  },
  {
    "countryCode": "LA",
    "region": "BL",
    "description": "Bolikhamxai"
  },
  {
    "countryCode": "LA",
    "region": "CH",
    "description": "Champasak"
  },
  {
    "countryCode": "LA",
    "region": "HO",
    "description": "Houaphan"
  },
  {
    "countryCode": "LA",
    "region": "KH",
    "description": "Khammouan"
  },
  {
    "countryCode": "LA",
    "region": "LM",
    "description": "Louang Namtha"
  },
  {
    "countryCode": "LA",
    "region": "LP",
    "description": "Luangphabang"
  },
  {
    "countryCode": "LA",
    "region": "OU",
    "description": "Oud\u00f4mxai"
  },
  {
    "countryCode": "LA",
    "region": "PH",
    "description": "Ph\u00f4ngsali"
  },
  {
    "countryCode": "LA",
    "region": "SL",
    "description": "Salavan"
  },
  {
    "countryCode": "LA",
    "region": "SV",
    "description": "Savannakh\u00e9t"
  },
  {
    "countryCode": "LA",
    "region": "VI",
    "description": "Vientiane"
  },
  {
    "countryCode": "LA",
    "region": "VT",
    "description": "Vientiane Prefecture"
  },
  {
    "countryCode": "LA",
    "region": "XA",
    "description": "Xaignabouli"
  },
  {
    "countryCode": "LA",
    "region": "XE",
    "description": "X\u00e9kong"
  },
  {
    "countryCode": "LA",
    "region": "XI",
    "description": "Xiangkhouang"
  },
  {
    "countryCode": "LA",
    "region": "XS",
    "description": "Xais\u00f4mboun"
  },
  {
    "countryCode": "LB",
    "region": "AK",
    "description": "Akkar"
  },
  {
    "countryCode": "LB",
    "region": "AS",
    "description": "North-Lebanon"
  },
  {
    "countryCode": "LB",
    "region": "BA",
    "description": "Beirut"
  },
  {
    "countryCode": "LB",
    "region": "BH",
    "description": "Baalbek-Hermel"
  },
  {
    "countryCode": "LB",
    "region": "BI",
    "description": "B\u00e9qaa"
  },
  {
    "countryCode": "LB",
    "region": "JA",
    "description": "South-Lebanon"
  },
  {
    "countryCode": "LB",
    "region": "JL",
    "description": "Mount Lebanon"
  },
  {
    "countryCode": "LB",
    "region": "NA",
    "description": "Nabatieh"
  },
  {
    "countryCode": "LI",
    "region": "01",
    "description": "Balzers"
  },
  {
    "countryCode": "LI",
    "region": "02",
    "description": "Eschen"
  },
  {
    "countryCode": "LI",
    "region": "03",
    "description": "Gamprin"
  },
  {
    "countryCode": "LI",
    "region": "04",
    "description": "Mauren"
  },
  {
    "countryCode": "LI",
    "region": "05",
    "description": "Planken"
  },
  {
    "countryCode": "LI",
    "region": "06",
    "description": "Ruggell"
  },
  {
    "countryCode": "LI",
    "region": "07",
    "description": "Schaan"
  },
  {
    "countryCode": "LI",
    "region": "08",
    "description": "Schellenberg"
  },
  {
    "countryCode": "LI",
    "region": "09",
    "description": "Triesen"
  },
  {
    "countryCode": "LI",
    "region": "10",
    "description": "Triesenberg"
  },
  {
    "countryCode": "LI",
    "region": "11",
    "description": "Vaduz"
  },
  {
    "countryCode": "LK",
    "region": "11",
    "description": "Colombo"
  },
  {
    "countryCode": "LK",
    "region": "12",
    "description": "Gampaha"
  },
  {
    "countryCode": "LK",
    "region": "13",
    "description": "Kalutara"
  },
  {
    "countryCode": "LK",
    "region": "21",
    "description": "Kandy"
  },
  {
    "countryCode": "LK",
    "region": "22",
    "description": "Matale"
  },
  {
    "countryCode": "LK",
    "region": "23",
    "description": "Nuwara Eliya"
  },
  {
    "countryCode": "LK",
    "region": "31",
    "description": "Galle"
  },
  {
    "countryCode": "LK",
    "region": "32",
    "description": "Matara"
  },
  {
    "countryCode": "LK",
    "region": "33",
    "description": "Hambantota"
  },
  {
    "countryCode": "LK",
    "region": "41",
    "description": "Jaffna"
  },
  {
    "countryCode": "LK",
    "region": "42",
    "description": "Kilinochchi"
  },
  {
    "countryCode": "LK",
    "region": "43",
    "description": "Mannar"
  },
  {
    "countryCode": "LK",
    "region": "44",
    "description": "Vavuniya"
  },
  {
    "countryCode": "LK",
    "region": "45",
    "description": "Mullaitivu"
  },
  {
    "countryCode": "LK",
    "region": "51",
    "description": "Batticaola"
  },
  {
    "countryCode": "LK",
    "region": "52",
    "description": "Ampara"
  },
  {
    "countryCode": "LK",
    "region": "53",
    "description": "Trincomalee"
  },
  {
    "countryCode": "LK",
    "region": "61",
    "description": "Kurunegala"
  },
  {
    "countryCode": "LK",
    "region": "62",
    "description": "Puttalam"
  },
  {
    "countryCode": "LK",
    "region": "71",
    "description": "Arunadhapura"
  },
  {
    "countryCode": "LK",
    "region": "72",
    "description": "Polonnaruwa"
  },
  {
    "countryCode": "LK",
    "region": "81",
    "description": "Badulla"
  },
  {
    "countryCode": "LK",
    "region": "82",
    "description": "Moneragala"
  },
  {
    "countryCode": "LK",
    "region": "91",
    "description": "Ratnapura"
  },
  {
    "countryCode": "LK",
    "region": "92",
    "description": "Kegalle"
  },
  {
    "countryCode": "LR",
    "region": "BG",
    "description": "Bong"
  },
  {
    "countryCode": "LR",
    "region": "BM",
    "description": "Bomi"
  },
  {
    "countryCode": "LR",
    "region": "CM",
    "description": "Grand Cape Mount"
  },
  {
    "countryCode": "LR",
    "region": "GB",
    "description": "Grand Bassa"
  },
  {
    "countryCode": "LR",
    "region": "GG",
    "description": "Grand Gedeh"
  },
  {
    "countryCode": "LR",
    "region": "GK",
    "description": "Grand Kru"
  },
  {
    "countryCode": "LR",
    "region": "GP",
    "description": "Gbarpolu"
  },
  {
    "countryCode": "LR",
    "region": "LO",
    "description": "Lofa"
  },
  {
    "countryCode": "LR",
    "region": "MG",
    "description": "Margibi"
  },
  {
    "countryCode": "LR",
    "region": "MO",
    "description": "Montserrado"
  },
  {
    "countryCode": "LR",
    "region": "MY",
    "description": "Maryland"
  },
  {
    "countryCode": "LR",
    "region": "NI",
    "description": "Nimba"
  },
  {
    "countryCode": "LR",
    "region": "RG",
    "description": "River Gee"
  },
  {
    "countryCode": "LR",
    "region": "RI",
    "description": "River Cess"
  },
  {
    "countryCode": "LR",
    "region": "SI",
    "description": "Sinoe"
  },
  {
    "countryCode": "LS",
    "region": "A",
    "description": "Maseru"
  },
  {
    "countryCode": "LS",
    "region": "B",
    "description": "Botha-Bothe"
  },
  {
    "countryCode": "LS",
    "region": "C",
    "description": "Leribe"
  },
  {
    "countryCode": "LS",
    "region": "D",
    "description": "Berea"
  },
  {
    "countryCode": "LS",
    "region": "E",
    "description": "Mafeteng"
  },
  {
    "countryCode": "LS",
    "region": "F",
    "description": "Mohale's Hoek"
  },
  {
    "countryCode": "LS",
    "region": "G",
    "description": "Quthing"
  },
  {
    "countryCode": "LS",
    "region": "H",
    "description": "Qacha's Nek"
  },
  {
    "countryCode": "LS",
    "region": "J",
    "description": "Mokhotlong"
  },
  {
    "countryCode": "LS",
    "region": "K",
    "description": "Thaba-Tseka"
  },
  {
    "countryCode": "LT",
    "region": "AL",
    "description": "Alytus County"
  },
  {
    "countryCode": "LT",
    "region": "KL",
    "description": "Klaip\u0117da County"
  },
  {
    "countryCode": "LT",
    "region": "KU",
    "description": "Kaunas County"
  },
  {
    "countryCode": "LT",
    "region": "MR",
    "description": "Marijampol\u0117 County"
  },
  {
    "countryCode": "LT",
    "region": "PN",
    "description": "Panev\u0117\u017eys County"
  },
  {
    "countryCode": "LT",
    "region": "SA",
    "description": "Siauliai County"
  },
  {
    "countryCode": "LT",
    "region": "TA",
    "description": "Taurag\u0117 County"
  },
  {
    "countryCode": "LT",
    "region": "TE",
    "description": "Tel\u0161iai County"
  },
  {
    "countryCode": "LT",
    "region": "UT",
    "description": "Utena County"
  },
  {
    "countryCode": "LT",
    "region": "VL",
    "description": "Vilnius County"
  },
  {
    "countryCode": "LU",
    "region": "CA",
    "description": "Capellen"
  },
  {
    "countryCode": "LU",
    "region": "CL",
    "description": "Clerf"
  },
  {
    "countryCode": "LU",
    "region": "DI",
    "description": "Diekirch"
  },
  {
    "countryCode": "LU",
    "region": "EC",
    "description": "Echternach"
  },
  {
    "countryCode": "LU",
    "region": "ES",
    "description": "Esch an der Alzette"
  },
  {
    "countryCode": "LU",
    "region": "GR",
    "description": "Grevenmacher"
  },
  {
    "countryCode": "LU",
    "region": "LU",
    "description": "Luxemburg"
  },
  {
    "countryCode": "LU",
    "region": "ME",
    "description": "Mersch"
  },
  {
    "countryCode": "LU",
    "region": "RD",
    "description": "Redingen"
  },
  {
    "countryCode": "LU",
    "region": "RM",
    "description": "Remich"
  },
  {
    "countryCode": "LU",
    "region": "VD",
    "description": "Vianden"
  },
  {
    "countryCode": "LU",
    "region": "WI",
    "description": "Wiltz"
  },
  {
    "countryCode": "LV",
    "region": "001",
    "description": "Obsolete"
  },
  {
    "countryCode": "LV",
    "region": "002",
    "description": "Aizkraukle"
  },
  {
    "countryCode": "LV",
    "region": "003",
    "description": "Obsolete"
  },
  {
    "countryCode": "LV",
    "region": "004",
    "description": "Obsolete"
  },
  {
    "countryCode": "LV",
    "region": "005",
    "description": "Obsolete"
  },
  {
    "countryCode": "LV",
    "region": "006",
    "description": "Obsolete"
  },
  {
    "countryCode": "LV",
    "region": "007",
    "description": "Al\u016bksne"
  },
  {
    "countryCode": "LV",
    "region": "008",
    "description": "Obsolete"
  },
  {
    "countryCode": "LV",
    "region": "009",
    "description": "Obsolete"
  },
  {
    "countryCode": "LV",
    "region": "010",
    "description": "Obsolete"
  },
  {
    "countryCode": "LV",
    "region": "011",
    "description": "\u0100da\u017ei"
  },
  {
    "countryCode": "LV",
    "region": "012",
    "description": "Obsolete"
  },
  {
    "countryCode": "LV",
    "region": "013",
    "description": "Obsolete"
  },
  {
    "countryCode": "LV",
    "region": "014",
    "description": "Obsolete"
  },
  {
    "countryCode": "LV",
    "region": "015",
    "description": "Balvi"
  },
  {
    "countryCode": "LV",
    "region": "016",
    "description": "Bauska"
  },
  {
    "countryCode": "LV",
    "region": "017",
    "description": "Obsolete"
  },
  {
    "countryCode": "LV",
    "region": "018",
    "description": "Obsolete"
  },
  {
    "countryCode": "LV",
    "region": "019",
    "description": "Obsolete"
  },
  {
    "countryCode": "LV",
    "region": "020",
    "description": "Obsolete"
  },
  {
    "countryCode": "LV",
    "region": "021",
    "description": "Obsolete"
  },
  {
    "countryCode": "LV",
    "region": "022",
    "description": "C\u0113sis"
  },
  {
    "countryCode": "LV",
    "region": "023",
    "description": "Obsolete"
  },
  {
    "countryCode": "LV",
    "region": "024",
    "description": "Obsolete"
  },
  {
    "countryCode": "LV",
    "region": "025",
    "description": "Obsolete"
  },
  {
    "countryCode": "LV",
    "region": "026",
    "description": "Dobele"
  },
  {
    "countryCode": "LV",
    "region": "027",
    "description": "Obsolete"
  },
  {
    "countryCode": "LV",
    "region": "028",
    "description": "Obsolete"
  },
  {
    "countryCode": "LV",
    "region": "029",
    "description": "Obsolete"
  },
  {
    "countryCode": "LV",
    "region": "030",
    "description": "Obsolete"
  },
  {
    "countryCode": "LV",
    "region": "031",
    "description": "Obsolete"
  },
  {
    "countryCode": "LV",
    "region": "032",
    "description": "Obsolete"
  },
  {
    "countryCode": "LV",
    "region": "033",
    "description": "Gulbene"
  },
  {
    "countryCode": "LV",
    "region": "034",
    "description": "Obsolete"
  },
  {
    "countryCode": "LV",
    "region": "035",
    "description": "Obsolete"
  },
  {
    "countryCode": "LV",
    "region": "036",
    "description": "Obsolete"
  },
  {
    "countryCode": "LV",
    "region": "037",
    "description": "Obsolete"
  },
  {
    "countryCode": "LV",
    "region": "038",
    "description": "Obsolete"
  },
  {
    "countryCode": "LV",
    "region": "039",
    "description": "Obsolete"
  },
  {
    "countryCode": "LV",
    "region": "040",
    "description": "Obsolete"
  },
  {
    "countryCode": "LV",
    "region": "041",
    "description": "Jelgava"
  },
  {
    "countryCode": "LV",
    "region": "042",
    "description": "J\u0113kabpils"
  },
  {
    "countryCode": "LV",
    "region": "043",
    "description": "Obsolete"
  },
  {
    "countryCode": "LV",
    "region": "044",
    "description": "Obsolete"
  },
  {
    "countryCode": "LV",
    "region": "045",
    "description": "Obsolete"
  },
  {
    "countryCode": "LV",
    "region": "046",
    "description": "Obsolete"
  },
  {
    "countryCode": "LV",
    "region": "047",
    "description": "Kr\u0101slava"
  },
  {
    "countryCode": "LV",
    "region": "048",
    "description": "Obsolete"
  },
  {
    "countryCode": "LV",
    "region": "049",
    "description": "Obsolete"
  },
  {
    "countryCode": "LV",
    "region": "050",
    "description": "Kuld\u012bga"
  },
  {
    "countryCode": "LV",
    "region": "051",
    "description": "Obsolete"
  },
  {
    "countryCode": "LV",
    "region": "052",
    "description": "\u0136ekava"
  },
  {
    "countryCode": "LV",
    "region": "053",
    "description": "Obsolete"
  },
  {
    "countryCode": "LV",
    "region": "054",
    "description": "Limba\u017ei"
  },
  {
    "countryCode": "LV",
    "region": "055",
    "description": "Obsolete"
  },
  {
    "countryCode": "LV",
    "region": "056",
    "description": "L\u012bv\u0101ni"
  },
  {
    "countryCode": "LV",
    "region": "057",
    "description": "Obsolete"
  },
  {
    "countryCode": "LV",
    "region": "058",
    "description": "Ludza"
  },
  {
    "countryCode": "LV",
    "region": "059",
    "description": "Madona"
  },
  {
    "countryCode": "LV",
    "region": "060",
    "description": "Obsolete"
  },
  {
    "countryCode": "LV",
    "region": "061",
    "description": "Obsolete"
  },
  {
    "countryCode": "LV",
    "region": "062",
    "description": "M\u0101rupe"
  },
  {
    "countryCode": "LV",
    "region": "063",
    "description": "Obsolete"
  },
  {
    "countryCode": "LV",
    "region": "064",
    "description": "Obsolete"
  },
  {
    "countryCode": "LV",
    "region": "065",
    "description": "Obsolete"
  },
  {
    "countryCode": "LV",
    "region": "066",
    "description": "Obsolete"
  },
  {
    "countryCode": "LV",
    "region": "067",
    "description": "Ogre"
  },
  {
    "countryCode": "LV",
    "region": "068",
    "description": "Olaine"
  },
  {
    "countryCode": "LV",
    "region": "069",
    "description": "Obsolete"
  },
  {
    "countryCode": "LV",
    "region": "070",
    "description": "Obsolete"
  },
  {
    "countryCode": "LV",
    "region": "071",
    "description": "Obsolete"
  },
  {
    "countryCode": "LV",
    "region": "072",
    "description": "Obsolete"
  },
  {
    "countryCode": "LV",
    "region": "073",
    "description": "Prei\u013ci"
  },
  {
    "countryCode": "LV",
    "region": "074",
    "description": "Obsolete"
  },
  {
    "countryCode": "LV",
    "region": "075",
    "description": "Obsolete"
  },
  {
    "countryCode": "LV",
    "region": "076",
    "description": "Obsolete"
  },
  {
    "countryCode": "LV",
    "region": "077",
    "description": "R\u0113zekne"
  },
  {
    "countryCode": "LV",
    "region": "078",
    "description": "Obsolete"
  },
  {
    "countryCode": "LV",
    "region": "079",
    "description": "Obsolete"
  },
  {
    "countryCode": "LV",
    "region": "080",
    "description": "Ropa\u017ei"
  },
  {
    "countryCode": "LV",
    "region": "081",
    "description": "Obsolete"
  },
  {
    "countryCode": "LV",
    "region": "082",
    "description": "Obsolete"
  },
  {
    "countryCode": "LV",
    "region": "083",
    "description": "Obsolete"
  },
  {
    "countryCode": "LV",
    "region": "084",
    "description": "Obsolete"
  },
  {
    "countryCode": "LV",
    "region": "085",
    "description": "Obsolete"
  },
  {
    "countryCode": "LV",
    "region": "086",
    "description": "Obsolete"
  },
  {
    "countryCode": "LV",
    "region": "087",
    "description": "Salaspils"
  },
  {
    "countryCode": "LV",
    "region": "088",
    "description": "Saldus"
  },
  {
    "countryCode": "LV",
    "region": "089",
    "description": "Saulkrasti"
  },
  {
    "countryCode": "LV",
    "region": "090",
    "description": "Obsolete"
  },
  {
    "countryCode": "LV",
    "region": "091",
    "description": "Sigulda"
  },
  {
    "countryCode": "LV",
    "region": "092",
    "description": "Obsolete"
  },
  {
    "countryCode": "LV",
    "region": "093",
    "description": "Obsolete"
  },
  {
    "countryCode": "LV",
    "region": "094",
    "description": "Smiltene"
  },
  {
    "countryCode": "LV",
    "region": "095",
    "description": "Obsolete"
  },
  {
    "countryCode": "LV",
    "region": "096",
    "description": "Obsolete"
  },
  {
    "countryCode": "LV",
    "region": "097",
    "description": "Talsi"
  },
  {
    "countryCode": "LV",
    "region": "098",
    "description": "Obsolete"
  },
  {
    "countryCode": "LV",
    "region": "099",
    "description": "Tukums"
  },
  {
    "countryCode": "LV",
    "region": "100",
    "description": "Obsolete"
  },
  {
    "countryCode": "LV",
    "region": "101",
    "description": "Valka"
  },
  {
    "countryCode": "LV",
    "region": "102",
    "description": "Varak\u013c\u0101ni"
  },
  {
    "countryCode": "LV",
    "region": "103",
    "description": "Obsolete"
  },
  {
    "countryCode": "LV",
    "region": "104",
    "description": "Obsolete"
  },
  {
    "countryCode": "LV",
    "region": "105",
    "description": "Obsolete"
  },
  {
    "countryCode": "LV",
    "region": "106",
    "description": "Ventspils"
  },
  {
    "countryCode": "LV",
    "region": "107",
    "description": "Obsolete"
  },
  {
    "countryCode": "LV",
    "region": "108",
    "description": "Obsolete"
  },
  {
    "countryCode": "LV",
    "region": "109",
    "description": "Obsolete"
  },
  {
    "countryCode": "LV",
    "region": "110",
    "description": "Obsolete"
  },
  {
    "countryCode": "LV",
    "region": "111",
    "description": "Aug\u0161daugava"
  },
  {
    "countryCode": "LV",
    "region": "112",
    "description": "Dienvidkurzeme"
  },
  {
    "countryCode": "LV",
    "region": "113",
    "description": "Valmiera"
  },
  {
    "countryCode": "LV",
    "region": "DGV",
    "description": "Daugavpils"
  },
  {
    "countryCode": "LV",
    "region": "JEL",
    "description": "Jelgava"
  },
  {
    "countryCode": "LV",
    "region": "JKB",
    "description": "Obsolete"
  },
  {
    "countryCode": "LV",
    "region": "JUR",
    "description": "J\u016brmala"
  },
  {
    "countryCode": "LV",
    "region": "LPX",
    "description": "Liep\u0101ja"
  },
  {
    "countryCode": "LV",
    "region": "REZ",
    "description": "R\u0113zekne"
  },
  {
    "countryCode": "LV",
    "region": "RIX",
    "description": "R\u012bga"
  },
  {
    "countryCode": "LV",
    "region": "VEN",
    "description": "Ventspils"
  },
  {
    "countryCode": "LV",
    "region": "VMR",
    "description": "Obsolete"
  },
  {
    "countryCode": "LY",
    "region": "BA",
    "description": "Benghazi"
  },
  {
    "countryCode": "LY",
    "region": "BU",
    "description": "Butnan"
  },
  {
    "countryCode": "LY",
    "region": "DR",
    "description": "Darnah"
  },
  {
    "countryCode": "LY",
    "region": "GT",
    "description": "Ghat"
  },
  {
    "countryCode": "LY",
    "region": "JA",
    "description": "Jabal al Akhdar"
  },
  {
    "countryCode": "LY",
    "region": "JG",
    "description": "Jabal al Gharbi"
  },
  {
    "countryCode": "LY",
    "region": "JI",
    "description": "Al Jfara"
  },
  {
    "countryCode": "LY",
    "region": "JU",
    "description": "Jufrah"
  },
  {
    "countryCode": "LY",
    "region": "KF",
    "description": "Kufrah"
  },
  {
    "countryCode": "LY",
    "region": "MB",
    "description": "Murqub"
  },
  {
    "countryCode": "LY",
    "region": "MI",
    "description": "Misurata"
  },
  {
    "countryCode": "LY",
    "region": "MJ",
    "description": "Marj"
  },
  {
    "countryCode": "LY",
    "region": "MQ",
    "description": "Murzuq"
  },
  {
    "countryCode": "LY",
    "region": "NL",
    "description": "Nalut"
  },
  {
    "countryCode": "LY",
    "region": "NQ",
    "description": "Nuqat al Khams"
  },
  {
    "countryCode": "LY",
    "region": "SB",
    "description": "Sabha"
  },
  {
    "countryCode": "LY",
    "region": "SR",
    "description": "Surt"
  },
  {
    "countryCode": "LY",
    "region": "TB",
    "description": "Tarabulus"
  },
  {
    "countryCode": "LY",
    "region": "WA",
    "description": "Al Wahat"
  },
  {
    "countryCode": "LY",
    "region": "WD",
    "description": "Wadi al Hayaa"
  },
  {
    "countryCode": "LY",
    "region": "WS",
    "description": "Wadi al Shati"
  },
  {
    "countryCode": "LY",
    "region": "ZA",
    "description": "Zawiya"
  },
  {
    "countryCode": "MA",
    "region": "01",
    "description": "TangerT\u00e9touanAlHoce\u00ef"
  },
  {
    "countryCode": "MA",
    "region": "02",
    "description": "L'Oriental"
  },
  {
    "countryCode": "MA",
    "region": "03",
    "description": "F\u00e8s- Mekn\u00e8s"
  },
  {
    "countryCode": "MA",
    "region": "04",
    "description": "Rabat-Sal\u00e9-K\u00e9nitra"
  },
  {
    "countryCode": "MA",
    "region": "05",
    "description": "B\u00e9ni Mellal-Kh\u00e9nifra"
  },
  {
    "countryCode": "MA",
    "region": "06",
    "description": "Casablanca-Settat"
  },
  {
    "countryCode": "MA",
    "region": "07",
    "description": "Marrakech-Safi"
  },
  {
    "countryCode": "MA",
    "region": "08",
    "description": "Dr\u00e2a-Tafilalet"
  },
  {
    "countryCode": "MA",
    "region": "09",
    "description": "Souss-Massa"
  },
  {
    "countryCode": "MA",
    "region": "10",
    "description": "Guelmim-Oued Noun"
  },
  {
    "countryCode": "MA",
    "region": "11",
    "description": "La\u00e2youneSakiaElHamra"
  },
  {
    "countryCode": "MA",
    "region": "12",
    "description": "Dakhla-Oued Ed-Dahab"
  },
  {
    "countryCode": "MD",
    "region": "AN",
    "description": "Anenii Noi"
  },
  {
    "countryCode": "MD",
    "region": "BA",
    "description": "B\u0103l\u0163i"
  },
  {
    "countryCode": "MD",
    "region": "BD",
    "description": "Bender [Tighina]"
  },
  {
    "countryCode": "MD",
    "region": "BR",
    "description": "Briceni"
  },
  {
    "countryCode": "MD",
    "region": "BS",
    "description": "Basarabeasca"
  },
  {
    "countryCode": "MD",
    "region": "CA",
    "description": "Cahul"
  },
  {
    "countryCode": "MD",
    "region": "CL",
    "description": "C\u0103l\u0103ra\u015fi"
  },
  {
    "countryCode": "MD",
    "region": "CM",
    "description": "Cimi\u015flia"
  },
  {
    "countryCode": "MD",
    "region": "CR",
    "description": "Criuleni"
  },
  {
    "countryCode": "MD",
    "region": "CS",
    "description": "C\u0103u\u015feni"
  },
  {
    "countryCode": "MD",
    "region": "CT",
    "description": "Cantemir"
  },
  {
    "countryCode": "MD",
    "region": "CU",
    "description": "Chi\u015fin\u0103u"
  },
  {
    "countryCode": "MD",
    "region": "DO",
    "description": "Dondu\u015feni"
  },
  {
    "countryCode": "MD",
    "region": "DR",
    "description": "Drochia"
  },
  {
    "countryCode": "MD",
    "region": "DU",
    "description": "Dub\u0103sari"
  },
  {
    "countryCode": "MD",
    "region": "ED",
    "description": "Edine\u0163"
  },
  {
    "countryCode": "MD",
    "region": "FA",
    "description": "F\u0103le\u015fti"
  },
  {
    "countryCode": "MD",
    "region": "FL",
    "description": "Flore\u015fti"
  },
  {
    "countryCode": "MD",
    "region": "GA",
    "description": "G\u0103g\u0103uzia (UTAG)"
  },
  {
    "countryCode": "MD",
    "region": "GL",
    "description": "Glodeni"
  },
  {
    "countryCode": "MD",
    "region": "HI",
    "description": "H\u00eence\u015fti"
  },
  {
    "countryCode": "MD",
    "region": "IA",
    "description": "Ialoveni"
  },
  {
    "countryCode": "MD",
    "region": "LE",
    "description": "Leova"
  },
  {
    "countryCode": "MD",
    "region": "NI",
    "description": "Nisporeni"
  },
  {
    "countryCode": "MD",
    "region": "OC",
    "description": "Ocni\u0163a"
  },
  {
    "countryCode": "MD",
    "region": "OR",
    "description": "Orhei"
  },
  {
    "countryCode": "MD",
    "region": "RE",
    "description": "Rezina"
  },
  {
    "countryCode": "MD",
    "region": "RI",
    "description": "R\u00ee\u015fcani"
  },
  {
    "countryCode": "MD",
    "region": "SD",
    "description": "\u015eold\u0103ne\u015fti"
  },
  {
    "countryCode": "MD",
    "region": "SI",
    "description": "S\u00eengerei"
  },
  {
    "countryCode": "MD",
    "region": "SN",
    "description": "St\u00eenga Nistrului UTD"
  },
  {
    "countryCode": "MD",
    "region": "SO",
    "description": "Soroca"
  },
  {
    "countryCode": "MD",
    "region": "ST",
    "description": "Str\u0103\u015feni"
  },
  {
    "countryCode": "MD",
    "region": "SV",
    "description": "\u015etefan Vod\u0103"
  },
  {
    "countryCode": "MD",
    "region": "TA",
    "description": "Taraclia"
  },
  {
    "countryCode": "MD",
    "region": "TE",
    "description": "Telene\u015fti"
  },
  {
    "countryCode": "MD",
    "region": "UN",
    "description": "Ungheni"
  },
  {
    "countryCode": "ME",
    "region": "01",
    "description": "Andrijevica"
  },
  {
    "countryCode": "ME",
    "region": "02",
    "description": "Bar"
  },
  {
    "countryCode": "ME",
    "region": "03",
    "description": "Berane"
  },
  {
    "countryCode": "ME",
    "region": "04",
    "description": "Bijelo Polje"
  },
  {
    "countryCode": "ME",
    "region": "05",
    "description": "Budva"
  },
  {
    "countryCode": "ME",
    "region": "06",
    "description": "Cetinje"
  },
  {
    "countryCode": "ME",
    "region": "07",
    "description": "Danilovgrad"
  },
  {
    "countryCode": "ME",
    "region": "08",
    "description": "Herceg-Novi"
  },
  {
    "countryCode": "ME",
    "region": "09",
    "description": "Kola\u0161in"
  },
  {
    "countryCode": "ME",
    "region": "10",
    "description": "Kotor"
  },
  {
    "countryCode": "ME",
    "region": "11",
    "description": "Mojkovac"
  },
  {
    "countryCode": "ME",
    "region": "12",
    "description": "Nik\u0161i\u0107"
  },
  {
    "countryCode": "ME",
    "region": "13",
    "description": "Plav"
  },
  {
    "countryCode": "ME",
    "region": "14",
    "description": "Pljevlja"
  },
  {
    "countryCode": "ME",
    "region": "15",
    "description": "Plu\u017eine"
  },
  {
    "countryCode": "ME",
    "region": "16",
    "description": "Podgorica"
  },
  {
    "countryCode": "ME",
    "region": "17",
    "description": "Ro\u017eaje"
  },
  {
    "countryCode": "ME",
    "region": "18",
    "description": "\u0160avnik"
  },
  {
    "countryCode": "ME",
    "region": "19",
    "description": "Tivat"
  },
  {
    "countryCode": "ME",
    "region": "20",
    "description": "Ulcinj"
  },
  {
    "countryCode": "ME",
    "region": "21",
    "description": "\u017dabljak"
  },
  {
    "countryCode": "ME",
    "region": "22",
    "description": "Gusinje"
  },
  {
    "countryCode": "ME",
    "region": "23",
    "description": "Petnjica"
  },
  {
    "countryCode": "ME",
    "region": "24",
    "description": "Tuzi"
  },
  {
    "countryCode": "ME",
    "region": "25",
    "description": "Zeta"
  },
  {
    "countryCode": "MG",
    "region": "A",
    "description": "Toamasina"
  },
  {
    "countryCode": "MG",
    "region": "D",
    "description": "Antisiranana"
  },
  {
    "countryCode": "MG",
    "region": "F",
    "description": "Fianarantsoa"
  },
  {
    "countryCode": "MG",
    "region": "M",
    "description": "Mahajanga"
  },
  {
    "countryCode": "MG",
    "region": "T",
    "description": "Antananarivo"
  },
  {
    "countryCode": "MG",
    "region": "U",
    "description": "Toliara"
  },
  {
    "countryCode": "MK",
    "region": "02",
    "description": "Obsolete"
  },
  {
    "countryCode": "MK",
    "region": "03",
    "description": "Obsolete"
  },
  {
    "countryCode": "MK",
    "region": "04",
    "description": "Obsolete"
  },
  {
    "countryCode": "MK",
    "region": "05",
    "description": "Obsolete"
  },
  {
    "countryCode": "MK",
    "region": "06",
    "description": "Obsolete"
  },
  {
    "countryCode": "MK",
    "region": "07",
    "description": "Obsolete"
  },
  {
    "countryCode": "MK",
    "region": "08",
    "description": "Obsolete"
  },
  {
    "countryCode": "MK",
    "region": "10",
    "description": "Obsolete"
  },
  {
    "countryCode": "MK",
    "region": "101",
    "description": "Veles"
  },
  {
    "countryCode": "MK",
    "region": "102",
    "description": "Gradsko"
  },
  {
    "countryCode": "MK",
    "region": "103",
    "description": "Demir Kapija"
  },
  {
    "countryCode": "MK",
    "region": "104",
    "description": "Kavadarci"
  },
  {
    "countryCode": "MK",
    "region": "105",
    "description": "Lozovo"
  },
  {
    "countryCode": "MK",
    "region": "106",
    "description": "Negotino"
  },
  {
    "countryCode": "MK",
    "region": "107",
    "description": "Rosoman"
  },
  {
    "countryCode": "MK",
    "region": "108",
    "description": "Sveti Nikole"
  },
  {
    "countryCode": "MK",
    "region": "109",
    "description": "\u010ca\u0161ka"
  },
  {
    "countryCode": "MK",
    "region": "11",
    "description": "Obsolete"
  },
  {
    "countryCode": "MK",
    "region": "12",
    "description": "Obsolete"
  },
  {
    "countryCode": "MK",
    "region": "13",
    "description": "Obsolete"
  },
  {
    "countryCode": "MK",
    "region": "14",
    "description": "Obsolete"
  },
  {
    "countryCode": "MK",
    "region": "16",
    "description": "Obsolete"
  },
  {
    "countryCode": "MK",
    "region": "18",
    "description": "Obsolete"
  },
  {
    "countryCode": "MK",
    "region": "19",
    "description": "Obsolete"
  },
  {
    "countryCode": "MK",
    "region": "20",
    "description": "Obsolete"
  },
  {
    "countryCode": "MK",
    "region": "201",
    "description": "Berovo"
  },
  {
    "countryCode": "MK",
    "region": "202",
    "description": "Vinica"
  },
  {
    "countryCode": "MK",
    "region": "203",
    "description": "Del\u010devo"
  },
  {
    "countryCode": "MK",
    "region": "204",
    "description": "Zrnovci"
  },
  {
    "countryCode": "MK",
    "region": "205",
    "description": "Karbinci"
  },
  {
    "countryCode": "MK",
    "region": "206",
    "description": "Ko\u010dani"
  },
  {
    "countryCode": "MK",
    "region": "207",
    "description": "Makedonska Kamenica"
  },
  {
    "countryCode": "MK",
    "region": "208",
    "description": "Peh\u010devo"
  },
  {
    "countryCode": "MK",
    "region": "209",
    "description": "Probi\u0161tip"
  },
  {
    "countryCode": "MK",
    "region": "21",
    "description": "Obsolete"
  },
  {
    "countryCode": "MK",
    "region": "210",
    "description": "\u010ce\u0161inovo-Oble\u0161evo"
  },
  {
    "countryCode": "MK",
    "region": "211",
    "description": "\u0160tip"
  },
  {
    "countryCode": "MK",
    "region": "22",
    "description": "Obsolete"
  },
  {
    "countryCode": "MK",
    "region": "23",
    "description": "Obsolete"
  },
  {
    "countryCode": "MK",
    "region": "24",
    "description": "Obsolete"
  },
  {
    "countryCode": "MK",
    "region": "25",
    "description": "Obsolete"
  },
  {
    "countryCode": "MK",
    "region": "26",
    "description": "Obsolete"
  },
  {
    "countryCode": "MK",
    "region": "27",
    "description": "Obsolete"
  },
  {
    "countryCode": "MK",
    "region": "30",
    "description": "Obsolete"
  },
  {
    "countryCode": "MK",
    "region": "301",
    "description": "Vev\u010dani"
  },
  {
    "countryCode": "MK",
    "region": "303",
    "description": "Debar"
  },
  {
    "countryCode": "MK",
    "region": "304",
    "description": "Debrca"
  },
  {
    "countryCode": "MK",
    "region": "307",
    "description": "Ki\u010devo"
  },
  {
    "countryCode": "MK",
    "region": "308",
    "description": "Makedonski Brod"
  },
  {
    "countryCode": "MK",
    "region": "310",
    "description": "Ohrid"
  },
  {
    "countryCode": "MK",
    "region": "311",
    "description": "Plasnica"
  },
  {
    "countryCode": "MK",
    "region": "312",
    "description": "Struga"
  },
  {
    "countryCode": "MK",
    "region": "313",
    "description": "Centar \u017dupa"
  },
  {
    "countryCode": "MK",
    "region": "32",
    "description": "Obsolete"
  },
  {
    "countryCode": "MK",
    "region": "33",
    "description": "Obsolete"
  },
  {
    "countryCode": "MK",
    "region": "34",
    "description": "Obsolete"
  },
  {
    "countryCode": "MK",
    "region": "35",
    "description": "Obsolete"
  },
  {
    "countryCode": "MK",
    "region": "36",
    "description": "Obsolete"
  },
  {
    "countryCode": "MK",
    "region": "37",
    "description": "Obsolete"
  },
  {
    "countryCode": "MK",
    "region": "40",
    "description": "Obsolete"
  },
  {
    "countryCode": "MK",
    "region": "401",
    "description": "Bogdanci"
  },
  {
    "countryCode": "MK",
    "region": "402",
    "description": "Bosilovo"
  },
  {
    "countryCode": "MK",
    "region": "403",
    "description": "Valandovo"
  },
  {
    "countryCode": "MK",
    "region": "404",
    "description": "Vasilevo"
  },
  {
    "countryCode": "MK",
    "region": "405",
    "description": "Gevgelija"
  },
  {
    "countryCode": "MK",
    "region": "406",
    "description": "Dojran"
  },
  {
    "countryCode": "MK",
    "region": "407",
    "description": "Kon\u010de"
  },
  {
    "countryCode": "MK",
    "region": "408",
    "description": "Novo Selo"
  },
  {
    "countryCode": "MK",
    "region": "409",
    "description": "Radovi\u0161"
  },
  {
    "countryCode": "MK",
    "region": "41",
    "description": "Obsolete"
  },
  {
    "countryCode": "MK",
    "region": "410",
    "description": "Strumica"
  },
  {
    "countryCode": "MK",
    "region": "42",
    "description": "Obsolete"
  },
  {
    "countryCode": "MK",
    "region": "43",
    "description": "Obsolete"
  },
  {
    "countryCode": "MK",
    "region": "44",
    "description": "Obsolete"
  },
  {
    "countryCode": "MK",
    "region": "45",
    "description": "Obsolete"
  },
  {
    "countryCode": "MK",
    "region": "46",
    "description": "Obsolete"
  },
  {
    "countryCode": "MK",
    "region": "47",
    "description": "Obsolete"
  },
  {
    "countryCode": "MK",
    "region": "48",
    "description": "Obsolete"
  },
  {
    "countryCode": "MK",
    "region": "49",
    "description": "Obsolete"
  },
  {
    "countryCode": "MK",
    "region": "50",
    "description": "Obsolete"
  },
  {
    "countryCode": "MK",
    "region": "501",
    "description": "Bitola"
  },
  {
    "countryCode": "MK",
    "region": "502",
    "description": "Demir Hisar"
  },
  {
    "countryCode": "MK",
    "region": "503",
    "description": "Dolneni"
  },
  {
    "countryCode": "MK",
    "region": "504",
    "description": "Krivoga\u0161tani"
  },
  {
    "countryCode": "MK",
    "region": "505",
    "description": "Kru\u0161evo"
  },
  {
    "countryCode": "MK",
    "region": "506",
    "description": "Mogila"
  },
  {
    "countryCode": "MK",
    "region": "507",
    "description": "Novaci"
  },
  {
    "countryCode": "MK",
    "region": "508",
    "description": "Prilep"
  },
  {
    "countryCode": "MK",
    "region": "509",
    "description": "Resen"
  },
  {
    "countryCode": "MK",
    "region": "51",
    "description": "Obsolete"
  },
  {
    "countryCode": "MK",
    "region": "52",
    "description": "Obsolete"
  },
  {
    "countryCode": "MK",
    "region": "53",
    "description": "Obsolete"
  },
  {
    "countryCode": "MK",
    "region": "54",
    "description": "Obsolete"
  },
  {
    "countryCode": "MK",
    "region": "55",
    "description": "Obsolete"
  },
  {
    "countryCode": "MK",
    "region": "56",
    "description": "Obsolete"
  },
  {
    "countryCode": "MK",
    "region": "58",
    "description": "Obsolete"
  },
  {
    "countryCode": "MK",
    "region": "59",
    "description": "Obsolete"
  },
  {
    "countryCode": "MK",
    "region": "60",
    "description": "Obsolete"
  },
  {
    "countryCode": "MK",
    "region": "601",
    "description": "Bogovinje"
  },
  {
    "countryCode": "MK",
    "region": "602",
    "description": "Brvenica"
  },
  {
    "countryCode": "MK",
    "region": "603",
    "description": "Vrap\u010di\u0161te"
  },
  {
    "countryCode": "MK",
    "region": "604",
    "description": "Gostivar"
  },
  {
    "countryCode": "MK",
    "region": "605",
    "description": "\u017delino"
  },
  {
    "countryCode": "MK",
    "region": "606",
    "description": "Jegunovce"
  },
  {
    "countryCode": "MK",
    "region": "607",
    "description": "Mavrovo i Rostu\u0161e"
  },
  {
    "countryCode": "MK",
    "region": "608",
    "description": "Tearce"
  },
  {
    "countryCode": "MK",
    "region": "609",
    "description": "Tetovo"
  },
  {
    "countryCode": "MK",
    "region": "61",
    "description": "Obsolete"
  },
  {
    "countryCode": "MK",
    "region": "62",
    "description": "Obsolete"
  },
  {
    "countryCode": "MK",
    "region": "63",
    "description": "Obsolete"
  },
  {
    "countryCode": "MK",
    "region": "64",
    "description": "Obsolete"
  },
  {
    "countryCode": "MK",
    "region": "65",
    "description": "Obsolete"
  },
  {
    "countryCode": "MK",
    "region": "66",
    "description": "Obsolete"
  },
  {
    "countryCode": "MK",
    "region": "67",
    "description": "Obsolete"
  },
  {
    "countryCode": "MK",
    "region": "69",
    "description": "Obsolete"
  },
  {
    "countryCode": "MK",
    "region": "70",
    "description": "Obsolete"
  },
  {
    "countryCode": "MK",
    "region": "701",
    "description": "Kratovo"
  },
  {
    "countryCode": "MK",
    "region": "702",
    "description": "Kriva Palanka"
  },
  {
    "countryCode": "MK",
    "region": "703",
    "description": "Kumanovo"
  },
  {
    "countryCode": "MK",
    "region": "704",
    "description": "Lipkovo"
  },
  {
    "countryCode": "MK",
    "region": "705",
    "description": "Rankovce"
  },
  {
    "countryCode": "MK",
    "region": "706",
    "description": "Staro Nagori\u010dane"
  },
  {
    "countryCode": "MK",
    "region": "71",
    "description": "Obsolete"
  },
  {
    "countryCode": "MK",
    "region": "72",
    "description": "Obsolete"
  },
  {
    "countryCode": "MK",
    "region": "73",
    "description": "Obsolete"
  },
  {
    "countryCode": "MK",
    "region": "74",
    "description": "Obsolete"
  },
  {
    "countryCode": "MK",
    "region": "75",
    "description": "Obsolete"
  },
  {
    "countryCode": "MK",
    "region": "76",
    "description": "Obsolete"
  },
  {
    "countryCode": "MK",
    "region": "78",
    "description": "Obsolete"
  },
  {
    "countryCode": "MK",
    "region": "80",
    "description": "Obsolete"
  },
  {
    "countryCode": "MK",
    "region": "801",
    "description": "Aerodrom"
  },
  {
    "countryCode": "MK",
    "region": "802",
    "description": "Ara\u010dinovo"
  },
  {
    "countryCode": "MK",
    "region": "803",
    "description": "Butel"
  },
  {
    "countryCode": "MK",
    "region": "804",
    "description": "Gazi Baba"
  },
  {
    "countryCode": "MK",
    "region": "805",
    "description": "Gjor\u010de Petrov"
  },
  {
    "countryCode": "MK",
    "region": "806",
    "description": "Zelenikovo"
  },
  {
    "countryCode": "MK",
    "region": "807",
    "description": "Ilinden"
  },
  {
    "countryCode": "MK",
    "region": "808",
    "description": "Karpo\u0161"
  },
  {
    "countryCode": "MK",
    "region": "809",
    "description": "Kisela Voda"
  },
  {
    "countryCode": "MK",
    "region": "81",
    "description": "Obsolete"
  },
  {
    "countryCode": "MK",
    "region": "810",
    "description": "Petrovec"
  },
  {
    "countryCode": "MK",
    "region": "811",
    "description": "Saraj"
  },
  {
    "countryCode": "MK",
    "region": "812",
    "description": "Sopi\u0161te"
  },
  {
    "countryCode": "MK",
    "region": "813",
    "description": "Studeni\u010dani"
  },
  {
    "countryCode": "MK",
    "region": "814",
    "description": "Centar"
  },
  {
    "countryCode": "MK",
    "region": "815",
    "description": "\u010cair"
  },
  {
    "countryCode": "MK",
    "region": "816",
    "description": "\u010cu\u010der-Sandevo"
  },
  {
    "countryCode": "MK",
    "region": "817",
    "description": "\u0160uto Orizari"
  },
  {
    "countryCode": "MK",
    "region": "82",
    "description": "Obsolete"
  },
  {
    "countryCode": "MK",
    "region": "83",
    "description": "Obsolete"
  },
  {
    "countryCode": "MK",
    "region": "85",
    "description": "Obsolete"
  },
  {
    "countryCode": "ML",
    "region": "1",
    "description": "Kayes"
  },
  {
    "countryCode": "ML",
    "region": "10",
    "description": "Taoud\u00e9nit"
  },
  {
    "countryCode": "ML",
    "region": "2",
    "description": "Koulikoro"
  },
  {
    "countryCode": "ML",
    "region": "3",
    "description": "Sikasso"
  },
  {
    "countryCode": "ML",
    "region": "4",
    "description": "S\u00e9gou"
  },
  {
    "countryCode": "ML",
    "region": "5",
    "description": "Mopti"
  },
  {
    "countryCode": "ML",
    "region": "6",
    "description": "Timbuktu"
  },
  {
    "countryCode": "ML",
    "region": "7",
    "description": "Gao"
  },
  {
    "countryCode": "ML",
    "region": "8",
    "description": "Kidal"
  },
  {
    "countryCode": "ML",
    "region": "9",
    "description": "M\u00e9naka"
  },
  {
    "countryCode": "ML",
    "region": "BK0",
    "description": "Bamako"
  },
  {
    "countryCode": "MM",
    "region": "01",
    "description": "Sagaing"
  },
  {
    "countryCode": "MM",
    "region": "02",
    "description": "Bago"
  },
  {
    "countryCode": "MM",
    "region": "03",
    "description": "Magway"
  },
  {
    "countryCode": "MM",
    "region": "04",
    "description": "Mandalay"
  },
  {
    "countryCode": "MM",
    "region": "05",
    "description": "Tanintharyi"
  },
  {
    "countryCode": "MM",
    "region": "06",
    "description": "Yangon"
  },
  {
    "countryCode": "MM",
    "region": "07",
    "description": "Ayeyarwady"
  },
  {
    "countryCode": "MM",
    "region": "11",
    "description": "Kachin"
  },
  {
    "countryCode": "MM",
    "region": "12",
    "description": "Kayah"
  },
  {
    "countryCode": "MM",
    "region": "13",
    "description": "Kayin"
  },
  {
    "countryCode": "MM",
    "region": "14",
    "description": "Chin"
  },
  {
    "countryCode": "MM",
    "region": "15",
    "description": "Mon"
  },
  {
    "countryCode": "MM",
    "region": "16",
    "description": "Rakhine"
  },
  {
    "countryCode": "MM",
    "region": "17",
    "description": "Shan"
  },
  {
    "countryCode": "MM",
    "region": "18",
    "description": "Nay Pyi Taw"
  },
  {
    "countryCode": "MN",
    "region": "035",
    "description": "Orhon"
  },
  {
    "countryCode": "MN",
    "region": "037",
    "description": "Darhan uul"
  },
  {
    "countryCode": "MN",
    "region": "039",
    "description": "Hentiy"
  },
  {
    "countryCode": "MN",
    "region": "041",
    "description": "H\u00f6vsg\u00f6l"
  },
  {
    "countryCode": "MN",
    "region": "043",
    "description": "Hovd"
  },
  {
    "countryCode": "MN",
    "region": "046",
    "description": "Uvs"
  },
  {
    "countryCode": "MN",
    "region": "047",
    "description": "T\u00f6v"
  },
  {
    "countryCode": "MN",
    "region": "049",
    "description": "Selenge"
  },
  {
    "countryCode": "MN",
    "region": "051",
    "description": "S\u00fchbaatar"
  },
  {
    "countryCode": "MN",
    "region": "053",
    "description": "\u00d6mn\u00f6gov\u012d"
  },
  {
    "countryCode": "MN",
    "region": "055",
    "description": "\u00d6v\u00f6rhangay"
  },
  {
    "countryCode": "MN",
    "region": "057",
    "description": "Dzavhan"
  },
  {
    "countryCode": "MN",
    "region": "059",
    "description": "Dundgov\u012d"
  },
  {
    "countryCode": "MN",
    "region": "061",
    "description": "Dornod"
  },
  {
    "countryCode": "MN",
    "region": "063",
    "description": "Dornogov\u012d"
  },
  {
    "countryCode": "MN",
    "region": "064",
    "description": "Gov\u012d-S\u00fcmber"
  },
  {
    "countryCode": "MN",
    "region": "065",
    "description": "Gov\u012d-Altay"
  },
  {
    "countryCode": "MN",
    "region": "067",
    "description": "Bulgan"
  },
  {
    "countryCode": "MN",
    "region": "069",
    "description": "Bayanhongor"
  },
  {
    "countryCode": "MN",
    "region": "071",
    "description": "Bayan-\u00d6lgiy"
  },
  {
    "countryCode": "MN",
    "region": "073",
    "description": "Arhangay"
  },
  {
    "countryCode": "MN",
    "region": "1",
    "description": "Ulaanbaatar"
  },
  {
    "countryCode": "MR",
    "region": "01",
    "description": "Hodh ech Chargui"
  },
  {
    "countryCode": "MR",
    "region": "02",
    "description": "Hodh el Gharbi"
  },
  {
    "countryCode": "MR",
    "region": "03",
    "description": "Assaba"
  },
  {
    "countryCode": "MR",
    "region": "04",
    "description": "Gorgol"
  },
  {
    "countryCode": "MR",
    "region": "05",
    "description": "Brakna"
  },
  {
    "countryCode": "MR",
    "region": "06",
    "description": "Trarza"
  },
  {
    "countryCode": "MR",
    "region": "07",
    "description": "Adrar"
  },
  {
    "countryCode": "MR",
    "region": "08",
    "description": "Dakhlet Nou\u00e2dhibou"
  },
  {
    "countryCode": "MR",
    "region": "09",
    "description": "Tagant"
  },
  {
    "countryCode": "MR",
    "region": "10",
    "description": "Guidimaka"
  },
  {
    "countryCode": "MR",
    "region": "11",
    "description": "Tiris Zemmour"
  },
  {
    "countryCode": "MR",
    "region": "12",
    "description": "Inchiri"
  },
  {
    "countryCode": "MR",
    "region": "13",
    "description": "Nouakchott Nord"
  },
  {
    "countryCode": "MR",
    "region": "14",
    "description": "Nouakchott Ouest"
  },
  {
    "countryCode": "MR",
    "region": "15",
    "description": "Nouakchott Sud"
  },
  {
    "countryCode": "MT",
    "region": "01",
    "description": "Attard"
  },
  {
    "countryCode": "MT",
    "region": "02",
    "description": "Balzan"
  },
  {
    "countryCode": "MT",
    "region": "03",
    "description": "Birgu"
  },
  {
    "countryCode": "MT",
    "region": "04",
    "description": "Birkirkara"
  },
  {
    "countryCode": "MT",
    "region": "05",
    "description": "Bir\u017cebbu\u0121a"
  },
  {
    "countryCode": "MT",
    "region": "06",
    "description": "Bormla"
  },
  {
    "countryCode": "MT",
    "region": "07",
    "description": "Dingli"
  },
  {
    "countryCode": "MT",
    "region": "08",
    "description": "Fgura"
  },
  {
    "countryCode": "MT",
    "region": "09",
    "description": "Floriana"
  },
  {
    "countryCode": "MT",
    "region": "10",
    "description": "Fontana"
  },
  {
    "countryCode": "MT",
    "region": "11",
    "description": "Gudja"
  },
  {
    "countryCode": "MT",
    "region": "12",
    "description": "G\u017cira"
  },
  {
    "countryCode": "MT",
    "region": "13",
    "description": "G\u0127ajnsielem"
  },
  {
    "countryCode": "MT",
    "region": "14",
    "description": "G\u0127arb"
  },
  {
    "countryCode": "MT",
    "region": "15",
    "description": "G\u0127arg\u0127ur"
  },
  {
    "countryCode": "MT",
    "region": "16",
    "description": "G\u0127asri"
  },
  {
    "countryCode": "MT",
    "region": "17",
    "description": "G\u0127axaq"
  },
  {
    "countryCode": "MT",
    "region": "18",
    "description": "\u0126amrun"
  },
  {
    "countryCode": "MT",
    "region": "19",
    "description": "Iklin"
  },
  {
    "countryCode": "MT",
    "region": "20",
    "description": "Isla"
  },
  {
    "countryCode": "MT",
    "region": "21",
    "description": "Kalkara"
  },
  {
    "countryCode": "MT",
    "region": "22",
    "description": "Ker\u010bem"
  },
  {
    "countryCode": "MT",
    "region": "23",
    "description": "Kirkop"
  },
  {
    "countryCode": "MT",
    "region": "24",
    "description": "Lija"
  },
  {
    "countryCode": "MT",
    "region": "25",
    "description": "Luqa"
  },
  {
    "countryCode": "MT",
    "region": "26",
    "description": "Marsa"
  },
  {
    "countryCode": "MT",
    "region": "27",
    "description": "Marsaskala"
  },
  {
    "countryCode": "MT",
    "region": "28",
    "description": "Marsaxlokk"
  },
  {
    "countryCode": "MT",
    "region": "29",
    "description": "Mdina"
  },
  {
    "countryCode": "MT",
    "region": "30",
    "description": "Mellie\u0127a"
  },
  {
    "countryCode": "MT",
    "region": "31",
    "description": "M\u0121arr"
  },
  {
    "countryCode": "MT",
    "region": "32",
    "description": "Mosta"
  },
  {
    "countryCode": "MT",
    "region": "33",
    "description": "Mqabba"
  },
  {
    "countryCode": "MT",
    "region": "34",
    "description": "Msida"
  },
  {
    "countryCode": "MT",
    "region": "35",
    "description": "Mtarfa"
  },
  {
    "countryCode": "MT",
    "region": "36",
    "description": "Munxar"
  },
  {
    "countryCode": "MT",
    "region": "37",
    "description": "Nadur"
  },
  {
    "countryCode": "MT",
    "region": "38",
    "description": "Naxxar"
  },
  {
    "countryCode": "MT",
    "region": "39",
    "description": "Paola"
  },
  {
    "countryCode": "MT",
    "region": "40",
    "description": "Pembroke"
  },
  {
    "countryCode": "MT",
    "region": "41",
    "description": "Piet\u00e0"
  },
  {
    "countryCode": "MT",
    "region": "42",
    "description": "Qala"
  },
  {
    "countryCode": "MT",
    "region": "43",
    "description": "Qormi"
  },
  {
    "countryCode": "MT",
    "region": "44",
    "description": "Qrendi"
  },
  {
    "countryCode": "MT",
    "region": "45",
    "description": "Rabat Gozo"
  },
  {
    "countryCode": "MT",
    "region": "46",
    "description": "Rabat Malta"
  },
  {
    "countryCode": "MT",
    "region": "47",
    "description": "Safi"
  },
  {
    "countryCode": "MT",
    "region": "48",
    "description": "Saint Julian's"
  },
  {
    "countryCode": "MT",
    "region": "49",
    "description": "Saint John"
  },
  {
    "countryCode": "MT",
    "region": "50",
    "description": "Saint Lawrence"
  },
  {
    "countryCode": "MT",
    "region": "51",
    "description": "Saint Paul's Bay"
  },
  {
    "countryCode": "MT",
    "region": "52",
    "description": "Sannat"
  },
  {
    "countryCode": "MT",
    "region": "53",
    "description": "Saint Lucia's"
  },
  {
    "countryCode": "MT",
    "region": "54",
    "description": "Santa Venera"
  },
  {
    "countryCode": "MT",
    "region": "55",
    "description": "Si\u0121\u0121iewi"
  },
  {
    "countryCode": "MT",
    "region": "56",
    "description": "Sliema"
  },
  {
    "countryCode": "MT",
    "region": "57",
    "description": "Swieqi"
  },
  {
    "countryCode": "MT",
    "region": "58",
    "description": "Ta' Xbiex"
  },
  {
    "countryCode": "MT",
    "region": "59",
    "description": "Tarxien"
  },
  {
    "countryCode": "MT",
    "region": "60",
    "description": "Valletta"
  },
  {
    "countryCode": "MT",
    "region": "61",
    "description": "Xag\u0127ra"
  },
  {
    "countryCode": "MT",
    "region": "62",
    "description": "Xewkija"
  },
  {
    "countryCode": "MT",
    "region": "63",
    "description": "Xg\u0127ajra"
  },
  {
    "countryCode": "MT",
    "region": "64",
    "description": "\u017babbar"
  },
  {
    "countryCode": "MT",
    "region": "65",
    "description": "\u017bebbu\u0121 Gozo"
  },
  {
    "countryCode": "MT",
    "region": "66",
    "description": "\u017bebbu\u0121 Malta"
  },
  {
    "countryCode": "MT",
    "region": "67",
    "description": "\u017bejtun"
  },
  {
    "countryCode": "MT",
    "region": "68",
    "description": "\u017burrieq"
  },
  {
    "countryCode": "MU",
    "region": "AG",
    "description": "Agalega Islands"
  },
  {
    "countryCode": "MU",
    "region": "BL",
    "description": "Black River"
  },
  {
    "countryCode": "MU",
    "region": "BR",
    "description": "Obsolete"
  },
  {
    "countryCode": "MU",
    "region": "CC",
    "description": "St. Brandon Islands"
  },
  {
    "countryCode": "MU",
    "region": "CU",
    "description": "Obsolete"
  },
  {
    "countryCode": "MU",
    "region": "FL",
    "description": "Flacq"
  },
  {
    "countryCode": "MU",
    "region": "GP",
    "description": "Grand Port"
  },
  {
    "countryCode": "MU",
    "region": "MO",
    "description": "Moka"
  },
  {
    "countryCode": "MU",
    "region": "PA",
    "description": "Pamplemousses"
  },
  {
    "countryCode": "MU",
    "region": "PL",
    "description": "Port Louis"
  },
  {
    "countryCode": "MU",
    "region": "PU",
    "description": "Obsolete"
  },
  {
    "countryCode": "MU",
    "region": "PW",
    "description": "Plaines Wilhem"
  },
  {
    "countryCode": "MU",
    "region": "QB",
    "description": "Obsolete"
  },
  {
    "countryCode": "MU",
    "region": "RO",
    "description": "Rodrigues Island"
  },
  {
    "countryCode": "MU",
    "region": "RR",
    "description": "Riviere du Rempart"
  },
  {
    "countryCode": "MU",
    "region": "SA",
    "description": "Savanne"
  },
  {
    "countryCode": "MU",
    "region": "VP",
    "description": "Obsolete"
  },
  {
    "countryCode": "MW",
    "region": "C",
    "description": "Central Region"
  },
  {
    "countryCode": "MW",
    "region": "N",
    "description": "Northern Region"
  },
  {
    "countryCode": "MW",
    "region": "S",
    "description": "Southern Region"
  },
  {
    "countryCode": "MX",
    "region": "AGU",
    "description": "Aguascalientes"
  },
  {
    "countryCode": "MX",
    "region": "BCN",
    "description": "Baja California"
  },
  {
    "countryCode": "MX",
    "region": "BCS",
    "description": "Baja California S"
  },
  {
    "countryCode": "MX",
    "region": "CAM",
    "description": "Campeche"
  },
  {
    "countryCode": "MX",
    "region": "CHH",
    "description": "Chihuahua"
  },
  {
    "countryCode": "MX",
    "region": "CHP",
    "description": "Chiapas"
  },
  {
    "countryCode": "MX",
    "region": "CMX",
    "description": "Ciudad de Mexico"
  },
  {
    "countryCode": "MX",
    "region": "COA",
    "description": "Coahuila"
  },
  {
    "countryCode": "MX",
    "region": "COL",
    "description": "Colima"
  },
  {
    "countryCode": "MX",
    "region": "DUR",
    "description": "Durango"
  },
  {
    "countryCode": "MX",
    "region": "GRO",
    "description": "Guerrero"
  },
  {
    "countryCode": "MX",
    "region": "GUA",
    "description": "Guanajuato"
  },
  {
    "countryCode": "MX",
    "region": "HID",
    "description": "Hidalgo"
  },
  {
    "countryCode": "MX",
    "region": "JAL",
    "description": "Jalisco"
  },
  {
    "countryCode": "MX",
    "region": "MEX",
    "description": "Estado de Mexico"
  },
  {
    "countryCode": "MX",
    "region": "MIC",
    "description": "Michoacan"
  },
  {
    "countryCode": "MX",
    "region": "MOR",
    "description": "Morelos"
  },
  {
    "countryCode": "MX",
    "region": "NAY",
    "description": "Nayarit"
  },
  {
    "countryCode": "MX",
    "region": "NLE",
    "description": "Nuevo Leon"
  },
  {
    "countryCode": "MX",
    "region": "OAX",
    "description": "Oaxaca"
  },
  {
    "countryCode": "MX",
    "region": "PUE",
    "description": "Puebla"
  },
  {
    "countryCode": "MX",
    "region": "QUE",
    "description": "Queretaro"
  },
  {
    "countryCode": "MX",
    "region": "ROO",
    "description": "Quintana Roo"
  },
  {
    "countryCode": "MX",
    "region": "SIN",
    "description": "Sinaloa"
  },
  {
    "countryCode": "MX",
    "region": "SLP",
    "description": "San Luis Potosi"
  },
  {
    "countryCode": "MX",
    "region": "SON",
    "description": "Sonora"
  },
  {
    "countryCode": "MX",
    "region": "TAB",
    "description": "Tabasco"
  },
  {
    "countryCode": "MX",
    "region": "TAM",
    "description": "Tamaulipas"
  },
  {
    "countryCode": "MX",
    "region": "TLA",
    "description": "Tlaxcala"
  },
  {
    "countryCode": "MX",
    "region": "VER",
    "description": "Veracruz"
  },
  {
    "countryCode": "MX",
    "region": "YUC",
    "description": "Yucatan"
  },
  {
    "countryCode": "MX",
    "region": "ZAC",
    "description": "Zacatecas"
  },
  {
    "countryCode": "MY",
    "region": "01",
    "description": "Johor"
  },
  {
    "countryCode": "MY",
    "region": "02",
    "description": "Kedah"
  },
  {
    "countryCode": "MY",
    "region": "03",
    "description": "Kelantan"
  },
  {
    "countryCode": "MY",
    "region": "04",
    "description": "Melaka"
  },
  {
    "countryCode": "MY",
    "region": "05",
    "description": "Negeri Sembilan"
  },
  {
    "countryCode": "MY",
    "region": "06",
    "description": "Pahang"
  },
  {
    "countryCode": "MY",
    "region": "07",
    "description": "Pulau Pinang"
  },
  {
    "countryCode": "MY",
    "region": "08",
    "description": "Perak"
  },
  {
    "countryCode": "MY",
    "region": "09",
    "description": "Perlis"
  },
  {
    "countryCode": "MY",
    "region": "10",
    "description": "Selangor"
  },
  {
    "countryCode": "MY",
    "region": "11",
    "description": "Terengganu"
  },
  {
    "countryCode": "MY",
    "region": "12",
    "description": "Sabah"
  },
  {
    "countryCode": "MY",
    "region": "13",
    "description": "Sarawak"
  },
  {
    "countryCode": "MY",
    "region": "14",
    "description": "Kuala Lumpur"
  },
  {
    "countryCode": "MY",
    "region": "15",
    "description": "Labuan"
  },
  {
    "countryCode": "MY",
    "region": "16",
    "description": "Putrajaya"
  },
  {
    "countryCode": "MZ",
    "region": "A",
    "description": "Niassa"
  },
  {
    "countryCode": "MZ",
    "region": "B",
    "description": "Manica"
  },
  {
    "countryCode": "MZ",
    "region": "G",
    "description": "Gaza"
  },
  {
    "countryCode": "MZ",
    "region": "I",
    "description": "Inhambane"
  },
  {
    "countryCode": "MZ",
    "region": "L",
    "description": "Maputo (Province)"
  },
  {
    "countryCode": "MZ",
    "region": "MPM",
    "description": "Maputo"
  },
  {
    "countryCode": "MZ",
    "region": "N",
    "description": "Nampula"
  },
  {
    "countryCode": "MZ",
    "region": "P",
    "description": "Cabo Delgado"
  },
  {
    "countryCode": "MZ",
    "region": "Q",
    "description": "Zambezia"
  },
  {
    "countryCode": "MZ",
    "region": "S",
    "description": "Sofala"
  },
  {
    "countryCode": "MZ",
    "region": "T",
    "description": "Tete"
  },
  {
    "countryCode": "NA",
    "region": "CA",
    "description": "Zambezi"
  },
  {
    "countryCode": "NA",
    "region": "ER",
    "description": "Erongo"
  },
  {
    "countryCode": "NA",
    "region": "HA",
    "description": "Hardap"
  },
  {
    "countryCode": "NA",
    "region": "KA",
    "description": "//Karas"
  },
  {
    "countryCode": "NA",
    "region": "KE",
    "description": "Kavango East"
  },
  {
    "countryCode": "NA",
    "region": "KH",
    "description": "Khomas"
  },
  {
    "countryCode": "NA",
    "region": "KU",
    "description": "Kunene"
  },
  {
    "countryCode": "NA",
    "region": "KW",
    "description": "Kavango West"
  },
  {
    "countryCode": "NA",
    "region": "OD",
    "description": "Otjozondjupa"
  },
  {
    "countryCode": "NA",
    "region": "OH",
    "description": "Omaheke"
  },
  {
    "countryCode": "NA",
    "region": "ON",
    "description": "Oshana"
  },
  {
    "countryCode": "NA",
    "region": "OS",
    "description": "Omusati"
  },
  {
    "countryCode": "NA",
    "region": "OT",
    "description": "Oshikoto"
  },
  {
    "countryCode": "NA",
    "region": "OW",
    "description": "Ohangwena"
  },
  {
    "countryCode": "NE",
    "region": "1",
    "description": "Agadez"
  },
  {
    "countryCode": "NE",
    "region": "2",
    "description": "Diffa"
  },
  {
    "countryCode": "NE",
    "region": "3",
    "description": "Dosso"
  },
  {
    "countryCode": "NE",
    "region": "4",
    "description": "Maradi"
  },
  {
    "countryCode": "NE",
    "region": "5",
    "description": "Tahoua"
  },
  {
    "countryCode": "NE",
    "region": "6",
    "description": "Tillab\u00e9ri"
  },
  {
    "countryCode": "NE",
    "region": "7",
    "description": "Zinder"
  },
  {
    "countryCode": "NE",
    "region": "8",
    "description": "Niamey"
  },
  {
    "countryCode": "NG",
    "region": "AB",
    "description": "Abia"
  },
  {
    "countryCode": "NG",
    "region": "AD",
    "description": "Adamawa"
  },
  {
    "countryCode": "NG",
    "region": "AK",
    "description": "Akwa Ibom"
  },
  {
    "countryCode": "NG",
    "region": "AN",
    "description": "Anambra"
  },
  {
    "countryCode": "NG",
    "region": "BA",
    "description": "Bauchi"
  },
  {
    "countryCode": "NG",
    "region": "BE",
    "description": "Benue"
  },
  {
    "countryCode": "NG",
    "region": "BO",
    "description": "Borno"
  },
  {
    "countryCode": "NG",
    "region": "BY",
    "description": "Bayelsa"
  },
  {
    "countryCode": "NG",
    "region": "CR",
    "description": "Cross River"
  },
  {
    "countryCode": "NG",
    "region": "DE",
    "description": "Delta"
  },
  {
    "countryCode": "NG",
    "region": "EB",
    "description": "Ebonyi"
  },
  {
    "countryCode": "NG",
    "region": "ED",
    "description": "Edo"
  },
  {
    "countryCode": "NG",
    "region": "EK",
    "description": "Ekiti"
  },
  {
    "countryCode": "NG",
    "region": "EN",
    "description": "Enugu"
  },
  {
    "countryCode": "NG",
    "region": "FC",
    "description": "Abuja Fed. Capital"
  },
  {
    "countryCode": "NG",
    "region": "GO",
    "description": "Gombe"
  },
  {
    "countryCode": "NG",
    "region": "IM",
    "description": "Imo"
  },
  {
    "countryCode": "NG",
    "region": "JI",
    "description": "Jigawa"
  },
  {
    "countryCode": "NG",
    "region": "KD",
    "description": "Kaduna"
  },
  {
    "countryCode": "NG",
    "region": "KE",
    "description": "Kebbi"
  },
  {
    "countryCode": "NG",
    "region": "KN",
    "description": "Kano"
  },
  {
    "countryCode": "NG",
    "region": "KO",
    "description": "Kogi"
  },
  {
    "countryCode": "NG",
    "region": "KT",
    "description": "Katsina"
  },
  {
    "countryCode": "NG",
    "region": "KW",
    "description": "Kwara"
  },
  {
    "countryCode": "NG",
    "region": "LA",
    "description": "Lagos"
  },
  {
    "countryCode": "NG",
    "region": "NA",
    "description": "Nassarawa"
  },
  {
    "countryCode": "NG",
    "region": "NI",
    "description": "Niger"
  },
  {
    "countryCode": "NG",
    "region": "OG",
    "description": "Ogun"
  },
  {
    "countryCode": "NG",
    "region": "ON",
    "description": "Ondo"
  },
  {
    "countryCode": "NG",
    "region": "OS",
    "description": "Osun"
  },
  {
    "countryCode": "NG",
    "region": "OY",
    "description": "Oyo"
  },
  {
    "countryCode": "NG",
    "region": "PL",
    "description": "Plateau"
  },
  {
    "countryCode": "NG",
    "region": "RI",
    "description": "Rivers"
  },
  {
    "countryCode": "NG",
    "region": "SO",
    "description": "Sokoto"
  },
  {
    "countryCode": "NG",
    "region": "TA",
    "description": "Taraba"
  },
  {
    "countryCode": "NG",
    "region": "YO",
    "description": "Yobe"
  },
  {
    "countryCode": "NG",
    "region": "ZA",
    "description": "Zamfara"
  },
  {
    "countryCode": "NI",
    "region": "AN",
    "description": "Atl\u00e1ntico Norte"
  },
  {
    "countryCode": "NI",
    "region": "AS",
    "description": "Atl\u00e1ntico Sur"
  },
  {
    "countryCode": "NI",
    "region": "BO",
    "description": "Boaco"
  },
  {
    "countryCode": "NI",
    "region": "CA",
    "description": "Carazo"
  },
  {
    "countryCode": "NI",
    "region": "CI",
    "description": "Chinandega"
  },
  {
    "countryCode": "NI",
    "region": "CO",
    "description": "Chontales"
  },
  {
    "countryCode": "NI",
    "region": "ES",
    "description": "Estel\u00ed"
  },
  {
    "countryCode": "NI",
    "region": "GR",
    "description": "Granada"
  },
  {
    "countryCode": "NI",
    "region": "JI",
    "description": "Jinotega"
  },
  {
    "countryCode": "NI",
    "region": "LE",
    "description": "Le\u00f3n"
  },
  {
    "countryCode": "NI",
    "region": "MD",
    "description": "Madriz"
  },
  {
    "countryCode": "NI",
    "region": "MN",
    "description": "Managua"
  },
  {
    "countryCode": "NI",
    "region": "MS",
    "description": "Masaya"
  },
  {
    "countryCode": "NI",
    "region": "MT",
    "description": "Matagalpa"
  },
  {
    "countryCode": "NI",
    "region": "NS",
    "description": "Nueva Segovia"
  },
  {
    "countryCode": "NI",
    "region": "RI",
    "description": "Rivas"
  },
  {
    "countryCode": "NI",
    "region": "SJ",
    "description": "Rio San Juan"
  },
  {
    "countryCode": "NL",
    "region": "DR",
    "description": "Drenthe"
  },
  {
    "countryCode": "NL",
    "region": "FL",
    "description": "Flevoland"
  },
  {
    "countryCode": "NL",
    "region": "FR",
    "description": "Friesland"
  },
  {
    "countryCode": "NL",
    "region": "GE",
    "description": "Gelderland"
  },
  {
    "countryCode": "NL",
    "region": "GR",
    "description": "Groningen"
  },
  {
    "countryCode": "NL",
    "region": "LI",
    "description": "Limburg"
  },
  {
    "countryCode": "NL",
    "region": "NB",
    "description": "North Brabant"
  },
  {
    "countryCode": "NL",
    "region": "NH",
    "description": "North Holland"
  },
  {
    "countryCode": "NL",
    "region": "OV",
    "description": "Overijssel"
  },
  {
    "countryCode": "NL",
    "region": "UT",
    "description": "Utrecht"
  },
  {
    "countryCode": "NL",
    "region": "ZE",
    "description": "Zeeland"
  },
  {
    "countryCode": "NL",
    "region": "ZH",
    "description": "South Holland"
  },
  {
    "countryCode": "NO",
    "region": "01",
    "description": "Obsolete"
  },
  {
    "countryCode": "NO",
    "region": "02",
    "description": "Obsolete"
  },
  {
    "countryCode": "NO",
    "region": "03",
    "description": "Oslo"
  },
  {
    "countryCode": "NO",
    "region": "04",
    "description": "Obsolete"
  },
  {
    "countryCode": "NO",
    "region": "05",
    "description": "Obsolete"
  },
  {
    "countryCode": "NO",
    "region": "06",
    "description": "Obsolete"
  },
  {
    "countryCode": "NO",
    "region": "07",
    "description": "Obsolete"
  },
  {
    "countryCode": "NO",
    "region": "08",
    "description": "Obsolete"
  },
  {
    "countryCode": "NO",
    "region": "09",
    "description": "Obsolete"
  },
  {
    "countryCode": "NO",
    "region": "10",
    "description": "Obsolete"
  },
  {
    "countryCode": "NO",
    "region": "11",
    "description": "Rogaland"
  },
  {
    "countryCode": "NO",
    "region": "12",
    "description": "Obsolete"
  },
  {
    "countryCode": "NO",
    "region": "14",
    "description": "Obsolete"
  },
  {
    "countryCode": "NO",
    "region": "15",
    "description": "More og Romsdal"
  },
  {
    "countryCode": "NO",
    "region": "18",
    "description": "Nordland"
  },
  {
    "countryCode": "NO",
    "region": "19",
    "description": "Obsolete"
  },
  {
    "countryCode": "NO",
    "region": "20",
    "description": "Obsolete"
  },
  {
    "countryCode": "NO",
    "region": "21",
    "description": "Svalbard"
  },
  {
    "countryCode": "NO",
    "region": "22",
    "description": "Jan Mayen"
  },
  {
    "countryCode": "NO",
    "region": "30",
    "description": "Viken"
  },
  {
    "countryCode": "NO",
    "region": "34",
    "description": "Innlandet"
  },
  {
    "countryCode": "NO",
    "region": "38",
    "description": "Vestfold og Telemark"
  },
  {
    "countryCode": "NO",
    "region": "42",
    "description": "Agder"
  },
  {
    "countryCode": "NO",
    "region": "46",
    "description": "Vestland"
  },
  {
    "countryCode": "NO",
    "region": "50",
    "description": "Tr\u00f8ndelag"
  },
  {
    "countryCode": "NO",
    "region": "54",
    "description": "Troms og Finnmark"
  },
  {
    "countryCode": "NP",
    "region": "P1",
    "description": "Koshi"
  },
  {
    "countryCode": "NP",
    "region": "P2",
    "description": "Madhesh"
  },
  {
    "countryCode": "NP",
    "region": "P3",
    "description": "Bagmati"
  },
  {
    "countryCode": "NP",
    "region": "P4",
    "description": "Gandaki"
  },
  {
    "countryCode": "NP",
    "region": "P5",
    "description": "Lumbini"
  },
  {
    "countryCode": "NP",
    "region": "P6",
    "description": "Karnali"
  },
  {
    "countryCode": "NP",
    "region": "P7",
    "description": "Sudurpashchim"
  },
  {
    "countryCode": "NR",
    "region": "01",
    "description": "Aiwo"
  },
  {
    "countryCode": "NR",
    "region": "02",
    "description": "Anabar"
  },
  {
    "countryCode": "NR",
    "region": "03",
    "description": "Anetan"
  },
  {
    "countryCode": "NR",
    "region": "04",
    "description": "Anibare"
  },
  {
    "countryCode": "NR",
    "region": "05",
    "description": "Baiti"
  },
  {
    "countryCode": "NR",
    "region": "06",
    "description": "Boe"
  },
  {
    "countryCode": "NR",
    "region": "07",
    "description": "Buada"
  },
  {
    "countryCode": "NR",
    "region": "08",
    "description": "Denigomodu"
  },
  {
    "countryCode": "NR",
    "region": "09",
    "description": "Ewa"
  },
  {
    "countryCode": "NR",
    "region": "10",
    "description": "Ijuw"
  },
  {
    "countryCode": "NR",
    "region": "11",
    "description": "Meneng"
  },
  {
    "countryCode": "NR",
    "region": "12",
    "description": "Nibok"
  },
  {
    "countryCode": "NR",
    "region": "13",
    "description": "Uaboe"
  },
  {
    "countryCode": "NR",
    "region": "14",
    "description": "Yaren"
  },
  {
    "countryCode": "NZ",
    "region": "AUK",
    "description": "Auckland"
  },
  {
    "countryCode": "NZ",
    "region": "BOP",
    "description": "Bay of Plenty"
  },
  {
    "countryCode": "NZ",
    "region": "CAN",
    "description": "Canterbury"
  },
  {
    "countryCode": "NZ",
    "region": "CIT",
    "description": "Chatham Islands"
  },
  {
    "countryCode": "NZ",
    "region": "GIS",
    "description": "Gisborne"
  },
  {
    "countryCode": "NZ",
    "region": "HKB",
    "description": "Hawke\u00b4s Bay"
  },
  {
    "countryCode": "NZ",
    "region": "MBH",
    "description": "Marlborough"
  },
  {
    "countryCode": "NZ",
    "region": "MWT",
    "description": "Manawat\u016b Whanganui"
  },
  {
    "countryCode": "NZ",
    "region": "NSN",
    "description": "Nelson"
  },
  {
    "countryCode": "NZ",
    "region": "NTL",
    "description": "Northland"
  },
  {
    "countryCode": "NZ",
    "region": "OTA",
    "description": "Otago"
  },
  {
    "countryCode": "NZ",
    "region": "STL",
    "description": "Southland"
  },
  {
    "countryCode": "NZ",
    "region": "TAS",
    "description": "Tasman"
  },
  {
    "countryCode": "NZ",
    "region": "TKI",
    "description": "Taranaki"
  },
  {
    "countryCode": "NZ",
    "region": "WGN",
    "description": "Greater Wellington"
  },
  {
    "countryCode": "NZ",
    "region": "WKO",
    "description": "Waikato"
  },
  {
    "countryCode": "NZ",
    "region": "WTC",
    "description": "West Coast"
  },
  {
    "countryCode": "OM",
    "region": "BJ",
    "description": "Al Batinah South"
  },
  {
    "countryCode": "OM",
    "region": "BS",
    "description": "Al Batinah North"
  },
  {
    "countryCode": "OM",
    "region": "BU",
    "description": "Al Buraimi"
  },
  {
    "countryCode": "OM",
    "region": "DA",
    "description": "Ad Dakhiliyah"
  },
  {
    "countryCode": "OM",
    "region": "MA",
    "description": "Masqat"
  },
  {
    "countryCode": "OM",
    "region": "MU",
    "description": "Musandam"
  },
  {
    "countryCode": "OM",
    "region": "SJ",
    "description": "Ash Sharqiyah South"
  },
  {
    "countryCode": "OM",
    "region": "SS",
    "description": "Ash Sharqiyah North"
  },
  {
    "countryCode": "OM",
    "region": "WU",
    "description": "Al Wusta"
  },
  {
    "countryCode": "OM",
    "region": "ZA",
    "description": "Al Dhahirah"
  },
  {
    "countryCode": "OM",
    "region": "ZU",
    "description": "Dhofar"
  },
  {
    "countryCode": "PA",
    "region": "1",
    "description": "Bocas del Toro"
  },
  {
    "countryCode": "PA",
    "region": "10",
    "description": "Panam\u00e1 Oeste"
  },
  {
    "countryCode": "PA",
    "region": "2",
    "description": "Cocl\u00e9"
  },
  {
    "countryCode": "PA",
    "region": "3",
    "description": "Col\u00f3n"
  },
  {
    "countryCode": "PA",
    "region": "4",
    "description": "Chiriqu\u00ed"
  },
  {
    "countryCode": "PA",
    "region": "5",
    "description": "Dari\u00e9n"
  },
  {
    "countryCode": "PA",
    "region": "6",
    "description": "Herrera"
  },
  {
    "countryCode": "PA",
    "region": "7",
    "description": "Los Santos"
  },
  {
    "countryCode": "PA",
    "region": "8",
    "description": "Panam\u00e1"
  },
  {
    "countryCode": "PA",
    "region": "9",
    "description": "Veraguas"
  },
  {
    "countryCode": "PA",
    "region": "EM",
    "description": "Ember\u00e1"
  },
  {
    "countryCode": "PA",
    "region": "KY",
    "description": "Kuna Yala"
  },
  {
    "countryCode": "PA",
    "region": "NB",
    "description": "Ng\u00e4be-Bugl\u00e9"
  },
  {
    "countryCode": "PA",
    "region": "NT",
    "description": "Naso Tj\u00ebr Di"
  },
  {
    "countryCode": "PE",
    "region": "AMA",
    "description": "Amazon"
  },
  {
    "countryCode": "PE",
    "region": "ANC",
    "description": "Ancash"
  },
  {
    "countryCode": "PE",
    "region": "APU",
    "description": "Apurimac"
  },
  {
    "countryCode": "PE",
    "region": "ARE",
    "description": "Arequipa"
  },
  {
    "countryCode": "PE",
    "region": "AYA",
    "description": "Ayacucho"
  },
  {
    "countryCode": "PE",
    "region": "CAJ",
    "description": "Cajamarca"
  },
  {
    "countryCode": "PE",
    "region": "CAL",
    "description": "Callao"
  },
  {
    "countryCode": "PE",
    "region": "CUS",
    "description": "Cuzco"
  },
  {
    "countryCode": "PE",
    "region": "HUC",
    "description": "Huanuco"
  },
  {
    "countryCode": "PE",
    "region": "HUV",
    "description": "Huancavelica"
  },
  {
    "countryCode": "PE",
    "region": "ICA",
    "description": "Ica"
  },
  {
    "countryCode": "PE",
    "region": "JUN",
    "description": "Junin"
  },
  {
    "countryCode": "PE",
    "region": "LAL",
    "description": "La Libertad"
  },
  {
    "countryCode": "PE",
    "region": "LAM",
    "description": "Lambayeque"
  },
  {
    "countryCode": "PE",
    "region": "LIM",
    "description": "Lima Region"
  },
  {
    "countryCode": "PE",
    "region": "LMA",
    "description": "Lima Province"
  },
  {
    "countryCode": "PE",
    "region": "LOR",
    "description": "Loreto"
  },
  {
    "countryCode": "PE",
    "region": "MDD",
    "description": "Madre de Dios"
  },
  {
    "countryCode": "PE",
    "region": "MOQ",
    "description": "Moquegua"
  },
  {
    "countryCode": "PE",
    "region": "PAS",
    "description": "Pasco"
  },
  {
    "countryCode": "PE",
    "region": "PIU",
    "description": "Piura"
  },
  {
    "countryCode": "PE",
    "region": "PUN",
    "description": "Puno"
  },
  {
    "countryCode": "PE",
    "region": "SAM",
    "description": "San Martin"
  },
  {
    "countryCode": "PE",
    "region": "TAC",
    "description": "Tacna"
  },
  {
    "countryCode": "PE",
    "region": "TUM",
    "description": "Tumbes"
  },
  {
    "countryCode": "PE",
    "region": "UCA",
    "description": "Ucayali"
  },
  {
    "countryCode": "PG",
    "region": "CPK",
    "description": "Chimbu"
  },
  {
    "countryCode": "PG",
    "region": "CPM",
    "description": "Central"
  },
  {
    "countryCode": "PG",
    "region": "EBR",
    "description": "East New Britain"
  },
  {
    "countryCode": "PG",
    "region": "EHG",
    "description": "Eastern Highlands"
  },
  {
    "countryCode": "PG",
    "region": "EPW",
    "description": "Enga"
  },
  {
    "countryCode": "PG",
    "region": "ESW",
    "description": "East Sepik"
  },
  {
    "countryCode": "PG",
    "region": "GPK",
    "description": "Gulf"
  },
  {
    "countryCode": "PG",
    "region": "HLA",
    "description": "Hela"
  },
  {
    "countryCode": "PG",
    "region": "JWK",
    "description": "Jiwaka"
  },
  {
    "countryCode": "PG",
    "region": "MBA",
    "description": "Milne Bay"
  },
  {
    "countryCode": "PG",
    "region": "MPL",
    "description": "Morobe"
  },
  {
    "countryCode": "PG",
    "region": "MPM",
    "description": "Madang"
  },
  {
    "countryCode": "PG",
    "region": "MRL",
    "description": "Manus"
  },
  {
    "countryCode": "PG",
    "region": "NCD",
    "description": "National Capital Dis"
  },
  {
    "countryCode": "PG",
    "region": "NIK",
    "description": "New Ireland"
  },
  {
    "countryCode": "PG",
    "region": "NPP",
    "description": "Northern (Oro)"
  },
  {
    "countryCode": "PG",
    "region": "NSB",
    "description": "Bougainville"
  },
  {
    "countryCode": "PG",
    "region": "SAN",
    "description": "Sandaun (West Sepik)"
  },
  {
    "countryCode": "PG",
    "region": "SHM",
    "description": "Southern Highlands"
  },
  {
    "countryCode": "PG",
    "region": "WBK",
    "description": "West New Britain"
  },
  {
    "countryCode": "PG",
    "region": "WHM",
    "description": "Western Highlands"
  },
  {
    "countryCode": "PG",
    "region": "WPD",
    "description": "Western (Fly River)"
  },
  {
    "countryCode": "PH",
    "region": "00",
    "description": "National Capital Reg"
  },
  {
    "countryCode": "PH",
    "region": "01",
    "description": "Ilocos"
  },
  {
    "countryCode": "PH",
    "region": "02",
    "description": "Cagayan Valley"
  },
  {
    "countryCode": "PH",
    "region": "03",
    "description": "Central Luzon"
  },
  {
    "countryCode": "PH",
    "region": "05",
    "description": "Bicol"
  },
  {
    "countryCode": "PH",
    "region": "06",
    "description": "Western Visayas"
  },
  {
    "countryCode": "PH",
    "region": "07",
    "description": "Central Visayas"
  },
  {
    "countryCode": "PH",
    "region": "08",
    "description": "Eastern Visayas"
  },
  {
    "countryCode": "PH",
    "region": "09",
    "description": "Zamboanga Peninsula"
  },
  {
    "countryCode": "PH",
    "region": "10",
    "description": "Northern Mindanao"
  },
  {
    "countryCode": "PH",
    "region": "11",
    "description": "Davao"
  },
  {
    "countryCode": "PH",
    "region": "12",
    "description": "Soccsksargen"
  },
  {
    "countryCode": "PH",
    "region": "13",
    "description": "Caraga"
  },
  {
    "countryCode": "PH",
    "region": "14",
    "description": "MuslimMindanao(ARMM)"
  },
  {
    "countryCode": "PH",
    "region": "15",
    "description": "Cordillera A.R.(CAR)"
  },
  {
    "countryCode": "PH",
    "region": "40",
    "description": "Calabarzon"
  },
  {
    "countryCode": "PH",
    "region": "41",
    "description": "Mimaropa"
  },
  {
    "countryCode": "PK",
    "region": "BA",
    "description": "Balochistan"
  },
  {
    "countryCode": "PK",
    "region": "GB",
    "description": "Gilgit-Baltistan"
  },
  {
    "countryCode": "PK",
    "region": "IS",
    "description": "Islamabad"
  },
  {
    "countryCode": "PK",
    "region": "JK",
    "description": "Azad Kashmir"
  },
  {
    "countryCode": "PK",
    "region": "KP",
    "description": "Khyber Pakhtunkhwa"
  },
  {
    "countryCode": "PK",
    "region": "PB",
    "description": "Punjab"
  },
  {
    "countryCode": "PK",
    "region": "SD",
    "description": "Sindh"
  },
  {
    "countryCode": "PL",
    "region": "02",
    "description": "Dolnoslaskie"
  },
  {
    "countryCode": "PL",
    "region": "04",
    "description": "Kujawsko-Pomorskie"
  },
  {
    "countryCode": "PL",
    "region": "06",
    "description": "Lubelskie"
  },
  {
    "countryCode": "PL",
    "region": "08",
    "description": "Lubuskie"
  },
  {
    "countryCode": "PL",
    "region": "10",
    "description": "Lodzkie"
  },
  {
    "countryCode": "PL",
    "region": "12",
    "description": "Malopolskie"
  },
  {
    "countryCode": "PL",
    "region": "14",
    "description": "Mazowieckie"
  },
  {
    "countryCode": "PL",
    "region": "16",
    "description": "Opolskie"
  },
  {
    "countryCode": "PL",
    "region": "18",
    "description": "Podkarpackie"
  },
  {
    "countryCode": "PL",
    "region": "20",
    "description": "Podlaskie"
  },
  {
    "countryCode": "PL",
    "region": "22",
    "description": "Pomorskie"
  },
  {
    "countryCode": "PL",
    "region": "24",
    "description": "Slaskie"
  },
  {
    "countryCode": "PL",
    "region": "26",
    "description": "Swietokrzyskie"
  },
  {
    "countryCode": "PL",
    "region": "28",
    "description": "Warmi\u0144sko-Mazurskie"
  },
  {
    "countryCode": "PL",
    "region": "30",
    "description": "Wielkopolskie"
  },
  {
    "countryCode": "PL",
    "region": "32",
    "description": "Zachodnio-Pomorskie"
  },
  {
    "countryCode": "PS",
    "region": "BTH",
    "description": "Bethlehem"
  },
  {
    "countryCode": "PS",
    "region": "DEB",
    "description": "Deir El Balah"
  },
  {
    "countryCode": "PS",
    "region": "GZA",
    "description": "Gaza"
  },
  {
    "countryCode": "PS",
    "region": "HBN",
    "description": "Hebron"
  },
  {
    "countryCode": "PS",
    "region": "JEM",
    "description": "Jerusalem"
  },
  {
    "countryCode": "PS",
    "region": "JEN",
    "description": "Jenin"
  },
  {
    "countryCode": "PS",
    "region": "JRH",
    "description": "Jericho & Al Aghwar"
  },
  {
    "countryCode": "PS",
    "region": "KYS",
    "description": "Khan Yunis"
  },
  {
    "countryCode": "PS",
    "region": "NBS",
    "description": "Nablus"
  },
  {
    "countryCode": "PS",
    "region": "NGZ",
    "description": "North Gaza"
  },
  {
    "countryCode": "PS",
    "region": "QQA",
    "description": "Qalqilya"
  },
  {
    "countryCode": "PS",
    "region": "RBH",
    "description": "Ramallah"
  },
  {
    "countryCode": "PS",
    "region": "RFH",
    "description": "Rafah"
  },
  {
    "countryCode": "PS",
    "region": "SLT",
    "description": "Salfit"
  },
  {
    "countryCode": "PS",
    "region": "TBS",
    "description": "Tubas"
  },
  {
    "countryCode": "PS",
    "region": "TKM",
    "description": "Tulkarm"
  },
  {
    "countryCode": "PT",
    "region": "10",
    "description": "Alto Minho"
  },
  {
    "countryCode": "PT",
    "region": "11",
    "description": "Cavado"
  },
  {
    "countryCode": "PT",
    "region": "30",
    "description": "Oeste"
  },
  {
    "countryCode": "PT",
    "region": "31",
    "description": "Grande Lisboa"
  },
  {
    "countryCode": "PT",
    "region": "32",
    "description": "Pen\u00ednsula de Set\u00fabal"
  },
  {
    "countryCode": "PT",
    "region": "34",
    "description": "Leziria do Tejo"
  },
  {
    "countryCode": "PT",
    "region": "35",
    "description": "Obsolete"
  },
  {
    "countryCode": "PT",
    "region": "36",
    "description": "M\u00e9dio Tejo"
  },
  {
    "countryCode": "PT",
    "region": "40",
    "description": "Alentejo Litoral"
  },
  {
    "countryCode": "PT",
    "region": "43",
    "description": "Baixo Alentejo"
  },
  {
    "countryCode": "PT",
    "region": "44",
    "description": "Alto Alentejo"
  },
  {
    "countryCode": "PT",
    "region": "45",
    "description": "Alentejo Central"
  },
  {
    "countryCode": "PT",
    "region": "50",
    "description": "Algarve"
  },
  {
    "countryCode": "PT",
    "region": "60",
    "description": "Reg. Aut. dos A\u00e7ores"
  },
  {
    "countryCode": "PT",
    "region": "70",
    "description": "Reg. Aut. da Madeira"
  },
  {
    "countryCode": "PT",
    "region": "80",
    "description": "Ave"
  },
  {
    "countryCode": "PT",
    "region": "81",
    "description": "Metropolitana Porto"
  },
  {
    "countryCode": "PT",
    "region": "82",
    "description": "T\u00e2mega e Sousa"
  },
  {
    "countryCode": "PT",
    "region": "83",
    "description": "Alto T\u00e2mega"
  },
  {
    "countryCode": "PT",
    "region": "84",
    "description": "Douro"
  },
  {
    "countryCode": "PT",
    "region": "85",
    "description": "Tr\u00e1s-os-Montes"
  },
  {
    "countryCode": "PT",
    "region": "90",
    "description": "Regi\u00e3o de Aveiro"
  },
  {
    "countryCode": "PT",
    "region": "91",
    "description": "Regi\u00e3o de Coimbra"
  },
  {
    "countryCode": "PT",
    "region": "92",
    "description": "Regi\u00e3o de Leiria"
  },
  {
    "countryCode": "PT",
    "region": "93",
    "description": "Viseu D\u00e3o Laf\u00f5es"
  },
  {
    "countryCode": "PT",
    "region": "94",
    "description": "Beira Baixa"
  },
  {
    "countryCode": "PT",
    "region": "95",
    "description": "Beiras e Estrela"
  },
  {
    "countryCode": "PY",
    "region": "1",
    "description": "Concepci\u00f3n"
  },
  {
    "countryCode": "PY",
    "region": "10",
    "description": "Alto Paran\u00e1"
  },
  {
    "countryCode": "PY",
    "region": "11",
    "description": "Central"
  },
  {
    "countryCode": "PY",
    "region": "12",
    "description": "\u00d1eembuc\u00fa"
  },
  {
    "countryCode": "PY",
    "region": "13",
    "description": "Amambay"
  },
  {
    "countryCode": "PY",
    "region": "14",
    "description": "Canindey\u00fa"
  },
  {
    "countryCode": "PY",
    "region": "15",
    "description": "Presidente Hayes"
  },
  {
    "countryCode": "PY",
    "region": "16",
    "description": "Alto Paraguay"
  },
  {
    "countryCode": "PY",
    "region": "19",
    "description": "Boquer\u00f3n"
  },
  {
    "countryCode": "PY",
    "region": "2",
    "description": "San Pedro"
  },
  {
    "countryCode": "PY",
    "region": "3",
    "description": "Cordillera"
  },
  {
    "countryCode": "PY",
    "region": "4",
    "description": "Guair\u00e1"
  },
  {
    "countryCode": "PY",
    "region": "5",
    "description": "Caaguaz\u00fa"
  },
  {
    "countryCode": "PY",
    "region": "6",
    "description": "Caazap\u00e1"
  },
  {
    "countryCode": "PY",
    "region": "7",
    "description": "Itap\u00faa"
  },
  {
    "countryCode": "PY",
    "region": "8",
    "description": "Misiones"
  },
  {
    "countryCode": "PY",
    "region": "9",
    "description": "Paraguar\u00ed"
  },
  {
    "countryCode": "PY",
    "region": "ASU",
    "description": "Asunci\u00f3n"
  },
  {
    "countryCode": "QA",
    "region": "DA",
    "description": "Doha"
  },
  {
    "countryCode": "QA",
    "region": "KH",
    "description": "Al Khor & Dhekra"
  },
  {
    "countryCode": "QA",
    "region": "MS",
    "description": "Al Shamal"
  },
  {
    "countryCode": "QA",
    "region": "RA",
    "description": "Al Rayyan"
  },
  {
    "countryCode": "QA",
    "region": "SH",
    "description": "Ash Shahaniyah"
  },
  {
    "countryCode": "QA",
    "region": "US",
    "description": "Umm Salal"
  },
  {
    "countryCode": "QA",
    "region": "WA",
    "description": "Al Wakrah"
  },
  {
    "countryCode": "QA",
    "region": "ZA",
    "description": "Al Daayen"
  },
  {
    "countryCode": "RO",
    "region": "AB",
    "description": "Alba"
  },
  {
    "countryCode": "RO",
    "region": "AG",
    "description": "Arges"
  },
  {
    "countryCode": "RO",
    "region": "AR",
    "description": "Arad"
  },
  {
    "countryCode": "RO",
    "region": "B",
    "description": "Bucuresti"
  },
  {
    "countryCode": "RO",
    "region": "BC",
    "description": "Bacau"
  },
  {
    "countryCode": "RO",
    "region": "BH",
    "description": "Bihor"
  },
  {
    "countryCode": "RO",
    "region": "BN",
    "description": "Bistrita-Nasaud"
  },
  {
    "countryCode": "RO",
    "region": "BR",
    "description": "Braila"
  },
  {
    "countryCode": "RO",
    "region": "BT",
    "description": "Botosani"
  },
  {
    "countryCode": "RO",
    "region": "BV",
    "description": "Brasov"
  },
  {
    "countryCode": "RO",
    "region": "BZ",
    "description": "Buzau"
  },
  {
    "countryCode": "RO",
    "region": "CJ",
    "description": "Cluj"
  },
  {
    "countryCode": "RO",
    "region": "CL",
    "description": "Calarasi"
  },
  {
    "countryCode": "RO",
    "region": "CS",
    "description": "Caras-Severin"
  },
  {
    "countryCode": "RO",
    "region": "CT",
    "description": "Constanta"
  },
  {
    "countryCode": "RO",
    "region": "CV",
    "description": "Covasna"
  },
  {
    "countryCode": "RO",
    "region": "DB",
    "description": "Dimbovita"
  },
  {
    "countryCode": "RO",
    "region": "DJ",
    "description": "Dolj"
  },
  {
    "countryCode": "RO",
    "region": "GJ",
    "description": "Gorj"
  },
  {
    "countryCode": "RO",
    "region": "GL",
    "description": "Galati"
  },
  {
    "countryCode": "RO",
    "region": "GR",
    "description": "Giurgiu"
  },
  {
    "countryCode": "RO",
    "region": "HD",
    "description": "Hunedoara"
  },
  {
    "countryCode": "RO",
    "region": "HR",
    "description": "Harghita"
  },
  {
    "countryCode": "RO",
    "region": "IF",
    "description": "Ilfov"
  },
  {
    "countryCode": "RO",
    "region": "IL",
    "description": "Ialomita"
  },
  {
    "countryCode": "RO",
    "region": "IS",
    "description": "Iasi"
  },
  {
    "countryCode": "RO",
    "region": "MH",
    "description": "Mehedinti"
  },
  {
    "countryCode": "RO",
    "region": "MM",
    "description": "Maramures"
  },
  {
    "countryCode": "RO",
    "region": "MS",
    "description": "Mures"
  },
  {
    "countryCode": "RO",
    "region": "NT",
    "description": "Neamt"
  },
  {
    "countryCode": "RO",
    "region": "OT",
    "description": "Olt"
  },
  {
    "countryCode": "RO",
    "region": "PH",
    "description": "Prahova"
  },
  {
    "countryCode": "RO",
    "region": "SB",
    "description": "Sibiu"
  },
  {
    "countryCode": "RO",
    "region": "SJ",
    "description": "Salaj"
  },
  {
    "countryCode": "RO",
    "region": "SM",
    "description": "Satu Mare"
  },
  {
    "countryCode": "RO",
    "region": "SV",
    "description": "Suceava"
  },
  {
    "countryCode": "RO",
    "region": "TL",
    "description": "Tulcea"
  },
  {
    "countryCode": "RO",
    "region": "TM",
    "description": "Timis"
  },
  {
    "countryCode": "RO",
    "region": "TR",
    "description": "Teleorman"
  },
  {
    "countryCode": "RO",
    "region": "VL",
    "description": "Vilcea"
  },
  {
    "countryCode": "RO",
    "region": "VN",
    "description": "Vrancea"
  },
  {
    "countryCode": "RO",
    "region": "VS",
    "description": "Vaslui"
  },
  {
    "countryCode": "RS",
    "region": "00",
    "description": "Obsolete"
  },
  {
    "countryCode": "RS",
    "region": "001",
    "description": "\u0410l\u0435ks\u0430ndr\u043ev\u0430c"
  },
  {
    "countryCode": "RS",
    "region": "002",
    "description": "\u0410l\u0435ksin\u0430c"
  },
  {
    "countryCode": "RS",
    "region": "003",
    "description": "\u0410r\u0430ndj\u0435l\u043ev\u0430c"
  },
  {
    "countryCode": "RS",
    "region": "004",
    "description": "\u0410rilj\u0435"
  },
  {
    "countryCode": "RS",
    "region": "006",
    "description": "B\u0430busnic\u0430"
  },
  {
    "countryCode": "RS",
    "region": "007",
    "description": "B\u0430\u0458in\u0430 B\u0430st\u0430"
  },
  {
    "countryCode": "RS",
    "region": "008",
    "description": "B\u0430t\u043ecin\u0430"
  },
  {
    "countryCode": "RS",
    "region": "009",
    "description": "B\u0435l\u0430 P\u0430l\u0430nk\u0430"
  },
  {
    "countryCode": "RS",
    "region": "01",
    "description": "Obsolete"
  },
  {
    "countryCode": "RS",
    "region": "010",
    "description": "B\u0430r\u0430\u0458\u0435v\u043e"
  },
  {
    "countryCode": "RS",
    "region": "011",
    "description": "Cuk\u0430ric\u0430"
  },
  {
    "countryCode": "RS",
    "region": "012",
    "description": "Gr\u043eck\u0430"
  },
  {
    "countryCode": "RS",
    "region": "013",
    "description": "N\u043evi B\u0435\u043egr\u0430d"
  },
  {
    "countryCode": "RS",
    "region": "014",
    "description": "\u041ebr\u0435n\u043ev\u0430c"
  },
  {
    "countryCode": "RS",
    "region": "015",
    "description": "P\u0430lilul\u0430"
  },
  {
    "countryCode": "RS",
    "region": "016",
    "description": "S\u0430vski V\u0435n\u0430c"
  },
  {
    "countryCode": "RS",
    "region": "017",
    "description": "S\u043ep\u043et"
  },
  {
    "countryCode": "RS",
    "region": "018",
    "description": "St\u0430ri Gr\u0430d"
  },
  {
    "countryCode": "RS",
    "region": "019",
    "description": "V\u043ezd\u043ev\u0430c"
  },
  {
    "countryCode": "RS",
    "region": "02",
    "description": "Obsolete"
  },
  {
    "countryCode": "RS",
    "region": "020",
    "description": "Vr\u0430c\u0430r"
  },
  {
    "countryCode": "RS",
    "region": "021",
    "description": "Zemun"
  },
  {
    "countryCode": "RS",
    "region": "022",
    "description": "Zv\u0435zd\u0430r\u0430"
  },
  {
    "countryCode": "RS",
    "region": "023",
    "description": "Bl\u0430c\u0435"
  },
  {
    "countryCode": "RS",
    "region": "024",
    "description": "B\u043eg\u0430tic"
  },
  {
    "countryCode": "RS",
    "region": "025",
    "description": "B\u043e\u0458nik"
  },
  {
    "countryCode": "RS",
    "region": "026",
    "description": "B\u043elj\u0435v\u0430c"
  },
  {
    "countryCode": "RS",
    "region": "027",
    "description": "B\u043er"
  },
  {
    "countryCode": "RS",
    "region": "028",
    "description": "B\u043esil\u0435gr\u0430d"
  },
  {
    "countryCode": "RS",
    "region": "029",
    "description": "Brus"
  },
  {
    "countryCode": "RS",
    "region": "03",
    "description": "Obsolete"
  },
  {
    "countryCode": "RS",
    "region": "030",
    "description": "Bu\u0458\u0430n\u043ev\u0430c"
  },
  {
    "countryCode": "RS",
    "region": "031",
    "description": "Crn\u0430 Tr\u0430v\u0430"
  },
  {
    "countryCode": "RS",
    "region": "032",
    "description": "Cic\u0435v\u0430c"
  },
  {
    "countryCode": "RS",
    "region": "033",
    "description": "Cupri\u0458\u0430"
  },
  {
    "countryCode": "RS",
    "region": "034",
    "description": "Grad C\u0430c\u0430k"
  },
  {
    "countryCode": "RS",
    "region": "035",
    "description": "C\u0430\u0458\u0435tin\u0430"
  },
  {
    "countryCode": "RS",
    "region": "036",
    "description": "D\u0435sp\u043et\u043ev\u0430c"
  },
  {
    "countryCode": "RS",
    "region": "037",
    "description": "Dimitr\u043evgr\u0430d"
  },
  {
    "countryCode": "RS",
    "region": "038",
    "description": "D\u043elj\u0435v\u0430c"
  },
  {
    "countryCode": "RS",
    "region": "039",
    "description": "G\u0430dzin H\u0430n"
  },
  {
    "countryCode": "RS",
    "region": "04",
    "description": "Obsolete"
  },
  {
    "countryCode": "RS",
    "region": "040",
    "description": "G\u043elub\u0430c"
  },
  {
    "countryCode": "RS",
    "region": "041",
    "description": "G\u043ernji Mil\u0430n\u043ev\u0430c"
  },
  {
    "countryCode": "RS",
    "region": "042",
    "description": "Iv\u0430njic\u0430"
  },
  {
    "countryCode": "RS",
    "region": "043",
    "description": "Kl\u0430d\u043ev\u043e"
  },
  {
    "countryCode": "RS",
    "region": "044",
    "description": "Knic"
  },
  {
    "countryCode": "RS",
    "region": "045",
    "description": "Knj\u0430z\u0435v\u0430c"
  },
  {
    "countryCode": "RS",
    "region": "046",
    "description": "K\u043ec\u0435lj\u0435v\u0430"
  },
  {
    "countryCode": "RS",
    "region": "048",
    "description": "K\u043es\u0458\u0435ric"
  },
  {
    "countryCode": "RS",
    "region": "049",
    "description": "Kr\u0430gu\u0458\u0435v\u0430c"
  },
  {
    "countryCode": "RS",
    "region": "05",
    "description": "Obsolete"
  },
  {
    "countryCode": "RS",
    "region": "050",
    "description": "Kr\u0430lj\u0435v\u043e"
  },
  {
    "countryCode": "RS",
    "region": "051",
    "description": "Krup\u0430nj"
  },
  {
    "countryCode": "RS",
    "region": "052",
    "description": "Grad Krus\u0435v\u0430c"
  },
  {
    "countryCode": "RS",
    "region": "053",
    "description": "Kuc\u0435v\u043e"
  },
  {
    "countryCode": "RS",
    "region": "054",
    "description": "Kursumli\u0458\u0430"
  },
  {
    "countryCode": "RS",
    "region": "055",
    "description": "L\u0430\u0458k\u043ev\u0430c"
  },
  {
    "countryCode": "RS",
    "region": "056",
    "description": "L\u0430z\u0430r\u0435v\u0430c"
  },
  {
    "countryCode": "RS",
    "region": "057",
    "description": "L\u0435b\u0430n\u0435"
  },
  {
    "countryCode": "RS",
    "region": "058",
    "description": "Grad L\u0435sk\u043ev\u0430c"
  },
  {
    "countryCode": "RS",
    "region": "059",
    "description": "Grad L\u043eznic\u0430"
  },
  {
    "countryCode": "RS",
    "region": "06",
    "description": "Obsolete"
  },
  {
    "countryCode": "RS",
    "region": "060",
    "description": "Luc\u0430ni"
  },
  {
    "countryCode": "RS",
    "region": "061",
    "description": "Ljig"
  },
  {
    "countryCode": "RS",
    "region": "062",
    "description": "Ljub\u043evi\u0458\u0430"
  },
  {
    "countryCode": "RS",
    "region": "063",
    "description": "M\u0430\u0458d\u0430np\u0435k"
  },
  {
    "countryCode": "RS",
    "region": "065",
    "description": "M\u0430li Zv\u043ernik"
  },
  {
    "countryCode": "RS",
    "region": "066",
    "description": "M\u0430l\u043e Crnic\u0435"
  },
  {
    "countryCode": "RS",
    "region": "067",
    "description": "M\u0435dv\u0435dj\u0430"
  },
  {
    "countryCode": "RS",
    "region": "068",
    "description": "M\u0435r\u043esin\u0430"
  },
  {
    "countryCode": "RS",
    "region": "069",
    "description": "Mi\u043enic\u0430"
  },
  {
    "countryCode": "RS",
    "region": "07",
    "description": "Obsolete"
  },
  {
    "countryCode": "RS",
    "region": "070",
    "description": "Ml\u0430d\u0435n\u043ev\u0430c"
  },
  {
    "countryCode": "RS",
    "region": "072",
    "description": "N\u0435g\u043etin"
  },
  {
    "countryCode": "RS",
    "region": "074",
    "description": "N\u043ev\u0430 V\u0430r\u043es"
  },
  {
    "countryCode": "RS",
    "region": "075",
    "description": "Grad N\u043evi P\u0430z\u0430r"
  },
  {
    "countryCode": "RS",
    "region": "076",
    "description": "\u041es\u0435\u010din\u0430"
  },
  {
    "countryCode": "RS",
    "region": "077",
    "description": "P\u0430r\u0430cin"
  },
  {
    "countryCode": "RS",
    "region": "078",
    "description": "P\u0435tr\u043ev\u0430c n\u0430 Ml\u0430vi"
  },
  {
    "countryCode": "RS",
    "region": "079",
    "description": "Pir\u043et"
  },
  {
    "countryCode": "RS",
    "region": "08",
    "description": "Obsolete"
  },
  {
    "countryCode": "RS",
    "region": "080",
    "description": "Grad P\u043ez\u0430r\u0435v\u0430c"
  },
  {
    "countryCode": "RS",
    "region": "081",
    "description": "P\u043ez\u0435g\u0430"
  },
  {
    "countryCode": "RS",
    "region": "082",
    "description": "Pr\u0435s\u0435v\u043e"
  },
  {
    "countryCode": "RS",
    "region": "083",
    "description": "Prib\u043e\u0458"
  },
  {
    "countryCode": "RS",
    "region": "084",
    "description": "Pri\u0458\u0435p\u043elj\u0435"
  },
  {
    "countryCode": "RS",
    "region": "085",
    "description": "Pr\u043ekuplj\u0435"
  },
  {
    "countryCode": "RS",
    "region": "086",
    "description": "R\u0430c\u0430"
  },
  {
    "countryCode": "RS",
    "region": "087",
    "description": "R\u0430sk\u0430"
  },
  {
    "countryCode": "RS",
    "region": "088",
    "description": "R\u0430z\u0430nj"
  },
  {
    "countryCode": "RS",
    "region": "089",
    "description": "R\u0435k\u043ev\u0430c"
  },
  {
    "countryCode": "RS",
    "region": "09",
    "description": "Obsolete"
  },
  {
    "countryCode": "RS",
    "region": "091",
    "description": "S\u0458\u0435nic\u0430"
  },
  {
    "countryCode": "RS",
    "region": "092",
    "description": "Grad Sm\u0435d\u0435r\u0435v\u043e"
  },
  {
    "countryCode": "RS",
    "region": "093",
    "description": "Sm\u0435d\u0435r\u0435vsk\u0430 P\u0430l\u0430nk\u0430"
  },
  {
    "countryCode": "RS",
    "region": "094",
    "description": "S\u043ek\u043eb\u0430nj\u0430"
  },
  {
    "countryCode": "RS",
    "region": "095",
    "description": "Surdulic\u0430"
  },
  {
    "countryCode": "RS",
    "region": "096",
    "description": "Grad \u0408\u0430g\u043edin\u0430"
  },
  {
    "countryCode": "RS",
    "region": "097",
    "description": "Svil\u0430\u0458n\u0430c"
  },
  {
    "countryCode": "RS",
    "region": "098",
    "description": "Svrljig"
  },
  {
    "countryCode": "RS",
    "region": "099",
    "description": "Grad S\u0430b\u0430c"
  },
  {
    "countryCode": "RS",
    "region": "10",
    "description": "Obsolete"
  },
  {
    "countryCode": "RS",
    "region": "100",
    "description": "Grad Uzic\u0435"
  },
  {
    "countryCode": "RS",
    "region": "101",
    "description": "T\u043ep\u043el\u0430"
  },
  {
    "countryCode": "RS",
    "region": "102",
    "description": "Trg\u043evist\u0435"
  },
  {
    "countryCode": "RS",
    "region": "103",
    "description": "Trst\u0435nik"
  },
  {
    "countryCode": "RS",
    "region": "104",
    "description": "Tutin"
  },
  {
    "countryCode": "RS",
    "region": "105",
    "description": "Ub"
  },
  {
    "countryCode": "RS",
    "region": "107",
    "description": "V\u0430lj\u0435v\u043e"
  },
  {
    "countryCode": "RS",
    "region": "108",
    "description": "V\u0430rv\u0430rin"
  },
  {
    "countryCode": "RS",
    "region": "109",
    "description": "V\u0435lik\u0430 Pl\u0430n\u0430"
  },
  {
    "countryCode": "RS",
    "region": "11",
    "description": "Obsolete"
  },
  {
    "countryCode": "RS",
    "region": "110",
    "description": "V\u0435lik\u043e Gr\u0430dist\u0435"
  },
  {
    "countryCode": "RS",
    "region": "111",
    "description": "Vl\u0430dicin H\u0430n"
  },
  {
    "countryCode": "RS",
    "region": "112",
    "description": "Vl\u0430dimirci"
  },
  {
    "countryCode": "RS",
    "region": "113",
    "description": "Vl\u0430s\u043etinc\u0435"
  },
  {
    "countryCode": "RS",
    "region": "114",
    "description": "Grad Vr\u0430nj\u0435"
  },
  {
    "countryCode": "RS",
    "region": "115",
    "description": "Vrnj\u0430ck\u0430 B\u0430nj\u0430"
  },
  {
    "countryCode": "RS",
    "region": "116",
    "description": "Grad Z\u0430\u0458\u0435c\u0430r"
  },
  {
    "countryCode": "RS",
    "region": "117",
    "description": "Z\u0430b\u0430ri"
  },
  {
    "countryCode": "RS",
    "region": "118",
    "description": "Z\u0430gubic\u0430"
  },
  {
    "countryCode": "RS",
    "region": "119",
    "description": "Zit\u043er\u0430dj\u0430"
  },
  {
    "countryCode": "RS",
    "region": "12",
    "description": "Obsolete"
  },
  {
    "countryCode": "RS",
    "region": "120",
    "description": "R\u0430k\u043evic\u0430"
  },
  {
    "countryCode": "RS",
    "region": "121",
    "description": "Lapovo"
  },
  {
    "countryCode": "RS",
    "region": "122",
    "description": "Nisk\u0430 B\u0430nj\u0430"
  },
  {
    "countryCode": "RS",
    "region": "123",
    "description": "Str\u0430g\u0430ri"
  },
  {
    "countryCode": "RS",
    "region": "124",
    "description": "Surcin"
  },
  {
    "countryCode": "RS",
    "region": "125",
    "description": "Pantelej"
  },
  {
    "countryCode": "RS",
    "region": "126",
    "description": "Nis Crveni krst"
  },
  {
    "countryCode": "RS",
    "region": "127",
    "description": "Nis Palilula"
  },
  {
    "countryCode": "RS",
    "region": "128",
    "description": "Medijana"
  },
  {
    "countryCode": "RS",
    "region": "129",
    "description": "Kostolac"
  },
  {
    "countryCode": "RS",
    "region": "13",
    "description": "Obsolete"
  },
  {
    "countryCode": "RS",
    "region": "14",
    "description": "Obsolete"
  },
  {
    "countryCode": "RS",
    "region": "15",
    "description": "Obsolete"
  },
  {
    "countryCode": "RS",
    "region": "16",
    "description": "Obsolete"
  },
  {
    "countryCode": "RS",
    "region": "17",
    "description": "Obsolete"
  },
  {
    "countryCode": "RS",
    "region": "18",
    "description": "Obsolete"
  },
  {
    "countryCode": "RS",
    "region": "19",
    "description": "Obsolete"
  },
  {
    "countryCode": "RS",
    "region": "20",
    "description": "Obsolete"
  },
  {
    "countryCode": "RS",
    "region": "201",
    "description": "\u0410d\u0430"
  },
  {
    "countryCode": "RS",
    "region": "202",
    "description": "\u0410libun\u0430r"
  },
  {
    "countryCode": "RS",
    "region": "203",
    "description": "\u0410p\u0430tin"
  },
  {
    "countryCode": "RS",
    "region": "204",
    "description": "B\u0430c"
  },
  {
    "countryCode": "RS",
    "region": "205",
    "description": "B\u0430ck\u0430 P\u0430l\u0430nk\u0430"
  },
  {
    "countryCode": "RS",
    "region": "206",
    "description": "B\u0430ck\u0430 T\u043ep\u043el\u0430"
  },
  {
    "countryCode": "RS",
    "region": "207",
    "description": "B\u0430cki P\u0435tr\u043ev\u0430c"
  },
  {
    "countryCode": "RS",
    "region": "208",
    "description": "B\u0435c\u0435\u0458"
  },
  {
    "countryCode": "RS",
    "region": "209",
    "description": "B\u0435l\u0430 Crkv\u0430"
  },
  {
    "countryCode": "RS",
    "region": "21",
    "description": "Obsolete"
  },
  {
    "countryCode": "RS",
    "region": "210",
    "description": "B\u0435\u043ecin"
  },
  {
    "countryCode": "RS",
    "region": "211",
    "description": "C\u043ek\u0430"
  },
  {
    "countryCode": "RS",
    "region": "212",
    "description": "Indji\u0458\u0430"
  },
  {
    "countryCode": "RS",
    "region": "213",
    "description": "Irig"
  },
  {
    "countryCode": "RS",
    "region": "214",
    "description": "K\u0430njiz\u0430"
  },
  {
    "countryCode": "RS",
    "region": "215",
    "description": "Kikind\u0430"
  },
  {
    "countryCode": "RS",
    "region": "216",
    "description": "K\u043ev\u0430cic\u0430"
  },
  {
    "countryCode": "RS",
    "region": "217",
    "description": "K\u043evin"
  },
  {
    "countryCode": "RS",
    "region": "218",
    "description": "Kul\u0430"
  },
  {
    "countryCode": "RS",
    "region": "219",
    "description": "M\u0430li Idjos"
  },
  {
    "countryCode": "RS",
    "region": "22",
    "description": "Obsolete"
  },
  {
    "countryCode": "RS",
    "region": "220",
    "description": "N\u043ev\u0430 Crnj\u0430"
  },
  {
    "countryCode": "RS",
    "region": "221",
    "description": "N\u043evi B\u0435c\u0435\u0458"
  },
  {
    "countryCode": "RS",
    "region": "222",
    "description": "N\u043evi kn\u0435z\u0435v\u0430c"
  },
  {
    "countryCode": "RS",
    "region": "223",
    "description": "Novi Sad"
  },
  {
    "countryCode": "RS",
    "region": "224",
    "description": "Odzaci"
  },
  {
    "countryCode": "RS",
    "region": "225",
    "description": "Opovo"
  },
  {
    "countryCode": "RS",
    "region": "226",
    "description": "Grad Pancevo"
  },
  {
    "countryCode": "RS",
    "region": "227",
    "description": "Pecinci"
  },
  {
    "countryCode": "RS",
    "region": "228",
    "description": "Plandiste"
  },
  {
    "countryCode": "RS",
    "region": "229",
    "description": "Ruma"
  },
  {
    "countryCode": "RS",
    "region": "23",
    "description": "Obsolete"
  },
  {
    "countryCode": "RS",
    "region": "230",
    "description": "Secanj"
  },
  {
    "countryCode": "RS",
    "region": "231",
    "description": "Senta"
  },
  {
    "countryCode": "RS",
    "region": "232",
    "description": "Grad Sombor"
  },
  {
    "countryCode": "RS",
    "region": "233",
    "description": "Srbobran"
  },
  {
    "countryCode": "RS",
    "region": "234",
    "description": "Grad Sremska Mitrovi"
  },
  {
    "countryCode": "RS",
    "region": "235",
    "description": "Stara Pazova"
  },
  {
    "countryCode": "RS",
    "region": "236",
    "description": "Grad Subotica"
  },
  {
    "countryCode": "RS",
    "region": "237",
    "description": "Sid"
  },
  {
    "countryCode": "RS",
    "region": "238",
    "description": "Temerin"
  },
  {
    "countryCode": "RS",
    "region": "239",
    "description": "Tit\u0435l"
  },
  {
    "countryCode": "RS",
    "region": "24",
    "description": "Obsolete"
  },
  {
    "countryCode": "RS",
    "region": "240",
    "description": "Vrb\u0430s"
  },
  {
    "countryCode": "RS",
    "region": "241",
    "description": "Vrs\u0430c"
  },
  {
    "countryCode": "RS",
    "region": "242",
    "description": "Grad Zrenjanin"
  },
  {
    "countryCode": "RS",
    "region": "243",
    "description": "Z\u0430b\u0430lj"
  },
  {
    "countryCode": "RS",
    "region": "244",
    "description": "Zitist\u0435"
  },
  {
    "countryCode": "RS",
    "region": "247",
    "description": "P\u0435tr\u043ev\u0430r\u0430din"
  },
  {
    "countryCode": "RS",
    "region": "25",
    "description": "Obsolete"
  },
  {
    "countryCode": "RS",
    "region": "250",
    "description": "Sr\u0435mski k\u0430rl\u043evci"
  },
  {
    "countryCode": "RS",
    "region": "26",
    "description": "Obsolete"
  },
  {
    "countryCode": "RS",
    "region": "27",
    "description": "Obsolete"
  },
  {
    "countryCode": "RS",
    "region": "28",
    "description": "Obsolete"
  },
  {
    "countryCode": "RS",
    "region": "29",
    "description": "Obsolete"
  },
  {
    "countryCode": "RS",
    "region": "301",
    "description": "D\u0435c\u0430ni"
  },
  {
    "countryCode": "RS",
    "region": "303",
    "description": "Dj\u0430k\u043evic\u0430"
  },
  {
    "countryCode": "RS",
    "region": "304",
    "description": "Gl\u043eg\u043ev\u0430c"
  },
  {
    "countryCode": "RS",
    "region": "305",
    "description": "Gnjil\u0430n\u0435"
  },
  {
    "countryCode": "RS",
    "region": "306",
    "description": "Ist\u043ek"
  },
  {
    "countryCode": "RS",
    "region": "307",
    "description": "K\u0430c\u0430nik"
  },
  {
    "countryCode": "RS",
    "region": "308",
    "description": "Klin\u0430"
  },
  {
    "countryCode": "RS",
    "region": "309",
    "description": "K\u043es\u043evsk\u0430 K\u0430m\u0435nic\u0430"
  },
  {
    "countryCode": "RS",
    "region": "310",
    "description": "K\u043es\u043evsk\u0430 Mitr\u043evic\u0430"
  },
  {
    "countryCode": "RS",
    "region": "311",
    "description": "L\u0435p\u043es\u0430vic"
  },
  {
    "countryCode": "RS",
    "region": "312",
    "description": "Liplj\u0430n"
  },
  {
    "countryCode": "RS",
    "region": "313",
    "description": "\u041er\u0430h\u043ev\u0430c"
  },
  {
    "countryCode": "RS",
    "region": "314",
    "description": "P\u0435c"
  },
  {
    "countryCode": "RS",
    "region": "315",
    "description": "P\u043edu\u0458\u0435v\u043e"
  },
  {
    "countryCode": "RS",
    "region": "316",
    "description": "Pristin\u0430"
  },
  {
    "countryCode": "RS",
    "region": "317",
    "description": "Prizr\u0435n"
  },
  {
    "countryCode": "RS",
    "region": "318",
    "description": "Srbic\u0430"
  },
  {
    "countryCode": "RS",
    "region": "319",
    "description": "Suv\u0430 R\u0435k\u0430"
  },
  {
    "countryCode": "RS",
    "region": "320",
    "description": "Ur\u043es\u0435v\u0430c"
  },
  {
    "countryCode": "RS",
    "region": "321",
    "description": "Gnjilane"
  },
  {
    "countryCode": "RS",
    "region": "322",
    "description": "Vucitrn"
  },
  {
    "countryCode": "RS",
    "region": "324",
    "description": "Zubin P\u043et\u043ek"
  },
  {
    "countryCode": "RS",
    "region": "325",
    "description": "Stimlj\u0435"
  },
  {
    "countryCode": "RS",
    "region": "326",
    "description": "Strpc\u0435"
  },
  {
    "countryCode": "RS",
    "region": "327",
    "description": "\u041ebilic"
  },
  {
    "countryCode": "RS",
    "region": "328",
    "description": "K\u043es\u043ev\u043e P\u043elj\u0435"
  },
  {
    "countryCode": "RS",
    "region": "329",
    "description": "N\u043ev\u043e Brd\u043e"
  },
  {
    "countryCode": "RS",
    "region": "330",
    "description": "Zv\u0435c\u0430n"
  },
  {
    "countryCode": "RS",
    "region": "331",
    "description": "Gora(sediste Dragas)"
  },
  {
    "countryCode": "RS",
    "region": "501",
    "description": "Gr\u0430d B\u0435\u043egr\u0430d"
  },
  {
    "countryCode": "RS",
    "region": "511",
    "description": "Gr\u0430d N\u043evi S\u0430d"
  },
  {
    "countryCode": "RS",
    "region": "521",
    "description": "Gr\u0430d Nis"
  },
  {
    "countryCode": "RS",
    "region": "531",
    "description": "Gr\u0430d Kr\u0430gu\u0458\u0435v\u0430c"
  },
  {
    "countryCode": "RS",
    "region": "541",
    "description": "Gr\u0430d Pristin\u0430"
  },
  {
    "countryCode": "RS",
    "region": "581",
    "description": "\u0410p V\u043e\u0458v\u043edin\u0430"
  },
  {
    "countryCode": "RS",
    "region": "591",
    "description": "\u0410p k\u043es\u043ev\u043e i M\u0435t\u043ehi\u0458\u0430"
  },
  {
    "countryCode": "RS",
    "region": "601",
    "description": "R\u0435publik\u0430 Srbi\u0458\u0430"
  },
  {
    "countryCode": "RU",
    "region": "01",
    "description": "Adigeja Republic"
  },
  {
    "countryCode": "RU",
    "region": "02",
    "description": "Republ.of Bashkortos"
  },
  {
    "countryCode": "RU",
    "region": "03",
    "description": "Buryat Republic"
  },
  {
    "countryCode": "RU",
    "region": "04",
    "description": "Highlands-Altay Rep."
  },
  {
    "countryCode": "RU",
    "region": "05",
    "description": "Dagestan Republic"
  },
  {
    "countryCode": "RU",
    "region": "06",
    "description": "Ingushetija Republic"
  },
  {
    "countryCode": "RU",
    "region": "07",
    "description": "Kabardino-Balkar.Rep"
  },
  {
    "countryCode": "RU",
    "region": "08",
    "description": "Kalmyk Republic"
  },
  {
    "countryCode": "RU",
    "region": "09",
    "description": "Karach.-Cherkessk Re"
  },
  {
    "countryCode": "RU",
    "region": "10",
    "description": "Karelian Republic"
  },
  {
    "countryCode": "RU",
    "region": "11",
    "description": "Komi Republic"
  },
  {
    "countryCode": "RU",
    "region": "12",
    "description": "Marijskaya Republic"
  },
  {
    "countryCode": "RU",
    "region": "13",
    "description": "Mordovian Republic"
  },
  {
    "countryCode": "RU",
    "region": "14",
    "description": "Yakutiya-Saha Rrepub"
  },
  {
    "countryCode": "RU",
    "region": "15",
    "description": "North-Osetiya Republ"
  },
  {
    "countryCode": "RU",
    "region": "16",
    "description": "Tatarstan Republic"
  },
  {
    "countryCode": "RU",
    "region": "17",
    "description": "Tuva Republic"
  },
  {
    "countryCode": "RU",
    "region": "18",
    "description": "The Udmurt Republic"
  },
  {
    "countryCode": "RU",
    "region": "19",
    "description": "Chakassky Republic"
  },
  {
    "countryCode": "RU",
    "region": "20",
    "description": "Chechenskaya Republ."
  },
  {
    "countryCode": "RU",
    "region": "21",
    "description": "Chuvash Republic"
  },
  {
    "countryCode": "RU",
    "region": "22",
    "description": "Altay Territory"
  },
  {
    "countryCode": "RU",
    "region": "23",
    "description": "Krasnodar Territory"
  },
  {
    "countryCode": "RU",
    "region": "24",
    "description": "Krasnoyarsk Territor"
  },
  {
    "countryCode": "RU",
    "region": "25",
    "description": "Primorye Territory"
  },
  {
    "countryCode": "RU",
    "region": "26",
    "description": "Stavropol Territory"
  },
  {
    "countryCode": "RU",
    "region": "27",
    "description": "Khabarovsk Territory"
  },
  {
    "countryCode": "RU",
    "region": "28",
    "description": "The Amur Area"
  },
  {
    "countryCode": "RU",
    "region": "29",
    "description": "The Arkhangelsk Area"
  },
  {
    "countryCode": "RU",
    "region": "30",
    "description": "The Astrakhan Area"
  },
  {
    "countryCode": "RU",
    "region": "31",
    "description": "The Belgorod Area"
  },
  {
    "countryCode": "RU",
    "region": "32",
    "description": "The Bryansk Area"
  },
  {
    "countryCode": "RU",
    "region": "33",
    "description": "The Vladimir Area"
  },
  {
    "countryCode": "RU",
    "region": "34",
    "description": "The Volgograd Area"
  },
  {
    "countryCode": "RU",
    "region": "35",
    "description": "The Vologda Area"
  },
  {
    "countryCode": "RU",
    "region": "36",
    "description": "The Voronezh Area"
  },
  {
    "countryCode": "RU",
    "region": "37",
    "description": "The Ivanovo Area"
  },
  {
    "countryCode": "RU",
    "region": "38",
    "description": "The Irkutsk Area"
  },
  {
    "countryCode": "RU",
    "region": "39",
    "description": "The Kaliningrad Area"
  },
  {
    "countryCode": "RU",
    "region": "40",
    "description": "The Kaluga Area"
  },
  {
    "countryCode": "RU",
    "region": "41",
    "description": "Kamchatka Territory"
  },
  {
    "countryCode": "RU",
    "region": "42",
    "description": "The Kemerovo Area"
  },
  {
    "countryCode": "RU",
    "region": "43",
    "description": "The Kirov Area"
  },
  {
    "countryCode": "RU",
    "region": "44",
    "description": "The Kostroma Area"
  },
  {
    "countryCode": "RU",
    "region": "45",
    "description": "The Kurgan Area"
  },
  {
    "countryCode": "RU",
    "region": "46",
    "description": "The Kursk Area"
  },
  {
    "countryCode": "RU",
    "region": "47",
    "description": "The Leningrad Area"
  },
  {
    "countryCode": "RU",
    "region": "48",
    "description": "The Lipetsk Area"
  },
  {
    "countryCode": "RU",
    "region": "49",
    "description": "The Magadan Area"
  },
  {
    "countryCode": "RU",
    "region": "50",
    "description": "The Moscow Area"
  },
  {
    "countryCode": "RU",
    "region": "51",
    "description": "The Murmansk Area"
  },
  {
    "countryCode": "RU",
    "region": "52",
    "description": "The Nizhniy Novgorod"
  },
  {
    "countryCode": "RU",
    "region": "53",
    "description": "The Novgorod Area"
  },
  {
    "countryCode": "RU",
    "region": "54",
    "description": "The Novosibirsk Area"
  },
  {
    "countryCode": "RU",
    "region": "55",
    "description": "The Omsk Area"
  },
  {
    "countryCode": "RU",
    "region": "56",
    "description": "The Orenburg Area"
  },
  {
    "countryCode": "RU",
    "region": "57",
    "description": "The Oryol Area"
  },
  {
    "countryCode": "RU",
    "region": "58",
    "description": "The Penza Area"
  },
  {
    "countryCode": "RU",
    "region": "59",
    "description": "Perm Territory"
  },
  {
    "countryCode": "RU",
    "region": "60",
    "description": "The Pskov Area"
  },
  {
    "countryCode": "RU",
    "region": "61",
    "description": "The Rostov Area"
  },
  {
    "countryCode": "RU",
    "region": "62",
    "description": "The Ryazan Area"
  },
  {
    "countryCode": "RU",
    "region": "63",
    "description": "The Samara Area"
  },
  {
    "countryCode": "RU",
    "region": "64",
    "description": "The Saratov Area"
  },
  {
    "countryCode": "RU",
    "region": "65",
    "description": "The Sakhalin Area"
  },
  {
    "countryCode": "RU",
    "region": "66",
    "description": "The Sverdlovsk Area"
  },
  {
    "countryCode": "RU",
    "region": "67",
    "description": "The Smolensk Area"
  },
  {
    "countryCode": "RU",
    "region": "68",
    "description": "The Tambov Area"
  },
  {
    "countryCode": "RU",
    "region": "69",
    "description": "The Tver Area"
  },
  {
    "countryCode": "RU",
    "region": "70",
    "description": "The Tomsk Area"
  },
  {
    "countryCode": "RU",
    "region": "71",
    "description": "The Tula Area"
  },
  {
    "countryCode": "RU",
    "region": "72",
    "description": "The Tyumen Area"
  },
  {
    "countryCode": "RU",
    "region": "73",
    "description": "The Ulyanovsk Area"
  },
  {
    "countryCode": "RU",
    "region": "74",
    "description": "The Chelyabinsk Area"
  },
  {
    "countryCode": "RU",
    "region": "75",
    "description": "Zabaykalsk Territory"
  },
  {
    "countryCode": "RU",
    "region": "76",
    "description": "The Yaroslavl Area"
  },
  {
    "countryCode": "RU",
    "region": "77",
    "description": "c.Moscow"
  },
  {
    "countryCode": "RU",
    "region": "78",
    "description": "c.St-Peterburg"
  },
  {
    "countryCode": "RU",
    "region": "79",
    "description": "The Jewish Auton.are"
  },
  {
    "countryCode": "RU",
    "region": "80",
    "description": "Aginsk Buryat Aut.di"
  },
  {
    "countryCode": "RU",
    "region": "81",
    "description": "Komy Permjats.Aut.di"
  },
  {
    "countryCode": "RU",
    "region": "82",
    "description": "Korjacs Auton.distri"
  },
  {
    "countryCode": "RU",
    "region": "83",
    "description": "Nenekchky Auton.dist"
  },
  {
    "countryCode": "RU",
    "region": "84",
    "description": "The Taymir Auton.dis"
  },
  {
    "countryCode": "RU",
    "region": "85",
    "description": "Ust-Ordinsky Buryat"
  },
  {
    "countryCode": "RU",
    "region": "86",
    "description": "Chanti-Mansyjsky Aut"
  },
  {
    "countryCode": "RU",
    "region": "87",
    "description": "Chukotka Auton. dist"
  },
  {
    "countryCode": "RU",
    "region": "88",
    "description": "Evensky Auton.distri"
  },
  {
    "countryCode": "RU",
    "region": "89",
    "description": "Jamalo-Nenekchky Aut"
  },
  {
    "countryCode": "RW",
    "region": "01",
    "description": "City of Kigali"
  },
  {
    "countryCode": "RW",
    "region": "02",
    "description": "Eastern"
  },
  {
    "countryCode": "RW",
    "region": "03",
    "description": "Northern"
  },
  {
    "countryCode": "RW",
    "region": "04",
    "description": "Western"
  },
  {
    "countryCode": "RW",
    "region": "05",
    "description": "Southern"
  },
  {
    "countryCode": "SA",
    "region": "01",
    "description": "Riyadh"
  },
  {
    "countryCode": "SA",
    "region": "02",
    "description": "Makkah"
  },
  {
    "countryCode": "SA",
    "region": "03",
    "description": "Madinah"
  },
  {
    "countryCode": "SA",
    "region": "04",
    "description": "Eastern Province"
  },
  {
    "countryCode": "SA",
    "region": "05",
    "description": "Qassim"
  },
  {
    "countryCode": "SA",
    "region": "06",
    "description": "Ha'il"
  },
  {
    "countryCode": "SA",
    "region": "07",
    "description": "Tabuk"
  },
  {
    "countryCode": "SA",
    "region": "08",
    "description": "Northern Borders"
  },
  {
    "countryCode": "SA",
    "region": "09",
    "description": "Jizan"
  },
  {
    "countryCode": "SA",
    "region": "10",
    "description": "Najran"
  },
  {
    "countryCode": "SA",
    "region": "11",
    "description": "Bahah"
  },
  {
    "countryCode": "SA",
    "region": "12",
    "description": "Jawf"
  },
  {
    "countryCode": "SA",
    "region": "14",
    "description": "'Asir"
  },
  {
    "countryCode": "SD",
    "region": "DC",
    "description": "Central Darfur"
  },
  {
    "countryCode": "SD",
    "region": "DE",
    "description": "East Darfur"
  },
  {
    "countryCode": "SD",
    "region": "DN",
    "description": "North Darfur"
  },
  {
    "countryCode": "SD",
    "region": "DS",
    "description": "South Darfur"
  },
  {
    "countryCode": "SD",
    "region": "DW",
    "description": "West Darfur"
  },
  {
    "countryCode": "SD",
    "region": "GD",
    "description": "Gedaref"
  },
  {
    "countryCode": "SD",
    "region": "GK",
    "description": "West Kordofan"
  },
  {
    "countryCode": "SD",
    "region": "GZ",
    "description": "Gezira"
  },
  {
    "countryCode": "SD",
    "region": "KA",
    "description": "Kassala"
  },
  {
    "countryCode": "SD",
    "region": "KH",
    "description": "Khartoum"
  },
  {
    "countryCode": "SD",
    "region": "KN",
    "description": "North Kordofan"
  },
  {
    "countryCode": "SD",
    "region": "KS",
    "description": "South Kordofan"
  },
  {
    "countryCode": "SD",
    "region": "NB",
    "description": "Blue Nile"
  },
  {
    "countryCode": "SD",
    "region": "NO",
    "description": "Northern"
  },
  {
    "countryCode": "SD",
    "region": "NR",
    "description": "River Nile"
  },
  {
    "countryCode": "SD",
    "region": "NW",
    "description": "White Nile"
  },
  {
    "countryCode": "SD",
    "region": "RS",
    "description": "Red Sea"
  },
  {
    "countryCode": "SD",
    "region": "SI",
    "description": "Sennar"
  },
  {
    "countryCode": "SE",
    "region": "AB",
    "description": "Stockholm County"
  },
  {
    "countryCode": "SE",
    "region": "AC",
    "description": "Vaesterbotten County"
  },
  {
    "countryCode": "SE",
    "region": "BD",
    "description": "Norrbotten County"
  },
  {
    "countryCode": "SE",
    "region": "C",
    "description": "Uppsala County"
  },
  {
    "countryCode": "SE",
    "region": "D",
    "description": "Soedermanland County"
  },
  {
    "countryCode": "SE",
    "region": "E",
    "description": "Oestergoetland Cnty"
  },
  {
    "countryCode": "SE",
    "region": "F",
    "description": "Joenkoeping County"
  },
  {
    "countryCode": "SE",
    "region": "G",
    "description": "Kronoberg County"
  },
  {
    "countryCode": "SE",
    "region": "H",
    "description": "Kalmar County"
  },
  {
    "countryCode": "SE",
    "region": "I",
    "description": "Gotland County"
  },
  {
    "countryCode": "SE",
    "region": "K",
    "description": "Blekinge County"
  },
  {
    "countryCode": "SE",
    "region": "M",
    "description": "Skaane County"
  },
  {
    "countryCode": "SE",
    "region": "N",
    "description": "Halland County"
  },
  {
    "countryCode": "SE",
    "region": "O",
    "description": "Vaestra Goetaland C."
  },
  {
    "countryCode": "SE",
    "region": "S",
    "description": "Vaermland County"
  },
  {
    "countryCode": "SE",
    "region": "T",
    "description": "Oerebro County"
  },
  {
    "countryCode": "SE",
    "region": "U",
    "description": "Vaestmanland County"
  },
  {
    "countryCode": "SE",
    "region": "W",
    "description": "Dalarnas County"
  },
  {
    "countryCode": "SE",
    "region": "X",
    "description": "Gaevleborg County"
  },
  {
    "countryCode": "SE",
    "region": "Y",
    "description": "Vaesternorrland Cnty"
  },
  {
    "countryCode": "SE",
    "region": "Z",
    "description": "Jaemtland County"
  },
  {
    "countryCode": "SG",
    "region": "SG",
    "description": "Singapore"
  },
  {
    "countryCode": "SH",
    "region": "AC",
    "description": "Ascension"
  },
  {
    "countryCode": "SH",
    "region": "HL",
    "description": "St. Helena"
  },
  {
    "countryCode": "SH",
    "region": "TA",
    "description": "Tristan da Cunha"
  },
  {
    "countryCode": "SI",
    "region": "001",
    "description": "Ajdovscina"
  },
  {
    "countryCode": "SI",
    "region": "002",
    "description": "Beltinci"
  },
  {
    "countryCode": "SI",
    "region": "003",
    "description": "Bled"
  },
  {
    "countryCode": "SI",
    "region": "004",
    "description": "Bohinj"
  },
  {
    "countryCode": "SI",
    "region": "005",
    "description": "Borovnica"
  },
  {
    "countryCode": "SI",
    "region": "006",
    "description": "Bovec"
  },
  {
    "countryCode": "SI",
    "region": "007",
    "description": "Brda"
  },
  {
    "countryCode": "SI",
    "region": "008",
    "description": "Brezovica"
  },
  {
    "countryCode": "SI",
    "region": "009",
    "description": "Brezice"
  },
  {
    "countryCode": "SI",
    "region": "010",
    "description": "Tisina"
  },
  {
    "countryCode": "SI",
    "region": "011",
    "description": "Celje"
  },
  {
    "countryCode": "SI",
    "region": "012",
    "description": "Cerklje na Gorenjske"
  },
  {
    "countryCode": "SI",
    "region": "013",
    "description": "Cerknica"
  },
  {
    "countryCode": "SI",
    "region": "014",
    "description": "Cerkno"
  },
  {
    "countryCode": "SI",
    "region": "015",
    "description": "Crensovci"
  },
  {
    "countryCode": "SI",
    "region": "016",
    "description": "Crna na Koroskem"
  },
  {
    "countryCode": "SI",
    "region": "017",
    "description": "Crnomelj"
  },
  {
    "countryCode": "SI",
    "region": "018",
    "description": "Destrnik"
  },
  {
    "countryCode": "SI",
    "region": "019",
    "description": "Divaca"
  },
  {
    "countryCode": "SI",
    "region": "020",
    "description": "Dobrepolje"
  },
  {
    "countryCode": "SI",
    "region": "021",
    "description": "Dobrova-Polhov Grade"
  },
  {
    "countryCode": "SI",
    "region": "022",
    "description": "Dol pri Ljubljani"
  },
  {
    "countryCode": "SI",
    "region": "023",
    "description": "Domzale"
  },
  {
    "countryCode": "SI",
    "region": "024",
    "description": "Dornava"
  },
  {
    "countryCode": "SI",
    "region": "025",
    "description": "Dravograd"
  },
  {
    "countryCode": "SI",
    "region": "026",
    "description": "Duplek"
  },
  {
    "countryCode": "SI",
    "region": "027",
    "description": "Gorenja vas-Poljane"
  },
  {
    "countryCode": "SI",
    "region": "028",
    "description": "Gorisnica"
  },
  {
    "countryCode": "SI",
    "region": "029",
    "description": "Gornja Radgona"
  },
  {
    "countryCode": "SI",
    "region": "030",
    "description": "Gornji Grad"
  },
  {
    "countryCode": "SI",
    "region": "031",
    "description": "Gornji Petrovci"
  },
  {
    "countryCode": "SI",
    "region": "032",
    "description": "Grosuplje"
  },
  {
    "countryCode": "SI",
    "region": "033",
    "description": "Salovci"
  },
  {
    "countryCode": "SI",
    "region": "034",
    "description": "Hrastnik"
  },
  {
    "countryCode": "SI",
    "region": "035",
    "description": "Hrpelje-Kozina"
  },
  {
    "countryCode": "SI",
    "region": "036",
    "description": "Idrija"
  },
  {
    "countryCode": "SI",
    "region": "037",
    "description": "Ig"
  },
  {
    "countryCode": "SI",
    "region": "038",
    "description": "Ilirska Bistrica"
  },
  {
    "countryCode": "SI",
    "region": "039",
    "description": "Ivancna Gorica"
  },
  {
    "countryCode": "SI",
    "region": "040",
    "description": "Izola - Isola"
  },
  {
    "countryCode": "SI",
    "region": "041",
    "description": "Jesenice"
  },
  {
    "countryCode": "SI",
    "region": "042",
    "description": "Jursinci"
  },
  {
    "countryCode": "SI",
    "region": "043",
    "description": "Kamnik"
  },
  {
    "countryCode": "SI",
    "region": "044",
    "description": "Kanal ob So\u010di"
  },
  {
    "countryCode": "SI",
    "region": "045",
    "description": "Kidricevo"
  },
  {
    "countryCode": "SI",
    "region": "046",
    "description": "Kobarid"
  },
  {
    "countryCode": "SI",
    "region": "047",
    "description": "Kobilje"
  },
  {
    "countryCode": "SI",
    "region": "048",
    "description": "Kocevje"
  },
  {
    "countryCode": "SI",
    "region": "049",
    "description": "Komen"
  },
  {
    "countryCode": "SI",
    "region": "050",
    "description": "Koper - Capodistria"
  },
  {
    "countryCode": "SI",
    "region": "051",
    "description": "Kozje"
  },
  {
    "countryCode": "SI",
    "region": "052",
    "description": "Kranj"
  },
  {
    "countryCode": "SI",
    "region": "053",
    "description": "Kranjska Gora"
  },
  {
    "countryCode": "SI",
    "region": "054",
    "description": "Krsko"
  },
  {
    "countryCode": "SI",
    "region": "055",
    "description": "Kungota"
  },
  {
    "countryCode": "SI",
    "region": "056",
    "description": "Kuzma"
  },
  {
    "countryCode": "SI",
    "region": "057",
    "description": "Lasko"
  },
  {
    "countryCode": "SI",
    "region": "058",
    "description": "Lenart"
  },
  {
    "countryCode": "SI",
    "region": "059",
    "description": "Lendava - Lendva"
  },
  {
    "countryCode": "SI",
    "region": "060",
    "description": "Litija"
  },
  {
    "countryCode": "SI",
    "region": "061",
    "description": "Ljubljana"
  },
  {
    "countryCode": "SI",
    "region": "062",
    "description": "Ljubno"
  },
  {
    "countryCode": "SI",
    "region": "063",
    "description": "Ljutomer"
  },
  {
    "countryCode": "SI",
    "region": "064",
    "description": "Logatec"
  },
  {
    "countryCode": "SI",
    "region": "065",
    "description": "Loska dolina"
  },
  {
    "countryCode": "SI",
    "region": "066",
    "description": "Loski Potok"
  },
  {
    "countryCode": "SI",
    "region": "067",
    "description": "Luce"
  },
  {
    "countryCode": "SI",
    "region": "068",
    "description": "Lukovica"
  },
  {
    "countryCode": "SI",
    "region": "069",
    "description": "Majsperk"
  },
  {
    "countryCode": "SI",
    "region": "070",
    "description": "Maribor"
  },
  {
    "countryCode": "SI",
    "region": "071",
    "description": "Medvode"
  },
  {
    "countryCode": "SI",
    "region": "072",
    "description": "Menges"
  },
  {
    "countryCode": "SI",
    "region": "073",
    "description": "Metlika"
  },
  {
    "countryCode": "SI",
    "region": "074",
    "description": "Mezica"
  },
  {
    "countryCode": "SI",
    "region": "075",
    "description": "Miren-Kostanjevica"
  },
  {
    "countryCode": "SI",
    "region": "076",
    "description": "Mislinja"
  },
  {
    "countryCode": "SI",
    "region": "077",
    "description": "Moravce"
  },
  {
    "countryCode": "SI",
    "region": "078",
    "description": "Moravske Toplice"
  },
  {
    "countryCode": "SI",
    "region": "079",
    "description": "Mozirje"
  },
  {
    "countryCode": "SI",
    "region": "080",
    "description": "Murska Sobota"
  },
  {
    "countryCode": "SI",
    "region": "081",
    "description": "Muta"
  },
  {
    "countryCode": "SI",
    "region": "082",
    "description": "Naklo"
  },
  {
    "countryCode": "SI",
    "region": "083",
    "description": "Nazarje"
  },
  {
    "countryCode": "SI",
    "region": "084",
    "description": "Nova Gorica"
  },
  {
    "countryCode": "SI",
    "region": "085",
    "description": "Novo mesto"
  },
  {
    "countryCode": "SI",
    "region": "086",
    "description": "Odranci"
  },
  {
    "countryCode": "SI",
    "region": "087",
    "description": "Ormoz"
  },
  {
    "countryCode": "SI",
    "region": "088",
    "description": "Osilnica"
  },
  {
    "countryCode": "SI",
    "region": "089",
    "description": "Pesnica"
  },
  {
    "countryCode": "SI",
    "region": "090",
    "description": "Piran - Pirano"
  },
  {
    "countryCode": "SI",
    "region": "091",
    "description": "Pivka"
  },
  {
    "countryCode": "SI",
    "region": "092",
    "description": "Podcetrtek"
  },
  {
    "countryCode": "SI",
    "region": "093",
    "description": "Podvelka"
  },
  {
    "countryCode": "SI",
    "region": "094",
    "description": "Postojna"
  },
  {
    "countryCode": "SI",
    "region": "095",
    "description": "Preddvor"
  },
  {
    "countryCode": "SI",
    "region": "096",
    "description": "Ptuj"
  },
  {
    "countryCode": "SI",
    "region": "097",
    "description": "Puconci"
  },
  {
    "countryCode": "SI",
    "region": "098",
    "description": "Race-Fram"
  },
  {
    "countryCode": "SI",
    "region": "099",
    "description": "Radece"
  },
  {
    "countryCode": "SI",
    "region": "100",
    "description": "Radenci"
  },
  {
    "countryCode": "SI",
    "region": "101",
    "description": "Radlje ob Dravi"
  },
  {
    "countryCode": "SI",
    "region": "102",
    "description": "Radovljica"
  },
  {
    "countryCode": "SI",
    "region": "103",
    "description": "Ravne na Koroskem"
  },
  {
    "countryCode": "SI",
    "region": "104",
    "description": "Ribnica"
  },
  {
    "countryCode": "SI",
    "region": "105",
    "description": "Rogasovci"
  },
  {
    "countryCode": "SI",
    "region": "106",
    "description": "Rogaska Slatina"
  },
  {
    "countryCode": "SI",
    "region": "107",
    "description": "Rogatec"
  },
  {
    "countryCode": "SI",
    "region": "108",
    "description": "Ruse"
  },
  {
    "countryCode": "SI",
    "region": "109",
    "description": "Semic"
  },
  {
    "countryCode": "SI",
    "region": "110",
    "description": "Sevnica"
  },
  {
    "countryCode": "SI",
    "region": "111",
    "description": "Sezana"
  },
  {
    "countryCode": "SI",
    "region": "112",
    "description": "Slovenj Gradec"
  },
  {
    "countryCode": "SI",
    "region": "113",
    "description": "Slovenska Bistrica"
  },
  {
    "countryCode": "SI",
    "region": "114",
    "description": "Slovenske Konjice"
  },
  {
    "countryCode": "SI",
    "region": "115",
    "description": "Starse"
  },
  {
    "countryCode": "SI",
    "region": "116",
    "description": "Sveti Jurij"
  },
  {
    "countryCode": "SI",
    "region": "117",
    "description": "Sencur"
  },
  {
    "countryCode": "SI",
    "region": "118",
    "description": "Sentilj"
  },
  {
    "countryCode": "SI",
    "region": "119",
    "description": "Sentjernej"
  },
  {
    "countryCode": "SI",
    "region": "120",
    "description": "Sentjur pri Celju"
  },
  {
    "countryCode": "SI",
    "region": "121",
    "description": "Skocjan"
  },
  {
    "countryCode": "SI",
    "region": "122",
    "description": "Skofja Loka"
  },
  {
    "countryCode": "SI",
    "region": "123",
    "description": "Skofljica"
  },
  {
    "countryCode": "SI",
    "region": "124",
    "description": "Smarje pri Jelsah"
  },
  {
    "countryCode": "SI",
    "region": "125",
    "description": "Smartno ob Paki"
  },
  {
    "countryCode": "SI",
    "region": "126",
    "description": "Sostanj"
  },
  {
    "countryCode": "SI",
    "region": "127",
    "description": "Store"
  },
  {
    "countryCode": "SI",
    "region": "128",
    "description": "Tolmin"
  },
  {
    "countryCode": "SI",
    "region": "129",
    "description": "Trbovlje"
  },
  {
    "countryCode": "SI",
    "region": "130",
    "description": "Trebnje"
  },
  {
    "countryCode": "SI",
    "region": "131",
    "description": "Trzic"
  },
  {
    "countryCode": "SI",
    "region": "132",
    "description": "Turnisce"
  },
  {
    "countryCode": "SI",
    "region": "133",
    "description": "Velenje"
  },
  {
    "countryCode": "SI",
    "region": "134",
    "description": "Velike Lasce"
  },
  {
    "countryCode": "SI",
    "region": "135",
    "description": "Videm"
  },
  {
    "countryCode": "SI",
    "region": "136",
    "description": "Vipava"
  },
  {
    "countryCode": "SI",
    "region": "137",
    "description": "Vitanje"
  },
  {
    "countryCode": "SI",
    "region": "138",
    "description": "Vodice"
  },
  {
    "countryCode": "SI",
    "region": "139",
    "description": "Vojnik"
  },
  {
    "countryCode": "SI",
    "region": "140",
    "description": "Vrhnika"
  },
  {
    "countryCode": "SI",
    "region": "141",
    "description": "Vuzenica"
  },
  {
    "countryCode": "SI",
    "region": "142",
    "description": "Zagorje ob Savi"
  },
  {
    "countryCode": "SI",
    "region": "143",
    "description": "Zavrc"
  },
  {
    "countryCode": "SI",
    "region": "144",
    "description": "Zrece"
  },
  {
    "countryCode": "SI",
    "region": "146",
    "description": "Zelezniki"
  },
  {
    "countryCode": "SI",
    "region": "147",
    "description": "Ziri"
  },
  {
    "countryCode": "SI",
    "region": "148",
    "description": "Benedikt"
  },
  {
    "countryCode": "SI",
    "region": "149",
    "description": "Bistrica ob Sotli"
  },
  {
    "countryCode": "SI",
    "region": "150",
    "description": "Bloke"
  },
  {
    "countryCode": "SI",
    "region": "151",
    "description": "Braslovce"
  },
  {
    "countryCode": "SI",
    "region": "152",
    "description": "Cankova"
  },
  {
    "countryCode": "SI",
    "region": "153",
    "description": "Cerkvenjak"
  },
  {
    "countryCode": "SI",
    "region": "154",
    "description": "Dobje"
  },
  {
    "countryCode": "SI",
    "region": "155",
    "description": "Dobrna"
  },
  {
    "countryCode": "SI",
    "region": "156",
    "description": "Dobrovnik - Dobronak"
  },
  {
    "countryCode": "SI",
    "region": "157",
    "description": "Dolenjske Toplice"
  },
  {
    "countryCode": "SI",
    "region": "158",
    "description": "Grad"
  },
  {
    "countryCode": "SI",
    "region": "159",
    "description": "Hajdina"
  },
  {
    "countryCode": "SI",
    "region": "160",
    "description": "Hoce-Slivnica"
  },
  {
    "countryCode": "SI",
    "region": "161",
    "description": "Hodos - Hodos"
  },
  {
    "countryCode": "SI",
    "region": "162",
    "description": "Horjul"
  },
  {
    "countryCode": "SI",
    "region": "163",
    "description": "Jezersko"
  },
  {
    "countryCode": "SI",
    "region": "164",
    "description": "Komenda"
  },
  {
    "countryCode": "SI",
    "region": "165",
    "description": "Kostel"
  },
  {
    "countryCode": "SI",
    "region": "166",
    "description": "Krizevci"
  },
  {
    "countryCode": "SI",
    "region": "167",
    "description": "Lovrenc na Pohorju"
  },
  {
    "countryCode": "SI",
    "region": "168",
    "description": "Markovci"
  },
  {
    "countryCode": "SI",
    "region": "169",
    "description": "Miklavz na Dravskem"
  },
  {
    "countryCode": "SI",
    "region": "170",
    "description": "Mirna Pec"
  },
  {
    "countryCode": "SI",
    "region": "171",
    "description": "Oplotnica"
  },
  {
    "countryCode": "SI",
    "region": "172",
    "description": "Podlehnik"
  },
  {
    "countryCode": "SI",
    "region": "173",
    "description": "Polzela"
  },
  {
    "countryCode": "SI",
    "region": "174",
    "description": "Prebold"
  },
  {
    "countryCode": "SI",
    "region": "175",
    "description": "Prevalje"
  },
  {
    "countryCode": "SI",
    "region": "176",
    "description": "Razkrizje"
  },
  {
    "countryCode": "SI",
    "region": "177",
    "description": "Ribnica na Pohorju"
  },
  {
    "countryCode": "SI",
    "region": "178",
    "description": "Selnica ob Dravi"
  },
  {
    "countryCode": "SI",
    "region": "179",
    "description": "Sodrazica"
  },
  {
    "countryCode": "SI",
    "region": "180",
    "description": "Solcava"
  },
  {
    "countryCode": "SI",
    "region": "181",
    "description": "Sveta Ana"
  },
  {
    "countryCode": "SI",
    "region": "182",
    "description": "Sveti Andraz v Slov."
  },
  {
    "countryCode": "SI",
    "region": "183",
    "description": "Sempeter - Vrtojba"
  },
  {
    "countryCode": "SI",
    "region": "184",
    "description": "Tabor"
  },
  {
    "countryCode": "SI",
    "region": "185",
    "description": "Trnovska Vas"
  },
  {
    "countryCode": "SI",
    "region": "186",
    "description": "Trzin"
  },
  {
    "countryCode": "SI",
    "region": "187",
    "description": "Velika Polana"
  },
  {
    "countryCode": "SI",
    "region": "188",
    "description": "Verzej"
  },
  {
    "countryCode": "SI",
    "region": "189",
    "description": "Vransko"
  },
  {
    "countryCode": "SI",
    "region": "190",
    "description": "Zalec"
  },
  {
    "countryCode": "SI",
    "region": "191",
    "description": "Zetale"
  },
  {
    "countryCode": "SI",
    "region": "192",
    "description": "Zirovnica"
  },
  {
    "countryCode": "SI",
    "region": "193",
    "description": "Zuzemberk"
  },
  {
    "countryCode": "SI",
    "region": "194",
    "description": "Smartno pri Litiji"
  },
  {
    "countryCode": "SI",
    "region": "195",
    "description": "Apace"
  },
  {
    "countryCode": "SI",
    "region": "196",
    "description": "Cirkulane"
  },
  {
    "countryCode": "SI",
    "region": "197",
    "description": "Kostanjevica na Krki"
  },
  {
    "countryCode": "SI",
    "region": "198",
    "description": "Makole"
  },
  {
    "countryCode": "SI",
    "region": "199",
    "description": "Mokronog\u2013Trebelno"
  },
  {
    "countryCode": "SI",
    "region": "200",
    "description": "Poljcane"
  },
  {
    "countryCode": "SI",
    "region": "201",
    "description": "Rence-Vogrsko"
  },
  {
    "countryCode": "SI",
    "region": "202",
    "description": "Sredisce ob Dravi"
  },
  {
    "countryCode": "SI",
    "region": "203",
    "description": "Straza"
  },
  {
    "countryCode": "SI",
    "region": "204",
    "description": "Sveta Tr. v Slov. G."
  },
  {
    "countryCode": "SI",
    "region": "205",
    "description": "Sveti Tomaz"
  },
  {
    "countryCode": "SI",
    "region": "206",
    "description": "SmarjeSke Toplice"
  },
  {
    "countryCode": "SI",
    "region": "207",
    "description": "Gorje"
  },
  {
    "countryCode": "SI",
    "region": "208",
    "description": "Log-Dragomer"
  },
  {
    "countryCode": "SI",
    "region": "209",
    "description": "Recica ob Savinji"
  },
  {
    "countryCode": "SI",
    "region": "210",
    "description": "Sveti Ju. v Slov. G."
  },
  {
    "countryCode": "SI",
    "region": "211",
    "description": "Sentrupert"
  },
  {
    "countryCode": "SI",
    "region": "212",
    "description": "Mina"
  },
  {
    "countryCode": "SI",
    "region": "213",
    "description": "Ancarano"
  },
  {
    "countryCode": "SK",
    "region": "101",
    "description": "Bratislava I"
  },
  {
    "countryCode": "SK",
    "region": "102",
    "description": "Bratislava II"
  },
  {
    "countryCode": "SK",
    "region": "103",
    "description": "Bratislava III"
  },
  {
    "countryCode": "SK",
    "region": "104",
    "description": "Bratislava IV"
  },
  {
    "countryCode": "SK",
    "region": "105",
    "description": "Bratislava V"
  },
  {
    "countryCode": "SK",
    "region": "106",
    "description": "Malacky"
  },
  {
    "countryCode": "SK",
    "region": "107",
    "description": "Pezinok"
  },
  {
    "countryCode": "SK",
    "region": "108",
    "description": "Senec"
  },
  {
    "countryCode": "SK",
    "region": "201",
    "description": "Dunajska Streda"
  },
  {
    "countryCode": "SK",
    "region": "202",
    "description": "Galanta"
  },
  {
    "countryCode": "SK",
    "region": "203",
    "description": "Hlohovec"
  },
  {
    "countryCode": "SK",
    "region": "204",
    "description": "Piestany"
  },
  {
    "countryCode": "SK",
    "region": "205",
    "description": "Senica"
  },
  {
    "countryCode": "SK",
    "region": "206",
    "description": "Skalica"
  },
  {
    "countryCode": "SK",
    "region": "207",
    "description": "Trnava"
  },
  {
    "countryCode": "SK",
    "region": "301",
    "description": "Banovce nad Bebravou"
  },
  {
    "countryCode": "SK",
    "region": "302",
    "description": "Ilava"
  },
  {
    "countryCode": "SK",
    "region": "303",
    "description": "Myjava"
  },
  {
    "countryCode": "SK",
    "region": "304",
    "description": "Nove Mesto nad Vahom"
  },
  {
    "countryCode": "SK",
    "region": "305",
    "description": "Partizanske"
  },
  {
    "countryCode": "SK",
    "region": "306",
    "description": "Povazska Bystrica"
  },
  {
    "countryCode": "SK",
    "region": "307",
    "description": "Prievidza"
  },
  {
    "countryCode": "SK",
    "region": "308",
    "description": "Puchov"
  },
  {
    "countryCode": "SK",
    "region": "309",
    "description": "Trencin"
  },
  {
    "countryCode": "SK",
    "region": "401",
    "description": "Komarno"
  },
  {
    "countryCode": "SK",
    "region": "402",
    "description": "Levice"
  },
  {
    "countryCode": "SK",
    "region": "403",
    "description": "Nitra"
  },
  {
    "countryCode": "SK",
    "region": "404",
    "description": "Nove Zamky"
  },
  {
    "countryCode": "SK",
    "region": "405",
    "description": "Sa\u013ea"
  },
  {
    "countryCode": "SK",
    "region": "406",
    "description": "Topo\u013ecany"
  },
  {
    "countryCode": "SK",
    "region": "407",
    "description": "Zlate Moravce"
  },
  {
    "countryCode": "SK",
    "region": "501",
    "description": "Bytca"
  },
  {
    "countryCode": "SK",
    "region": "502",
    "description": "Cadca"
  },
  {
    "countryCode": "SK",
    "region": "503",
    "description": "Dolny Kubin"
  },
  {
    "countryCode": "SK",
    "region": "504",
    "description": "Kysucke Nove Mesto"
  },
  {
    "countryCode": "SK",
    "region": "505",
    "description": "Liptovsky Mikulas"
  },
  {
    "countryCode": "SK",
    "region": "506",
    "description": "Martin"
  },
  {
    "countryCode": "SK",
    "region": "507",
    "description": "Namestovo"
  },
  {
    "countryCode": "SK",
    "region": "508",
    "description": "Ruzomberok"
  },
  {
    "countryCode": "SK",
    "region": "509",
    "description": "Turcianske Teplice"
  },
  {
    "countryCode": "SK",
    "region": "510",
    "description": "Tvrdosin"
  },
  {
    "countryCode": "SK",
    "region": "511",
    "description": "Zilina"
  },
  {
    "countryCode": "SK",
    "region": "601",
    "description": "Banska Bystrica"
  },
  {
    "countryCode": "SK",
    "region": "602",
    "description": "Banska Stiavnica"
  },
  {
    "countryCode": "SK",
    "region": "603",
    "description": "Brezno"
  },
  {
    "countryCode": "SK",
    "region": "604",
    "description": "Detva"
  },
  {
    "countryCode": "SK",
    "region": "605",
    "description": "Krupina"
  },
  {
    "countryCode": "SK",
    "region": "606",
    "description": "Lucenec"
  },
  {
    "countryCode": "SK",
    "region": "607",
    "description": "Poltar"
  },
  {
    "countryCode": "SK",
    "region": "608",
    "description": "Revuca"
  },
  {
    "countryCode": "SK",
    "region": "609",
    "description": "Rimavska Sobota"
  },
  {
    "countryCode": "SK",
    "region": "610",
    "description": "Ve\u013eky Krtis"
  },
  {
    "countryCode": "SK",
    "region": "611",
    "description": "Zvolen"
  },
  {
    "countryCode": "SK",
    "region": "612",
    "description": "Zarnovica"
  },
  {
    "countryCode": "SK",
    "region": "613",
    "description": "Ziar nad Hronom"
  },
  {
    "countryCode": "SK",
    "region": "701",
    "description": "Bardejov"
  },
  {
    "countryCode": "SK",
    "region": "702",
    "description": "Humenne"
  },
  {
    "countryCode": "SK",
    "region": "703",
    "description": "Kezmarok"
  },
  {
    "countryCode": "SK",
    "region": "704",
    "description": "Levoca"
  },
  {
    "countryCode": "SK",
    "region": "705",
    "description": "Medzilaborce"
  },
  {
    "countryCode": "SK",
    "region": "706",
    "description": "Poprad"
  },
  {
    "countryCode": "SK",
    "region": "707",
    "description": "Presov"
  },
  {
    "countryCode": "SK",
    "region": "708",
    "description": "Sabinov"
  },
  {
    "countryCode": "SK",
    "region": "709",
    "description": "Snina"
  },
  {
    "countryCode": "SK",
    "region": "710",
    "description": "Stara \u013dubov\u0148a"
  },
  {
    "countryCode": "SK",
    "region": "711",
    "description": "Stropkov"
  },
  {
    "countryCode": "SK",
    "region": "712",
    "description": "Svidnik"
  },
  {
    "countryCode": "SK",
    "region": "713",
    "description": "Vranov nad Top\u013eou"
  },
  {
    "countryCode": "SK",
    "region": "801",
    "description": "Gelnica"
  },
  {
    "countryCode": "SK",
    "region": "802",
    "description": "Kosice I"
  },
  {
    "countryCode": "SK",
    "region": "803",
    "description": "Kosice II"
  },
  {
    "countryCode": "SK",
    "region": "804",
    "description": "Kosice III"
  },
  {
    "countryCode": "SK",
    "region": "805",
    "description": "Kosice IV"
  },
  {
    "countryCode": "SK",
    "region": "806",
    "description": "Kosice-okolie"
  },
  {
    "countryCode": "SK",
    "region": "807",
    "description": "Michalovce"
  },
  {
    "countryCode": "SK",
    "region": "808",
    "description": "Roz\u0148ava"
  },
  {
    "countryCode": "SK",
    "region": "809",
    "description": "Sobrance"
  },
  {
    "countryCode": "SK",
    "region": "810",
    "description": "Spisska Nova Ves"
  },
  {
    "countryCode": "SK",
    "region": "811",
    "description": "Trebisov"
  },
  {
    "countryCode": "SL",
    "region": "E",
    "description": "Eastern"
  },
  {
    "countryCode": "SL",
    "region": "N",
    "description": "Northern"
  },
  {
    "countryCode": "SL",
    "region": "NW",
    "description": "North Western"
  },
  {
    "countryCode": "SL",
    "region": "S",
    "description": "Southern"
  },
  {
    "countryCode": "SL",
    "region": "W",
    "description": "Western Area"
  },
  {
    "countryCode": "SM",
    "region": "01",
    "description": "Acquaviva"
  },
  {
    "countryCode": "SM",
    "region": "02",
    "description": "Chiesanuova"
  },
  {
    "countryCode": "SM",
    "region": "03",
    "description": "Domagnano"
  },
  {
    "countryCode": "SM",
    "region": "04",
    "description": "Faetano"
  },
  {
    "countryCode": "SM",
    "region": "05",
    "description": "Fiorentino"
  },
  {
    "countryCode": "SM",
    "region": "06",
    "description": "Borgo Maggiore"
  },
  {
    "countryCode": "SM",
    "region": "07",
    "description": "San Marino City"
  },
  {
    "countryCode": "SM",
    "region": "08",
    "description": "Montegiardino"
  },
  {
    "countryCode": "SM",
    "region": "09",
    "description": "Serravalle"
  },
  {
    "countryCode": "SN",
    "region": "DB",
    "description": "Diourbel"
  },
  {
    "countryCode": "SN",
    "region": "DK",
    "description": "Dakar"
  },
  {
    "countryCode": "SN",
    "region": "FK",
    "description": "Fatick"
  },
  {
    "countryCode": "SN",
    "region": "KA",
    "description": "Kaffrine"
  },
  {
    "countryCode": "SN",
    "region": "KD",
    "description": "Kolda"
  },
  {
    "countryCode": "SN",
    "region": "KE",
    "description": "K\u00e9dougou"
  },
  {
    "countryCode": "SN",
    "region": "KL",
    "description": "Kaolack"
  },
  {
    "countryCode": "SN",
    "region": "LG",
    "description": "Louga"
  },
  {
    "countryCode": "SN",
    "region": "MT",
    "description": "Matam"
  },
  {
    "countryCode": "SN",
    "region": "SE",
    "description": "S\u00e9dhiou"
  },
  {
    "countryCode": "SN",
    "region": "SL",
    "description": "Saint-Louis"
  },
  {
    "countryCode": "SN",
    "region": "TC",
    "description": "Tambacounda"
  },
  {
    "countryCode": "SN",
    "region": "TH",
    "description": "Thi\u00e8s"
  },
  {
    "countryCode": "SN",
    "region": "ZG",
    "description": "Ziguinchor"
  },
  {
    "countryCode": "SO",
    "region": "AW",
    "description": "Awdal"
  },
  {
    "countryCode": "SO",
    "region": "BK",
    "description": "Bakool"
  },
  {
    "countryCode": "SO",
    "region": "BN",
    "description": "Banaadir"
  },
  {
    "countryCode": "SO",
    "region": "BR",
    "description": "Bari"
  },
  {
    "countryCode": "SO",
    "region": "BY",
    "description": "Bay"
  },
  {
    "countryCode": "SO",
    "region": "GA",
    "description": "Galguduud"
  },
  {
    "countryCode": "SO",
    "region": "GE",
    "description": "Gedo"
  },
  {
    "countryCode": "SO",
    "region": "HI",
    "description": "Hiiraan"
  },
  {
    "countryCode": "SO",
    "region": "JD",
    "description": "Middle Juba"
  },
  {
    "countryCode": "SO",
    "region": "JH",
    "description": "Lower Juba"
  },
  {
    "countryCode": "SO",
    "region": "MU",
    "description": "Mudug"
  },
  {
    "countryCode": "SO",
    "region": "NU",
    "description": "Nugaal"
  },
  {
    "countryCode": "SO",
    "region": "SA",
    "description": "Sanaag"
  },
  {
    "countryCode": "SO",
    "region": "SD",
    "description": "Middle Shebelle"
  },
  {
    "countryCode": "SO",
    "region": "SH",
    "description": "Lower Shebelle"
  },
  {
    "countryCode": "SO",
    "region": "SO",
    "description": "Sool"
  },
  {
    "countryCode": "SO",
    "region": "TO",
    "description": "Togdheer"
  },
  {
    "countryCode": "SO",
    "region": "WO",
    "description": "Woqooyi Galbeed"
  },
  {
    "countryCode": "SR",
    "region": "BR",
    "description": "Brokopondo"
  },
  {
    "countryCode": "SR",
    "region": "CM",
    "description": "Commewijne"
  },
  {
    "countryCode": "SR",
    "region": "CR",
    "description": "Coronie"
  },
  {
    "countryCode": "SR",
    "region": "MA",
    "description": "Marowijne"
  },
  {
    "countryCode": "SR",
    "region": "NI",
    "description": "Nickerie"
  },
  {
    "countryCode": "SR",
    "region": "PM",
    "description": "Paramaribo"
  },
  {
    "countryCode": "SR",
    "region": "PR",
    "description": "Para"
  },
  {
    "countryCode": "SR",
    "region": "SA",
    "description": "Saramacca"
  },
  {
    "countryCode": "SR",
    "region": "SI",
    "description": "Sipaliwini"
  },
  {
    "countryCode": "SR",
    "region": "WA",
    "description": "Wanica"
  },
  {
    "countryCode": "SS",
    "region": "BN",
    "description": "Northern Bahr Ghazal"
  },
  {
    "countryCode": "SS",
    "region": "BW",
    "description": "Western Bahr Ghazal"
  },
  {
    "countryCode": "SS",
    "region": "EC",
    "description": "Central Equatoria"
  },
  {
    "countryCode": "SS",
    "region": "EE",
    "description": "Eastern Equatoria"
  },
  {
    "countryCode": "SS",
    "region": "EW",
    "description": "Western Equatoria"
  },
  {
    "countryCode": "SS",
    "region": "JG",
    "description": "Jonglei"
  },
  {
    "countryCode": "SS",
    "region": "LK",
    "description": "Lakes"
  },
  {
    "countryCode": "SS",
    "region": "NU",
    "description": "Upper Nile"
  },
  {
    "countryCode": "SS",
    "region": "UY",
    "description": "Unity"
  },
  {
    "countryCode": "SS",
    "region": "WR",
    "description": "Warrap"
  },
  {
    "countryCode": "ST",
    "region": "01",
    "description": "\u00c1gua Grande"
  },
  {
    "countryCode": "ST",
    "region": "02",
    "description": "Cantagalo"
  },
  {
    "countryCode": "ST",
    "region": "03",
    "description": "Cau\u00e9"
  },
  {
    "countryCode": "ST",
    "region": "04",
    "description": "Lemb\u00e1"
  },
  {
    "countryCode": "ST",
    "region": "05",
    "description": "Lobata"
  },
  {
    "countryCode": "ST",
    "region": "06",
    "description": "M\u00e9-Z\u00f3chi"
  },
  {
    "countryCode": "ST",
    "region": "P",
    "description": "Pr\u00edncipe"
  },
  {
    "countryCode": "ST",
    "region": "S",
    "description": "Obsolete"
  },
  {
    "countryCode": "SV",
    "region": "AH",
    "description": "Ahuachap\u00e1n"
  },
  {
    "countryCode": "SV",
    "region": "CA",
    "description": "Caba\u00f1as"
  },
  {
    "countryCode": "SV",
    "region": "CH",
    "description": "Chalatenango"
  },
  {
    "countryCode": "SV",
    "region": "CU",
    "description": "Cuscatl\u00e1n"
  },
  {
    "countryCode": "SV",
    "region": "LI",
    "description": "La Libertad"
  },
  {
    "countryCode": "SV",
    "region": "MO",
    "description": "Moraz\u00e1n"
  },
  {
    "countryCode": "SV",
    "region": "PA",
    "description": "La Paz"
  },
  {
    "countryCode": "SV",
    "region": "SA",
    "description": "Santa Ana"
  },
  {
    "countryCode": "SV",
    "region": "SM",
    "description": "San Miguel"
  },
  {
    "countryCode": "SV",
    "region": "SO",
    "description": "Sonsonate"
  },
  {
    "countryCode": "SV",
    "region": "SS",
    "description": "San Salvador"
  },
  {
    "countryCode": "SV",
    "region": "SV",
    "description": "San Vicente"
  },
  {
    "countryCode": "SV",
    "region": "UN",
    "description": "La Uni\u00f3n"
  },
  {
    "countryCode": "SV",
    "region": "US",
    "description": "Usulut\u00e1n"
  },
  {
    "countryCode": "SY",
    "region": "DI",
    "description": "Damascus"
  },
  {
    "countryCode": "SY",
    "region": "DR",
    "description": "Dar'a"
  },
  {
    "countryCode": "SY",
    "region": "DY",
    "description": "Dair az-Zaur"
  },
  {
    "countryCode": "SY",
    "region": "HA",
    "description": "Al-Hasaka"
  },
  {
    "countryCode": "SY",
    "region": "HI",
    "description": "Homs"
  },
  {
    "countryCode": "SY",
    "region": "HL",
    "description": "Aleppo"
  },
  {
    "countryCode": "SY",
    "region": "HM",
    "description": "Hama"
  },
  {
    "countryCode": "SY",
    "region": "ID",
    "description": "Idlib"
  },
  {
    "countryCode": "SY",
    "region": "LA",
    "description": "Latakia"
  },
  {
    "countryCode": "SY",
    "region": "QU",
    "description": "Al-Qunaitira"
  },
  {
    "countryCode": "SY",
    "region": "RA",
    "description": "Ar-Raqqah"
  },
  {
    "countryCode": "SY",
    "region": "RD",
    "description": "Rif Dimashq"
  },
  {
    "countryCode": "SY",
    "region": "SU",
    "description": "As-Suwaida"
  },
  {
    "countryCode": "SY",
    "region": "TA",
    "description": "Tartus"
  },
  {
    "countryCode": "SZ",
    "region": "HH",
    "description": "Hhohho"
  },
  {
    "countryCode": "SZ",
    "region": "LU",
    "description": "Lubombo"
  },
  {
    "countryCode": "SZ",
    "region": "MA",
    "description": "Manzini"
  },
  {
    "countryCode": "SZ",
    "region": "SH",
    "description": "Shiselweni"
  },
  {
    "countryCode": "TD",
    "region": "BA",
    "description": "Batha"
  },
  {
    "countryCode": "TD",
    "region": "BG",
    "description": "Bahr el Ghazal"
  },
  {
    "countryCode": "TD",
    "region": "BO",
    "description": "Borkou"
  },
  {
    "countryCode": "TD",
    "region": "CB",
    "description": "Chari-Baguirmi"
  },
  {
    "countryCode": "TD",
    "region": "EE",
    "description": "Ennedi-Est"
  },
  {
    "countryCode": "TD",
    "region": "EO",
    "description": "Ennedi-Ouest"
  },
  {
    "countryCode": "TD",
    "region": "GR",
    "description": "Gu\u00e9ra"
  },
  {
    "countryCode": "TD",
    "region": "HL",
    "description": "Hadjer Lamis"
  },
  {
    "countryCode": "TD",
    "region": "KA",
    "description": "Kanem"
  },
  {
    "countryCode": "TD",
    "region": "LC",
    "description": "Lac"
  },
  {
    "countryCode": "TD",
    "region": "LO",
    "description": "Logone-Occidental"
  },
  {
    "countryCode": "TD",
    "region": "LR",
    "description": "Logone-Oriental"
  },
  {
    "countryCode": "TD",
    "region": "MA",
    "description": "Mandoul"
  },
  {
    "countryCode": "TD",
    "region": "MC",
    "description": "Moyen-Chari"
  },
  {
    "countryCode": "TD",
    "region": "ME",
    "description": "Mayo-Kebbi-Est"
  },
  {
    "countryCode": "TD",
    "region": "MO",
    "description": "Mayo-Kebbi-Ouest"
  },
  {
    "countryCode": "TD",
    "region": "ND",
    "description": "Ville de Ndjamena"
  },
  {
    "countryCode": "TD",
    "region": "OD",
    "description": "Ouadda\u00ef"
  },
  {
    "countryCode": "TD",
    "region": "SA",
    "description": "Salamat"
  },
  {
    "countryCode": "TD",
    "region": "SI",
    "description": "Sila"
  },
  {
    "countryCode": "TD",
    "region": "TA",
    "description": "Tandjil\u00e9"
  },
  {
    "countryCode": "TD",
    "region": "TI",
    "description": "Tibesti"
  },
  {
    "countryCode": "TD",
    "region": "WF",
    "description": "Wadi Fira"
  },
  {
    "countryCode": "TG",
    "region": "C",
    "description": "Centrale"
  },
  {
    "countryCode": "TG",
    "region": "K",
    "description": "Kara"
  },
  {
    "countryCode": "TG",
    "region": "M",
    "description": "Maritime (R\u00e9gion)"
  },
  {
    "countryCode": "TG",
    "region": "P",
    "description": "Plateaux"
  },
  {
    "countryCode": "TG",
    "region": "S",
    "description": "Savanes"
  },
  {
    "countryCode": "TH",
    "region": "10",
    "description": "KrungThep Mahanakorn"
  },
  {
    "countryCode": "TH",
    "region": "11",
    "description": "Samut Prakan"
  },
  {
    "countryCode": "TH",
    "region": "12",
    "description": "Nonthaburi"
  },
  {
    "countryCode": "TH",
    "region": "13",
    "description": "Pathum Thani"
  },
  {
    "countryCode": "TH",
    "region": "14",
    "description": "Phra Nakhon Si Ayut."
  },
  {
    "countryCode": "TH",
    "region": "15",
    "description": "Ang Thong"
  },
  {
    "countryCode": "TH",
    "region": "16",
    "description": "Lop Buri"
  },
  {
    "countryCode": "TH",
    "region": "17",
    "description": "Sing Buri"
  },
  {
    "countryCode": "TH",
    "region": "18",
    "description": "Chai Nat"
  },
  {
    "countryCode": "TH",
    "region": "19",
    "description": "Saraburi"
  },
  {
    "countryCode": "TH",
    "region": "20",
    "description": "Chon Buri"
  },
  {
    "countryCode": "TH",
    "region": "21",
    "description": "Rayong"
  },
  {
    "countryCode": "TH",
    "region": "22",
    "description": "Chanthaburi"
  },
  {
    "countryCode": "TH",
    "region": "23",
    "description": "Trat"
  },
  {
    "countryCode": "TH",
    "region": "24",
    "description": "Chachoengsao"
  },
  {
    "countryCode": "TH",
    "region": "25",
    "description": "Prachin Buri"
  },
  {
    "countryCode": "TH",
    "region": "26",
    "description": "Nakhon Nayok"
  },
  {
    "countryCode": "TH",
    "region": "27",
    "description": "Sa Kaeo"
  },
  {
    "countryCode": "TH",
    "region": "30",
    "description": "Nakhon Ratchasima"
  },
  {
    "countryCode": "TH",
    "region": "31",
    "description": "Buri Ram"
  },
  {
    "countryCode": "TH",
    "region": "32",
    "description": "Surin"
  },
  {
    "countryCode": "TH",
    "region": "33",
    "description": "Si Sa Ket"
  },
  {
    "countryCode": "TH",
    "region": "34",
    "description": "Ubon Ratchathani"
  },
  {
    "countryCode": "TH",
    "region": "35",
    "description": "Yasothon"
  },
  {
    "countryCode": "TH",
    "region": "36",
    "description": "Chaiyaphum"
  },
  {
    "countryCode": "TH",
    "region": "37",
    "description": "Amnat Charoen"
  },
  {
    "countryCode": "TH",
    "region": "38",
    "description": "Bueng Kan"
  },
  {
    "countryCode": "TH",
    "region": "39",
    "description": "Nong Bua Lam Phu"
  },
  {
    "countryCode": "TH",
    "region": "40",
    "description": "Khon Kaen"
  },
  {
    "countryCode": "TH",
    "region": "41",
    "description": "Udon Thani"
  },
  {
    "countryCode": "TH",
    "region": "42",
    "description": "Loei"
  },
  {
    "countryCode": "TH",
    "region": "43",
    "description": "Nong Khai"
  },
  {
    "countryCode": "TH",
    "region": "44",
    "description": "Maha Sarakham"
  },
  {
    "countryCode": "TH",
    "region": "45",
    "description": "Roi Et"
  },
  {
    "countryCode": "TH",
    "region": "46",
    "description": "Kalasin"
  },
  {
    "countryCode": "TH",
    "region": "47",
    "description": "Sakon Nakhon"
  },
  {
    "countryCode": "TH",
    "region": "48",
    "description": "Nakhon Phanom"
  },
  {
    "countryCode": "TH",
    "region": "49",
    "description": "Mukdahan"
  },
  {
    "countryCode": "TH",
    "region": "50",
    "description": "Chiang Mai"
  },
  {
    "countryCode": "TH",
    "region": "51",
    "description": "Lamphun"
  },
  {
    "countryCode": "TH",
    "region": "52",
    "description": "Lampang"
  },
  {
    "countryCode": "TH",
    "region": "53",
    "description": "Uttaradit"
  },
  {
    "countryCode": "TH",
    "region": "54",
    "description": "Phrae"
  },
  {
    "countryCode": "TH",
    "region": "55",
    "description": "Nan"
  },
  {
    "countryCode": "TH",
    "region": "56",
    "description": "Phayao"
  },
  {
    "countryCode": "TH",
    "region": "57",
    "description": "Chiang Rai"
  },
  {
    "countryCode": "TH",
    "region": "58",
    "description": "Mae Hong Son"
  },
  {
    "countryCode": "TH",
    "region": "60",
    "description": "Nakhon Sawan"
  },
  {
    "countryCode": "TH",
    "region": "61",
    "description": "Uthai Thani"
  },
  {
    "countryCode": "TH",
    "region": "62",
    "description": "Kamphaeng Phet"
  },
  {
    "countryCode": "TH",
    "region": "63",
    "description": "Tak"
  },
  {
    "countryCode": "TH",
    "region": "64",
    "description": "Sukhothai"
  },
  {
    "countryCode": "TH",
    "region": "65",
    "description": "Phitsanulok"
  },
  {
    "countryCode": "TH",
    "region": "66",
    "description": "Phichit"
  },
  {
    "countryCode": "TH",
    "region": "67",
    "description": "Phetchabun"
  },
  {
    "countryCode": "TH",
    "region": "70",
    "description": "Ratchaburi"
  },
  {
    "countryCode": "TH",
    "region": "71",
    "description": "Kanchanaburi"
  },
  {
    "countryCode": "TH",
    "region": "72",
    "description": "Suphan Buri"
  },
  {
    "countryCode": "TH",
    "region": "73",
    "description": "Nakhon Pathom"
  },
  {
    "countryCode": "TH",
    "region": "74",
    "description": "Samut Sakhon"
  },
  {
    "countryCode": "TH",
    "region": "75",
    "description": "Samut Songkhram"
  },
  {
    "countryCode": "TH",
    "region": "76",
    "description": "Phetchaburi"
  },
  {
    "countryCode": "TH",
    "region": "77",
    "description": "Prachuap Khiri Khan"
  },
  {
    "countryCode": "TH",
    "region": "80",
    "description": "Nakhon Si Thammarat"
  },
  {
    "countryCode": "TH",
    "region": "81",
    "description": "Krabi"
  },
  {
    "countryCode": "TH",
    "region": "82",
    "description": "Phangnga"
  },
  {
    "countryCode": "TH",
    "region": "83",
    "description": "Phuket"
  },
  {
    "countryCode": "TH",
    "region": "84",
    "description": "Surat Thani"
  },
  {
    "countryCode": "TH",
    "region": "85",
    "description": "Ranong"
  },
  {
    "countryCode": "TH",
    "region": "86",
    "description": "Chumphon"
  },
  {
    "countryCode": "TH",
    "region": "90",
    "description": "Songkhla"
  },
  {
    "countryCode": "TH",
    "region": "91",
    "description": "Satun"
  },
  {
    "countryCode": "TH",
    "region": "92",
    "description": "Trang"
  },
  {
    "countryCode": "TH",
    "region": "93",
    "description": "Phatthalung"
  },
  {
    "countryCode": "TH",
    "region": "94",
    "description": "Pattani"
  },
  {
    "countryCode": "TH",
    "region": "95",
    "description": "Yala"
  },
  {
    "countryCode": "TH",
    "region": "96",
    "description": "Narathiwat"
  },
  {
    "countryCode": "TH",
    "region": "S",
    "description": "Phatthaya"
  },
  {
    "countryCode": "TJ",
    "region": "DU",
    "description": "Dushanbe"
  },
  {
    "countryCode": "TJ",
    "region": "GB",
    "description": "K\u016dhistoni Badakhshon"
  },
  {
    "countryCode": "TJ",
    "region": "KT",
    "description": "Khatlon"
  },
  {
    "countryCode": "TJ",
    "region": "RA",
    "description": "Districts Rep. Adm."
  },
  {
    "countryCode": "TJ",
    "region": "SU",
    "description": "Sughd"
  },
  {
    "countryCode": "TL",
    "region": "AL",
    "description": "Aileu"
  },
  {
    "countryCode": "TL",
    "region": "AN",
    "description": "Ainaro"
  },
  {
    "countryCode": "TL",
    "region": "BA",
    "description": "Baucau"
  },
  {
    "countryCode": "TL",
    "region": "BO",
    "description": "Bobonaro"
  },
  {
    "countryCode": "TL",
    "region": "CO",
    "description": "Cova Lima"
  },
  {
    "countryCode": "TL",
    "region": "DI",
    "description": "Dili"
  },
  {
    "countryCode": "TL",
    "region": "ER",
    "description": "Ermera"
  },
  {
    "countryCode": "TL",
    "region": "LA",
    "description": "Lautein"
  },
  {
    "countryCode": "TL",
    "region": "LI",
    "description": "Liqui\u00e7\u00e1"
  },
  {
    "countryCode": "TL",
    "region": "MF",
    "description": "Manufahi"
  },
  {
    "countryCode": "TL",
    "region": "MT",
    "description": "Manatuto"
  },
  {
    "countryCode": "TL",
    "region": "OE",
    "description": "Oecusi-Ambeno"
  },
  {
    "countryCode": "TL",
    "region": "VI",
    "description": "Viqueque"
  },
  {
    "countryCode": "TM",
    "region": "A",
    "description": "Ahal"
  },
  {
    "countryCode": "TM",
    "region": "B",
    "description": "Balkan"
  },
  {
    "countryCode": "TM",
    "region": "D",
    "description": "Da\u015foguz"
  },
  {
    "countryCode": "TM",
    "region": "L",
    "description": "Lebap"
  },
  {
    "countryCode": "TM",
    "region": "M",
    "description": "Mary"
  },
  {
    "countryCode": "TM",
    "region": "S",
    "description": "Asgabat"
  },
  {
    "countryCode": "TN",
    "region": "11",
    "description": "Tunis"
  },
  {
    "countryCode": "TN",
    "region": "12",
    "description": "L'Ariana"
  },
  {
    "countryCode": "TN",
    "region": "13",
    "description": "Ben Arous"
  },
  {
    "countryCode": "TN",
    "region": "14",
    "description": "La Manouba"
  },
  {
    "countryCode": "TN",
    "region": "21",
    "description": "Nabeul"
  },
  {
    "countryCode": "TN",
    "region": "22",
    "description": "Zaghouan"
  },
  {
    "countryCode": "TN",
    "region": "23",
    "description": "Bizerte"
  },
  {
    "countryCode": "TN",
    "region": "31",
    "description": "B\u00e9ja"
  },
  {
    "countryCode": "TN",
    "region": "32",
    "description": "Jendouba"
  },
  {
    "countryCode": "TN",
    "region": "33",
    "description": "Le Kef"
  },
  {
    "countryCode": "TN",
    "region": "34",
    "description": "Siliana"
  },
  {
    "countryCode": "TN",
    "region": "41",
    "description": "Kairouan"
  },
  {
    "countryCode": "TN",
    "region": "42",
    "description": "Kasserine"
  },
  {
    "countryCode": "TN",
    "region": "43",
    "description": "Sidi Bouzid"
  },
  {
    "countryCode": "TN",
    "region": "51",
    "description": "Sousse"
  },
  {
    "countryCode": "TN",
    "region": "52",
    "description": "Monastir"
  },
  {
    "countryCode": "TN",
    "region": "53",
    "description": "Mahdia"
  },
  {
    "countryCode": "TN",
    "region": "61",
    "description": "Sfax"
  },
  {
    "countryCode": "TN",
    "region": "71",
    "description": "Gafsa"
  },
  {
    "countryCode": "TN",
    "region": "72",
    "description": "Tozeur"
  },
  {
    "countryCode": "TN",
    "region": "73",
    "description": "K\u00e9bili"
  },
  {
    "countryCode": "TN",
    "region": "81",
    "description": "Gab\u00e8s"
  },
  {
    "countryCode": "TN",
    "region": "82",
    "description": "M\u00e9denine"
  },
  {
    "countryCode": "TN",
    "region": "83",
    "description": "Tataouine"
  },
  {
    "countryCode": "TO",
    "region": "01",
    "description": "Eua Island"
  },
  {
    "countryCode": "TO",
    "region": "02",
    "description": "Ha\u02bbapai"
  },
  {
    "countryCode": "TO",
    "region": "03",
    "description": "Niuas"
  },
  {
    "countryCode": "TO",
    "region": "04",
    "description": "Tongatapu"
  },
  {
    "countryCode": "TO",
    "region": "05",
    "description": "Vava\u02bbu"
  },
  {
    "countryCode": "TR",
    "region": "01",
    "description": "Adana"
  },
  {
    "countryCode": "TR",
    "region": "02",
    "description": "Adiyaman"
  },
  {
    "countryCode": "TR",
    "region": "03",
    "description": "Afyon"
  },
  {
    "countryCode": "TR",
    "region": "04",
    "description": "Agri"
  },
  {
    "countryCode": "TR",
    "region": "05",
    "description": "Amasya"
  },
  {
    "countryCode": "TR",
    "region": "06",
    "description": "Ankara"
  },
  {
    "countryCode": "TR",
    "region": "07",
    "description": "Antalya"
  },
  {
    "countryCode": "TR",
    "region": "08",
    "description": "Artvin"
  },
  {
    "countryCode": "TR",
    "region": "09",
    "description": "Aydin"
  },
  {
    "countryCode": "TR",
    "region": "10",
    "description": "Balikesir"
  },
  {
    "countryCode": "TR",
    "region": "11",
    "description": "Bilecik"
  },
  {
    "countryCode": "TR",
    "region": "12",
    "description": "Bing\u00f6l"
  },
  {
    "countryCode": "TR",
    "region": "13",
    "description": "Bitlis"
  },
  {
    "countryCode": "TR",
    "region": "14",
    "description": "Bolu"
  },
  {
    "countryCode": "TR",
    "region": "15",
    "description": "Burdur"
  },
  {
    "countryCode": "TR",
    "region": "16",
    "description": "Bursa"
  },
  {
    "countryCode": "TR",
    "region": "17",
    "description": "Canakkale"
  },
  {
    "countryCode": "TR",
    "region": "18",
    "description": "Cankiri"
  },
  {
    "countryCode": "TR",
    "region": "19",
    "description": "Corum"
  },
  {
    "countryCode": "TR",
    "region": "20",
    "description": "Denizli"
  },
  {
    "countryCode": "TR",
    "region": "21",
    "description": "Diyarbakir"
  },
  {
    "countryCode": "TR",
    "region": "22",
    "description": "Edirne"
  },
  {
    "countryCode": "TR",
    "region": "23",
    "description": "Elazig"
  },
  {
    "countryCode": "TR",
    "region": "24",
    "description": "Erzincan"
  },
  {
    "countryCode": "TR",
    "region": "25",
    "description": "Erzurum"
  },
  {
    "countryCode": "TR",
    "region": "26",
    "description": "Eskisehir"
  },
  {
    "countryCode": "TR",
    "region": "27",
    "description": "Gaziantep"
  },
  {
    "countryCode": "TR",
    "region": "28",
    "description": "Giresun"
  },
  {
    "countryCode": "TR",
    "region": "29",
    "description": "Guemueshane"
  },
  {
    "countryCode": "TR",
    "region": "30",
    "description": "Hakkari"
  },
  {
    "countryCode": "TR",
    "region": "31",
    "description": "Hatay"
  },
  {
    "countryCode": "TR",
    "region": "32",
    "description": "Isparta"
  },
  {
    "countryCode": "TR",
    "region": "33",
    "description": "Icel"
  },
  {
    "countryCode": "TR",
    "region": "34",
    "description": "Istanbul"
  },
  {
    "countryCode": "TR",
    "region": "35",
    "description": "Izmir"
  },
  {
    "countryCode": "TR",
    "region": "36",
    "description": "Kars"
  },
  {
    "countryCode": "TR",
    "region": "37",
    "description": "Kastamonu"
  },
  {
    "countryCode": "TR",
    "region": "38",
    "description": "Kayseri"
  },
  {
    "countryCode": "TR",
    "region": "39",
    "description": "Kirklareli"
  },
  {
    "countryCode": "TR",
    "region": "40",
    "description": "Kirshehir"
  },
  {
    "countryCode": "TR",
    "region": "41",
    "description": "Kocaeli"
  },
  {
    "countryCode": "TR",
    "region": "42",
    "description": "Konya"
  },
  {
    "countryCode": "TR",
    "region": "43",
    "description": "Kuetahya"
  },
  {
    "countryCode": "TR",
    "region": "44",
    "description": "Malatya"
  },
  {
    "countryCode": "TR",
    "region": "45",
    "description": "Manisa"
  },
  {
    "countryCode": "TR",
    "region": "46",
    "description": "K.Marash"
  },
  {
    "countryCode": "TR",
    "region": "47",
    "description": "Mardin"
  },
  {
    "countryCode": "TR",
    "region": "48",
    "description": "Mugla"
  },
  {
    "countryCode": "TR",
    "region": "49",
    "description": "Mush"
  },
  {
    "countryCode": "TR",
    "region": "50",
    "description": "Nevshehir"
  },
  {
    "countryCode": "TR",
    "region": "51",
    "description": "Nigde"
  },
  {
    "countryCode": "TR",
    "region": "52",
    "description": "Ordu"
  },
  {
    "countryCode": "TR",
    "region": "53",
    "description": "Rize"
  },
  {
    "countryCode": "TR",
    "region": "54",
    "description": "Sakarya"
  },
  {
    "countryCode": "TR",
    "region": "55",
    "description": "Samsun"
  },
  {
    "countryCode": "TR",
    "region": "56",
    "description": "Siirt"
  },
  {
    "countryCode": "TR",
    "region": "57",
    "description": "Sinop"
  },
  {
    "countryCode": "TR",
    "region": "58",
    "description": "Sivas"
  },
  {
    "countryCode": "TR",
    "region": "59",
    "description": "Tekirdag"
  },
  {
    "countryCode": "TR",
    "region": "60",
    "description": "Tokat"
  },
  {
    "countryCode": "TR",
    "region": "61",
    "description": "Trabzon"
  },
  {
    "countryCode": "TR",
    "region": "62",
    "description": "Tunceli"
  },
  {
    "countryCode": "TR",
    "region": "63",
    "description": "Shanliurfa"
  },
  {
    "countryCode": "TR",
    "region": "64",
    "description": "Ushak"
  },
  {
    "countryCode": "TR",
    "region": "65",
    "description": "Van"
  },
  {
    "countryCode": "TR",
    "region": "66",
    "description": "Yozgat"
  },
  {
    "countryCode": "TR",
    "region": "67",
    "description": "Zonguldak"
  },
  {
    "countryCode": "TR",
    "region": "68",
    "description": "Aksaray"
  },
  {
    "countryCode": "TR",
    "region": "69",
    "description": "Bayburt"
  },
  {
    "countryCode": "TR",
    "region": "70",
    "description": "Karaman"
  },
  {
    "countryCode": "TR",
    "region": "71",
    "description": "Kirikkale"
  },
  {
    "countryCode": "TR",
    "region": "72",
    "description": "Batman"
  },
  {
    "countryCode": "TR",
    "region": "73",
    "description": "Shirnak"
  },
  {
    "countryCode": "TR",
    "region": "74",
    "description": "Bartin"
  },
  {
    "countryCode": "TR",
    "region": "75",
    "description": "Ardahan"
  },
  {
    "countryCode": "TR",
    "region": "76",
    "description": "Igdir"
  },
  {
    "countryCode": "TR",
    "region": "77",
    "description": "Yalova"
  },
  {
    "countryCode": "TR",
    "region": "78",
    "description": "Karab\u00fck"
  },
  {
    "countryCode": "TR",
    "region": "79",
    "description": "Kilis"
  },
  {
    "countryCode": "TR",
    "region": "80",
    "description": "Osmaniye"
  },
  {
    "countryCode": "TR",
    "region": "81",
    "description": "D\u00fczce"
  },
  {
    "countryCode": "TT",
    "region": "ARI",
    "description": "Arima"
  },
  {
    "countryCode": "TT",
    "region": "CHA",
    "description": "Chaguanas"
  },
  {
    "countryCode": "TT",
    "region": "CTT",
    "description": "Couva/Tabaquite/Tal."
  },
  {
    "countryCode": "TT",
    "region": "DMN",
    "description": "Diego Martin"
  },
  {
    "countryCode": "TT",
    "region": "MRC",
    "description": "Mayaro-Rio Claro"
  },
  {
    "countryCode": "TT",
    "region": "PED",
    "description": "Penal-Debe"
  },
  {
    "countryCode": "TT",
    "region": "POS",
    "description": "Port of Spain"
  },
  {
    "countryCode": "TT",
    "region": "PRT",
    "description": "Princes Town"
  },
  {
    "countryCode": "TT",
    "region": "PTF",
    "description": "Point Fortin"
  },
  {
    "countryCode": "TT",
    "region": "SFO",
    "description": "San Fernando"
  },
  {
    "countryCode": "TT",
    "region": "SGE",
    "description": "Sangre Grande"
  },
  {
    "countryCode": "TT",
    "region": "SIP",
    "description": "Siparia"
  },
  {
    "countryCode": "TT",
    "region": "SJL",
    "description": "San Juan-Laventille"
  },
  {
    "countryCode": "TT",
    "region": "TOB",
    "description": "Tobago"
  },
  {
    "countryCode": "TT",
    "region": "TUP",
    "description": "Tunapuna-Piarco"
  },
  {
    "countryCode": "TV",
    "region": "FUN",
    "description": "Funafuti"
  },
  {
    "countryCode": "TV",
    "region": "NIT",
    "description": "Niutao"
  },
  {
    "countryCode": "TV",
    "region": "NIU",
    "description": "Nui"
  },
  {
    "countryCode": "TV",
    "region": "NKF",
    "description": "Nukufetau"
  },
  {
    "countryCode": "TV",
    "region": "NKL",
    "description": "Nukulaelae"
  },
  {
    "countryCode": "TV",
    "region": "NMA",
    "description": "Nanumea"
  },
  {
    "countryCode": "TV",
    "region": "NMG",
    "description": "Nanumanga"
  },
  {
    "countryCode": "TV",
    "region": "VAI",
    "description": "Vaitupu"
  },
  {
    "countryCode": "TW",
    "region": "CHA",
    "description": "Changhua"
  },
  {
    "countryCode": "TW",
    "region": "CYI",
    "description": "Chiayi"
  },
  {
    "countryCode": "TW",
    "region": "CYQ",
    "description": "Chiayi"
  },
  {
    "countryCode": "TW",
    "region": "HSQ",
    "description": "Hsinchu"
  },
  {
    "countryCode": "TW",
    "region": "HSZ",
    "description": "Hsinchu"
  },
  {
    "countryCode": "TW",
    "region": "HUA",
    "description": "Hualien"
  },
  {
    "countryCode": "TW",
    "region": "ILA",
    "description": "Yilan"
  },
  {
    "countryCode": "TW",
    "region": "KEE",
    "description": "Keelung"
  },
  {
    "countryCode": "TW",
    "region": "KHH",
    "description": "Kaohsiung"
  },
  {
    "countryCode": "TW",
    "region": "KIN",
    "description": "Kinmen"
  },
  {
    "countryCode": "TW",
    "region": "LIE",
    "description": "Lienchiang"
  },
  {
    "countryCode": "TW",
    "region": "MIA",
    "description": "Miaoli"
  },
  {
    "countryCode": "TW",
    "region": "NAN",
    "description": "Nantou"
  },
  {
    "countryCode": "TW",
    "region": "NWT",
    "description": "New Taipei"
  },
  {
    "countryCode": "TW",
    "region": "PEN",
    "description": "Penghu"
  },
  {
    "countryCode": "TW",
    "region": "PIF",
    "description": "Pingtung"
  },
  {
    "countryCode": "TW",
    "region": "TAO",
    "description": "Taoyuan"
  },
  {
    "countryCode": "TW",
    "region": "TNN",
    "description": "Tainan"
  },
  {
    "countryCode": "TW",
    "region": "TPE",
    "description": "Taipei"
  },
  {
    "countryCode": "TW",
    "region": "TTT",
    "description": "Taitung"
  },
  {
    "countryCode": "TW",
    "region": "TXG",
    "description": "Taichung"
  },
  {
    "countryCode": "TW",
    "region": "YUN",
    "description": "Yunlin"
  },
  {
    "countryCode": "TZ",
    "region": "01",
    "description": "Arusha"
  },
  {
    "countryCode": "TZ",
    "region": "02",
    "description": "Daressalam"
  },
  {
    "countryCode": "TZ",
    "region": "03",
    "description": "Dodoma"
  },
  {
    "countryCode": "TZ",
    "region": "04",
    "description": "Iringa"
  },
  {
    "countryCode": "TZ",
    "region": "05",
    "description": "Kagera"
  },
  {
    "countryCode": "TZ",
    "region": "06",
    "description": "Pemba North"
  },
  {
    "countryCode": "TZ",
    "region": "07",
    "description": "Zanzibar North"
  },
  {
    "countryCode": "TZ",
    "region": "08",
    "description": "Kigoma"
  },
  {
    "countryCode": "TZ",
    "region": "09",
    "description": "Kilimanjaro"
  },
  {
    "countryCode": "TZ",
    "region": "10",
    "description": "Pemba South"
  },
  {
    "countryCode": "TZ",
    "region": "11",
    "description": "Zanzibar Central/S."
  },
  {
    "countryCode": "TZ",
    "region": "12",
    "description": "Lindi"
  },
  {
    "countryCode": "TZ",
    "region": "13",
    "description": "Mara"
  },
  {
    "countryCode": "TZ",
    "region": "14",
    "description": "Mbeya"
  },
  {
    "countryCode": "TZ",
    "region": "15",
    "description": "Zanzibar Urban/West"
  },
  {
    "countryCode": "TZ",
    "region": "16",
    "description": "Morogoro"
  },
  {
    "countryCode": "TZ",
    "region": "17",
    "description": "Mtwara"
  },
  {
    "countryCode": "TZ",
    "region": "18",
    "description": "Mwanza"
  },
  {
    "countryCode": "TZ",
    "region": "19",
    "description": "Pwani"
  },
  {
    "countryCode": "TZ",
    "region": "20",
    "description": "Rukwa"
  },
  {
    "countryCode": "TZ",
    "region": "21",
    "description": "Ruvuma"
  },
  {
    "countryCode": "TZ",
    "region": "22",
    "description": "Shinyanga"
  },
  {
    "countryCode": "TZ",
    "region": "23",
    "description": "Singida"
  },
  {
    "countryCode": "TZ",
    "region": "24",
    "description": "Tabora"
  },
  {
    "countryCode": "TZ",
    "region": "25",
    "description": "Tanga"
  },
  {
    "countryCode": "TZ",
    "region": "26",
    "description": "Manyara"
  },
  {
    "countryCode": "TZ",
    "region": "27",
    "description": "Geita"
  },
  {
    "countryCode": "TZ",
    "region": "28",
    "description": "Katavi"
  },
  {
    "countryCode": "TZ",
    "region": "29",
    "description": "Njombe"
  },
  {
    "countryCode": "TZ",
    "region": "30",
    "description": "Simiyu"
  },
  {
    "countryCode": "UA",
    "region": "05",
    "description": "Vinnytska oblast"
  },
  {
    "countryCode": "UA",
    "region": "07",
    "description": "Volynska oblast"
  },
  {
    "countryCode": "UA",
    "region": "09",
    "description": "Luhanska oblast"
  },
  {
    "countryCode": "UA",
    "region": "12",
    "description": "Dnipropetrovska obl."
  },
  {
    "countryCode": "UA",
    "region": "14",
    "description": "Donetska oblast"
  },
  {
    "countryCode": "UA",
    "region": "18",
    "description": "Zhytomyrska oblast"
  },
  {
    "countryCode": "UA",
    "region": "21",
    "description": "Zakarpatska oblast"
  },
  {
    "countryCode": "UA",
    "region": "23",
    "description": "Zaporizka oblast"
  },
  {
    "countryCode": "UA",
    "region": "26",
    "description": "Ivano-Frankivska obl"
  },
  {
    "countryCode": "UA",
    "region": "30",
    "description": "Kyiv"
  },
  {
    "countryCode": "UA",
    "region": "32",
    "description": "Kyivska oblast"
  },
  {
    "countryCode": "UA",
    "region": "35",
    "description": "Kirovohradska oblast"
  },
  {
    "countryCode": "UA",
    "region": "40",
    "description": "Sevastopol"
  },
  {
    "countryCode": "UA",
    "region": "43",
    "description": "Respublika Krym"
  },
  {
    "countryCode": "UA",
    "region": "46",
    "description": "Lvivska oblast"
  },
  {
    "countryCode": "UA",
    "region": "48",
    "description": "Mykolaivska oblast"
  },
  {
    "countryCode": "UA",
    "region": "51",
    "description": "Odeska oblast"
  },
  {
    "countryCode": "UA",
    "region": "53",
    "description": "Poltavska oblast"
  },
  {
    "countryCode": "UA",
    "region": "56",
    "description": "Rivnenska oblast"
  },
  {
    "countryCode": "UA",
    "region": "59",
    "description": "Sumska oblast"
  },
  {
    "countryCode": "UA",
    "region": "61",
    "description": "Ternopilska oblast"
  },
  {
    "countryCode": "UA",
    "region": "63",
    "description": "Kharkivska oblast"
  },
  {
    "countryCode": "UA",
    "region": "65",
    "description": "Khersonska oblast"
  },
  {
    "countryCode": "UA",
    "region": "68",
    "description": "Khmelnytska oblast"
  },
  {
    "countryCode": "UA",
    "region": "71",
    "description": "Cherkaska oblast"
  },
  {
    "countryCode": "UA",
    "region": "74",
    "description": "Chernihivska oblast"
  },
  {
    "countryCode": "UA",
    "region": "77",
    "description": "Chernivetska oblast"
  },
  {
    "countryCode": "UG",
    "region": "C",
    "description": "Central"
  },
  {
    "countryCode": "UG",
    "region": "E",
    "description": "Eastern"
  },
  {
    "countryCode": "UG",
    "region": "N",
    "description": "Northern"
  },
  {
    "countryCode": "UG",
    "region": "W",
    "description": "Western"
  },
  {
    "countryCode": "UM",
    "region": "67",
    "description": "Johnston Atoll"
  },
  {
    "countryCode": "UM",
    "region": "71",
    "description": "Midway Islands"
  },
  {
    "countryCode": "UM",
    "region": "76",
    "description": "Navassa Island"
  },
  {
    "countryCode": "UM",
    "region": "79",
    "description": "Wake Island"
  },
  {
    "countryCode": "UM",
    "region": "81",
    "description": "Baker Island"
  },
  {
    "countryCode": "UM",
    "region": "84",
    "description": "Howland Island"
  },
  {
    "countryCode": "UM",
    "region": "86",
    "description": "Jarvis Island"
  },
  {
    "countryCode": "UM",
    "region": "89",
    "description": "Kingman Reef"
  },
  {
    "countryCode": "UM",
    "region": "95",
    "description": "Palmyra Atoll"
  },
  {
    "countryCode": "US",
    "region": "AA",
    "description": "A.Forces Americas"
  },
  {
    "countryCode": "US",
    "region": "AE",
    "description": "A.Forces Eur./ME/Afr"
  },
  {
    "countryCode": "US",
    "region": "AK",
    "description": "Alaska"
  },
  {
    "countryCode": "US",
    "region": "AL",
    "description": "Alabama"
  },
  {
    "countryCode": "US",
    "region": "AP",
    "description": "Armed Forces Pacific"
  },
  {
    "countryCode": "US",
    "region": "AR",
    "description": "Arkansas"
  },
  {
    "countryCode": "US",
    "region": "AS",
    "description": "American Samoa"
  },
  {
    "countryCode": "US",
    "region": "AZ",
    "description": "Arizona"
  },
  {
    "countryCode": "US",
    "region": "CA",
    "description": "California"
  },
  {
    "countryCode": "US",
    "region": "CO",
    "description": "Colorado"
  },
  {
    "countryCode": "US",
    "region": "CT",
    "description": "Connecticut"
  },
  {
    "countryCode": "US",
    "region": "DC",
    "description": "District of Columbia"
  },
  {
    "countryCode": "US",
    "region": "DE",
    "description": "Delaware"
  },
  {
    "countryCode": "US",
    "region": "FL",
    "description": "Florida"
  },
  {
    "countryCode": "US",
    "region": "GA",
    "description": "Georgia"
  },
  {
    "countryCode": "US",
    "region": "GU",
    "description": "Guam"
  },
  {
    "countryCode": "US",
    "region": "HI",
    "description": "Hawaii"
  },
  {
    "countryCode": "US",
    "region": "IA",
    "description": "Iowa"
  },
  {
    "countryCode": "US",
    "region": "ID",
    "description": "Idaho"
  },
  {
    "countryCode": "US",
    "region": "IL",
    "description": "Illinois"
  },
  {
    "countryCode": "US",
    "region": "IN",
    "description": "Indiana"
  },
  {
    "countryCode": "US",
    "region": "KS",
    "description": "Kansas"
  },
  {
    "countryCode": "US",
    "region": "KY",
    "description": "Kentucky"
  },
  {
    "countryCode": "US",
    "region": "LA",
    "description": "Louisiana"
  },
  {
    "countryCode": "US",
    "region": "MA",
    "description": "Massachusetts"
  },
  {
    "countryCode": "US",
    "region": "MD",
    "description": "Maryland"
  },
  {
    "countryCode": "US",
    "region": "ME",
    "description": "Maine"
  },
  {
    "countryCode": "US",
    "region": "MI",
    "description": "Michigan"
  },
  {
    "countryCode": "US",
    "region": "MN",
    "description": "Minnesota"
  },
  {
    "countryCode": "US",
    "region": "MO",
    "description": "Missouri"
  },
  {
    "countryCode": "US",
    "region": "MP",
    "description": "Northern Mariana Isl"
  },
  {
    "countryCode": "US",
    "region": "MS",
    "description": "Mississippi"
  },
  {
    "countryCode": "US",
    "region": "MT",
    "description": "Montana"
  },
  {
    "countryCode": "US",
    "region": "NC",
    "description": "North Carolina"
  },
  {
    "countryCode": "US",
    "region": "ND",
    "description": "North Dakota"
  },
  {
    "countryCode": "US",
    "region": "NE",
    "description": "Nebraska"
  },
  {
    "countryCode": "US",
    "region": "NH",
    "description": "New Hampshire"
  },
  {
    "countryCode": "US",
    "region": "NJ",
    "description": "New Jersey"
  },
  {
    "countryCode": "US",
    "region": "NM",
    "description": "New Mexico"
  },
  {
    "countryCode": "US",
    "region": "NV",
    "description": "Nevada"
  },
  {
    "countryCode": "US",
    "region": "NY",
    "description": "New York"
  },
  {
    "countryCode": "US",
    "region": "OH",
    "description": "Ohio"
  },
  {
    "countryCode": "US",
    "region": "OK",
    "description": "Oklahoma"
  },
  {
    "countryCode": "US",
    "region": "OR",
    "description": "Oregon"
  },
  {
    "countryCode": "US",
    "region": "PA",
    "description": "Pennsylvania"
  },
  {
    "countryCode": "US",
    "region": "PR",
    "description": "Puerto Rico"
  },
  {
    "countryCode": "US",
    "region": "RI",
    "description": "Rhode Island"
  },
  {
    "countryCode": "US",
    "region": "SC",
    "description": "South Carolina"
  },
  {
    "countryCode": "US",
    "region": "SD",
    "description": "South Dakota"
  },
  {
    "countryCode": "US",
    "region": "TN",
    "description": "Tennessee"
  },
  {
    "countryCode": "US",
    "region": "TX",
    "description": "Texas"
  },
  {
    "countryCode": "US",
    "region": "UM",
    "description": "US Minor Outl. Isl."
  },
  {
    "countryCode": "US",
    "region": "UT",
    "description": "Utah"
  },
  {
    "countryCode": "US",
    "region": "VA",
    "description": "Virginia"
  },
  {
    "countryCode": "US",
    "region": "VI",
    "description": "Virgin Islands"
  },
  {
    "countryCode": "US",
    "region": "VT",
    "description": "Vermont"
  },
  {
    "countryCode": "US",
    "region": "WA",
    "description": "Washington"
  },
  {
    "countryCode": "US",
    "region": "WI",
    "description": "Wisconsin"
  },
  {
    "countryCode": "US",
    "region": "WV",
    "description": "West Virginia"
  },
  {
    "countryCode": "US",
    "region": "WY",
    "description": "Wyoming"
  },
  {
    "countryCode": "UY",
    "region": "AR",
    "description": "Artigas"
  },
  {
    "countryCode": "UY",
    "region": "CA",
    "description": "Canelones"
  },
  {
    "countryCode": "UY",
    "region": "CL",
    "description": "Cerro Largo"
  },
  {
    "countryCode": "UY",
    "region": "CO",
    "description": "Colonia"
  },
  {
    "countryCode": "UY",
    "region": "DU",
    "description": "Durazno"
  },
  {
    "countryCode": "UY",
    "region": "FD",
    "description": "Florida"
  },
  {
    "countryCode": "UY",
    "region": "FS",
    "description": "Flores"
  },
  {
    "countryCode": "UY",
    "region": "LA",
    "description": "Lavalleja"
  },
  {
    "countryCode": "UY",
    "region": "MA",
    "description": "Maldonado"
  },
  {
    "countryCode": "UY",
    "region": "MO",
    "description": "Montevideo"
  },
  {
    "countryCode": "UY",
    "region": "PA",
    "description": "Paysand\u00fa"
  },
  {
    "countryCode": "UY",
    "region": "RN",
    "description": "R\u00edo Negro"
  },
  {
    "countryCode": "UY",
    "region": "RO",
    "description": "Rocha"
  },
  {
    "countryCode": "UY",
    "region": "RV",
    "description": "Rivera"
  },
  {
    "countryCode": "UY",
    "region": "SA",
    "description": "Salto"
  },
  {
    "countryCode": "UY",
    "region": "SJ",
    "description": "San Jos\u00e9"
  },
  {
    "countryCode": "UY",
    "region": "SO",
    "description": "Soriano"
  },
  {
    "countryCode": "UY",
    "region": "TA",
    "description": "Tacauremb\u00f3"
  },
  {
    "countryCode": "UY",
    "region": "TT",
    "description": "Treinta y tres"
  },
  {
    "countryCode": "UZ",
    "region": "AN",
    "description": "Andijon"
  },
  {
    "countryCode": "UZ",
    "region": "BU",
    "description": "Buxoro"
  },
  {
    "countryCode": "UZ",
    "region": "FA",
    "description": "Farg\u02bbona"
  },
  {
    "countryCode": "UZ",
    "region": "JI",
    "description": "Jizzax"
  },
  {
    "countryCode": "UZ",
    "region": "NG",
    "description": "Namangan"
  },
  {
    "countryCode": "UZ",
    "region": "NW",
    "description": "Navoiy"
  },
  {
    "countryCode": "UZ",
    "region": "QA",
    "description": "Qashqadaryo"
  },
  {
    "countryCode": "UZ",
    "region": "QR",
    "description": "Karakalpakistan"
  },
  {
    "countryCode": "UZ",
    "region": "SA",
    "description": "Samarqand"
  },
  {
    "countryCode": "UZ",
    "region": "SI",
    "description": "Sirdaryo"
  },
  {
    "countryCode": "UZ",
    "region": "SU",
    "description": "Surxondaryo"
  },
  {
    "countryCode": "UZ",
    "region": "TK",
    "description": "Toshkent (city)"
  },
  {
    "countryCode": "UZ",
    "region": "TO",
    "description": "Toshkent (region)"
  },
  {
    "countryCode": "UZ",
    "region": "XO",
    "description": "Xorazm"
  },
  {
    "countryCode": "VE",
    "region": "A",
    "description": "Distrito Capital"
  },
  {
    "countryCode": "VE",
    "region": "B",
    "description": "Anzoategui"
  },
  {
    "countryCode": "VE",
    "region": "C",
    "description": "Apure"
  },
  {
    "countryCode": "VE",
    "region": "D",
    "description": "Aragua"
  },
  {
    "countryCode": "VE",
    "region": "E",
    "description": "Barinas"
  },
  {
    "countryCode": "VE",
    "region": "F",
    "description": "Bolivar"
  },
  {
    "countryCode": "VE",
    "region": "G",
    "description": "Carabobo"
  },
  {
    "countryCode": "VE",
    "region": "H",
    "description": "Cojedes"
  },
  {
    "countryCode": "VE",
    "region": "I",
    "description": "Falcon"
  },
  {
    "countryCode": "VE",
    "region": "J",
    "description": "Guarico"
  },
  {
    "countryCode": "VE",
    "region": "K",
    "description": "Lara"
  },
  {
    "countryCode": "VE",
    "region": "L",
    "description": "Merida"
  },
  {
    "countryCode": "VE",
    "region": "M",
    "description": "Miranda"
  },
  {
    "countryCode": "VE",
    "region": "N",
    "description": "Monagas"
  },
  {
    "countryCode": "VE",
    "region": "O",
    "description": "Nueva Esparta"
  },
  {
    "countryCode": "VE",
    "region": "P",
    "description": "Portuguesa"
  },
  {
    "countryCode": "VE",
    "region": "R",
    "description": "Sucre"
  },
  {
    "countryCode": "VE",
    "region": "S",
    "description": "Tachira"
  },
  {
    "countryCode": "VE",
    "region": "T",
    "description": "Trujillo"
  },
  {
    "countryCode": "VE",
    "region": "U",
    "description": "Yaracuy"
  },
  {
    "countryCode": "VE",
    "region": "V",
    "description": "Zulia"
  },
  {
    "countryCode": "VE",
    "region": "W",
    "description": "Dependencias Federal"
  },
  {
    "countryCode": "VE",
    "region": "X",
    "description": "La Guaira"
  },
  {
    "countryCode": "VE",
    "region": "Y",
    "description": "Delta Amacuro"
  },
  {
    "countryCode": "VE",
    "region": "Z",
    "description": "Amazon"
  },
  {
    "countryCode": "VN",
    "region": "01",
    "description": "Lai Ch\u00e2u"
  },
  {
    "countryCode": "VN",
    "region": "02",
    "description": "L\u00e0o Cai"
  },
  {
    "countryCode": "VN",
    "region": "03",
    "description": "H\u00e0 Giang"
  },
  {
    "countryCode": "VN",
    "region": "04",
    "description": "Cao B\u1eb1ng"
  },
  {
    "countryCode": "VN",
    "region": "05",
    "description": "S\u01a1n La"
  },
  {
    "countryCode": "VN",
    "region": "06",
    "description": "Y\u00ean B\u00e1i"
  },
  {
    "countryCode": "VN",
    "region": "07",
    "description": "Tuy\u00ean Quang"
  },
  {
    "countryCode": "VN",
    "region": "09",
    "description": "L\u1ea1ng S\u01a1n"
  },
  {
    "countryCode": "VN",
    "region": "13",
    "description": "Qu\u1ea3ng Ninh"
  },
  {
    "countryCode": "VN",
    "region": "14",
    "description": "H\u00f2a B\u00ecnh"
  },
  {
    "countryCode": "VN",
    "region": "18",
    "description": "Ninh B\u00ecnh"
  },
  {
    "countryCode": "VN",
    "region": "20",
    "description": "Th\u00e1i B\u00ecnh"
  },
  {
    "countryCode": "VN",
    "region": "21",
    "description": "Thanh H\u00f3a"
  },
  {
    "countryCode": "VN",
    "region": "22",
    "description": "Ngh\u1ec7 An"
  },
  {
    "countryCode": "VN",
    "region": "23",
    "description": "H\u00e0 T\u0129nh"
  },
  {
    "countryCode": "VN",
    "region": "24",
    "description": "Qu\u1ea3ng B\u00ecnh"
  },
  {
    "countryCode": "VN",
    "region": "25",
    "description": "Qu\u1ea3ng Tr\u1ecb"
  },
  {
    "countryCode": "VN",
    "region": "26",
    "description": "Th\u1eeba Thi\u00ean-Hu\u1ebf"
  },
  {
    "countryCode": "VN",
    "region": "27",
    "description": "Qu\u1ea3ng Nam"
  },
  {
    "countryCode": "VN",
    "region": "28",
    "description": "Kon Tum"
  },
  {
    "countryCode": "VN",
    "region": "29",
    "description": "Qu\u1ea3ng Ng\u00e3i"
  },
  {
    "countryCode": "VN",
    "region": "30",
    "description": "Gia Lai"
  },
  {
    "countryCode": "VN",
    "region": "31",
    "description": "B\u00ecnh \u0110\u1ecbnh"
  },
  {
    "countryCode": "VN",
    "region": "32",
    "description": "Ph\u00fa Y\u00ean"
  },
  {
    "countryCode": "VN",
    "region": "33",
    "description": "\u0110\u1eafk L\u1eafk"
  },
  {
    "countryCode": "VN",
    "region": "34",
    "description": "Kh\u00e1nh H\u00f2a"
  },
  {
    "countryCode": "VN",
    "region": "35",
    "description": "L\u00e2m \u00d0\u1ed3ng"
  },
  {
    "countryCode": "VN",
    "region": "36",
    "description": "Ninh Thu\u1eadn"
  },
  {
    "countryCode": "VN",
    "region": "37",
    "description": "T\u00e2y Ninh"
  },
  {
    "countryCode": "VN",
    "region": "39",
    "description": "\u00d0\u1ed3ng Nai"
  },
  {
    "countryCode": "VN",
    "region": "40",
    "description": "B\u00ecnh Thu\u1eadn"
  },
  {
    "countryCode": "VN",
    "region": "41",
    "description": "Long An"
  },
  {
    "countryCode": "VN",
    "region": "43",
    "description": "B\u00e0 R\u1ecba - V\u0169ng T\u00e0u"
  },
  {
    "countryCode": "VN",
    "region": "44",
    "description": "An Giang"
  },
  {
    "countryCode": "VN",
    "region": "45",
    "description": "\u00d0\u1ed3ng Th\u00e1p"
  },
  {
    "countryCode": "VN",
    "region": "46",
    "description": "Ti\u1ec1n Giang"
  },
  {
    "countryCode": "VN",
    "region": "47",
    "description": "Ki\u1ebfn Giang"
  },
  {
    "countryCode": "VN",
    "region": "49",
    "description": "V\u0129nh Long"
  },
  {
    "countryCode": "VN",
    "region": "50",
    "description": "B\u1ebfn Tre"
  },
  {
    "countryCode": "VN",
    "region": "51",
    "description": "Tr\u00e0 Vinh"
  },
  {
    "countryCode": "VN",
    "region": "52",
    "description": "S\u00f3c Tr\u0103ng"
  },
  {
    "countryCode": "VN",
    "region": "53",
    "description": "B\u1eafc K\u1ea1n"
  },
  {
    "countryCode": "VN",
    "region": "54",
    "description": "B\u1eafc Giang"
  },
  {
    "countryCode": "VN",
    "region": "55",
    "description": "B\u1ea1c Li\u00eau"
  },
  {
    "countryCode": "VN",
    "region": "56",
    "description": "B\u1eafc Ninh"
  },
  {
    "countryCode": "VN",
    "region": "57",
    "description": "B\u00ecnh D\u01b0\u01a1ng"
  },
  {
    "countryCode": "VN",
    "region": "58",
    "description": "B\u00ecnh Ph\u01b0\u1edbc"
  },
  {
    "countryCode": "VN",
    "region": "59",
    "description": "C\u00e0 Mau"
  },
  {
    "countryCode": "VN",
    "region": "61",
    "description": "H\u1ea3i D\u01b0\u01a1ng"
  },
  {
    "countryCode": "VN",
    "region": "63",
    "description": "H\u00e0 Nam"
  },
  {
    "countryCode": "VN",
    "region": "66",
    "description": "H\u01b0ng Y\u00ean"
  },
  {
    "countryCode": "VN",
    "region": "67",
    "description": "Nam \u00d0\u1ecbnh"
  },
  {
    "countryCode": "VN",
    "region": "68",
    "description": "Ph\u00fa Th\u1ecd"
  },
  {
    "countryCode": "VN",
    "region": "69",
    "description": "Th\u00e1i Nguy\u00ean"
  },
  {
    "countryCode": "VN",
    "region": "70",
    "description": "V\u0129nh Ph\u00fac"
  },
  {
    "countryCode": "VN",
    "region": "71",
    "description": "\u0110i\u1ec7n Bi\u00ean"
  },
  {
    "countryCode": "VN",
    "region": "72",
    "description": "\u0110\u1eafk N\u00f4ng"
  },
  {
    "countryCode": "VN",
    "region": "73",
    "description": "H\u1eadu Giang"
  },
  {
    "countryCode": "VN",
    "region": "CT",
    "description": "Can Tho"
  },
  {
    "countryCode": "VN",
    "region": "DN",
    "description": "Da Nang"
  },
  {
    "countryCode": "VN",
    "region": "HN",
    "description": "Ha Noi"
  },
  {
    "countryCode": "VN",
    "region": "HP",
    "description": "Hai Phong"
  },
  {
    "countryCode": "VN",
    "region": "SG",
    "description": "Ho Chi Minh"
  },
  {
    "countryCode": "VU",
    "region": "MAP",
    "description": "Malampa"
  },
  {
    "countryCode": "VU",
    "region": "PAM",
    "description": "Penama"
  },
  {
    "countryCode": "VU",
    "region": "SAM",
    "description": "Sanma"
  },
  {
    "countryCode": "VU",
    "region": "SEE",
    "description": "Shefa"
  },
  {
    "countryCode": "VU",
    "region": "TAE",
    "description": "Tafea"
  },
  {
    "countryCode": "VU",
    "region": "TOB",
    "description": "Torba"
  },
  {
    "countryCode": "WS",
    "region": "AA",
    "description": "A'ana"
  },
  {
    "countryCode": "WS",
    "region": "AL",
    "description": "Aiga-i-le-Tai"
  },
  {
    "countryCode": "WS",
    "region": "AT",
    "description": "Atua"
  },
  {
    "countryCode": "WS",
    "region": "FA",
    "description": "Fa'aaaleleaga"
  },
  {
    "countryCode": "WS",
    "region": "GE",
    "description": "Gaga'emauga"
  },
  {
    "countryCode": "WS",
    "region": "GI",
    "description": "Gagaifomauga"
  },
  {
    "countryCode": "WS",
    "region": "PA",
    "description": "Palauli"
  },
  {
    "countryCode": "WS",
    "region": "SA",
    "description": "Satupa'itea"
  },
  {
    "countryCode": "WS",
    "region": "TU",
    "description": "Tuamasaga"
  },
  {
    "countryCode": "WS",
    "region": "VF",
    "description": "Va'a-o-Fonoti"
  },
  {
    "countryCode": "WS",
    "region": "VS",
    "description": "Vaisigano"
  },
  {
    "countryCode": "YE",
    "region": "AB",
    "description": "Abyan"
  },
  {
    "countryCode": "YE",
    "region": "AD",
    "description": "Aden"
  },
  {
    "countryCode": "YE",
    "region": "AM",
    "description": "'Amran"
  },
  {
    "countryCode": "YE",
    "region": "BA",
    "description": "Al Bayda"
  },
  {
    "countryCode": "YE",
    "region": "DA",
    "description": "Dhale"
  },
  {
    "countryCode": "YE",
    "region": "DH",
    "description": "Dhamar"
  },
  {
    "countryCode": "YE",
    "region": "HD",
    "description": "Hadramaut"
  },
  {
    "countryCode": "YE",
    "region": "HJ",
    "description": "Hajjah"
  },
  {
    "countryCode": "YE",
    "region": "HU",
    "description": "Al Hudaydah"
  },
  {
    "countryCode": "YE",
    "region": "IB",
    "description": "Ibb"
  },
  {
    "countryCode": "YE",
    "region": "JA",
    "description": "Al Jawf"
  },
  {
    "countryCode": "YE",
    "region": "LA",
    "description": "Lahij"
  },
  {
    "countryCode": "YE",
    "region": "MA",
    "description": "Ma'rib"
  },
  {
    "countryCode": "YE",
    "region": "MR",
    "description": "Al Mahrah"
  },
  {
    "countryCode": "YE",
    "region": "MW",
    "description": "Al Mahwit"
  },
  {
    "countryCode": "YE",
    "region": "RA",
    "description": "Raymah"
  },
  {
    "countryCode": "YE",
    "region": "SA",
    "description": "Amanat Al Asimah"
  },
  {
    "countryCode": "YE",
    "region": "SD",
    "description": "Sa'dah"
  },
  {
    "countryCode": "YE",
    "region": "SH",
    "description": "Shabwah"
  },
  {
    "countryCode": "YE",
    "region": "SN",
    "description": "Sana'a"
  },
  {
    "countryCode": "YE",
    "region": "SU",
    "description": "Arkhab\u012bl Suqu\u0163r\u00e1"
  },
  {
    "countryCode": "YE",
    "region": "TA",
    "description": "Taiz"
  },
  {
    "countryCode": "ZA",
    "region": "EC",
    "description": "Eastern Cape"
  },
  {
    "countryCode": "ZA",
    "region": "FS",
    "description": "Free State"
  },
  {
    "countryCode": "ZA",
    "region": "GP",
    "description": "Gauteng"
  },
  {
    "countryCode": "ZA",
    "region": "KZN",
    "description": "Kwazulu-Natal"
  },
  {
    "countryCode": "ZA",
    "region": "LP",
    "description": "Limpopo"
  },
  {
    "countryCode": "ZA",
    "region": "MP",
    "description": "Mpumalanga"
  },
  {
    "countryCode": "ZA",
    "region": "NC",
    "description": "Northern Cape"
  },
  {
    "countryCode": "ZA",
    "region": "NW",
    "description": "Northwest"
  },
  {
    "countryCode": "ZA",
    "region": "WC",
    "description": "Western Cape"
  },
  {
    "countryCode": "ZA",
    "region": "ZN",
    "description": "Obsolete"
  },
  {
    "countryCode": "ZM",
    "region": "01",
    "description": "Western"
  },
  {
    "countryCode": "ZM",
    "region": "02",
    "description": "Central"
  },
  {
    "countryCode": "ZM",
    "region": "03",
    "description": "Eastern"
  },
  {
    "countryCode": "ZM",
    "region": "04",
    "description": "Luapula"
  },
  {
    "countryCode": "ZM",
    "region": "05",
    "description": "Northern"
  },
  {
    "countryCode": "ZM",
    "region": "06",
    "description": "North-Western"
  },
  {
    "countryCode": "ZM",
    "region": "07",
    "description": "Southern"
  },
  {
    "countryCode": "ZM",
    "region": "08",
    "description": "Copperbelt"
  },
  {
    "countryCode": "ZM",
    "region": "09",
    "description": "Lusaka"
  },
  {
    "countryCode": "ZM",
    "region": "10",
    "description": "Muchinga"
  },
  {
    "countryCode": "ZW",
    "region": "BU",
    "description": "Bulawayo"
  },
  {
    "countryCode": "ZW",
    "region": "HA",
    "description": "Harare"
  },
  {
    "countryCode": "ZW",
    "region": "MA",
    "description": "Manicaland"
  },
  {
    "countryCode": "ZW",
    "region": "MC",
    "description": "Mashonaland Central"
  },
  {
    "countryCode": "ZW",
    "region": "ME",
    "description": "Mashonaland East"
  },
  {
    "countryCode": "ZW",
    "region": "MI",
    "description": "Midlands"
  },
  {
    "countryCode": "ZW",
    "region": "MN",
    "description": "Matabeleland North"
  },
  {
    "countryCode": "ZW",
    "region": "MS",
    "description": "Matabeleland South"
  },
  {
    "countryCode": "ZW",
    "region": "MV",
    "description": "Masvingo"
  },
  {
    "countryCode": "ZW",
    "region": "MW",
    "description": "Mashonaland West"
  }
];

export const getStlDigitalRegionsForCountry = (countryCode) => {
    if (!countryCode) return [];
    return stldigitalRegionData.filter(r => r.countryCode === countryCode);
};
